/*
 * theme.js -- webpack output, hand-maintained. There is no build config in this
 * repo, so this file is the source of truth. Read this before editing it.
 *
 * webpack emitted this in mode: "development" with devtool: "eval", which ships
 * each of its modules as a string handed to eval, roughly:
 *
 *     ((module, exports, __webpack_require__) => {
 *       "use strict";
 *       eval( <the whole module, escaped as a JS string literal> );
 *     })
 *
 * Every module body has been lifted out of its eval call and inlined into its
 * factory function, which is what webpack emits with devtool off. This is
 * behaviour-preserving: each factory body was only ever that call plus an
 * optional "use strict", so nothing else shared the scope and could observe the
 * declarations moving from eval scope into factory scope. The module sources are
 * byte-for-byte what eval previously received.
 *
 * Why: eval'd code sits outside the engine's normal parse and code-cache path,
 * so every module was recompiled on every page load rather than served from
 * cache. The file is barely smaller, because the string escaping was only 3% of
 * it -- this is a parse and compile change, not a size one.
 *
 * Still unminified and readable on purpose, because hand-editing is currently
 * the only way to change it. To sanity-check an edit, count the module map
 * entries: there should be 40. (127 until 2026-09-22, when the 87 modules of
 * InstantSearch.js and its dependencies were removed; see
 * instantsearch-integration.js.)
 *
 * The real fix is to recover the original webpack source and build in production
 * mode, which would also minify it (it is ~570 KB unminified).
 */

/*
 * Debug logging gate.
 *
 * This file carries 319 console.log calls -- development traces left in by the
 * original build (ProductRecommendations 69, ProductImageSlider 50,
 * InfiniteScroll 27, and six other components). They fire on every image
 * change, variant click and search keystroke, which buries the 65
 * console.error and 31 console.warn calls that actually signal breakage.
 *
 * Rather than delete 319 call sites by hand in a file with no build step --
 * 23 of them span multiple lines, and the brace-less `if (x) console.log(...)`
 * ones would leave dangling statements -- console.log is stubbed out here.
 * error, warn and info are untouched. Append ?debug=1 to any storefront URL to
 * get the traces back for that page load.
 *
 * Note this is a global override: it also silences console.log from Shopify
 * apps and other vendor scripts loaded after theme.js. That is the tradeoff for
 * not touching the call sites. Their error/warn output still comes through, and
 * a tool that wraps console.log after this runs still receives every call -- it
 * just ends in a no-op instead of the devtools console. Checked 2026-09-21:
 * nothing on the storefront wraps console (Clarity, Klaviyo, GTM, Smile,
 * Facebook and Shop all leave it native), so nothing is being displaced today.
 *
 * The try/catch is load-bearing. This sits above the webpack bootstrap, so an
 * exception here takes every module with it -- a browser missing
 * URLSearchParams would go from "degraded" to "no theme JS at all". Failing
 * open leaves the logs noisy, which is the harmless direction.
 */
try {
  if (!new URLSearchParams(window.location.search).has('debug')) {
    console.log = () => {};
  }
} catch (e) {
  /* leave console.log alone */
}

/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/.pnpm/embla-carousel-auto-scroll@8.6.0_embla-carousel@8.6.0/node_modules/embla-carousel-auto-scroll/esm/embla-carousel-auto-scroll.esm.js":
/*!****************************************************************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/embla-carousel-auto-scroll@8.6.0_embla-carousel@8.6.0/node_modules/embla-carousel-auto-scroll/esm/embla-carousel-auto-scroll.esm.js ***!
  \****************************************************************************************************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AutoScroll)
/* harmony export */ });
const defaultOptions = {
  direction: 'forward',
  speed: 2,
  startDelay: 1000,
  active: true,
  breakpoints: {},
  playOnInit: true,
  stopOnFocusIn: true,
  stopOnInteraction: true,
  stopOnMouseEnter: false,
  rootNode: null
};

function getAutoScrollRootNode(emblaApi, rootNode) {
  const emblaRootNode = emblaApi.rootNode();
  return rootNode && rootNode(emblaRootNode) || emblaRootNode;
}

function AutoScroll(userOptions = {}) {
  let options;
  let emblaApi;
  let destroyed;
  let startDelay;
  let timerId = 0;
  let autoScrollActive = false;
  let mouseIsOver = false;
  let defaultScrollBehaviour;
  function init(emblaApiInstance, optionsHandler) {
    emblaApi = emblaApiInstance;
    const {
      mergeOptions,
      optionsAtMedia
    } = optionsHandler;
    const optionsBase = mergeOptions(defaultOptions, AutoScroll.globalOptions);
    const allOptions = mergeOptions(optionsBase, userOptions);
    options = optionsAtMedia(allOptions);
    if (emblaApi.scrollSnapList().length <= 1) return;
    startDelay = options.startDelay;
    destroyed = false;
    defaultScrollBehaviour = emblaApi.internalEngine().scrollBody;
    const {
      eventStore
    } = emblaApi.internalEngine();
    const isDraggable = !!emblaApi.internalEngine().options.watchDrag;
    const root = getAutoScrollRootNode(emblaApi, options.rootNode);
    if (isDraggable) {
      emblaApi.on('pointerDown', pointerDown);
    }
    if (isDraggable && !options.stopOnInteraction) {
      emblaApi.on('pointerUp', pointerUp);
    }
    if (options.stopOnMouseEnter) {
      eventStore.add(root, 'mouseenter', mouseEnter);
    }
    if (options.stopOnMouseEnter && !options.stopOnInteraction) {
      eventStore.add(root, 'mouseleave', mouseLeave);
    }
    if (options.stopOnFocusIn) {
      emblaApi.on('slideFocusStart', stopAutoScroll);
    }
    if (options.stopOnFocusIn && !options.stopOnInteraction) {
      eventStore.add(emblaApi.containerNode(), 'focusout', startAutoScroll);
    }
    if (options.playOnInit) startAutoScroll();
  }
  function destroy() {
    emblaApi.off('pointerDown', pointerDown).off('pointerUp', pointerUp).off('slideFocusStart', stopAutoScroll).off('settle', settle);
    stopAutoScroll();
    destroyed = true;
    autoScrollActive = false;
  }
  function startAutoScroll() {
    if (destroyed) return;
    if (autoScrollActive) return;
    emblaApi.emit('autoScroll:play');
    const engine = emblaApi.internalEngine();
    const {
      ownerWindow
    } = engine;
    timerId = ownerWindow.setTimeout(() => {
      engine.scrollBody = createAutoScrollBehaviour(engine);
      engine.animation.start();
    }, startDelay);
    autoScrollActive = true;
  }
  function stopAutoScroll() {
    if (destroyed) return;
    if (!autoScrollActive) return;
    emblaApi.emit('autoScroll:stop');
    const engine = emblaApi.internalEngine();
    const {
      ownerWindow
    } = engine;
    engine.scrollBody = defaultScrollBehaviour;
    ownerWindow.clearTimeout(timerId);
    timerId = 0;
    autoScrollActive = false;
  }
  function createAutoScrollBehaviour(engine) {
    const {
      location,
      previousLocation,
      offsetLocation,
      target,
      scrollTarget,
      index,
      indexPrevious,
      limit: {
        reachedMin,
        reachedMax,
        constrain
      },
      options: {
        loop
      }
    } = engine;
    const directionSign = options.direction === 'forward' ? -1 : 1;
    const noop = () => self;
    let bodyVelocity = 0;
    let scrollDirection = 0;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    let hasSettled = false;
    function seek() {
      let directionDiff = 0;
      previousLocation.set(location);
      bodyVelocity = directionSign * options.speed;
      rawLocation += bodyVelocity;
      location.add(bodyVelocity);
      target.set(location);
      directionDiff = rawLocation - rawLocationPrevious;
      scrollDirection = Math.sign(directionDiff);
      rawLocationPrevious = rawLocation;
      const currentIndex = scrollTarget.byDistance(0, false).index;
      if (index.get() !== currentIndex) {
        indexPrevious.set(index.get());
        index.set(currentIndex);
        emblaApi.emit('select');
      }
      const reachedEnd = options.direction === 'forward' ? reachedMin(offsetLocation.get()) : reachedMax(offsetLocation.get());
      if (!loop && reachedEnd) {
        hasSettled = true;
        const constrainedLocation = constrain(location.get());
        location.set(constrainedLocation);
        target.set(location);
        stopAutoScroll();
      }
      return self;
    }
    const self = {
      direction: () => scrollDirection,
      duration: () => -1,
      velocity: () => bodyVelocity,
      settled: () => hasSettled,
      seek,
      useBaseFriction: noop,
      useBaseDuration: noop,
      useFriction: noop,
      useDuration: noop
    };
    return self;
  }
  function pointerDown() {
    if (!mouseIsOver) stopAutoScroll();
  }
  function pointerUp() {
    if (!mouseIsOver) startAutoScrollOnSettle();
  }
  function mouseEnter() {
    mouseIsOver = true;
    stopAutoScroll();
  }
  function mouseLeave() {
    mouseIsOver = false;
    startAutoScroll();
  }
  function settle() {
    emblaApi.off('settle', settle);
    startAutoScroll();
  }
  function startAutoScrollOnSettle() {
    emblaApi.on('settle', settle);
  }
  function play(startDelayOverride) {
    if (typeof startDelayOverride !== 'undefined') {
      startDelay = startDelayOverride;
    }
    startAutoScroll();
  }
  function stop() {
    if (autoScrollActive) stopAutoScroll();
  }
  function reset() {
    if (autoScrollActive) {
      stopAutoScroll();
      startAutoScrollOnSettle();
    }
  }
  function isPlaying() {
    return autoScrollActive;
  }
  const self = {
    name: 'autoScroll',
    options: userOptions,
    init,
    destroy,
    play,
    stop,
    reset,
    isPlaying
  };
  return self;
}
AutoScroll.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-auto-scroll.esm.js.map


//# sourceURL=webpack://liquid-starter/./node_modules/.pnpm/embla-carousel-auto-scroll@8.6.0_embla-carousel@8.6.0/node_modules/embla-carousel-auto-scroll/esm/embla-carousel-auto-scroll.esm.js?
;

/***/ }),

/***/ "./node_modules/.pnpm/embla-carousel@8.6.0/node_modules/embla-carousel/esm/embla-carousel.esm.js":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/.pnpm/embla-carousel@8.6.0/node_modules/embla-carousel/esm/embla-carousel.esm.js ***!
  \*******************************************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EmblaCarousel)
/* harmony export */ });
function isNumber(subject) {
  return typeof subject === 'number';
}
function isString(subject) {
  return typeof subject === 'string';
}
function isBoolean(subject) {
  return typeof subject === 'boolean';
}
function isObject(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function mathAbs(n) {
  return Math.abs(n);
}
function mathSign(n) {
  return Math.sign(n);
}
function deltaAbs(valueB, valueA) {
  return mathAbs(valueB - valueA);
}
function factorAbs(valueB, valueA) {
  if (valueB === 0 || valueA === 0) return 0;
  if (mathAbs(valueB) <= mathAbs(valueA)) return 0;
  const diff = deltaAbs(mathAbs(valueB), mathAbs(valueA));
  return mathAbs(diff / valueB);
}
function roundToTwoDecimals(num) {
  return Math.round(num * 100) / 100;
}
function arrayKeys(array) {
  return objectKeys(array).map(Number);
}
function arrayLast(array) {
  return array[arrayLastIndex(array)];
}
function arrayLastIndex(array) {
  return Math.max(0, array.length - 1);
}
function arrayIsLastIndex(array, index) {
  return index === arrayLastIndex(array);
}
function arrayFromNumber(n, startAt = 0) {
  return Array.from(Array(n), (_, i) => startAt + i);
}
function objectKeys(object) {
  return Object.keys(object);
}
function objectsMergeDeep(objectA, objectB) {
  return [objectA, objectB].reduce((mergedObjects, currentObject) => {
    objectKeys(currentObject).forEach(key => {
      const valueA = mergedObjects[key];
      const valueB = currentObject[key];
      const areObjects = isObject(valueA) && isObject(valueB);
      mergedObjects[key] = areObjects ? objectsMergeDeep(valueA, valueB) : valueB;
    });
    return mergedObjects;
  }, {});
}
function isMouseEvent(evt, ownerWindow) {
  return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}

function Alignment(align, viewSize) {
  const predefined = {
    start,
    center,
    end
  };
  function start() {
    return 0;
  }
  function center(n) {
    return end(n) / 2;
  }
  function end(n) {
    return viewSize - n;
  }
  function measure(n, index) {
    if (isString(align)) return predefined[align](n);
    return align(viewSize, n, index);
  }
  const self = {
    measure
  };
  return self;
}

function EventStore() {
  let listeners = [];
  function add(node, type, handler, options = {
    passive: true
  }) {
    let removeListener;
    if ('addEventListener' in node) {
      node.addEventListener(type, handler, options);
      removeListener = () => node.removeEventListener(type, handler, options);
    } else {
      const legacyMediaQueryList = node;
      legacyMediaQueryList.addListener(handler);
      removeListener = () => legacyMediaQueryList.removeListener(handler);
    }
    listeners.push(removeListener);
    return self;
  }
  function clear() {
    listeners = listeners.filter(remove => remove());
  }
  const self = {
    add,
    clear
  };
  return self;
}

function Animations(ownerDocument, ownerWindow, update, render) {
  const documentVisibleHandler = EventStore();
  const fixedTimeStep = 1000 / 60;
  let lastTimeStamp = null;
  let accumulatedTime = 0;
  let animationId = 0;
  function init() {
    documentVisibleHandler.add(ownerDocument, 'visibilitychange', () => {
      if (ownerDocument.hidden) reset();
    });
  }
  function destroy() {
    stop();
    documentVisibleHandler.clear();
  }
  function animate(timeStamp) {
    if (!animationId) return;
    if (!lastTimeStamp) {
      lastTimeStamp = timeStamp;
      update();
      update();
    }
    const timeElapsed = timeStamp - lastTimeStamp;
    lastTimeStamp = timeStamp;
    accumulatedTime += timeElapsed;
    while (accumulatedTime >= fixedTimeStep) {
      update();
      accumulatedTime -= fixedTimeStep;
    }
    const alpha = accumulatedTime / fixedTimeStep;
    render(alpha);
    if (animationId) {
      animationId = ownerWindow.requestAnimationFrame(animate);
    }
  }
  function start() {
    if (animationId) return;
    animationId = ownerWindow.requestAnimationFrame(animate);
  }
  function stop() {
    ownerWindow.cancelAnimationFrame(animationId);
    lastTimeStamp = null;
    accumulatedTime = 0;
    animationId = 0;
  }
  function reset() {
    lastTimeStamp = null;
    accumulatedTime = 0;
  }
  const self = {
    init,
    destroy,
    start,
    stop,
    update,
    render
  };
  return self;
}

function Axis(axis, contentDirection) {
  const isRightToLeft = contentDirection === 'rtl';
  const isVertical = axis === 'y';
  const scroll = isVertical ? 'y' : 'x';
  const cross = isVertical ? 'x' : 'y';
  const sign = !isVertical && isRightToLeft ? -1 : 1;
  const startEdge = getStartEdge();
  const endEdge = getEndEdge();
  function measureSize(nodeRect) {
    const {
      height,
      width
    } = nodeRect;
    return isVertical ? height : width;
  }
  function getStartEdge() {
    if (isVertical) return 'top';
    return isRightToLeft ? 'right' : 'left';
  }
  function getEndEdge() {
    if (isVertical) return 'bottom';
    return isRightToLeft ? 'left' : 'right';
  }
  function direction(n) {
    return n * sign;
  }
  const self = {
    scroll,
    cross,
    startEdge,
    endEdge,
    measureSize,
    direction
  };
  return self;
}

function Limit(min = 0, max = 0) {
  const length = mathAbs(min - max);
  function reachedMin(n) {
    return n < min;
  }
  function reachedMax(n) {
    return n > max;
  }
  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }
  function constrain(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? min : max;
  }
  function removeOffset(n) {
    if (!length) return n;
    return n - length * Math.ceil((n - max) / length);
  }
  const self = {
    length,
    max,
    min,
    constrain,
    reachedAny,
    reachedMax,
    reachedMin,
    removeOffset
  };
  return self;
}

function Counter(max, start, loop) {
  const {
    constrain
  } = Limit(0, max);
  const loopEnd = max + 1;
  let counter = withinLimit(start);
  function withinLimit(n) {
    return !loop ? constrain(n) : mathAbs((loopEnd + n) % loopEnd);
  }
  function get() {
    return counter;
  }
  function set(n) {
    counter = withinLimit(n);
    return self;
  }
  function add(n) {
    return clone().set(get() + n);
  }
  function clone() {
    return Counter(max, get(), loop);
  }
  const self = {
    get,
    set,
    add,
    clone
  };
  return self;
}

function DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
  const {
    cross: crossAxis,
    direction
  } = axis;
  const focusNodes = ['INPUT', 'SELECT', 'TEXTAREA'];
  const nonPassiveEvent = {
    passive: false
  };
  const initEvents = EventStore();
  const dragEvents = EventStore();
  const goToNextThreshold = Limit(50, 225).constrain(percentOfView.measure(20));
  const snapForceBoost = {
    mouse: 300,
    touch: 400
  };
  const freeForceBoost = {
    mouse: 500,
    touch: 600
  };
  const baseSpeed = dragFree ? 43 : 25;
  let isMoving = false;
  let startScroll = 0;
  let startCross = 0;
  let pointerIsDown = false;
  let preventScroll = false;
  let preventClick = false;
  let isMouse = false;
  function init(emblaApi) {
    if (!watchDrag) return;
    function downIfAllowed(evt) {
      if (isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
    }
    const node = rootNode;
    initEvents.add(node, 'dragstart', evt => evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', () => undefined, nonPassiveEvent).add(node, 'touchend', () => undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
  }
  function destroy() {
    initEvents.clear();
    dragEvents.clear();
  }
  function addDragEvents() {
    const node = isMouse ? ownerDocument : rootNode;
    dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
  }
  function isFocusNode(node) {
    const nodeName = node.nodeName || '';
    return focusNodes.includes(nodeName);
  }
  function forceBoost() {
    const boost = dragFree ? freeForceBoost : snapForceBoost;
    const type = isMouse ? 'mouse' : 'touch';
    return boost[type];
  }
  function allowedForce(force, targetChanged) {
    const next = index.add(mathSign(force) * -1);
    const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
    if (dragFree || mathAbs(force) < goToNextThreshold) return baseForce;
    if (skipSnaps && targetChanged) return baseForce * 0.5;
    return scrollTarget.byIndex(next.get(), 0).distance;
  }
  function down(evt) {
    const isMouseEvt = isMouseEvent(evt, ownerWindow);
    isMouse = isMouseEvt;
    preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
    isMoving = deltaAbs(target.get(), location.get()) >= 2;
    if (isMouseEvt && evt.button !== 0) return;
    if (isFocusNode(evt.target)) return;
    pointerIsDown = true;
    dragTracker.pointerDown(evt);
    scrollBody.useFriction(0).useDuration(0);
    target.set(location);
    addDragEvents();
    startScroll = dragTracker.readPoint(evt);
    startCross = dragTracker.readPoint(evt, crossAxis);
    eventHandler.emit('pointerDown');
  }
  function move(evt) {
    const isTouchEvt = !isMouseEvent(evt, ownerWindow);
    if (isTouchEvt && evt.touches.length >= 2) return up(evt);
    const lastScroll = dragTracker.readPoint(evt);
    const lastCross = dragTracker.readPoint(evt, crossAxis);
    const diffScroll = deltaAbs(lastScroll, startScroll);
    const diffCross = deltaAbs(lastCross, startCross);
    if (!preventScroll && !isMouse) {
      if (!evt.cancelable) return up(evt);
      preventScroll = diffScroll > diffCross;
      if (!preventScroll) return up(evt);
    }
    const diff = dragTracker.pointerMove(evt);
    if (diffScroll > dragThreshold) preventClick = true;
    scrollBody.useFriction(0.3).useDuration(0.75);
    animation.start();
    target.add(direction(diff));
    evt.preventDefault();
  }
  function up(evt) {
    const currentLocation = scrollTarget.byDistance(0, false);
    const targetChanged = currentLocation.index !== index.get();
    const rawForce = dragTracker.pointerUp(evt) * forceBoost();
    const force = allowedForce(direction(rawForce), targetChanged);
    const forceFactor = factorAbs(rawForce, force);
    const speed = baseSpeed - 10 * forceFactor;
    const friction = baseFriction + forceFactor / 50;
    preventScroll = false;
    pointerIsDown = false;
    dragEvents.clear();
    scrollBody.useDuration(speed).useFriction(friction);
    scrollTo.distance(force, !dragFree);
    isMouse = false;
    eventHandler.emit('pointerUp');
  }
  function click(evt) {
    if (preventClick) {
      evt.stopPropagation();
      evt.preventDefault();
      preventClick = false;
    }
  }
  function pointerDown() {
    return pointerIsDown;
  }
  const self = {
    init,
    destroy,
    pointerDown
  };
  return self;
}

function DragTracker(axis, ownerWindow) {
  const logInterval = 170;
  let startEvent;
  let lastEvent;
  function readTime(evt) {
    return evt.timeStamp;
  }
  function readPoint(evt, evtAxis) {
    const property = evtAxis || axis.scroll;
    const coord = `client${property === 'x' ? 'X' : 'Y'}`;
    return (isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
  }
  function pointerDown(evt) {
    startEvent = evt;
    lastEvent = evt;
    return readPoint(evt);
  }
  function pointerMove(evt) {
    const diff = readPoint(evt) - readPoint(lastEvent);
    const expired = readTime(evt) - readTime(startEvent) > logInterval;
    lastEvent = evt;
    if (expired) startEvent = evt;
    return diff;
  }
  function pointerUp(evt) {
    if (!startEvent || !lastEvent) return 0;
    const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
    const diffTime = readTime(evt) - readTime(startEvent);
    const expired = readTime(evt) - readTime(lastEvent) > logInterval;
    const force = diffDrag / diffTime;
    const isFlick = diffTime && !expired && mathAbs(force) > 0.1;
    return isFlick ? force : 0;
  }
  const self = {
    pointerDown,
    pointerMove,
    pointerUp,
    readPoint
  };
  return self;
}

function NodeRects() {
  function measure(node) {
    const {
      offsetTop,
      offsetLeft,
      offsetWidth,
      offsetHeight
    } = node;
    const offset = {
      top: offsetTop,
      right: offsetLeft + offsetWidth,
      bottom: offsetTop + offsetHeight,
      left: offsetLeft,
      width: offsetWidth,
      height: offsetHeight
    };
    return offset;
  }
  const self = {
    measure
  };
  return self;
}

function PercentOfView(viewSize) {
  function measure(n) {
    return viewSize * (n / 100);
  }
  const self = {
    measure
  };
  return self;
}

function ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
  const observeNodes = [container].concat(slides);
  let resizeObserver;
  let containerSize;
  let slideSizes = [];
  let destroyed = false;
  function readSize(node) {
    return axis.measureSize(nodeRects.measure(node));
  }
  function init(emblaApi) {
    if (!watchResize) return;
    containerSize = readSize(container);
    slideSizes = slides.map(readSize);
    function defaultCallback(entries) {
      for (const entry of entries) {
        if (destroyed) return;
        const isContainer = entry.target === container;
        const slideIndex = slides.indexOf(entry.target);
        const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
        const newSize = readSize(isContainer ? container : slides[slideIndex]);
        const diffSize = mathAbs(newSize - lastSize);
        if (diffSize >= 0.5) {
          emblaApi.reInit();
          eventHandler.emit('resize');
          break;
        }
      }
    }
    resizeObserver = new ResizeObserver(entries => {
      if (isBoolean(watchResize) || watchResize(emblaApi, entries)) {
        defaultCallback(entries);
      }
    });
    ownerWindow.requestAnimationFrame(() => {
      observeNodes.forEach(node => resizeObserver.observe(node));
    });
  }
  function destroy() {
    destroyed = true;
    if (resizeObserver) resizeObserver.disconnect();
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
  let scrollVelocity = 0;
  let scrollDirection = 0;
  let scrollDuration = baseDuration;
  let scrollFriction = baseFriction;
  let rawLocation = location.get();
  let rawLocationPrevious = 0;
  function seek() {
    const displacement = target.get() - location.get();
    const isInstant = !scrollDuration;
    let scrollDistance = 0;
    if (isInstant) {
      scrollVelocity = 0;
      previousLocation.set(target);
      location.set(target);
      scrollDistance = displacement;
    } else {
      previousLocation.set(location);
      scrollVelocity += displacement / scrollDuration;
      scrollVelocity *= scrollFriction;
      rawLocation += scrollVelocity;
      location.add(scrollVelocity);
      scrollDistance = rawLocation - rawLocationPrevious;
    }
    scrollDirection = mathSign(scrollDistance);
    rawLocationPrevious = rawLocation;
    return self;
  }
  function settled() {
    const diff = target.get() - offsetLocation.get();
    return mathAbs(diff) < 0.001;
  }
  function duration() {
    return scrollDuration;
  }
  function direction() {
    return scrollDirection;
  }
  function velocity() {
    return scrollVelocity;
  }
  function useBaseDuration() {
    return useDuration(baseDuration);
  }
  function useBaseFriction() {
    return useFriction(baseFriction);
  }
  function useDuration(n) {
    scrollDuration = n;
    return self;
  }
  function useFriction(n) {
    scrollFriction = n;
    return self;
  }
  const self = {
    direction,
    duration,
    velocity,
    seek,
    settled,
    useBaseFriction,
    useBaseDuration,
    useFriction,
    useDuration
  };
  return self;
}

function ScrollBounds(limit, location, target, scrollBody, percentOfView) {
  const pullBackThreshold = percentOfView.measure(10);
  const edgeOffsetTolerance = percentOfView.measure(50);
  const frictionLimit = Limit(0.1, 0.99);
  let disabled = false;
  function shouldConstrain() {
    if (disabled) return false;
    if (!limit.reachedAny(target.get())) return false;
    if (!limit.reachedAny(location.get())) return false;
    return true;
  }
  function constrain(pointerDown) {
    if (!shouldConstrain()) return;
    const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
    const diffToEdge = mathAbs(limit[edge] - location.get());
    const diffToTarget = target.get() - location.get();
    const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
    target.subtract(diffToTarget * friction);
    if (!pointerDown && mathAbs(diffToTarget) < pullBackThreshold) {
      target.set(limit.constrain(target.get()));
      scrollBody.useDuration(25).useBaseFriction();
    }
  }
  function toggleActive(active) {
    disabled = !active;
  }
  const self = {
    shouldConstrain,
    constrain,
    toggleActive
  };
  return self;
}

function ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
  const scrollBounds = Limit(-contentSize + viewSize, 0);
  const snapsBounded = measureBounded();
  const scrollContainLimit = findScrollContainLimit();
  const snapsContained = measureContained();
  function usePixelTolerance(bound, snap) {
    return deltaAbs(bound, snap) <= 1;
  }
  function findScrollContainLimit() {
    const startSnap = snapsBounded[0];
    const endSnap = arrayLast(snapsBounded);
    const min = snapsBounded.lastIndexOf(startSnap);
    const max = snapsBounded.indexOf(endSnap) + 1;
    return Limit(min, max);
  }
  function measureBounded() {
    return snapsAligned.map((snapAligned, index) => {
      const {
        min,
        max
      } = scrollBounds;
      const snap = scrollBounds.constrain(snapAligned);
      const isFirst = !index;
      const isLast = arrayIsLastIndex(snapsAligned, index);
      if (isFirst) return max;
      if (isLast) return min;
      if (usePixelTolerance(min, snap)) return min;
      if (usePixelTolerance(max, snap)) return max;
      return snap;
    }).map(scrollBound => parseFloat(scrollBound.toFixed(3)));
  }
  function measureContained() {
    if (contentSize <= viewSize + pixelTolerance) return [scrollBounds.max];
    if (containScroll === 'keepSnaps') return snapsBounded;
    const {
      min,
      max
    } = scrollContainLimit;
    return snapsBounded.slice(min, max);
  }
  const self = {
    snapsContained,
    scrollContainLimit
  };
  return self;
}

function ScrollLimit(contentSize, scrollSnaps, loop) {
  const max = scrollSnaps[0];
  const min = loop ? max - contentSize : arrayLast(scrollSnaps);
  const limit = Limit(min, max);
  const self = {
    limit
  };
  return self;
}

function ScrollLooper(contentSize, limit, location, vectors) {
  const jointSafety = 0.1;
  const min = limit.min + jointSafety;
  const max = limit.max + jointSafety;
  const {
    reachedMin,
    reachedMax
  } = Limit(min, max);
  function shouldLoop(direction) {
    if (direction === 1) return reachedMax(location.get());
    if (direction === -1) return reachedMin(location.get());
    return false;
  }
  function loop(direction) {
    if (!shouldLoop(direction)) return;
    const loopDistance = contentSize * (direction * -1);
    vectors.forEach(v => v.add(loopDistance));
  }
  const self = {
    loop
  };
  return self;
}

function ScrollProgress(limit) {
  const {
    max,
    length
  } = limit;
  function get(n) {
    const currentLocation = n - max;
    return length ? currentLocation / -length : 0;
  }
  const self = {
    get
  };
  return self;
}

function ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
  const {
    startEdge,
    endEdge
  } = axis;
  const {
    groupSlides
  } = slidesToScroll;
  const alignments = measureSizes().map(alignment.measure);
  const snaps = measureUnaligned();
  const snapsAligned = measureAligned();
  function measureSizes() {
    return groupSlides(slideRects).map(rects => arrayLast(rects)[endEdge] - rects[0][startEdge]).map(mathAbs);
  }
  function measureUnaligned() {
    return slideRects.map(rect => containerRect[startEdge] - rect[startEdge]).map(snap => -mathAbs(snap));
  }
  function measureAligned() {
    return groupSlides(snaps).map(g => g[0]).map((snap, index) => snap + alignments[index]);
  }
  const self = {
    snaps,
    snapsAligned
  };
  return self;
}

function SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
  const {
    groupSlides
  } = slidesToScroll;
  const {
    min,
    max
  } = scrollContainLimit;
  const slideRegistry = createSlideRegistry();
  function createSlideRegistry() {
    const groupedSlideIndexes = groupSlides(slideIndexes);
    const doNotContain = !containSnaps || containScroll === 'keepSnaps';
    if (scrollSnaps.length === 1) return [slideIndexes];
    if (doNotContain) return groupedSlideIndexes;
    return groupedSlideIndexes.slice(min, max).map((group, index, groups) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(groups, index);
      if (isFirst) {
        const range = arrayLast(groups[0]) + 1;
        return arrayFromNumber(range);
      }
      if (isLast) {
        const range = arrayLastIndex(slideIndexes) - arrayLast(groups)[0] + 1;
        return arrayFromNumber(range, arrayLast(groups)[0]);
      }
      return group;
    });
  }
  const self = {
    slideRegistry
  };
  return self;
}

function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
  const {
    reachedAny,
    removeOffset,
    constrain
  } = limit;
  function minDistance(distances) {
    return distances.concat().sort((a, b) => mathAbs(a) - mathAbs(b))[0];
  }
  function findTargetSnap(target) {
    const distance = loop ? removeOffset(target) : constrain(target);
    const ascDiffsToSnaps = scrollSnaps.map((snap, index) => ({
      diff: shortcut(snap - distance, 0),
      index
    })).sort((d1, d2) => mathAbs(d1.diff) - mathAbs(d2.diff));
    const {
      index
    } = ascDiffsToSnaps[0];
    return {
      index,
      distance
    };
  }
  function shortcut(target, direction) {
    const targets = [target, target + contentSize, target - contentSize];
    if (!loop) return target;
    if (!direction) return minDistance(targets);
    const matchingTargets = targets.filter(t => mathSign(t) === direction);
    if (matchingTargets.length) return minDistance(matchingTargets);
    return arrayLast(targets) - contentSize;
  }
  function byIndex(index, direction) {
    const diffToSnap = scrollSnaps[index] - targetVector.get();
    const distance = shortcut(diffToSnap, direction);
    return {
      index,
      distance
    };
  }
  function byDistance(distance, snap) {
    const target = targetVector.get() + distance;
    const {
      index,
      distance: targetSnapDistance
    } = findTargetSnap(target);
    const reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound) return {
      index,
      distance
    };
    const diffToSnap = scrollSnaps[index] - targetSnapDistance;
    const snapDistance = distance + shortcut(diffToSnap, 0);
    return {
      index,
      distance: snapDistance
    };
  }
  const self = {
    byDistance,
    byIndex,
    shortcut
  };
  return self;
}

function ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
  function scrollTo(target) {
    const distanceDiff = target.distance;
    const indexDiff = target.index !== indexCurrent.get();
    targetVector.add(distanceDiff);
    if (distanceDiff) {
      if (scrollBody.duration()) {
        animation.start();
      } else {
        animation.update();
        animation.render(1);
        animation.update();
      }
    }
    if (indexDiff) {
      indexPrevious.set(indexCurrent.get());
      indexCurrent.set(target.index);
      eventHandler.emit('select');
    }
  }
  function distance(n, snap) {
    const target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }
  function index(n, direction) {
    const targetIndex = indexCurrent.clone().set(n);
    const target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }
  const self = {
    distance,
    index
  };
  return self;
}

function SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
  const focusListenerOptions = {
    passive: true,
    capture: true
  };
  let lastTabPressTime = 0;
  function init(emblaApi) {
    if (!watchFocus) return;
    function defaultCallback(index) {
      const nowTime = new Date().getTime();
      const diffTime = nowTime - lastTabPressTime;
      if (diffTime > 10) return;
      eventHandler.emit('slideFocusStart');
      root.scrollLeft = 0;
      const group = slideRegistry.findIndex(group => group.includes(index));
      if (!isNumber(group)) return;
      scrollBody.useDuration(0);
      scrollTo.index(group, 0);
      eventHandler.emit('slideFocus');
    }
    eventStore.add(document, 'keydown', registerTabPress, false);
    slides.forEach((slide, slideIndex) => {
      eventStore.add(slide, 'focus', evt => {
        if (isBoolean(watchFocus) || watchFocus(emblaApi, evt)) {
          defaultCallback(slideIndex);
        }
      }, focusListenerOptions);
    });
  }
  function registerTabPress(event) {
    if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
  }
  const self = {
    init
  };
  return self;
}

function Vector1D(initialValue) {
  let value = initialValue;
  function get() {
    return value;
  }
  function set(n) {
    value = normalizeInput(n);
  }
  function add(n) {
    value += normalizeInput(n);
  }
  function subtract(n) {
    value -= normalizeInput(n);
  }
  function normalizeInput(n) {
    return isNumber(n) ? n : n.get();
  }
  const self = {
    get,
    set,
    add,
    subtract
  };
  return self;
}

function Translate(axis, container) {
  const translate = axis.scroll === 'x' ? x : y;
  const containerStyle = container.style;
  let previousTarget = null;
  let disabled = false;
  function x(n) {
    return `translate3d(${n}px,0px,0px)`;
  }
  function y(n) {
    return `translate3d(0px,${n}px,0px)`;
  }
  function to(target) {
    if (disabled) return;
    const newTarget = roundToTwoDecimals(axis.direction(target));
    if (newTarget === previousTarget) return;
    containerStyle.transform = translate(newTarget);
    previousTarget = newTarget;
  }
  function toggleActive(active) {
    disabled = !active;
  }
  function clear() {
    if (disabled) return;
    containerStyle.transform = '';
    if (!container.getAttribute('style')) container.removeAttribute('style');
  }
  const self = {
    clear,
    to,
    toggleActive
  };
  return self;
}

function SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
  const roundingSafety = 0.5;
  const ascItems = arrayKeys(slideSizesWithGaps);
  const descItems = arrayKeys(slideSizesWithGaps).reverse();
  const loopPoints = startPoints().concat(endPoints());
  function removeSlideSizes(indexes, from) {
    return indexes.reduce((a, i) => {
      return a - slideSizesWithGaps[i];
    }, from);
  }
  function slidesInGap(indexes, gap) {
    return indexes.reduce((a, i) => {
      const remainingGap = removeSlideSizes(a, gap);
      return remainingGap > 0 ? a.concat([i]) : a;
    }, []);
  }
  function findSlideBounds(offset) {
    return snaps.map((snap, index) => ({
      start: snap - slideSizes[index] + roundingSafety + offset,
      end: snap + viewSize - roundingSafety + offset
    }));
  }
  function findLoopPoints(indexes, offset, isEndEdge) {
    const slideBounds = findSlideBounds(offset);
    return indexes.map(index => {
      const initial = isEndEdge ? 0 : -contentSize;
      const altered = isEndEdge ? contentSize : 0;
      const boundEdge = isEndEdge ? 'end' : 'start';
      const loopPoint = slideBounds[index][boundEdge];
      return {
        index,
        loopPoint,
        slideLocation: Vector1D(-1),
        translate: Translate(axis, slides[index]),
        target: () => location.get() > loopPoint ? initial : altered
      };
    });
  }
  function startPoints() {
    const gap = scrollSnaps[0];
    const indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, contentSize, false);
  }
  function endPoints() {
    const gap = viewSize - scrollSnaps[0] - 1;
    const indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, -contentSize, true);
  }
  function canLoop() {
    return loopPoints.every(({
      index
    }) => {
      const otherIndexes = ascItems.filter(i => i !== index);
      return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
    });
  }
  function loop() {
    loopPoints.forEach(loopPoint => {
      const {
        target,
        translate,
        slideLocation
      } = loopPoint;
      const shiftLocation = target();
      if (shiftLocation === slideLocation.get()) return;
      translate.to(shiftLocation);
      slideLocation.set(shiftLocation);
    });
  }
  function clear() {
    loopPoints.forEach(loopPoint => loopPoint.translate.clear());
  }
  const self = {
    canLoop,
    clear,
    loop,
    loopPoints
  };
  return self;
}

function SlidesHandler(container, eventHandler, watchSlides) {
  let mutationObserver;
  let destroyed = false;
  function init(emblaApi) {
    if (!watchSlides) return;
    function defaultCallback(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          emblaApi.reInit();
          eventHandler.emit('slidesChanged');
          break;
        }
      }
    }
    mutationObserver = new MutationObserver(mutations => {
      if (destroyed) return;
      if (isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) {
        defaultCallback(mutations);
      }
    });
    mutationObserver.observe(container, {
      childList: true
    });
  }
  function destroy() {
    if (mutationObserver) mutationObserver.disconnect();
    destroyed = true;
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function SlidesInView(container, slides, eventHandler, threshold) {
  const intersectionEntryMap = {};
  let inViewCache = null;
  let notInViewCache = null;
  let intersectionObserver;
  let destroyed = false;
  function init() {
    intersectionObserver = new IntersectionObserver(entries => {
      if (destroyed) return;
      entries.forEach(entry => {
        const index = slides.indexOf(entry.target);
        intersectionEntryMap[index] = entry;
      });
      inViewCache = null;
      notInViewCache = null;
      eventHandler.emit('slidesInView');
    }, {
      root: container.parentElement,
      threshold
    });
    slides.forEach(slide => intersectionObserver.observe(slide));
  }
  function destroy() {
    if (intersectionObserver) intersectionObserver.disconnect();
    destroyed = true;
  }
  function createInViewList(inView) {
    return objectKeys(intersectionEntryMap).reduce((list, slideIndex) => {
      const index = parseInt(slideIndex);
      const {
        isIntersecting
      } = intersectionEntryMap[index];
      const inViewMatch = inView && isIntersecting;
      const notInViewMatch = !inView && !isIntersecting;
      if (inViewMatch || notInViewMatch) list.push(index);
      return list;
    }, []);
  }
  function get(inView = true) {
    if (inView && inViewCache) return inViewCache;
    if (!inView && notInViewCache) return notInViewCache;
    const slideIndexes = createInViewList(inView);
    if (inView) inViewCache = slideIndexes;
    if (!inView) notInViewCache = slideIndexes;
    return slideIndexes;
  }
  const self = {
    init,
    destroy,
    get
  };
  return self;
}

function SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
  const {
    measureSize,
    startEdge,
    endEdge
  } = axis;
  const withEdgeGap = slideRects[0] && readEdgeGap;
  const startGap = measureStartGap();
  const endGap = measureEndGap();
  const slideSizes = slideRects.map(measureSize);
  const slideSizesWithGaps = measureWithGaps();
  function measureStartGap() {
    if (!withEdgeGap) return 0;
    const slideRect = slideRects[0];
    return mathAbs(containerRect[startEdge] - slideRect[startEdge]);
  }
  function measureEndGap() {
    if (!withEdgeGap) return 0;
    const style = ownerWindow.getComputedStyle(arrayLast(slides));
    return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
  }
  function measureWithGaps() {
    return slideRects.map((rect, index, rects) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(rects, index);
      if (isFirst) return slideSizes[index] + startGap;
      if (isLast) return slideSizes[index] + endGap;
      return rects[index + 1][startEdge] - rect[startEdge];
    }).map(mathAbs);
  }
  const self = {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  };
  return self;
}

function SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
  const {
    startEdge,
    endEdge,
    direction
  } = axis;
  const groupByNumber = isNumber(slidesToScroll);
  function byNumber(array, groupSize) {
    return arrayKeys(array).filter(i => i % groupSize === 0).map(i => array.slice(i, i + groupSize));
  }
  function bySize(array) {
    if (!array.length) return [];
    return arrayKeys(array).reduce((groups, rectB, index) => {
      const rectA = arrayLast(groups) || 0;
      const isFirst = rectA === 0;
      const isLast = rectB === arrayLastIndex(array);
      const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
      const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
      const gapA = !loop && isFirst ? direction(startGap) : 0;
      const gapB = !loop && isLast ? direction(endGap) : 0;
      const chunkSize = mathAbs(edgeB - gapB - (edgeA + gapA));
      if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
      if (isLast) groups.push(array.length);
      return groups;
    }, []).map((currentSize, index, groups) => {
      const previousSize = Math.max(groups[index - 1] || 0);
      return array.slice(previousSize, currentSize);
    });
  }
  function groupSlides(array) {
    return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
  }
  const self = {
    groupSlides
  };
  return self;
}

function Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
  // Options
  const {
    align,
    axis: scrollAxis,
    direction,
    startIndex,
    loop,
    duration,
    dragFree,
    dragThreshold,
    inViewThreshold,
    slidesToScroll: groupSlides,
    skipSnaps,
    containScroll,
    watchResize,
    watchSlides,
    watchDrag,
    watchFocus
  } = options;
  // Measurements
  const pixelTolerance = 2;
  const nodeRects = NodeRects();
  const containerRect = nodeRects.measure(container);
  const slideRects = slides.map(nodeRects.measure);
  const axis = Axis(scrollAxis, direction);
  const viewSize = axis.measureSize(containerRect);
  const percentOfView = PercentOfView(viewSize);
  const alignment = Alignment(align, viewSize);
  const containSnaps = !loop && !!containScroll;
  const readEdgeGap = loop || !!containScroll;
  const {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  } = SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
  const slidesToScroll = SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
  const {
    snaps,
    snapsAligned
  } = ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
  const contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps);
  const {
    snapsContained,
    scrollContainLimit
  } = ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
  const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
  const {
    limit
  } = ScrollLimit(contentSize, scrollSnaps, loop);
  // Indexes
  const index = Counter(arrayLastIndex(scrollSnaps), startIndex, loop);
  const indexPrevious = index.clone();
  const slideIndexes = arrayKeys(slides);
  // Animation
  const update = ({
    dragHandler,
    scrollBody,
    scrollBounds,
    options: {
      loop
    }
  }) => {
    if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
    scrollBody.seek();
  };
  const render = ({
    scrollBody,
    translate,
    location,
    offsetLocation,
    previousLocation,
    scrollLooper,
    slideLooper,
    dragHandler,
    animation,
    eventHandler,
    scrollBounds,
    options: {
      loop
    }
  }, alpha) => {
    const shouldSettle = scrollBody.settled();
    const withinBounds = !scrollBounds.shouldConstrain();
    const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
    const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
    if (hasSettledAndIdle) animation.stop();
    const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
    offsetLocation.set(interpolatedLocation);
    if (loop) {
      scrollLooper.loop(scrollBody.direction());
      slideLooper.loop();
    }
    translate.to(offsetLocation.get());
    if (hasSettledAndIdle) eventHandler.emit('settle');
    if (!hasSettled) eventHandler.emit('scroll');
  };
  const animation = Animations(ownerDocument, ownerWindow, () => update(engine), alpha => render(engine, alpha));
  // Shared
  const friction = 0.68;
  const startLocation = scrollSnaps[index.get()];
  const location = Vector1D(startLocation);
  const previousLocation = Vector1D(startLocation);
  const offsetLocation = Vector1D(startLocation);
  const target = Vector1D(startLocation);
  const scrollBody = ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
  const scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
  const scrollTo = ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
  const scrollProgress = ScrollProgress(limit);
  const eventStore = EventStore();
  const slidesInView = SlidesInView(container, slides, eventHandler, inViewThreshold);
  const {
    slideRegistry
  } = SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
  const slideFocus = SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
  // Engine
  const engine = {
    ownerDocument,
    ownerWindow,
    eventHandler,
    containerRect,
    slideRects,
    animation,
    axis,
    dragHandler: DragHandler(axis, root, ownerDocument, ownerWindow, target, DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
    eventStore,
    percentOfView,
    index,
    indexPrevious,
    limit,
    location,
    offsetLocation,
    previousLocation,
    options,
    resizeHandler: ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
    scrollBody,
    scrollBounds: ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
    scrollLooper: ScrollLooper(contentSize, limit, offsetLocation, [location, offsetLocation, previousLocation, target]),
    scrollProgress,
    scrollSnapList: scrollSnaps.map(scrollProgress.get),
    scrollSnaps,
    scrollTarget,
    scrollTo,
    slideLooper: SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
    slideFocus,
    slidesHandler: SlidesHandler(container, eventHandler, watchSlides),
    slidesInView,
    slideIndexes,
    slideRegistry,
    slidesToScroll,
    target,
    translate: Translate(axis, container)
  };
  return engine;
}

function EventHandler() {
  let listeners = {};
  let api;
  function init(emblaApi) {
    api = emblaApi;
  }
  function getListeners(evt) {
    return listeners[evt] || [];
  }
  function emit(evt) {
    getListeners(evt).forEach(e => e(api, evt));
    return self;
  }
  function on(evt, cb) {
    listeners[evt] = getListeners(evt).concat([cb]);
    return self;
  }
  function off(evt, cb) {
    listeners[evt] = getListeners(evt).filter(e => e !== cb);
    return self;
  }
  function clear() {
    listeners = {};
  }
  const self = {
    init,
    emit,
    off,
    on,
    clear
  };
  return self;
}

const defaultOptions = {
  align: 'center',
  axis: 'x',
  container: null,
  slides: null,
  containScroll: 'trimSnaps',
  direction: 'ltr',
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: false,
  dragThreshold: 10,
  loop: false,
  skipSnaps: false,
  duration: 25,
  startIndex: 0,
  active: true,
  watchDrag: true,
  watchResize: true,
  watchSlides: true,
  watchFocus: true
};

function OptionsHandler(ownerWindow) {
  function mergeOptions(optionsA, optionsB) {
    return objectsMergeDeep(optionsA, optionsB || {});
  }
  function optionsAtMedia(options) {
    const optionsAtMedia = options.breakpoints || {};
    const matchedMediaOptions = objectKeys(optionsAtMedia).filter(media => ownerWindow.matchMedia(media).matches).map(media => optionsAtMedia[media]).reduce((a, mediaOption) => mergeOptions(a, mediaOption), {});
    return mergeOptions(options, matchedMediaOptions);
  }
  function optionsMediaQueries(optionsList) {
    return optionsList.map(options => objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries) => acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
  }
  const self = {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  };
  return self;
}

function PluginsHandler(optionsHandler) {
  let activePlugins = [];
  function init(emblaApi, plugins) {
    activePlugins = plugins.filter(({
      options
    }) => optionsHandler.optionsAtMedia(options).active !== false);
    activePlugins.forEach(plugin => plugin.init(emblaApi, optionsHandler));
    return plugins.reduce((map, plugin) => Object.assign(map, {
      [plugin.name]: plugin
    }), {});
  }
  function destroy() {
    activePlugins = activePlugins.filter(plugin => plugin.destroy());
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function EmblaCarousel(root, userOptions, userPlugins) {
  const ownerDocument = root.ownerDocument;
  const ownerWindow = ownerDocument.defaultView;
  const optionsHandler = OptionsHandler(ownerWindow);
  const pluginsHandler = PluginsHandler(optionsHandler);
  const mediaHandlers = EventStore();
  const eventHandler = EventHandler();
  const {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  } = optionsHandler;
  const {
    on,
    off,
    emit
  } = eventHandler;
  const reInit = reActivate;
  let destroyed = false;
  let engine;
  let optionsBase = mergeOptions(defaultOptions, EmblaCarousel.globalOptions);
  let options = mergeOptions(optionsBase);
  let pluginList = [];
  let pluginApis;
  let container;
  let slides;
  function storeElements() {
    const {
      container: userContainer,
      slides: userSlides
    } = options;
    const customContainer = isString(userContainer) ? root.querySelector(userContainer) : userContainer;
    container = customContainer || root.children[0];
    const customSlides = isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
    slides = [].slice.call(customSlides || container.children);
  }
  function createEngine(options) {
    const engine = Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
    if (options.loop && !engine.slideLooper.canLoop()) {
      const optionsWithoutLoop = Object.assign({}, options, {
        loop: false
      });
      return createEngine(optionsWithoutLoop);
    }
    return engine;
  }
  function activate(withOptions, withPlugins) {
    if (destroyed) return;
    optionsBase = mergeOptions(optionsBase, withOptions);
    options = optionsAtMedia(optionsBase);
    pluginList = withPlugins || pluginList;
    storeElements();
    engine = createEngine(options);
    optionsMediaQueries([optionsBase, ...pluginList.map(({
      options
    }) => options)]).forEach(query => mediaHandlers.add(query, 'change', reActivate));
    if (!options.active) return;
    engine.translate.to(engine.location.get());
    engine.animation.init();
    engine.slidesInView.init();
    engine.slideFocus.init(self);
    engine.eventHandler.init(self);
    engine.resizeHandler.init(self);
    engine.slidesHandler.init(self);
    if (engine.options.loop) engine.slideLooper.loop();
    if (container.offsetParent && slides.length) engine.dragHandler.init(self);
    pluginApis = pluginsHandler.init(self, pluginList);
  }
  function reActivate(withOptions, withPlugins) {
    const startIndex = selectedScrollSnap();
    deActivate();
    activate(mergeOptions({
      startIndex
    }, withOptions), withPlugins);
    eventHandler.emit('reInit');
  }
  function deActivate() {
    engine.dragHandler.destroy();
    engine.eventStore.clear();
    engine.translate.clear();
    engine.slideLooper.clear();
    engine.resizeHandler.destroy();
    engine.slidesHandler.destroy();
    engine.slidesInView.destroy();
    engine.animation.destroy();
    pluginsHandler.destroy();
    mediaHandlers.clear();
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    mediaHandlers.clear();
    deActivate();
    eventHandler.emit('destroy');
    eventHandler.clear();
  }
  function scrollTo(index, jump, direction) {
    if (!options.active || destroyed) return;
    engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
    engine.scrollTo.index(index, direction || 0);
  }
  function scrollNext(jump) {
    const next = engine.index.add(1).get();
    scrollTo(next, jump, -1);
  }
  function scrollPrev(jump) {
    const prev = engine.index.add(-1).get();
    scrollTo(prev, jump, 1);
  }
  function canScrollNext() {
    const next = engine.index.add(1).get();
    return next !== selectedScrollSnap();
  }
  function canScrollPrev() {
    const prev = engine.index.add(-1).get();
    return prev !== selectedScrollSnap();
  }
  function scrollSnapList() {
    return engine.scrollSnapList;
  }
  function scrollProgress() {
    return engine.scrollProgress.get(engine.offsetLocation.get());
  }
  function selectedScrollSnap() {
    return engine.index.get();
  }
  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }
  function slidesInView() {
    return engine.slidesInView.get();
  }
  function slidesNotInView() {
    return engine.slidesInView.get(false);
  }
  function plugins() {
    return pluginApis;
  }
  function internalEngine() {
    return engine;
  }
  function rootNode() {
    return root;
  }
  function containerNode() {
    return container;
  }
  function slideNodes() {
    return slides;
  }
  const self = {
    canScrollNext,
    canScrollPrev,
    containerNode,
    internalEngine,
    destroy,
    off,
    on,
    emit,
    plugins,
    previousScrollSnap,
    reInit,
    rootNode,
    scrollNext,
    scrollPrev,
    scrollProgress,
    scrollSnapList,
    scrollTo,
    selectedScrollSnap,
    slideNodes,
    slidesInView,
    slidesNotInView
  };
  activate(userOptions, userPlugins);
  setTimeout(() => eventHandler.emit('init'), 0);
  return self;
}
EmblaCarousel.globalOptions = undefined;


//# sourceMappingURL=embla-carousel.esm.js.map


//# sourceURL=webpack://liquid-starter/./node_modules/.pnpm/embla-carousel@8.6.0/node_modules/embla-carousel/esm/embla-carousel.esm.js?
;

/***/ }),

/***/ "./node_modules/.pnpm/focus-trap@7.6.5/node_modules/focus-trap/dist/focus-trap.esm.js":
/*!********************************************************************************************!*\
  !*** ./node_modules/.pnpm/focus-trap@7.6.5/node_modules/focus-trap/dist/focus-trap.esm.js ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createFocusTrap: () => (/* binding */ createFocusTrap)
/* harmony export */ });
/* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tabbable */ "./node_modules/.pnpm/tabbable@6.2.0/node_modules/tabbable/dist/index.esm.js");
/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/


function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var activeFocusTraps = {
  activateTrap: function activateTrap(trapStack, trap) {
    if (trapStack.length > 0) {
      var activeTrap = trapStack[trapStack.length - 1];
      if (activeTrap !== trap) {
        activeTrap._setPausedState(true);
      }
    }
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex === -1) {
      trapStack.push(trap);
    } else {
      // move this existing trap to the front of the queue
      trapStack.splice(trapIndex, 1);
      trapStack.push(trap);
    }
  },
  deactivateTrap: function deactivateTrap(trapStack, trap) {
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex !== -1) {
      trapStack.splice(trapIndex, 1);
    }
    if (trapStack.length > 0 && !trapStack[trapStack.length - 1]._isManuallyPaused()) {
      trapStack[trapStack.length - 1]._setPausedState(false);
    }
  }
};
var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var isEscapeEvent = function isEscapeEvent(e) {
  return (e === null || e === void 0 ? void 0 : e.key) === 'Escape' || (e === null || e === void 0 ? void 0 : e.key) === 'Esc' || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var isTabEvent = function isTabEvent(e) {
  return (e === null || e === void 0 ? void 0 : e.key) === 'Tab' || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};

// checks for TAB by default
var isKeyForward = function isKeyForward(e) {
  return isTabEvent(e) && !e.shiftKey;
};

// checks for SHIFT+TAB by default
var isKeyBackward = function isKeyBackward(e) {
  return isTabEvent(e) && e.shiftKey;
};
var delay = function delay(fn) {
  return setTimeout(fn, 0);
};

/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */
var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var internalTrapStack = [];
var createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true,
    isKeyForward: isKeyForward,
    isKeyBackward: isKeyBackward
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list

    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    manuallyPaused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */
  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */
  var findContainerIndex = function findContainerIndex(element, event) {
    var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
        tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || (// fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };

  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @param {Object} options
   * @param {boolean} [options.hasFallback] True if the option could be a selector string
   *  and the option allows for a fallback scenario in the case where the selector is
   *  valid but does not match a node (i.e. the queried node doesn't exist in the DOM).
   * @param {Array} [options.params] Params to pass to the option if it's a function.
   * @returns {undefined | null | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `null` if the option didn't resolve
   *  to a node but `options.hasFallback=true`, `false` if the option resolved to `false`
   *  (node explicitly not given); otherwise, the resolved DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node, unless the option is a selector string and `options.hasFallback=true`.
   */
  var getNodeForOption = function getNodeForOption(optionName) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$hasFallback = _ref2.hasFallback,
      hasFallback = _ref2$hasFallback === void 0 ? false : _ref2$hasFallback,
      _ref2$params = _ref2.params,
      params = _ref2$params === void 0 ? [] : _ref2$params;
    var optionValue = config[optionName];
    if (typeof optionValue === 'function') {
      optionValue = optionValue.apply(void 0, _toConsumableArray(params));
    }
    if (optionValue === true) {
      optionValue = undefined; // use default value
    }
    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      }
      // else, empty string (invalid), null (invalid), 0 (invalid)

      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      try {
        node = doc.querySelector(optionValue); // resolve to node, or null if fails
      } catch (err) {
        throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""));
      }
      if (!node) {
        if (!hasFallback) {
          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        // else, `node` MUST be `null` because that's what `Document.querySelector()` returns
        //  if the selector is valid but doesn't match anything
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus', {
      hasFallback: true
    });

    // false explicitly indicates we want no initialFocus at all
    if (node === false) {
      return false;
    }
    if (node === undefined || node && !(0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isFocusable)(node, config.tabbableOptions)) {
      // option not specified nor focusable: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;

        // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    } else if (node === null) {
      // option is a VALID selector string that doesn't yield a node: use the `fallbackFocus`
      //  option instead of the default behavior when the option isn't specified at all
      node = getNodeForOption('fallbackFocus');
    }
    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.tabbable)(container, config.tabbableOptions);

      // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
      //  are focusable but not tabbable
      var focusableNodes = (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.focusable)(container, config.tabbableOptions);
      var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
      var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
      var firstDomTabbableNode = focusableNodes.find(function (node) {
        return (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(node);
      });
      var lastDomTabbableNode = focusableNodes.slice().reverse().find(function (node) {
        return (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(node);
      });
      var posTabIndexesFound = !!tabbableNodes.find(function (node) {
        return (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.getTabIndex)(node) > 0;
      });
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: posTabIndexesFound,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: firstTabbableNode,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: lastTabbableNode,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: firstDomTabbableNode,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: lastDomTabbableNode,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          var nodeIdx = tabbableNodes.indexOf(node);
          if (nodeIdx < 0) {
            // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
            //  since `node` should at least have been focusable, we assume that's the case and mimic
            //  what browsers do, which is set focus to the next node in __document position order__,
            //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
            //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
            //  basic DOM order
            if (forward) {
              return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function (el) {
                return (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(el);
              });
            }
            return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function (el) {
              return (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(el);
            });
          }
          return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    });

    // throw if no groups have tabbable nodes and we don't have a fallback focus node either
    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }

    // NOTE: Positive tabindexes are only properly supported in single-container traps because
    //  doing it across multiple containers where tabindexes could be all over the place
    //  would require Tabbable to support multiple containers, would require additional
    //  specialized Shadow DOM support, and would require Tabbable's multi-container support
    //  to look at those containers in document position order rather than user-provided
    //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
    //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
    if (state.containerGroups.find(function (g) {
      return g.posTabIndexesFound;
    }) && state.containerGroups.length > 1) {
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    }
  };

  /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/
  var _getActiveElement = function getActiveElement(el) {
    var activeElement = el.activeElement;
    if (!activeElement) {
      return;
    }
    if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) {
      return _getActiveElement(activeElement.shadowRoot);
    }
    return activeElement;
  };
  var _tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }
    if (node === _getActiveElement(document)) {
      return;
    }
    if (!node || !node.focus) {
      _tryFocus(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    // NOTE: focus() API does not trigger focusIn event so set MRU node manually
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', {
      params: [previousActiveElement]
    });
    return node ? node : node === false ? false : previousActiveElement;
  };

  /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */
  var findNextNavNode = function findNextNavNode(_ref3) {
    var target = _ref3.target,
      event = _ref3.event,
      _ref3$isBackward = _ref3.isBackward,
      isBackward = _ref3$isBackward === void 0 ? false : _ref3$isBackward;
    target = target || getActualTarget(event);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target, event);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back into...
        if (isBackward) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (isBackward) {
        // REVERSE

        // is the target the first tabbable node in a group?
        var startOfGroupIndex = state.tabbableGroups.findIndex(function (_ref4) {
          var firstTabbableNode = _ref4.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isFocusable)(target, config.tabbableOptions) && !(0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.getTabIndex)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
        } else if (!isTabEvent(event)) {
          // user must have customized the nav keys so we have to move focus manually _within_
          //  the active group: do this based on the order determined by tabbable()
          destinationNode = containerGroup.nextTabbableNode(target, false);
        }
      } else {
        // FORWARD

        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = state.tabbableGroups.findIndex(function (_ref5) {
          var lastTabbableNode = _ref5.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isFocusable)(target, config.tabbableOptions) && !(0,tabbable__WEBPACK_IMPORTED_MODULE_0__.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.getTabIndex)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
        } else if (!isTabEvent(event)) {
          // user must have customized the nav keys so we have to move focus manually _within_
          //  the active group: do this based on the order determined by tabbable()
          destinationNode = containerGroup.nextTabbableNode(target);
        }
      }
    } else {
      // no groups available
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }
    return destinationNode;
  };

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked (and if not focusable, to "nothing"); by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node), whether the
        //  outside click was on a focusable node or not
        returnFocus: config.returnFocusOnDeactivate
      });
      return;
    }

    // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)
    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    }

    // otherwise, prevent the click
    e.preventDefault();
  };

  // In case focus escapes the trap for some strange reason, pull it back in.
  // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
  //  scrolling if the node that got focused was out of view; there's nothing we can do to
  //  prevent that from happening by the time we discover that focus escaped
  var checkFocusIn = function checkFocusIn(event) {
    var target = getActualTarget(event);
    var targetContained = findContainerIndex(target, event) >= 0;

    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      event.stopImmediatePropagation();

      // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
      //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
      //  toward a node with a positive tab index
      var nextNode; // next node to focus, if we find one
      var navAcrossContainers = true;
      if (state.mostRecentlyFocusedNode) {
        if ((0,tabbable__WEBPACK_IMPORTED_MODULE_0__.getTabIndex)(state.mostRecentlyFocusedNode) > 0) {
          // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
          var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
          // there MAY not be any tabbable nodes in the container if there are at least 2 containers
          //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
          //  with at least one tabbable node in order to function, so this could be the other container
          //  with nothing tabbable in it)
          var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
          if (tabbableNodes.length > 0) {
            // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
            var mruTabIdx = tabbableNodes.findIndex(function (node) {
              return node === state.mostRecentlyFocusedNode;
            });
            if (mruTabIdx >= 0) {
              if (config.isKeyForward(state.recentNavEvent)) {
                if (mruTabIdx + 1 < tabbableNodes.length) {
                  nextNode = tabbableNodes[mruTabIdx + 1];
                  navAcrossContainers = false;
                }
                // else, don't wrap within the container as focus should move to next/previous
                //  container
              } else {
                if (mruTabIdx - 1 >= 0) {
                  nextNode = tabbableNodes[mruTabIdx - 1];
                  navAcrossContainers = false;
                }
                // else, don't wrap within the container as focus should move to next/previous
                //  container
              }
              // else, don't find in container order without considering direction too
            }
          }
          // else, no tabbable nodes in that container (which means we must have at least one other
          //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
          //  an error the last time updateTabbableNodes() was run): find next node among all known
          //  containers
        } else {
          // check to see if there's at least one tabbable node with a positive tab index inside
          //  the trap because focus seems to escape when navigating backward from a tabbable node
          //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
          //  the greatest positive tab index like it should)
          if (!state.containerGroups.some(function (g) {
            return g.tabbableNodes.some(function (n) {
              return (0,tabbable__WEBPACK_IMPORTED_MODULE_0__.getTabIndex)(n) > 0;
            });
          })) {
            // no containers with tabbable nodes with positive tab indexes which means the focus
            //  escaped for some other reason and we should just execute the fallback to the
            //  MRU node or initial focus node, if any
            navAcrossContainers = false;
          }
        }
      } else {
        // no MRU node means we're likely in some initial condition when the trap has just
        //  been activated and initial focus hasn't been given yet, in which case we should
        //  fall through to trying to focus the initial focus node, which is what should
        //  happen below at this point in the logic
        navAcrossContainers = false;
      }
      if (navAcrossContainers) {
        nextNode = findNextNavNode({
          // move FROM the MRU node, not event-related node (which will be the node that is
          //  outside the trap causing the focus escape we're trying to fix)
          target: state.mostRecentlyFocusedNode,
          isBackward: config.isKeyBackward(state.recentNavEvent)
        });
      }
      if (nextNode) {
        _tryFocus(nextNode);
      } else {
        _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    }
    state.recentNavEvent = undefined; // clear
  };

  // Hijack key nav events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  var checkKeyNav = function checkKeyNav(event) {
    var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    state.recentNavEvent = event;
    var destinationNode = findNextNavNode({
      event: event,
      isBackward: isBackward
    });
    if (destinationNode) {
      if (isTabEvent(event)) {
        // since tab natively moves focus, we wouldn't have a destination node unless we
        //  were on the edge of a container and had to move to the next/previous edge, in
        //  which case we want to prevent default to keep the browser from moving focus
        //  to where it normally would
        event.preventDefault();
      }
      _tryFocus(destinationNode);
    }
    // else, let the browser take care of [shift+]tab and move the focus
  };
  var checkTabKey = function checkTabKey(event) {
    if (config.isKeyForward(event) || config.isKeyBackward(event)) {
      checkKeyNav(event, config.isKeyBackward(event));
    }
  };

  // we use a different event phase for the Escape key to allow canceling the event and checking for this in escapeDeactivates
  var checkEscapeKey = function checkEscapeKey(event) {
    if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
      event.preventDefault();
      trap.deactivate();
    }
  };
  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };

  //
  // EVENT LISTENERS
  //

  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    }

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trapStack, trap);

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      _tryFocus(getInitialFocusNode());
    }) : _tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkTabKey, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkEscapeKey);
    return trap;
  };
  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkTabKey, true);
    doc.removeEventListener('keydown', checkEscapeKey);
    return trap;
  };

  //
  // MUTATION OBSERVER
  //

  var checkDomRemoval = function checkDomRemoval(mutations) {
    var isFocusedNodeRemoved = mutations.some(function (mutation) {
      var removedNodes = Array.from(mutation.removedNodes);
      return removedNodes.some(function (node) {
        return node === state.mostRecentlyFocusedNode;
      });
    });

    // If the currently focused is removed then browsers will move focus to the
    // <body> element. If this happens, try to move focus back into the trap.
    if (isFocusedNodeRemoved) {
      _tryFocus(getInitialFocusNode());
    }
  };

  // Use MutationObserver - if supported - to detect if focused node is removed
  // from the DOM.
  var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
  var updateObservedNodes = function updateObservedNodes() {
    if (!mutationObserver) {
      return;
    }
    mutationObserver.disconnect();
    if (state.active && !state.paused) {
      state.containers.map(function (container) {
        mutationObserver.observe(container, {
          subtree: true,
          childList: true
        });
      });
    }
  };

  //
  // TRAP DEFINITION
  //

  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = _getActiveElement(doc);
      onActivate === null || onActivate === void 0 || onActivate();
      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        updateObservedNodes();
        onPostActivate === null || onPostActivate === void 0 || onPostActivate();
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer); // noop if undefined
      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      updateObservedNodes();
      activeFocusTraps.deactivateTrap(trapStack, trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
      onDeactivate === null || onDeactivate === void 0 || onDeactivate();
      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause(pauseOptions) {
      if (!state.active) {
        return this;
      }
      state.manuallyPaused = true;
      return this._setPausedState(true, pauseOptions);
    },
    unpause: function unpause(unpauseOptions) {
      if (!state.active) {
        return this;
      }
      state.manuallyPaused = false;
      if (trapStack[trapStack.length - 1] !== this) {
        return this;
      }
      return this._setPausedState(false, unpauseOptions);
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      updateObservedNodes();
      return this;
    }
  };
  Object.defineProperties(trap, {
    _isManuallyPaused: {
      value: function value() {
        return state.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function value(paused, options) {
        if (state.paused === paused) {
          return this;
        }
        state.paused = paused;
        if (paused) {
          var onPause = getOption(options, 'onPause');
          var onPostPause = getOption(options, 'onPostPause');
          onPause === null || onPause === void 0 || onPause();
          removeListeners();
          updateObservedNodes();
          onPostPause === null || onPostPause === void 0 || onPostPause();
        } else {
          var onUnpause = getOption(options, 'onUnpause');
          var onPostUnpause = getOption(options, 'onPostUnpause');
          onUnpause === null || onUnpause === void 0 || onUnpause();
          updateTabbableNodes();
          addListeners();
          updateObservedNodes();
          onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
        }
        return this;
      }
    }
  });

  // initialize container elements
  trap.updateContainerElements(elements);
  return trap;
};


//# sourceMappingURL=focus-trap.esm.js.map


//# sourceURL=webpack://liquid-starter/./node_modules/.pnpm/focus-trap@7.6.5/node_modules/focus-trap/dist/focus-trap.esm.js?
;

/***/ }),

/***/ "./node_modules/.pnpm/tabbable@6.2.0/node_modules/tabbable/dist/index.esm.js":
/*!***********************************************************************************!*\
  !*** ./node_modules/.pnpm/tabbable@6.2.0/node_modules/tabbable/dist/index.esm.js ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   focusable: () => (/* binding */ focusable),
/* harmony export */   getTabIndex: () => (/* binding */ getTabIndex),
/* harmony export */   isFocusable: () => (/* binding */ isFocusable),
/* harmony export */   isTabbable: () => (/* binding */ isTabbable),
/* harmony export */   tabbable: () => (/* binding */ tabbable)
/* harmony export */ });
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map


//# sourceURL=webpack://liquid-starter/./node_modules/.pnpm/tabbable@6.2.0/node_modules/tabbable/dist/index.esm.js?
;

/***/ }),

/***/ "./node_modules/.pnpm/what-input@5.2.12/node_modules/what-input/dist/what-input.js":
/*!*****************************************************************************************!*\
  !*** ./node_modules/.pnpm/what-input@5.2.12/node_modules/what-input/dist/what-input.js ***!
  \*****************************************************************************************/
/***/ (function(module) {


/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v5.2.12
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else // removed by dead control flow
{}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __nested_webpack_require_738__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_738__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_738__.m = modules;

/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_738__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_738__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_738__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	  /*
	   * bail out if there is no document or window
	   * (i.e. in a node/non-DOM environment)
	   *
	   * Return a stubbed API instead
	   */
	  if (typeof document === 'undefined' || typeof window === 'undefined') {
	    return {
	      // always return "initial" because no interaction will ever be detected
	      ask: function ask() {
	        return 'initial';
	      },

	      // always return null
	      element: function element() {
	        return null;
	      },

	      // no-op
	      ignoreKeys: function ignoreKeys() {},

	      // no-op
	      specificKeys: function specificKeys() {},

	      // no-op
	      registerOnChange: function registerOnChange() {},

	      // no-op
	      unRegisterOnChange: function unRegisterOnChange() {}
	    };
	  }

	  /*
	   * variables
	   */

	  // cache document.documentElement
	  var docElem = document.documentElement;

	  // currently focused dom element
	  var currentElement = null;

	  // last used input type
	  var currentInput = 'initial';

	  // last used input intent
	  var currentIntent = currentInput;

	  // UNIX timestamp of current event
	  var currentTimestamp = Date.now();

	  // check for a `data-whatpersist` attribute on either the `html` or `body` elements, defaults to `true`
	  var shouldPersist = false;

	  // form input types
	  var formInputs = ['button', 'input', 'select', 'textarea'];

	  // empty array for holding callback functions
	  var functionList = [];

	  // list of modifier keys commonly used with the mouse and
	  // can be safely ignored to prevent false keyboard detection
	  var ignoreMap = [16, // shift
	  17, // control
	  18, // alt
	  91, // Windows key / left Apple cmd
	  93 // Windows menu / right Apple cmd
	  ];

	  var specificMap = [];

	  // mapping of events to input types
	  var inputMap = {
	    keydown: 'keyboard',
	    keyup: 'keyboard',
	    mousedown: 'mouse',
	    mousemove: 'mouse',
	    MSPointerDown: 'pointer',
	    MSPointerMove: 'pointer',
	    pointerdown: 'pointer',
	    pointermove: 'pointer',
	    touchstart: 'touch',
	    touchend: 'touch'

	    // boolean: true if the page is being scrolled
	  };var isScrolling = false;

	  // store current mouse position
	  var mousePos = {
	    x: null,
	    y: null

	    // map of IE 10 pointer events
	  };var pointerMap = {
	    2: 'touch',
	    3: 'touch', // treat pen like touch
	    4: 'mouse'

	    // check support for passive event listeners
	  };var supportsPassive = false;

	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });

	    window.addEventListener('test', null, opts);
	  } catch (e) {}
	  // fail silently


	  /*
	   * set up
	   */

	  var setUp = function setUp() {
	    // add correct mouse wheel event mapping to `inputMap`
	    inputMap[detectWheel()] = 'mouse';

	    addListeners();
	  };

	  /*
	   * events
	   */

	  var addListeners = function addListeners() {
	    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
	    // can only demonstrate potential, but not actual, interaction
	    // and are treated separately
	    var options = supportsPassive ? { passive: true, capture: true } : true;

	    document.addEventListener('DOMContentLoaded', setPersist, true);

	    // pointer events (mouse, pen, touch)
	    if (window.PointerEvent) {
	      window.addEventListener('pointerdown', setInput, true);
	      window.addEventListener('pointermove', setIntent, true);
	    } else if (window.MSPointerEvent) {
	      window.addEventListener('MSPointerDown', setInput, true);
	      window.addEventListener('MSPointerMove', setIntent, true);
	    } else {
	      // mouse events
	      window.addEventListener('mousedown', setInput, true);
	      window.addEventListener('mousemove', setIntent, true);

	      // touch events
	      if ('ontouchstart' in window) {
	        window.addEventListener('touchstart', setInput, options);
	        window.addEventListener('touchend', setInput, true);
	      }
	    }

	    // mouse wheel
	    window.addEventListener(detectWheel(), setIntent, options);

	    // keyboard events
	    window.addEventListener('keydown', setInput, true);
	    window.addEventListener('keyup', setInput, true);

	    // focus events
	    window.addEventListener('focusin', setElement, true);
	    window.addEventListener('focusout', clearElement, true);
	  };

	  // checks if input persistence should happen and
	  // get saved state from session storage if true (defaults to `false`)
	  var setPersist = function setPersist() {
	    shouldPersist = !(docElem.getAttribute('data-whatpersist') === 'false' || document.body.getAttribute('data-whatpersist') === 'false');

	    if (shouldPersist) {
	      // check for session variables and use if available
	      try {
	        if (window.sessionStorage.getItem('what-input')) {
	          currentInput = window.sessionStorage.getItem('what-input');
	        }

	        if (window.sessionStorage.getItem('what-intent')) {
	          currentIntent = window.sessionStorage.getItem('what-intent');
	        }
	      } catch (e) {
	        // fail silently
	      }
	    }

	    // always run these so at least `initial` state is set
	    doUpdate('input');
	    doUpdate('intent');
	  };

	  // checks conditions before updating new input
	  var setInput = function setInput(event) {
	    var eventKey = event.which;
	    var value = inputMap[event.type];

	    if (value === 'pointer') {
	      value = pointerType(event);
	    }

	    var ignoreMatch = !specificMap.length && ignoreMap.indexOf(eventKey) === -1;

	    var specificMatch = specificMap.length && specificMap.indexOf(eventKey) !== -1;

	    var shouldUpdate = value === 'keyboard' && eventKey && (ignoreMatch || specificMatch) || value === 'mouse' || value === 'touch';

	    // prevent touch detection from being overridden by event execution order
	    if (validateTouch(value)) {
	      shouldUpdate = false;
	    }

	    if (shouldUpdate && currentInput !== value) {
	      currentInput = value;

	      persistInput('input', currentInput);
	      doUpdate('input');
	    }

	    if (shouldUpdate && currentIntent !== value) {
	      // preserve intent for keyboard interaction with form fields
	      var activeElem = document.activeElement;
	      var notFormInput = activeElem && activeElem.nodeName && (formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1 || activeElem.nodeName.toLowerCase() === 'button' && !checkClosest(activeElem, 'form'));

	      if (notFormInput) {
	        currentIntent = value;

	        persistInput('intent', currentIntent);
	        doUpdate('intent');
	      }
	    }
	  };

	  // updates the doc and `inputTypes` array with new input
	  var doUpdate = function doUpdate(which) {
	    docElem.setAttribute('data-what' + which, which === 'input' ? currentInput : currentIntent);

	    fireFunctions(which);
	  };

	  // updates input intent for `mousemove` and `pointermove`
	  var setIntent = function setIntent(event) {
	    var value = inputMap[event.type];

	    if (value === 'pointer') {
	      value = pointerType(event);
	    }

	    // test to see if `mousemove` happened relative to the screen to detect scrolling versus mousemove
	    detectScrolling(event);

	    // only execute if scrolling isn't happening
	    if ((!isScrolling && !validateTouch(value) || isScrolling && event.type === 'wheel' || event.type === 'mousewheel' || event.type === 'DOMMouseScroll') && currentIntent !== value) {
	      currentIntent = value;

	      persistInput('intent', currentIntent);
	      doUpdate('intent');
	    }
	  };

	  var setElement = function setElement(event) {
	    if (!event.target.nodeName) {
	      // If nodeName is undefined, clear the element
	      // This can happen if click inside an <svg> element.
	      clearElement();
	      return;
	    }

	    currentElement = event.target.nodeName.toLowerCase();
	    docElem.setAttribute('data-whatelement', currentElement);

	    if (event.target.classList && event.target.classList.length) {
	      docElem.setAttribute('data-whatclasses', event.target.classList.toString().replace(' ', ','));
	    }
	  };

	  var clearElement = function clearElement() {
	    currentElement = null;

	    docElem.removeAttribute('data-whatelement');
	    docElem.removeAttribute('data-whatclasses');
	  };

	  var persistInput = function persistInput(which, value) {
	    if (shouldPersist) {
	      try {
	        window.sessionStorage.setItem('what-' + which, value);
	      } catch (e) {
	        // fail silently
	      }
	    }
	  };

	  /*
	   * utilities
	   */

	  var pointerType = function pointerType(event) {
	    if (typeof event.pointerType === 'number') {
	      return pointerMap[event.pointerType];
	    } else {
	      // treat pen like touch
	      return event.pointerType === 'pen' ? 'touch' : event.pointerType;
	    }
	  };

	  // prevent touch detection from being overridden by event execution order
	  var validateTouch = function validateTouch(value) {
	    var timestamp = Date.now();

	    var touchIsValid = value === 'mouse' && currentInput === 'touch' && timestamp - currentTimestamp < 200;

	    currentTimestamp = timestamp;

	    return touchIsValid;
	  };

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/API/Element/wheel_event
	  var detectWheel = function detectWheel() {
	    var wheelType = null;

	    // Modern browsers support "wheel"
	    if ('onwheel' in document.createElement('div')) {
	      wheelType = 'wheel';
	    } else {
	      // Webkit and IE support at least "mousewheel"
	      // or assume that remaining browsers are older Firefox
	      wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
	    }

	    return wheelType;
	  };

	  // runs callback functions
	  var fireFunctions = function fireFunctions(type) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].type === type) {
	        functionList[i].fn.call(undefined, type === 'input' ? currentInput : currentIntent);
	      }
	    }
	  };

	  // finds matching element in an object
	  var objPos = function objPos(match) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].fn === match) {
	        return i;
	      }
	    }
	  };

	  var detectScrolling = function detectScrolling(event) {
	    if (mousePos.x !== event.screenX || mousePos.y !== event.screenY) {
	      isScrolling = false;

	      mousePos.x = event.screenX;
	      mousePos.y = event.screenY;
	    } else {
	      isScrolling = true;
	    }
	  };

	  // manual version of `closest()`
	  var checkClosest = function checkClosest(elem, tag) {
	    var ElementPrototype = window.Element.prototype;

	    if (!ElementPrototype.matches) {
	      ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.webkitMatchesSelector;
	    }

	    if (!ElementPrototype.closest) {
	      do {
	        if (elem.matches(tag)) {
	          return elem;
	        }

	        elem = elem.parentElement || elem.parentNode;
	      } while (elem !== null && elem.nodeType === 1);

	      return null;
	    } else {
	      return elem.closest(tag);
	    }
	  };

	  /*
	   * init
	   */

	  // don't start script unless browser cuts the mustard
	  // (also passes if polyfills are used)
	  if ('addEventListener' in window && Array.prototype.indexOf) {
	    setUp();
	  }

	  /*
	   * api
	   */

	  return {
	    // returns string: the current input type
	    // opt: 'intent'|'input'
	    // 'input' (default): returns the same value as the `data-whatinput` attribute
	    // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
	    ask: function ask(opt) {
	      return opt === 'intent' ? currentIntent : currentInput;
	    },

	    // returns string: the currently focused element or null
	    element: function element() {
	      return currentElement;
	    },

	    // overwrites ignored keys with provided array
	    ignoreKeys: function ignoreKeys(arr) {
	      ignoreMap = arr;
	    },

	    // overwrites specific char keys to update on
	    specificKeys: function specificKeys(arr) {
	      specificMap = arr;
	    },

	    // attach functions to input and intent "events"
	    // funct: function to fire on change
	    // eventType: 'input'|'intent'
	    registerOnChange: function registerOnChange(fn, eventType) {
	      functionList.push({
	        fn: fn,
	        type: eventType || 'input'
	      });
	    },

	    unRegisterOnChange: function unRegisterOnChange(fn) {
	      var position = objPos(fn);

	      if (position || position === 0) {
	        functionList.splice(position, 1);
	      }
	    },

	    clearStorage: function clearStorage() {
	      window.sessionStorage.clear();
	    }
	  };
	}();

/***/ })
/******/ ])
});
;

//# sourceURL=webpack://liquid-starter/./node_modules/.pnpm/what-input@5.2.12/node_modules/what-input/dist/what-input.js?
;

/***/ }),

/***/ "./src/components/additional-product-selector.js":
/*!*******************************************************!*\
  !*** ./src/components/additional-product-selector.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Additional Product Selector Web Component
 * Handles size selection for additional products and communicates with add-to-cart
 */
class AdditionalProductSelector extends HTMLElement {
  constructor() {
    super();
    this.selectedSize = null;
    this.selectedVariantId = null;
    this.additionalProductId = null;
    this.additionalProductHandle = null;
    this.sizeOptions = [];
    this.variantInput = null;

    this.init();
  }

  init() {
    this.setupElements();
    this.bindEvents();
    this.setInitialState();
  }

  setupElements() {
    this.sizeOptions = Array.from(
      this.querySelectorAll('[data-trigger="additional-product-size"]'),
    );
    this.variantInput = this.querySelector('[data-additional-variant-input]');

    // Get additional product info from first size option
    if (this.sizeOptions.length > 0) {
      const firstOption = this.sizeOptions[0];
      this.additionalProductId = firstOption.getAttribute('data-additional-product-id');
      this.additionalProductHandle = firstOption.getAttribute('data-additional-product-handle');
    }
  }

  bindEvents() {
    // Handle size option clicks using event delegation
    this.addEventListener('click', this.handleSizeClick.bind(this));

    // Listen for primary product variant changes to update aria-labels
    document.addEventListener('variant:changed', this.handlePrimaryVariantChange.bind(this));
  }

  setInitialState() {
    // Check availability and set first available size as selected by default
    this.updateAvailabilityStates();

    // Find first available size option
    const firstAvailableOption = this.sizeOptions.find((option) => {
      return !option.hasAttribute('data-unavailable');
    });

    if (firstAvailableOption) {
      this.selectSize(firstAvailableOption);
    } else if (this.sizeOptions.length > 0) {
      // If no available options, still select the first one but it will be disabled
      this.selectSize(this.sizeOptions[0]);
    }
  }

  handleSizeClick(event) {
    const sizeOption = event.target.closest('[data-trigger="additional-product-size"]');
    if (!sizeOption) return;

    // Don't allow selection of unavailable options
    if (sizeOption.hasAttribute('data-unavailable')) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    this.selectSize(sizeOption);
  }

  selectSize(sizeOption) {
    // Update active state
    this.sizeOptions.forEach((option) => {
      option.setAttribute('data-active', 'false');
    });
    sizeOption.setAttribute('data-active', 'true');

    // Update selected values
    this.selectedSize = sizeOption.getAttribute('data-size-value');
    this.selectedVariantId = sizeOption.getAttribute('data-additional-variant-id');

    // Update hidden input
    if (this.variantInput) {
      this.variantInput.value = this.selectedVariantId;
    }

    // Dispatch event for add-to-cart to listen to
    this.dispatchEvent(
      new CustomEvent('additional-product:changed', {
        detail: {
          additionalProductId: this.additionalProductId,
          additionalProductHandle: this.additionalProductHandle,
          selectedVariantId: this.selectedVariantId,
          selectedSize: this.selectedSize,
        },
        bubbles: true,
      }),
    );
  }

  /**
   * Handle primary product variant changes to update aria-labels
   */
  handlePrimaryVariantChange(event) {
    const variant = event.detail.variant;
    if (variant && variant.options) {
      this.updateAriaLabels(variant);
    }
  }

  /**
   * Update aria-labels based on current primary product variant
   */
  updateAriaLabels(primaryVariant) {
    // Get the current length from the primary variant (assuming it's the first option)
    const currentLength = primaryVariant.options[0];

    this.sizeOptions.forEach((option) => {
      const sizeValue = option.getAttribute('data-size-value');
      const displaySize = this.getDisplaySize(sizeValue);

      // Create updated aria-label with current length context
      const ariaLabel = `Select ${displaySize} size for additional product (${currentLength})`;
      option.setAttribute('aria-label', ariaLabel);
    });
  }

  /**
   * Get display size value (handle special cases like 'one size')
   */
  getDisplaySize(sizeValue) {
    if (sizeValue === 'default' || sizeValue === 'one size' || sizeValue === 'one-size') {
      return 'OS';
    }
    return sizeValue;
  }

  /**
   * Get the currently selected additional product data
   */
  getSelectedData() {
    return {
      additionalProductId: this.additionalProductId,
      additionalProductHandle: this.additionalProductHandle,
      selectedVariantId: this.selectedVariantId,
      selectedSize: this.selectedSize,
    };
  }

  /**
   * Check if a size is selected
   */
  hasSelection() {
    return this.selectedVariantId !== null;
  }

  /**
   * Update availability states for all size options
   * This checks if variants are available and marks options accordingly
   */
  updateAvailabilityStates() {
    this.sizeOptions.forEach((option) => {
      // Check if this variant is available by looking for availability data
      // The availability should be set by the Liquid template
      const isAvailable = option.getAttribute('data-available') === 'true';

      if (isAvailable) {
        option.removeAttribute('data-unavailable');
        option.removeAttribute('data-disabled');
        option.disabled = false;
      } else {
        option.setAttribute('data-unavailable', 'true');
        option.setAttribute('data-disabled', 'true');
        option.disabled = true;
      }
    });
  }

  /**
   * Reset the selector to initial state
   */
  reset() {
    this.selectedSize = null;
    this.selectedVariantId = null;

    if (this.variantInput) {
      this.variantInput.value = '';
    }

    this.sizeOptions.forEach((option) => {
      option.setAttribute('data-active', 'false');
    });

    // Set first option as active again
    if (this.sizeOptions.length > 0) {
      this.selectSize(this.sizeOptions[0]);
    }
  }
}

// Register the web component
customElements.define('additional-product-selector', AdditionalProductSelector);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AdditionalProductSelector);


//# sourceURL=webpack://liquid-starter/./src/components/additional-product-selector.js?
;

/***/ }),

/***/ "./src/components/breadcrumbs.js":
/*!***************************************!*\
  !*** ./src/components/breadcrumbs.js ***!
  \***************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/**
 * Breadcrumb Component
 * Handles breadcrumb navigation functionality
 */
class BreadcrumbComponent {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    // Breadcrumbs are primarily static, but we can add
    // functionality like analytics tracking or keyboard navigation
    this.bindEvents();
  }

  bindEvents() {
    // Track breadcrumb clicks for analytics
    this.element.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const link = event.target.closest('.breadcrumbs__link');
    if (link) {
      // Track breadcrumb navigation
      this.trackBreadcrumbClick(link.href, link.textContent.trim());
    }
  }

  trackBreadcrumbClick(url, text) {
    // Analytics tracking for breadcrumb clicks
    if (typeof gtag !== 'undefined') {
      gtag('event', 'breadcrumb_click', {
        event_category: 'Navigation',
        event_label: text,
        value: 1,
      });
    }
  }
}

// Auto-initialize breadcrumb components
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="breadcrumbs"]').forEach((breadcrumb) => {
    new BreadcrumbComponent(breadcrumb);
  });
});


//# sourceURL=webpack://liquid-starter/./src/components/breadcrumbs.js?
;

/***/ }),

/***/ "./src/components/cart-addons.js":
/*!***************************************!*\
  !*** ./src/components/cart-addons.js ***!
  \***************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// Whole-phrase match, punctuation as in snippets/variant-image-match.liquid, so
// descriptive alts can't match inside words ("tan" in "standing"). Copy kept
// identical in product-card.js; test-alt-mentions.mjs checks both.
const altMentions = (alt, value) => {
  const norm = (s) => ` ${String(s).toLowerCase().replace(/["'\/~\\_()[\]:;.,&+|-]/g, ' ').replace(/\s+/g, ' ').trim()} `;
  return Boolean(alt && value) && norm(alt).includes(norm(value));
};

// Cart Add-ons Component. The add-ons were an Embla carousel until the
// drawer switched to stacked rows (snippets/cart-addons-slider.liquid);
// this now only handles variant picks and add-to-cart.
class CartAddonsComponent {
  constructor(element) {
    this.element = element;
    this.bindEvents();
  }

  bindEvents() {
    // Handle add to cart from cart add-ons
    this.element.addEventListener('click', (event) => {
      const addToCartButton = event.target.closest('[data-add-to-cart]');
      if (addToCartButton) {
        this.handleAddToCart(event, addToCartButton);
      }
    });

    // Handle variant selection
    this.element.addEventListener('click', (event) => {
      const variantTrigger = event.target.closest('[data-trigger="variant-option"]');
      if (variantTrigger) {
        this.handleVariantSelection(event, variantTrigger);
      }
    });

    // Handle variant dropdown
    this.element.addEventListener('change', (event) => {
      const variantDropdown = event.target.closest('[data-trigger="variant-dropdown"]');
      if (variantDropdown) {
        this.handleVariantDropdown(event, variantDropdown);
      }
    });
  }

  handleVariantSelection(event, trigger) {
    event.preventDefault();

    const productCard = trigger.closest('cart-product-card');
    if (!productCard) return;

    const optionIndex = trigger.getAttribute('data-option-index');
    const optionValue = trigger.getAttribute('data-option-value');

    // Update active state
    const optionGroup = trigger.closest(
      '.variant-selector__color-options, .variant-selector__size-options',
    );
    if (optionGroup) {
      optionGroup.querySelectorAll('[data-trigger="variant-option"]').forEach((btn) => {
        btn.removeAttribute('data-active');
      });
      trigger.setAttribute('data-active', 'true');
    }

    // Update current value display
    const label = productCard.querySelector(
      `.variant-selector__option:nth-child(${parseInt(optionIndex) + 1}) .variant-selector__current-value`,
    );
    if (label) {
      label.textContent = optionValue;
    }

    // Update hidden input
    const variantId = this.resolveVariantId(productCard, trigger.getAttribute('data-variant-id'));
    const hiddenInput = productCard.querySelector('[data-variant-id-input]');
    if (hiddenInput && variantId) {
      hiddenInput.value = variantId;
    }

    // Update add to cart button state
    this.updateAddToCartButton(productCard, variantId);

    // Update product image if this is a color variant
    if (trigger.closest('.variant-selector__color-options')) {
      this.updateProductImage(productCard, optionValue);
    }
  }

  handleVariantDropdown(event, dropdown) {
    const productCard = dropdown.closest('cart-product-card');
    if (!productCard) return;

    const optionIndex = dropdown.getAttribute('data-option-index');
    const selectedOption = dropdown.options[dropdown.selectedIndex];

    // Update current value display
    const label = productCard.querySelector(
      `.variant-selector__option:nth-child(${parseInt(optionIndex) + 1}) .variant-selector__current-value`,
    );
    if (label) {
      label.textContent = selectedOption.value;
    }

    // Update hidden input
    const variantId = this.resolveVariantId(productCard, selectedOption.getAttribute('data-variant-id'));
    const hiddenInput = productCard.querySelector('[data-variant-id-input]');
    if (hiddenInput && variantId) {
      hiddenInput.value = variantId;
    }

    // Update add to cart button state
    this.updateAddToCartButton(productCard, variantId);
  }

  // Each option button's data-variant-id is fixed at render time against the
  // variant the card opened on, so on a two-option product it only knows
  // half the answer: choosing Right then M on the glove sent the M button's
  // id, which is Left / M, and the wrong hand went into the cart. Resolve the
  // variant from every group's current pick instead; fall back to the
  // button's id if the card's product data can't be read.
  resolveVariantId(productCard, fallbackId) {
    const selected = [];
    productCard
      .querySelectorAll('[data-trigger="variant-option"][data-active="true"], [data-trigger="variant-dropdown"]')
      .forEach((el) => {
        selected[el.getAttribute('data-option-index')] =
          el.tagName === 'SELECT' ? el.value : el.getAttribute('data-option-value');
      });

    try {
      const { variants } = JSON.parse(productCard.querySelector('.product-data').textContent);
      const match = variants.find((v) => v.options.every((value, i) => selected[i] === undefined || selected[i] === value));
      return match ? String(match.id) : fallbackId;
    } catch (error) {
      return fallbackId;
    }
  }

  updateAddToCartButton(productCard, variantId) {
    const addToCartButton = productCard.querySelector('[data-add-to-cart]');
    if (!addToCartButton) return;

    // Get product data
    const productDataScript = productCard.querySelector('.product-data');
    if (!productDataScript) return;

    try {
      const productData = JSON.parse(productDataScript.textContent);
      const variant = productData.variants.find((v) => v.id.toString() === variantId);

      if (variant) {
        addToCartButton.disabled = !variant.available;
        addToCartButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    } catch (error) {
      console.error('Error parsing product data:', error);
    }
  }

  updateProductImage(productCard, colorValue) {
    const productImage = productCard.querySelector('.cart-product-card__image-main');
    if (!productImage) return;

    // Get product data
    const productDataScript = productCard.querySelector('.product-data');
    if (!productDataScript) return;

    try {
      const productData = JSON.parse(productDataScript.textContent);

      // Find the first image that matches the color
      let matchingImage = null;

      // First, check if there's a variant-specific image
      const variant = productData.variants.find((v) => {
        const colorOption =
          v.options &&
          v.options.find(
            (option) => option && option.toLowerCase().includes(colorValue.toLowerCase()),
          );
        return colorOption && v.image;
      });

      if (variant && variant.image) {
        matchingImage = variant.image;
      } else {
        // Fallback: look for images with matching alt text
        for (const image of productData.product.images) {
          if (altMentions(image.alt, colorValue)) {
            matchingImage = image;
            break;
          }
        }
      }

      // Update the image if we found a match
      if (matchingImage) {
        // srcset has to go first. The card image now ships a srcset/sizes
        // pair, and when a browser has candidates it resolves from those and
        // ignores src entirely - so assigning src alone would leave the
        // original image on screen and this swap would silently do nothing.
        productImage.srcset = '';
        productImage.sizes = '';
        productImage.src = matchingImage.src;
        productImage.alt = matchingImage.alt;
        console.log('🖼️ Updated cart product image for color:', colorValue);
      }
    } catch (error) {
      console.error('Error updating product image:', error);
    }
  }

  async handleAddToCart(event, button) {
    event.preventDefault();

    const productCard = button.closest('cart-product-card');
    if (!productCard) return;

    const productId = button.getAttribute('data-product-id');
    const hiddenInput = productCard.querySelector('[data-variant-id-input]');
    const variantId = hiddenInput ? hiddenInput.value : null;

    if (!variantId) {
      console.error('No variant selected');
      return;
    }

    // Disable button during request
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding...';

    try {
      // Use the global Cart API
      if (!window.Cart) {
        throw new Error('Cart API not available');
      }

      await window.Cart.addLine(variantId, 1);

      // Show success feedback
      button.textContent = 'Added!';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);

      // Open cart after a short delay
      setTimeout(() => {
        if (window.Cart.open) {
          window.Cart.open();
        }
      }, 500);
    } catch (error) {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }
}

// Auto-initialize cart add-ons components
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="cart-addons"]').forEach((element) => {
    new CartAddonsComponent(element);
  });
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CartAddonsComponent);


//# sourceURL=webpack://liquid-starter/./src/components/cart-addons.js?
;

/***/ }),

/***/ "./src/components/cart.js":
/*!********************************!*\
  !*** ./src/components/cart.js ***!
  \********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);

// Shopify's image CDN resizes via a width param. These components build img
// tags in JS from raw CDN URLs, so without this they download the original
// upload at full resolution for thumbnails - one was 472 KB for an 80px slot.
// Idempotent, and leaves non-Shopify URLs untouched.
function forayCdnImg(url, w) { if (!url || typeof url !== 'string') return url; if (url.indexOf('width=') !== -1) return url; if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url; return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _constants_events_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../constants/events.js */ "./src/constants/events.js");
/**
 * Cart Web Component
 *
 * A centralized cart component that provides a clean API for all cart operations.
 * Automatically manages cart state, updates cart count elements, and handles
 * the slide-out cart drawer functionality.
 *
 * Usage:
 * - Cart.addLine(variantId, quantity, properties)
 * - Cart.removeLine(itemId)
 * - Cart.updateQuantity(itemId, quantity)
 * - Cart.getCount()
 * - Cart.open()
 * - Cart.close()
 */



class CartComponent {
  constructor(element) {
    this.element = element;
    this.isOpen = false;
    this.isUpdating = false;
    this.cartData = null;

    // Cache DOM elements
    this.cartDrawer = this.element.querySelector('[data-cart-drawer]');
    this.cartOverlay = this.element.querySelector('[data-cart-overlay]');
    this.cartContent = this.element.querySelector('[data-cart-content]');
    this.cartItems = this.element.querySelector('[data-cart-items]');
    this.cartEmpty = this.element.querySelector('[data-cart-empty]');
    this.cartFooter = this.element.querySelector('[data-cart-footer]');
    this.cartTotal = this.element.querySelector('[data-cart-total]');

    this.init();
  }

  init() {
    this.bindEvents();
    this.setInitialState();

    // One /cart.js per page load, not two. This used to also fire
    // refreshCart() on a 500ms timer "to ensure we have the latest state",
    // which just repeated the request loadCart() had made milliseconds
    // earlier - confirmed on the live storefront, two identical GET /cart.js
    // per pageview - and it landed its JSON parse and DOM writes 500ms in,
    // inside the LCP window, for a drawer nobody had opened. Staleness is
    // handled where it actually occurs: open() refreshes, and the
    // cart:updated listener in bindEvents() covers add and remove.
    this.loadCart();

    // updateCartCounts() used to run here too, synchronously, before
    // loadCart() had resolved. getCount() reads this.cartData, which is still
    // null at that point, so it returned 0 and hid the server-rendered badge
    // until the fetch came back. snippets/cart-count.liquid already prints
    // cart.item_count, and loadCart -> updateCartData -> updateCartCounts
    // corrects it if it has moved, so leaving the markup alone is both fewer
    // lines and one less wrong render.
  }

  bindEvents() {
    // Cart drawer events
    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('keydown', this.handleKeydown.bind(this));

    // Cart-specific events
    this.element.addEventListener('click', this.handleCartClick.bind(this));
    this.element.addEventListener('submit', this.handleCartSubmit.bind(this));

    // Listen for external cart triggers
    document.addEventListener('click', this.handleExternalTriggers.bind(this));

    // Listen for cart update events from other components
    document.addEventListener('cart:updated', this.handleCartUpdated.bind(this));
  }

  handleClick(event) {
    const trigger = event.target.closest('[data-trigger="cart"]');
    if (trigger) {
      event.preventDefault();
      this.open();
    }
  }

  handleKeydown(event) {
    // Close cart with Escape key
    if (event.key === 'Escape' && this.isOpen) {
      this.close();
    }
  }

  handleCartClick(event) {
    const closeBtn = event.target.closest('[data-close="cart"]');
    const overlay = event.target.closest('[data-cart-overlay]');
    const removeAllBtn = event.target.closest('[data-remove-all="cart"]');
    const removeItemBtn = event.target.closest('[data-remove-item]');
    const quantityBtn = event.target.closest('[data-quantity-btn]');

    if (closeBtn || (overlay && !event.target.closest('[data-cart-content]'))) {
      event.preventDefault();
      this.close();
    }

    if (removeAllBtn) {
      event.preventDefault();
      this.clear();
    }

    if (removeItemBtn) {
      event.preventDefault();
      const itemId = removeItemBtn.getAttribute('data-remove-item');

      // The enhanced removeLine method will automatically handle unified products
      this.removeLine(itemId);
    }

    if (quantityBtn) {
      event.preventDefault();
      const itemId = quantityBtn.getAttribute('data-item-id');
      const action = quantityBtn.getAttribute('data-action');

      // The enhanced updateQuantity method will automatically handle unified products
      this.updateQuantity(itemId, action);
    }
  }

  handleCartSubmit(event) {
    const form = event.target.closest('[data-cart-form]');
    if (!form) return;

    event.preventDefault();
    this.updateCart(form);
  }

  handleExternalTriggers(event) {
    // Handle any external cart triggers
    const trigger = event.target.closest('[data-trigger="cart"]');
    if (trigger) {
      event.preventDefault();
      this.open();
    }
  }

  handleCartUpdated(event) {
    // Handle cart updates from other components (like cart add-ons)
    const cartData = event.detail?.cart;
    if (cartData) {
      // Was this.updateCartUI(), which never existed, so any cart:updated
      // carrying a cart threw before the drawer or counts refreshed.
      this.updateCartData(cartData);
    }
  }

  setInitialState() {
    this.element.setAttribute('data-active', 'false');
    this.element.setAttribute('data-has-items', 'false');
  }

  // Public API Methods

  /**
   * Whether the add-to-cart button for this exact variant is marked final sale.
   * This used to fall back to "any final-sale element on the page", which
   * tagged full-price items added from a page that merely showed a final-sale
   * card. Callers that know better (product cards) pass _isFinalSale in
   * properties; the drawer label doesn't depend on this at all (see
   * isFinalSaleItem).
   * @param {number|string} variantId - The variant ID to check
   * @returns {boolean}
   */
  isProductFinalSale(variantId) {
    return Boolean(
      document.querySelector(
        `[data-add-to-cart-button][data-variant-id="${variantId}"][data-is-final-sale="true"]`,
      ),
    );
  }

  /**
   * Final_Sale is a product tag, which /cart.js doesn't return, so each product
   * is looked up once. The _isFinalSale line property alone missed lines added
   * before the tag fix, cart add-ons, and bundles.
   */
  isFinalSaleItem(item) {
    return item.properties?._isFinalSale === 'true' || this.finalSaleHandles?.get(item.handle) === true;
  }

  async loadFinalSaleFlags(items) {
    this.finalSaleHandles ??= new Map();
    const unknown = [...new Set(items.map((item) => item.handle))].filter((h) => !this.finalSaleHandles.has(h));
    if (!unknown.length) return;
    await Promise.all(
      unknown.map(async (handle) => {
        try {
          const product = await (await fetch(`/products/${handle}.js`)).json();
          this.finalSaleHandles.set(handle, product.tags.includes('Final_Sale'));
        } catch {
          this.finalSaleHandles.set(handle, false);
        }
      }),
    );
    if (unknown.some((h) => this.finalSaleHandles.get(h)) && this.cartData) {
      this.renderCartItems(this.cartData.items);
    }
  }

  /**
   * Add a line item to the cart
   * @param {number|string} variantId - The variant ID to add
   * @param {number} quantity - Quantity to add (default: 1)
   * @param {object} properties - Custom properties for the line item
   * @returns {Promise<object>} - Updated cart data
   */
  async addLine(variantId, quantity = 1, properties = {}) {
    if (this.isUpdating) {
      return;
    }

    this.setUpdatingState(true);

    try {
      // Check if product is final sale and add property if needed
      const isFinalSale = this.isProductFinalSale(variantId);

      const enhancedProperties = {
        ...properties,
        ...(isFinalSale && { _isFinalSale: 'true' }),
      };

      const requestBody = {
        items: [
          {
            id: variantId,
            quantity: quantity,
            properties: enhancedProperties,
          },
        ],
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        const cart = await response.json();

        // Ensure we have valid cart data - handle different response formats
        if (cart && (typeof cart.item_count !== 'undefined' || cart.items || cart.token)) {
          // If it's a cart object, use it directly
          if (typeof cart.item_count !== 'undefined') {
            this.updateCartData(cart);
          } else {
            // If it's not a full cart object, reload the cart to get complete data
            const fullCart = await this.loadCart();
            if (fullCart) {
              this.updateCartData(fullCart);
            } else {
              throw new Error('Failed to load complete cart data');
            }
          }

          this.dispatchCartEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.CART_ADD, { variantId, quantity, properties });

          // Force a cart reload to ensure we have the latest state
          setTimeout(() => {
            this.loadCart();
          }, 100);

          return cart;
        } else if (cart && (cart.status === 'success' || cart.message)) {
          // Handle success response without cart data
          const fullCart = await this.loadCart();
          if (fullCart) {
            this.updateCartData(fullCart);
            this.dispatchCartEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.CART_ADD, { variantId, quantity, properties });
            return fullCart;
          } else {
            throw new Error('Failed to load cart data after successful add');
          }
        } else {
          console.error('Invalid cart data structure:', cart);
          throw new Error('Invalid cart data received from server');
        }
      } else {
        // Try to get error details from response
        let errorMessage = 'Failed to add item to cart';
        try {
          const errorData = await response.text();
          console.error('Cart add error response:', errorData);

          // Try to parse as JSON for more specific error messages
          try {
            const errorJson = JSON.parse(errorData);
            if (errorJson.description) {
              errorMessage = `Failed to add item to cart: ${errorJson.description}`;
            } else if (errorJson.message) {
              errorMessage = `Failed to add item to cart: ${errorJson.message}`;
            } else {
              errorMessage = `Failed to add item to cart: ${response.status} ${response.statusText}`;
            }
          } catch {
            // If not JSON, use the raw text
            if (errorData.includes('unavailable') || errorData.includes('out of stock')) {
              errorMessage = 'This item is currently out of stock.';
            } else if (errorData.includes('invalid') || errorData.includes('not found')) {
              errorMessage = 'This product variant is no longer available.';
            } else {
              errorMessage = `Failed to add item to cart: ${response.status} ${response.statusText}`;
            }
          }
        } catch (parseError) {
          console.error('Could not parse error response:', parseError);
          errorMessage = `Failed to add item to cart: ${response.status} ${response.statusText}`;
        }

        console.error('Cart add failed:', {
          status: response.status,
          statusText: response.statusText,
          variantId,
          quantity,
          properties,
          errorMessage,
        });

        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        variantId,
        quantity,
        properties,
      });
      throw error;
    } finally {
      this.setUpdatingState(false);
    }
  }

  /**
   * Remove a line item from the cart
   * @param {number|string} itemId - The line item ID to remove
   * @returns {Promise<object>} - Updated cart data
   */
  async removeLine(itemId) {
    if (this.isUpdating) return;

    this.setUpdatingState(true);

    try {
      // Check if this item is part of a unified product
      const itemToRemove = this.cartData?.items?.find(
        (item) => item.id.toString() === itemId.toString(),
      );

      if (itemToRemove?.properties?._unified_code) {
        // This is a unified product - find and remove all related items
        const unifiedCode = itemToRemove.properties._unified_code;
        const relatedItems = this.cartData?.items?.filter(
          (item) => item.properties?._unified_code === unifiedCode,
        );

        // Remove all related items sequentially to avoid race conditions
        for (const item of relatedItems) {
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: item?.id?.toString(),
                quantity: 0,
              }),
            });

            if (!response.ok) {
              console.warn(`⚠️ Failed to remove item ${item.id}, but continuing...`);
              // Continue with other items even if one fails
            }
          } catch (error) {
            console.warn(`⚠️ Error removing item ${item.id}:`, error);
            // Continue with other items even if one fails
          }
        }

        // Get the final cart state
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        this.updateCartData(cart);
        this.dispatchCartEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.CART_REMOVE, {
          itemId,
          unifiedCode,
          removedItems: relatedItems.map((item) => item.id),
        });
        return cart;
      } else {
        // Regular single item removal
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemId.toString(),
            quantity: 0,
          }),
        });

        if (response.ok) {
          const cart = await response.json();
          this.updateCartData(cart);
          this.dispatchCartEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.CART_REMOVE, { itemId });
          return cart;
        } else {
          throw new Error('Failed to remove item from cart');
        }
      }
    } catch (error) {
      console.error('Error removing from cart:', error);
      throw error;
    } finally {
      this.setUpdatingState(false);
    }
  }

  /**
   * Update the quantity of a line item
   * @param {number|string} itemId - The line item ID
   * @param {number|string} quantity - New quantity or action ('increase'/'decrease')
   * @returns {Promise<object>} - Updated cart data
   */
  async updateQuantity(itemId, quantity) {
    if (this.isUpdating) return;

    let newQuantity = quantity;

    // Handle increase/decrease actions
    if (quantity === 'increase') {
      const currentItem = this.cartData?.items?.find(
        (item) => item.id.toString() === itemId.toString(),
      );
      newQuantity = (currentItem?.quantity || 0) + 1;
    } else if (quantity === 'decrease') {
      const currentItem = this.cartData?.items?.find(
        (item) => item.id.toString() === itemId.toString(),
      );
      newQuantity = Math.max(0, (currentItem?.quantity || 0) - 1);
    }

    // Remove item if quantity is 0
    if (newQuantity === 0) {
      return this.removeLine(itemId);
    }

    // Check if this item is part of a unified product
    const itemToUpdate = this.cartData?.items?.find(
      (item) => item.id.toString() === itemId.toString(),
    );

    if (itemToUpdate?.properties?._unified_code) {
      // This is a unified product - update all related items
      const unifiedCode = itemToUpdate.properties._unified_code;
      const relatedItems = this.cartData?.items?.filter(
        (item) => item.properties?._unified_code === unifiedCode,
      );

      // Update all related items sequentially to avoid race conditions
      for (const item of relatedItems) {
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: item?.id?.toString(),
              quantity: newQuantity,
            }),
          });

          if (!response.ok) {
            console.warn(`⚠️ Failed to update item ${item.id}, but continuing...`);
            // Continue with other items even if one fails
          }
        } catch (error) {
          console.warn(`⚠️ Error updating item ${item.id}:`, error);
          // Continue with other items even if one fails
        }
      }

      // Get the final cart state
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      this.updateCartData(cart);
      this.dispatchCartEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.CART_UPDATE, {
        itemId,
        quantity: newQuantity,
        unifiedCode,
        updatedItems: relatedItems.map((item) => item.id),
      });
      return cart;
    } else {
      // Regular single item update
      this.setUpdatingState(true);

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemId.toString(),
            quantity: newQuantity,
          }),
        });

        if (response.ok) {
          const cart = await response.json();
          this.updateCartData(cart);
          this.dispatchCartEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.CART_UPDATE, { itemId, quantity: newQuantity });
          return cart;
        } else {
          throw new Error('Failed to update cart quantity');
        }
      } catch (error) {
        console.error('Error updating cart quantity:', error);
        throw error;
      } finally {
        this.setUpdatingState(false);
      }
    }
  }

  /**
   * Clear all items from the cart
   * @returns {Promise<object>} - Updated cart data
   */
  async clear() {
    if (this.isUpdating) return;

    this.setUpdatingState(true);

    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const cart = await response.json();
        this.updateCartData(cart);
        this.dispatchCartEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.CART_REMOVE, { all: true });
        return cart;
      } else {
        throw new Error('Failed to clear cart');
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
      throw error;
    } finally {
      this.setUpdatingState(false);
    }
  }

  /**
   * Remove both parent and child items for unified products
   * @param {number|string} parentItemId - The parent item ID to remove
   * @param {number|string} childItemId - The child item ID to remove
   * @returns {Promise<object>} - Updated cart data
   */
  async removeUnifiedItems(parentItemId, childItemId) {
    if (this.isUpdating) return;

    this.setUpdatingState(true);

    try {
      // Remove both items in sequence
      await this.removeLine(parentItemId);
      await this.removeLine(childItemId);

      // Refresh cart to get updated state
      await this.refreshCart();

      return this.cartData;
    } catch (error) {
      console.error('Error removing unified items:', error);
      throw error;
    } finally {
      this.setUpdatingState(false);
    }
  }

  /**
   * Update quantity for both parent and child items in unified products
   * @param {number|string} parentItemId - The parent item ID
   * @param {number|string} childItemId - The child item ID
   * @param {string} action - 'increase' or 'decrease'
   * @returns {Promise<object>} - Updated cart data
   */
  async updateUnifiedQuantity(parentItemId, childItemId, action) {
    if (this.isUpdating) return;

    this.setUpdatingState(true);

    try {
      // Get current quantities
      const parentItem = this.cartData?.items?.find((item) => item.id == parentItemId);
      const childItem = this.cartData?.items?.find((item) => item.id == childItemId);

      if (!parentItem || !childItem) {
        throw new Error('Parent or child item not found in cart');
      }

      let newQuantity;
      if (action === 'increase') {
        newQuantity = parentItem.quantity + 1;
      } else if (action === 'decrease') {
        newQuantity = Math.max(1, parentItem.quantity - 1);
      } else {
        throw new Error('Invalid action: must be "increase" or "decrease"');
      }

      // Update both items with the same quantity
      await this.updateQuantity(parentItemId, newQuantity);
      await this.updateQuantity(childItemId, newQuantity);

      // Refresh cart to get updated state
      await this.refreshCart();

      return this.cartData;
    } catch (error) {
      console.error('Error updating unified quantity:', error);
      throw error;
    } finally {
      this.setUpdatingState(false);
    }
  }

  /**
   * Get the current cart count
   * @returns {number} - Number of items in cart
   */
  getCount() {
    if (!this.cartData?.items) return 0;

    // Count only parent items and standalone items (exclude child items)
    let count = 0;
    this.cartData.items.forEach((item) => {
      const relationship = item.properties?._relationship;
      if (relationship !== 'child') {
        count += item.quantity;
      }
    });

    return count;
  }

  /**
   * Get the current cart data
   * @returns {object|null} - Current cart data
   */
  getData() {
    return this.cartData;
  }

  /**
   * Open the cart drawer
   */
  open() {
    this.isOpen = true;
    this.element.setAttribute('data-active', 'true');
    document.body.setAttribute('data-cart-open', 'true');

    // Focus management
    this.focusFirstElement();

    // No refresh here. Adding one looked right - the drawer renders from
    // cartData captured at page load - but measured on the live storefront it
    // turned one GET /cart.js per open into three: this call, then the
    // cart:opened listener in snippets/free-shipping-progress.liquid which
    // fetches /cart.js itself, then that same listener again when
    // refreshCart() dispatched cart-update on completion. The drawer is
    // already refreshed on open by that listener's fetch, and add, remove and
    // quantity changes each refresh through their own paths.
    //
    // Collapsing the remaining duplication means teaching
    // free-shipping-progress to read the cart off the cart-update payload
    // instead of re-fetching it. That is a change to a different snippet and
    // is not attempted here.

    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('cart:opened'));
  }

  /**
   * Close the cart drawer
   */
  close() {
    this.isOpen = false;
    this.element.setAttribute('data-active', 'false');
    document.body.removeAttribute('data-cart-open');

    // Return focus to trigger element
    this.returnFocus();

    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('cart:closed'));
  }

  /**
   * Load cart data from Shopify
   * @returns {Promise<object>} - Cart data
   */
  async loadCart() {
    try {
      const response = await fetch('/cart.js');

      if (response.ok) {
        const cart = await response.json();

        // Validate cart data structure
        if (cart && typeof cart === 'object') {
          if (typeof cart.item_count !== 'undefined') {
            this.updateCartData(cart);
            return cart;
          } else {
            console.warn(
              'Cart data missing item_count, but has other properties:',
              Object.keys(cart),
            );
            // Try to construct a valid cart object
            const validCart = {
              item_count: cart.items ? cart.items.length : 0,
              items: cart.items || [],
              total_price: cart.total_price || 0,
              ...cart,
            };
            this.updateCartData(validCart);
            return validCart;
          }
        } else {
          console.error('Invalid cart data received:', cart);
          throw new Error('Invalid cart data structure');
        }
      } else {
        console.error('Failed to load cart data:', response.status, response.statusText);
        throw new Error(`Failed to load cart: ${response.status} ${response.statusText}`);
      }
    } catch (error) {
      console.error('Error loading cart:', error);
      // Don't throw the error, just log it and continue
      // This prevents the cart from breaking if there's a network issue
    }
  }

  /**
   * Force refresh the cart state
   * @returns {Promise<object>} - Updated cart data
   */
  async refreshCart() {
    try {
      const cart = await this.loadCart();
      if (cart) {
        this.updateCartDisplay();
        this.updateCartCounts();
      }
      return cart;
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }

  // Private helper methods

  async updateCart(form) {
    if (this.isUpdating) return;

    this.setUpdatingState(true);

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const cart = await response.json();
        this.updateCartData(cart);
        this.dispatchCartEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.CART_UPDATE);
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    } finally {
      this.setUpdatingState(false);
    }
  }

  updateCartData(cart) {
    this.cartData = cart;
    this.updateCartDisplay();
    this.updateCartCounts();
  }

  updateCartDisplay() {
    if (!this.cartData) {
      return;
    }

    const hasItems = this.cartData.item_count > 0;

    // Don't recommend what's already in the cart. Done here rather than in
    // Liquid because the drawer updates client side: a card skipped at render
    // would stay gone after its product was removed again. The heading goes
    // too once nothing is left to show.
    const inCart = new Set(this.cartData.items.map((item) => String(item.product_id)));
    this.element.querySelectorAll('[data-component="cart-addons"]').forEach((addons) => {
      const cards = [...addons.querySelectorAll('cart-product-card')];
      cards.forEach((card) => {
        card.hidden = inCart.has(card.dataset.productId);
      });
      addons.hidden = cards.every((card) => card.hidden);
    });

    // Update the data-has-items attribute
    this.element.setAttribute('data-has-items', hasItems.toString());

    // Also update the cart footer visibility
    if (this.cartFooter) {
      this.cartFooter.style.display = hasItems ? 'block' : 'none';
    }

    if (hasItems) {
      this.renderCartItems(this.cartData.items);
      this.updateCartTotal(this.cartData.total_price);

      // Ensure cart items are visible and empty state is hidden
      if (this.cartItems) {
        this.cartItems.style.display = 'block';
      }
      if (this.cartEmpty) {
        this.cartEmpty.style.display = 'none';
      }
    } else {
      // Clear cart items and reset total
      if (this.cartItems) {
        this.cartItems.innerHTML = '';
        this.cartItems.style.display = 'none';
      }
      if (this.cartEmpty) {
        this.cartEmpty.style.display = 'flex';
      }
      this.updateCartTotal(0);
    }
  }

  updateCartCounts() {
    const count = this.getCount();

    // Update all cart count elements on the page
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    cartCountElements.forEach((element) => {
      element.textContent = count;
      element.setAttribute('data-count', count.toString());

      // Show/hide based on count
      if (count > 0) {
        element.style.display = 'block';
      } else {
        element.style.display = 'none';
      }
    });

    // Update cart count in any cart triggers
    const cartTriggers = document.querySelectorAll('[data-trigger="cart"]');
    cartTriggers.forEach((trigger) => {
      const countElement = trigger.querySelector('[data-cart-count]');
      if (countElement) {
        countElement.textContent = count;
        countElement.setAttribute('data-count', count.toString());
      }
    });
  }

  renderCartItems(items) {
    if (!this.cartItems) return;

    // Group items by unified code to handle parent-child relationships
    const groupedItems = this.groupItemsByUnifiedCode(items);

    this.cartItems.innerHTML = groupedItems
      .map((group) => {
        if (group.type === 'unified') {
          // Render unified parent-child items
          const parentItem = group.parent;
          const childItem = group.child;

          return `
            <div class="cart-item cart-item--unified" data-cart-item data-item-id="${parentItem.id}" data-unified-code="${parentItem.properties?._unified_code || ''}">
              <a href="${parentItem.url}" class="cart-item__image">
                <img src="${forayCdnImg(parentItem.image, 200)}" alt="${parentItem.title}" width="80" height="80" loading="lazy">
              </a>
              
              <div class="cart-item__content">
                <div class="cart-item__top">
                  <h3 class="cart-item__title h4"><a href="${parentItem.url}">${parentItem.product_title}</a></h3>
                  ${this.isFinalSaleItem(parentItem) ? '<p class="cart-item__final-sale">Final Sale</p>' : ''}
                  ${parentItem.options_with_values.map((option) => `<p class="cart-item__option"> <span>${option.name}:</span> ${option.value}</p>`).join('')}
                  
                  <div class="cart-item__additional-product">
                    <p class="cart-item__additional-title">+ ${childItem.product_title}</p>
                    ${childItem.options_with_values.map((option) => `<p class="cart-item__option cart-item__option--additional"> <span>${option.name}:</span> ${option.value}</p>`).join('')}
                  </div>
                  
                  <p class="cart-item__quantity">
                    <span>Qty:</span>
                    ${parentItem.quantity}
                  </p>
                  <p class="cart-item__price">${this.formatMoney(parentItem.final_price + childItem.final_price)}</p>
                </div>
                
                <div class="cart-item__controls">
                  <div class="cart-item__quantity" data-cart-item__quantity>
                    <button 
                      type="button" 
                      data-quantity-btn 
                      data-action="decrease" 
                      data-item-id="${parentItem.id}"
                      aria-label="Decrease quantity"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                    </button>
                    
                    <span class="cart-item__quantity-display">${parentItem.quantity}</span>
                    
                    <button 
                      type="button" 
                      data-quantity-btn 
                      data-action="increase" 
                      data-item-id="${parentItem.id}"
                      aria-label="Increase quantity"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                    </button>
                  </div>

                  <div class="cart-item__remove">
                    <button 
                      type="button" 
                      data-remove-item="${parentItem.id}"
                      class="cart-item__remove-button"
                      aria-label="Remove item"
                    >
                      Remove All
                    </button>
                  </div>
                </div>
              </div>
            </div>
          `;
        } else {
          // Render standard single item
          const item = group.item;

          return `
            <div class="cart-item" data-cart-item data-item-id="${item.id}">
              <a href="${item.url}" class="cart-item__image">
                <img src="${forayCdnImg(item.image, 200)}" alt="${item.title}" width="80" height="80" loading="lazy">
              </a>
              
              <div class="cart-item__content">
                <div class="cart-item__top">
                  <h3 class="cart-item__title h4"><a href="${item.url}">${item.product_title}</a></h3>

                  ${this.isFinalSaleItem(item) ? '<p class="cart-item__final-sale">Final Sale</p>' : ''}

                  ${item.options_with_values.map((option) => `<p class="cart-item__option"> <span>${option.name}:</span> ${option.value}</p>`).join('')}
                  <p class="cart-item__quantity">
                    <span>Qty:</span>
                    ${item.quantity}
                  </p>
                  <p class="cart-item__price">${this.formatMoney(item.final_price)}</p>
                </div>
                
                <div class="cart-item__controls">
                  <div class="cart-item__quantity" data-cart-item__quantity>
                    <button 
                      type="button" 
                      data-quantity-btn 
                      data-action="decrease" 
                      data-item-id="${item.id}"
                      aria-label="Decrease quantity"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                    </button>
                    
                    <span class="cart-item__quantity-display">${item.quantity}</span>
                    
                    <button 
                      type="button" 
                      data-quantity-btn 
                      data-action="increase" 
                      data-item-id="${item.id}"
                      aria-label="Increase quantity"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                    </button>
                  </div>

                  <div class="cart-item__remove">
                    <button 
                      type="button" 
                      data-remove-item="${item.id}"
                      class="cart-item__remove-button"
                      aria-label="Remove item"
                    >
                      Remove All
                    </button>
                  </div>
                </div>
              </div>
            </div>
          `;
        }
      })
      .join('');

    this.loadFinalSaleFlags(items);
  }

  /**
   * Group cart items by unified code to handle parent-child relationships
   */
  groupItemsByUnifiedCode(items) {
    const groups = [];
    const processedItems = new Set();

    items.forEach((item) => {
      if (processedItems.has(item.id)) return;

      const unifiedCode = item.properties?._unified_code;
      const relationship = item.properties?._relationship;

      if (unifiedCode && relationship === 'parent') {
        // Find the corresponding child item
        const childItem = items.find(
          (child) =>
            child.properties?._unified_code === unifiedCode &&
            child.properties?._relationship === 'child',
        );

        if (childItem) {
          groups.push({
            type: 'unified',
            parent: item,
            child: childItem,
          });
          processedItems.add(item.id);
          processedItems.add(childItem.id);
        } else {
          // Parent without child - treat as single item
          groups.push({
            type: 'single',
            item: item,
          });
          processedItems.add(item.id);
        }
      } else if (unifiedCode && relationship === 'child') {
        // Hide child items completely - they should only appear with their parent
        processedItems.add(item.id);
        // Don't add to groups - this hides the child item
      } else {
        // Standard item without unified code
        groups.push({
          type: 'single',
          item: item,
        });
        processedItems.add(item.id);
      }
    });

    return groups;
  }

  updateCartTotal(totalPrice) {
    // Update all cart total elements
    const cartTotalElements = this.element.querySelectorAll('[data-cart-total]');

    cartTotalElements.forEach((element) => {
      const formattedTotal = this.formatMoney(totalPrice);
      element.textContent = formattedTotal;
    });

    // Also update the cached cartTotal reference
    if (this.cartTotal) {
      this.cartTotal.textContent = this.formatMoney(totalPrice);
    }
  }

  formatMoney(cents) {
    // Delegates to the single currency-aware formatter defined in
    // layout/theme.liquid. This used to hardcode "$" and USD's two decimals,
    // which mislabelled every non-USD presentment currency.
    return window.Shopify.formatMoney(cents);
  }

  setUpdatingState(updating) {
    this.isUpdating = updating;
    this.element.setAttribute('data-updating', updating.toString());
  }

  dispatchCartEvent(eventType, data = {}) {
    document.dispatchEvent(
      new CustomEvent(eventType, {
        detail: {
          cart: this.cartData,
          ...data,
          timestamp: Date.now(),
        },
      }),
    );
  }

  // Accessibility methods
  focusFirstElement() {
    const focusableElements = this.getFocusableElements();
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }

  returnFocus() {
    // Return focus to the element that opened the cart
    const trigger = document.querySelector('[data-trigger="cart"]:focus');
    if (trigger) {
      trigger.focus();
    }
  }

  getFocusableElements() {
    const selectors = [
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'a[href]',
      '[tabindex]:not([tabindex="-1"])',
    ].join(', ');

    return Array.from(this.element.querySelectorAll(selectors));
  }
}

// Global Cart API
let cartInstance = null;

// Initialize cart component and make it globally available
document.addEventListener('DOMContentLoaded', () => {
  const cartElement = document.querySelector('[data-component="cart"]');
  if (cartElement) {
    cartInstance = new CartComponent(cartElement);

    // Make Cart API globally available
    window.Cart = {
      // Core cart operations
      addLine: (...args) => cartInstance.addLine(...args),
      removeLine: (...args) => cartInstance.removeLine(...args),
      updateQuantity: (...args) => cartInstance.updateQuantity(...args),
      clear: (...args) => cartInstance.clear(...args),

      // Cart state
      getCount: () => cartInstance.getCount(),
      getData: () => cartInstance.getData(),
      loadCart: (...args) => cartInstance.loadCart(...args),
      refreshCart: (...args) => cartInstance.refreshCart(...args),

      // Cart drawer
      open: () => cartInstance.open(),
      close: () => cartInstance.close(),

      // Utility methods
      formatMoney: (cents) => cartInstance.formatMoney(cents),

      // Debug methods
      debug: () => {
        // Debug method - console logs removed for production
      },

      // Test methods
      testAddItem: async (variantId = 123456789) => {
        try {
          const result = await cartInstance.addLine(variantId, 1);
          return result;
        } catch (error) {
          console.error('Test add failed:', error);
          throw error;
        }
      },

      // Test final sale detection
      testFinalSaleDetection: (variantId = 123456789) => {
        return cartInstance.isProductFinalSale(variantId);
      },

      // Instance access (for advanced usage)
      getInstance: () => cartInstance,
    };
  }
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CartComponent);


//# sourceURL=webpack://liquid-starter/./src/components/cart.js?
;

/***/ }),

/***/ "./src/components/collection-filter.js":
/*!*********************************************!*\
  !*** ./src/components/collection-filter.js ***!
  \*********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/**
 * Collection Filter Web Component
 * Handles filtering functionality for collection pages
 * Works with Shopify's built-in filtering system
 */
class CollectionFilter extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
    this.activeFilters = new Map();
    this.init();
  }

  init() {
    this.createOverlay();
    this.bindEvents();
    this.initializeFilterState();
    this.updateFilterCount();
    this.updateActiveFiltersDisplay();
  }

  initializeFilterState() {
    // Initialize active filters from URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Clear existing active filters
    this.activeFilters.clear();

    // Process all URL parameters
    for (const [name, value] of urlParams.entries()) {
      if (name.startsWith('filter.')) {
        this.addActiveFilter(name, value);
      }
    }

    // Update checkbox states to match URL parameters
    const checkboxes = this.querySelectorAll('[data-filter-checkbox]');
    checkboxes.forEach((checkbox) => {
      const name = checkbox.name;
      const value = checkbox.value;
      const isActive = this.activeFilters.has(name) && this.activeFilters.get(name).has(value);
      checkbox.checked = isActive;
    });
  }

  createOverlay() {
    // Create overlay element
    this.overlay = document.createElement('div');
    this.overlay.className = 'collection-filter-overlay';
    this.overlay.setAttribute('data-state', 'hidden');
    this.overlay.setAttribute('data-close', 'filter');
    document.body.appendChild(this.overlay);
  }

  bindEvents() {
    // Handle toggle from header button
    document.addEventListener('click', this.handleClick.bind(this));

    // Handle form submission
    const form = this.querySelector('[data-filter-form]');
    if (form) {
      form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    // Handle checkbox changes
    document.addEventListener('change', this.handleCheckboxChange.bind(this));

    // Handle price input changes
    document.addEventListener('input', this.handlePriceChange.bind(this));
    document.addEventListener('blur', this.handlePriceBlur.bind(this));

    // Handle sort changes
    const sortSelect = this.querySelector('[data-filter-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', this.handleSortChange.bind(this));
    }

    // Handle color filter tab changes
    document.addEventListener('click', this.handleColorTabClick.bind(this));

    // Handle color option clicks
    document.addEventListener('click', this.handleColorOptionClick.bind(this));

    // Handle escape key
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleClick(event) {
    const trigger = event.target.closest('[data-trigger="filter-toggle"]');
    const closeBtn = event.target.closest('[data-close="filter"]');
    const clearAll = event.target.closest('[data-filter-clear-all]');
    const clearBtn = event.target.closest('[data-filter-clear]');
    const activeRemove = event.target.closest('[data-remove-filter]');

    if (trigger) {
      this.toggle();
    }

    if (closeBtn) {
      this.close();
    }

    if (clearAll) {
      this.clearAllFilters();
    }

    if (clearBtn) {
      this.clearForm();
    }

    if (activeRemove) {
      const filterKey = activeRemove.getAttribute('data-remove-filter');
      const [name, value] = filterKey.split(':');
      this.removeActiveFilter(name, value);

      // Update corresponding form input
      const input = this.querySelector(`input[name="${name}"][value="${value}"]`);
      if (input) {
        input.checked = false;
      }

      this.updateActiveFiltersDisplay();
      this.updateFilterCount();

      // Don't auto-apply filters - just update the display
      // this.applyFilters(); // REMOVED - will only apply when button is clicked
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isExpanded) {
      this.close();
    }
  }

  toggle() {
    if (this.isExpanded) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isExpanded = true;
    this.setAttribute('data-state', 'expanded');
    this.overlay.setAttribute('data-state', 'visible');

    // Update header button state
    const headerBtn = document.querySelector('[data-trigger="filter-toggle"]');
    if (headerBtn) {
      headerBtn.setAttribute('aria-expanded', 'true');
    }

    // Prevent body scroll
    document.body.style.overflow = 'hidden';

    // Focus first focusable element
    this.focusFirstElement();
  }

  close() {
    this.isExpanded = false;
    this.setAttribute('data-state', 'collapsed');
    this.overlay.setAttribute('data-state', 'hidden');

    // Update header button state
    const headerBtn = document.querySelector('[data-trigger="filter-toggle"]');
    if (headerBtn) {
      headerBtn.setAttribute('aria-expanded', 'false');
    }

    // Restore body scroll
    document.body.style.overflow = '';

    // Focus header button
    if (headerBtn) {
      headerBtn.focus();
    }
  }

  focusFirstElement() {
    const focusableElements = this.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    // Build the filter URL and navigate
    this.applyFilters();
  }

  handleCheckboxChange(event) {
    const checkbox = event.target;
    if (!checkbox.matches('[data-filter-checkbox]')) return;

    const name = checkbox.name;
    const value = checkbox.value;
    const isChecked = checkbox.checked;

    // Add a small delay to ensure the checkbox state is properly updated
    setTimeout(() => {
      if (isChecked) {
        this.addActiveFilter(name, value);
      } else {
        this.removeActiveFilter(name, value);
      }

      this.updateActiveFiltersDisplay();
      this.updateFilterCount();

      // Don't auto-apply filters - just update the display
      // this.applyFilters(); // REMOVED - will only apply when button is clicked
    }, 50);
  }

  handlePriceChange(event) {
    const input = event.target;
    if (!input.matches('[data-filter-price-min], [data-filter-price-max]')) return;

    const name = input.name;
    const value = input.value;

    if (value && value !== '') {
      this.addActiveFilter(name, value);
    } else {
      this.removeActiveFilter(name, value);
    }

    this.updateActiveFiltersDisplay();
    this.updateFilterCount();

    // Don't auto-apply filters - just update the display
    // this.applyFilters(); // REMOVED - will only apply when button is clicked
  }

  handlePriceBlur(event) {
    const input = event.target;
    if (!input.matches('[data-filter-price-min], [data-filter-price-max]')) return;

    const minInput = this.querySelector('[data-filter-price-min]');
    const maxInput = this.querySelector('[data-filter-price-max]');

    if (minInput && maxInput) {
      const minValue = parseFloat(minInput.value);
      const maxValue = parseFloat(maxInput.value);

      if (!isNaN(minValue) && !isNaN(maxValue) && minValue > maxValue) {
        // Swap values if min is greater than max
        minInput.value = maxValue;
        maxInput.value = minValue;

        // Update active filters
        this.removeActiveFilter(minInput.name, minValue);
        this.removeActiveFilter(maxInput.name, maxValue);
        this.addActiveFilter(minInput.name, maxValue);
        this.addActiveFilter(maxInput.name, minValue);
      }

      // Don't auto-apply filters - just update the display
      // this.applyFilters(); // REMOVED - will only apply when button is clicked
    }
  }

  handleSortChange(event) {
    const select = event.target;
    const value = select.value;

    if (value) {
      this.addActiveFilter('sort_by', value);
    } else {
      this.removeActiveFilter('sort_by', value);
    }

    this.updateActiveFiltersDisplay();
    this.updateFilterCount();

    // Don't auto-apply filters - just update the display
    // this.applyFilters(); // REMOVED - will only apply when button is clicked
  }

  handleColorTabClick(event) {
    const colorTab = event.target.closest('[data-color-tab]');
    if (!colorTab) return;

    event.preventDefault();

    const tabName = colorTab.getAttribute('data-color-tab');
    const colorGroup = colorTab.closest('[data-filter-group]');

    if (!colorGroup) return;

    // Update tab states
    const tabs = colorGroup.querySelectorAll('[data-color-tab]');
    tabs.forEach((tab) => {
      tab.classList.remove('active');
    });
    colorTab.classList.add('active');

    // Update panel states
    const panels = colorGroup.querySelectorAll('[data-color-panel]');
    panels.forEach((panel) => {
      panel.classList.remove('active');
    });

    const activePanel = colorGroup.querySelector(`[data-color-panel="${tabName}"]`);
    if (activePanel) {
      activePanel.classList.add('active');
    }

    // Update ARIA attributes for accessibility
    colorTab.setAttribute('aria-selected', 'true');
    tabs.forEach((tab) => {
      if (tab !== colorTab) {
        tab.setAttribute('aria-selected', 'false');
      }
    });
  }

  handleColorOptionClick(event) {
    const colorButton = event.target.closest('.variant-option.color-option');
    if (!colorButton) return;

    event.preventDefault();

    const colorOption = colorButton.closest('.collection-filter__color-option');
    if (!colorOption) return;

    const checkbox = colorOption.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  addActiveFilter(name, value) {
    if (!this.activeFilters.has(name)) {
      this.activeFilters.set(name, new Set());
    }
    this.activeFilters.get(name).add(value);
  }

  removeActiveFilter(name, value) {
    if (this.activeFilters.has(name)) {
      this.activeFilters.get(name).delete(value);
      if (this.activeFilters.get(name).size === 0) {
        this.activeFilters.delete(name);
      }
    }
  }

  updateFilterCount() {
    const count = this.activeFilters.size;
    const countElements = document.querySelectorAll('[data-filter-count]');

    countElements.forEach((element) => {
      element.textContent = count;
      element.setAttribute('data-count', count);
    });
  }

  updateActiveFiltersDisplay() {
    const activeContainer = this.querySelector('[data-active-filters]');
    const activeList = this.querySelector('[data-active-filters-list]');

    if (!activeContainer || !activeList) return;

    // Clear existing active filters
    activeList.innerHTML = '';

    // Add current active filters
    this.activeFilters.forEach((values, name) => {
      values.forEach((value) => {
        const tag = document.createElement('div');
        tag.className = 'collection-filter__active-tag';
        tag.innerHTML = `
          <span>${this.getFilterDisplayName(name, value)}</span>
          <button
            class="collection-filter__active-remove"
            data-remove-filter="${name}:${value}"
            aria-label="Remove ${this.getFilterDisplayName(name, value)} filter"
            type="button"
          >
            ×
          </button>
        `;
        activeList.appendChild(tag);
      });
    });

    // Show/hide active filters container
    const hasActiveFilters = this.activeFilters.size > 0;
    activeContainer.setAttribute('data-state', hasActiveFilters ? 'visible' : 'hidden');
  }

  getFilterDisplayName(name, value) {
    // Get the display name for the filter value
    const checkbox = this.querySelector(`input[name="${name}"][value="${value}"]`);
    if (checkbox) {
      const label = checkbox.closest('label');
      if (label) {
        const textElement = label.querySelector('.collection-filter__checkbox-text, .collection-filter__color-text');
        if (textElement) {
          return textElement.textContent.trim().split('(')[0].trim();
        }
      }
    }
    return value;
  }

  applyFilters() {
    const form = this.querySelector('[data-filter-form]');
    if (!form) return;

    // Build URL with current filters
    const url = new URL(form.action);
    const formData = new FormData(form);

    // Clear existing filter parameters
    const paramsToRemove = [];
    for (const [key] of url.searchParams.entries()) {
      if (key.startsWith('filter.')) {
        paramsToRemove.push(key);
      }
    }
    paramsToRemove.forEach((key) => url.searchParams.delete(key));

    // Add active filters to form data and URL
    this.activeFilters.forEach((values, name) => {
      values.forEach((value) => {
        formData.append(name, value);
        // For multiple values with the same name, we need to handle them properly
        if (url.searchParams.has(name)) {
          // If the parameter already exists, append to it
          const existingValues = url.searchParams.getAll(name);
          if (!existingValues.includes(value)) {
            url.searchParams.append(name, value);
          }
        } else {
          url.searchParams.set(name, value);
        }
      });
    });

    // Add other form parameters (sort, etc.)
    for (const [name, value] of formData.entries()) {
      if (!name.startsWith('filter.') || this.activeFilters.has(name)) {
        // Skip filter parameters we've already handled, but include others
        if (!name.startsWith('filter.') || this.activeFilters.has(name)) {
          url.searchParams.set(name, value);
        }
      }
    }

    // Navigate to filtered URL
    window.location.href = url.toString();
  }

  clearAllFilters() {
    console.log('Clear All Filters clicked');

    this.activeFilters.clear();
    this.updateActiveFiltersDisplay();
    this.updateFilterCount();
    this.clearForm();

    console.log('Active filters cleared, form reset');

    // Don't auto-apply filters - just update the display
    // this.applyFilters(); // REMOVED - will only apply when button is clicked
  }

  clearForm() {
    // Clear form inputs
    const checkboxes = this.querySelectorAll('[data-filter-checkbox]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    const priceInputs = this.querySelectorAll('[data-filter-price-min], [data-filter-price-max]');
    priceInputs.forEach((input) => {
      input.value = '';
    });

    // Reset sort to "manual" (Featured)
    const sortSelect = this.querySelector('[data-filter-sort]');
    if (sortSelect) {
      sortSelect.value = 'manual';
    }
  }

  disconnectedCallback() {
    // Clean up overlay when component is removed
    if (this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }

    // Restore body scroll
    document.body.style.overflow = '';
  }
}

customElements.define('collection-filter', CollectionFilter);


//# sourceURL=webpack://liquid-starter/./src/components/collection-filter.js?
;

/***/ }),

/***/ "./src/components/custom-search-results.js":
/*!*************************************************!*\
  !*** ./src/components/custom-search-results.js ***!
  \*************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);

// Shopify's image CDN resizes via a width param. These components build img
// tags in JS from raw CDN URLs, so without this they download the original
// upload at full resolution for thumbnails - one was 472 KB for an 80px slot.
// Idempotent, and leaves non-Shopify URLs untouched.
function forayCdnImg(url, w) { if (!url || typeof url !== 'string') return url; if (url.indexOf('width=') !== -1) return url; if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url; return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }

// --- Algolia Insights -------------------------------------------------------
//
// Searches were being sent with clickAnalytics off and no event was ever
// reported, so Algolia's dashboard showed queries with no click-through and the
// index had no behavioural signal to rank on. loadInsights() in
// instantsearch-integration.js puts search-insights on the page.
//
// aa() is queue-safe: the stub loadInsights() installs accepts calls before
// search-insights.js finishes downloading and replays them on load. If the
// loader is ever removed, aa is simply undefined and these become no-ops
// rather than throwing on every click.
const INSIGHTS_INDEX = 'shopify_products';
const CONVERSION_KEY = 'foray:algolia:lastSearch';
// Read by the Algolia purchase custom pixel (algolia-purchase-pixel.js at the
// repo root, installed in Shopify admin > Customer events). The key and the
// record shape are a contract with that pixel.
const CART_SEARCHES_KEY = 'foray:algolia:cartSearches';
const INSIGHTS_TOKEN_KEY = 'foray:algolia:userToken';

// Algolia builds this index from the queries customers actually run, on a
// schedule -- it is not a list anyone maintains by hand. It only became useful
// once searches were reaching Algolia's analytics, so it starts near-empty and
// fills on its own.
const SUGGESTIONS_INDEX = 'shopify_products_query_suggestions';

// Below this many suggestions the row reads as broken rather than helpful --
// "Popular searches: skirt" is worse than no row at all. The index held exactly
// one entry the day this shipped, so the row simply will not appear until real
// search traffic has accumulated, and then appears on its own.
const MIN_SUGGESTIONS = 3;
const MAX_SUGGESTIONS = 8;

// search-insights refuses every method until init() has been given credentials:
// "Before calling any methods on the analytics, you first need to call the
// 'init' function with appId and apiKey parameters". The loader does not init,
// so this does. (Before it existed, the instantsearch middleware that loaded the
// script never completed init either, and every event was thrown away --
// verified on the live storefront 2026-09-22: aa.queue held 4 unsent events.)
let insightsReady = false;

function ensureInsights() {
  if (insightsReady) return true;

  const aa = window[window.AlgoliaAnalyticsObject || 'aa'];
  if (typeof aa !== 'function') return false;

  const config = (0,_constants_algolia_js__WEBPACK_IMPORTED_MODULE_0__.getAlgoliaConfig)();
  if (!config || !config.appId || !config.searchApiKey) return false;

  // useCookie is left off: the storefront runs a cookie-consent banner, and an
  // analytics cookie set before that is answered is exactly what it is there to
  // gate. Without it search-insights mints a fresh anonymous token per page
  // load, which would split a click on one page from its conversion on the
  // next, so the token is carried in sessionStorage instead -- same per-tab,
  // dies-with-the-session profile as the conversion handoff above, and never
  // sent to any other origin.
  let userToken;
  try {
    userToken = sessionStorage.getItem(INSIGHTS_TOKEN_KEY);
    if (!userToken) {
      userToken = `anon-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      sessionStorage.setItem(INSIGHTS_TOKEN_KEY, userToken);
    }
  } catch {
    userToken = undefined; // private mode: let search-insights mint its own
  }

  aa('init', { appId: config.appId, apiKey: config.searchApiKey });
  if (userToken) aa('setUserToken', userToken);

  insightsReady = true;
  return true;
}

// These strings are other customers' search queries coming back from an index,
// so they are untrusted input being written into markup.
function escapeAttribute(value) {
  return String(value).replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c],
  );
}

function aaSend(method, payload) {
  try {
    if (!ensureInsights()) return;
    const aa = window[window.AlgoliaAnalyticsObject || 'aa'];
    aa(method, payload);
  } catch {
    // Insights is telemetry. It must never break a click-through.
  }
}

// A conversion happens on the product page, one navigation after the search, so
// the queryID has to survive the hop. sessionStorage rather than a cookie: it
// is per-tab, dies with the session, and never rides along on a request.
//
// The handle, not the clicked variant, is what gets remembered. Records are per
// variant but getResultUrl() links to the bare product page, so the variant the
// search happened to surface is almost never the one the customer adds -- they
// pick their own size on the PDP. Gating on the product and reporting whichever
// variant they actually added is both correct and what Algolia wants, since
// every variant is its own objectID in this index.
//
// The index travels too. A queryID belongs to the index that answered the
// query, and a sorted results page queries a replica, not shopify_products --
// so a conversion reported against the primary cited a queryID from another
// index.
function rememberSearchHit(handle, queryID, index = INSIGHTS_INDEX) {
  if (!handle || !queryID) return;
  try {
    sessionStorage.setItem(CONVERSION_KEY, JSON.stringify({ handle, queryID, index, at: Date.now() }));
  } catch {
    // Private mode, or storage full. Conversion attribution is lost, nothing else.
  }
}

// Algolia attributes a conversion to the search that produced the click. An
// hour is well past the point where a cart add is plausibly the same intent,
// and keeps a stale tab from crediting this morning's search.
//
// Requiring the current page to be the product that was clicked keeps this
// conservative: a quick-add from a collection page reports nothing rather than
// crediting the search for a product it never showed.
function takeRememberedHit() {
  try {
    const raw = sessionStorage.getItem(CONVERSION_KEY);
    if (!raw) return null;
    const hit = JSON.parse(raw);
    if (!hit || !hit.handle || !hit.queryID) return null;
    if (Date.now() - hit.at > 60 * 60 * 1000) return null;
    // Exact handle, not a prefix: startsWith would credit a search for
    // "rib-polo" when the customer ended up on "rib-polo-long-sleeve". Matching
    // mid-path also covers /collections/<x>/products/<handle>.
    const onProduct = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!onProduct || onProduct[1] !== hit.handle) return null;

    // Single use. Adding a second size of the same product would otherwise
    // report a second conversion against the same search, inflating the
    // conversion rate the merchandising decisions get made on. One search that
    // led to a cart add is one conversion.
    sessionStorage.removeItem(CONVERSION_KEY);
    return hit;
  } catch {
    return null;
  }
}

// Purchases happen in checkout, which theme code never runs in, so the search
// behind each cart add is left here for the checkout pixel to pick up. One
// record per variant, latest search wins; capped so a long session cannot grow
// it without bound.
function recordCartSearch(variantId, hit) {
  try {
    const records = JSON.parse(sessionStorage.getItem(CART_SEARCHES_KEY) || '[]').filter(
      (r) => r && r.variantId !== String(variantId),
    );
    records.push({
      variantId: String(variantId),
      queryID: hit.queryID,
      index: hit.index || INSIGHTS_INDEX,
      at: Date.now(),
    });
    sessionStorage.setItem(CART_SEARCHES_KEY, JSON.stringify(records.slice(-50)));
  } catch {
    // Private mode or corrupt storage: this purchase goes unattributed, nothing else.
  }
}

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CustomSearchResults: () => (/* binding */ CustomSearchResults),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _constants_algolia_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../constants/algolia.js */ "./src/constants/algolia.js");
/* harmony import */ var _constants_events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/events.js */ "./src/constants/events.js");



/**
 * Custom Search Results Handler
 *
 * Manages the display and interaction of search results in the header search
 * Disables standard Algolia behavior and provides custom result rendering
 */
class CustomSearchResults {
  constructor() {
    this.searchClient = null;
    this.currentQuery = '';
    this.currentResults = [];
    this.currentPage = 1;
    this.resultsPerPage = 20;
    this.isLoading = false;
    this.searchTimeout = null;
    this.searchSeq = 0;
    this.queryID = null;
    this.popularLoaded = false;

    this.init();
  }

  init() {
    // Initialize Algolia search client
    this.searchClient = (0,_constants_algolia_js__WEBPACK_IMPORTED_MODULE_0__.createSearchClient)();

    if (!this.searchClient) {
      return;
    }

    this.bindEvents();
    this.setupResultsContainer();

    // Set initial empty state visibility
    this.setInitialEmptyStateVisibility();
  }

  bindEvents() {
    // Listen for search events from the search widget
    document.addEventListener(_constants_events_js__WEBPACK_IMPORTED_MODULE_1__.EVENTS.SEARCH, this.handleSearchEvent.bind(this));

    // Listen for input changes to show/hide results
    document.addEventListener('input', this.handleInputChange.bind(this));

    // Handle clear button
    document.addEventListener('click', this.handleClearResults.bind(this));

    // Handle pagination
    document.addEventListener('click', this.handlePagination.bind(this));

    // Handle filter changes
    document.addEventListener('change', this.handleFilterChange.bind(this));

    // Result items are proper links; this listener only reports the click to
    // Algolia and lets the navigation proceed untouched.
    document.addEventListener('click', this.handleResultClick.bind(this));

    // A cart add anywhere on the site may be the conversion for a search that
    // happened a page ago. Listening for the cart event rather than editing the
    // cart module keeps Insights out of the checkout path entirely.
    document.addEventListener(_constants_events_js__WEBPACK_IMPORTED_MODULE_1__.EVENTS.CART_ADD, this.handleCartAdd.bind(this));

    // Popular searches load on first focus, not on page load. The search widget
    // is rendered into the header of every page, so fetching on load would add
    // an Algolia request to every pageview on the site to populate a row most
    // visitors never open.
    document.addEventListener('focusin', (event) => {
      if (event.target.closest('.custom-search-input')) this.loadPopularSearches();
    });

    document.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-popular-search]');
      if (!chip) return;
      event.preventDefault();
      window.location.href = `/search?q=${encodeURIComponent(chip.dataset.popularSearch)}`;
    });
  }

  // Renders the row above the merchandised links in the dropdown's empty state,
  // which stay as the fallback when there is nothing popular enough to show.
  async loadPopularSearches() {
    if (this.popularLoaded || !this.searchClient) return;
    this.popularLoaded = true;

    let queries = [];
    try {
      const response = await this.searchClient.search([
        {
          indexName: SUGGESTIONS_INDEX,
          params: {
            query: '',
            hitsPerPage: MAX_SUGGESTIONS,
            attributesToRetrieve: ['query'],
            attributesToHighlight: [],
            // These are the customer's own past queries, not catalogue records.
            // Reporting them as searches would feed them back into the index
            // that generated them, inflating their own popularity.
            analytics: false,
            clickAnalytics: false,
          },
        },
      ]);
      queries = (response.results[0]?.hits || []).map((hit) => hit.query).filter(Boolean);
    } catch {
      return; // No suggestions index yet, or it is unreachable. Links remain.
    }

    if (queries.length < MIN_SUGGESTIONS) return;
    this.renderPopularSearches(queries);
  }

  renderPopularSearches(queries) {
    const widget = document.querySelector('.custom-search-widget');
    if (!widget || widget.querySelector('[data-popular-searches]')) return;

    const chips = queries
      .map(
        (q) =>
          `<button type="button" class="custom-popular-chip" data-popular-search="${escapeAttribute(q)}">${escapeAttribute(q)}</button>`,
      )
      .join('');

    const row = document.createElement('div');
    row.className = 'custom-search-popular';
    row.setAttribute('data-popular-searches', '');
    row.innerHTML = `<h5 class="custom-search-popular__title">Popular searches</h5><div class="custom-search-popular__chips">${chips}</div>`;

    // Before the merchandised links, and inside the widget so the existing
    // [data-has-query="true"] rule hides it the moment the customer types.
    const links = widget.querySelector('.custom-search-layout');
    if (links) widget.insertBefore(row, links);
    else widget.appendChild(row);
  }

  handleResultClick(event) {
    const link = event.target.closest('.search-result-item[data-object-id]');
    if (!link || !this.queryID) return;

    const objectID = link.dataset.objectId;
    const position = Number(link.dataset.position);
    if (!objectID || !position) return;

    rememberSearchHit(link.dataset.handle, this.queryID);
    aaSend('clickedObjectIDsAfterSearch', {
      index: INSIGHTS_INDEX,
      eventName: 'Search Result Clicked',
      queryID: this.queryID,
      objectIDs: [objectID],
      positions: [position],
    });
  }

  handleCartAdd(event) {
    // objectID in this index is the variant id, which is exactly what the cart
    // event carries -- no lookup needed to report the variant they chose.
    const variantId = event.detail?.variantId;
    if (!variantId) return;

    const hit = takeRememberedHit();
    if (!hit) return;

    // addedToCart rather than the generic converted event: it carries
    // eventSubtype "addToCart", which is what Algolia's add-to-cart rate and
    // revenue reports count. A plain conversion lands in neither.
    aaSend('addedToCartObjectIDsAfterSearch', {
      index: hit.index || INSIGHTS_INDEX, // hits remembered before the index was stored
      eventName: 'Product Added to Cart After Search',
      queryID: hit.queryID,
      objectIDs: [String(variantId)],
    });
    recordCartSearch(variantId, hit);
  }

  setupResultsContainer() {
    // Ensure the results container exists
    const resultsContainer = document.querySelector('[data-header-search-results]');

    if (!resultsContainer) {
      return;
    }

    // Hide results initially
    this.hideResults();
  }

  setInitialEmptyStateVisibility() {
    // Check if there's already a query in the search input
    const searchInput = document.querySelector('.custom-search-input, .search-input');
    if (searchInput) {
      const query = searchInput.value.trim();
      const hasQuery = query && query.length >= 2;
      this.toggleEmptyStateVisibility(hasQuery);
    } else {
      // No input found, show empty state
      this.toggleEmptyStateVisibility(false);
    }
  }

  handleSearchEvent(event) {
    const { query, type } = event.detail;

    if (type === 'submit' || type === 'suggestion_selected') {
      this.currentQuery = query;
      this.currentPage = 1;
      this.performSearch(query);
    }
  }

  handleInputChange(event) {
    const searchInput = event.target.closest('.custom-search-input, .search-input');
    if (!searchInput) return;

    const query = searchInput.value.trim();

    // Toggle empty state visibility based on query length
    this.toggleEmptyStateVisibility(query.length >= 2);

    if (query.length >= 2) {
      this.currentQuery = query;
      this.currentPage = 1;
      this.debouncedSearch(query);
    } else {
      clearTimeout(this.searchTimeout);
      this.hideResults();
      this.showEmptyState();
    }
  }

  // Keystrokes are debounced. Without this every character fired its own
  // Algolia request -- typing "skirt" cost four, each ~400 KB -- and the
  // responses could land out of order, rendering hits for a prefix of what the
  // customer had typed. Deliberate actions (pagination, filters, submitting the
  // form) keep calling performSearch directly, since those are one per click.
  debouncedSearch(query) {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => this.performSearch(query), 300);
  }

  handleClearResults(event) {
    const clearButton = event.target.closest('[data-search-results-clear]');
    if (!clearButton) return;

    event.preventDefault();
    this.clearResults();

    // Reset empty state visibility when clearing
    this.toggleEmptyStateVisibility(false);
  }

  handlePagination(event) {
    const prevButton = event.target.closest('[data-search-pagination-prev]');
    const nextButton = event.target.closest('[data-search-pagination-next]');

    if (prevButton && !prevButton.disabled) {
      event.preventDefault();
      this.currentPage = Math.max(1, this.currentPage - 1);
      this.performSearch(this.currentQuery);
    } else if (nextButton && !nextButton.disabled) {
      event.preventDefault();
      this.currentPage++;
      this.performSearch(this.currentQuery);
    }
  }

  handleFilterChange(event) {
    const filterCheckbox = event.target.closest('.search-filter-option input[type="checkbox"]');
    const sortSelect = event.target.closest('.search-sort-select');

    if (filterCheckbox || sortSelect) {
      this.currentPage = 1;
      this.performSearch(this.currentQuery);
    }
  }

  async performSearch(query) {
    if (!this.searchClient || !query.trim()) {
      this.hideResults();
      return;
    }

    clearTimeout(this.searchTimeout);
    const seq = ++this.searchSeq;
    this.setLoading(true);

    try {
      // Get active filters
      const activeFilters = this.getActiveFilters();
      const sortBy = this.getSortBy();

      // Perform search with Algolia
      const searchParams = {
        query,
        page: this.currentPage - 1, // Algolia uses 0-based pagination
        hitsPerPage: this.resultsPerPage,
        filters: this.buildFilters(activeFilters),
        // Only what renderResultItem() reads. Unrestricted, these records carry
        // the full description, every option and named tag, and a
        // _highlightResult mirroring all of it. Nothing highlights server-side
        // either -- highlightQuery() marks the match in the browser.
        attributesToRetrieve: [
          'title',
          'handle',
          'product_image',
          'image',
          'variants_min_price',
          'variants_max_price',
        ],
        attributesToHighlight: [],
        // Required for queryID, which every Insights event has to cite. Without
        // it Algolia records the search but can never tie a click or a purchase
        // back to it, so the dashboard shows traffic with a 0% click-through
        // rate and the index's AI re-ranking has nothing to learn from.
        clickAnalytics: true,
        ...this.buildSortParams(sortBy),
      };

      const results = await this.searchClient.search([
        {
          indexName: (0,_constants_algolia_js__WEBPACK_IMPORTED_MODULE_0__.getAlgoliaConfig)().indexName,
          params: searchParams,
        },
      ]);
      if (seq !== this.searchSeq) return; // a newer search already went out
      this.currentResults = results.results[0];
      this.queryID = this.currentResults?.queryID || null;
      this.renderResults();
    } catch {
      if (seq === this.searchSeq) this.showError('Search failed. Please try again.');
    } finally {
      if (seq === this.searchSeq) this.setLoading(false);
    }
  }

  getActiveFilters() {
    const checkboxes = document.querySelectorAll(
      '.search-filter-option input[type="checkbox"]:checked',
    );
    return Array.from(checkboxes).map((cb) => cb.value);
  }

  getSortBy() {
    const sortSelect = document.querySelector('.search-sort-select');
    return sortSelect ? sortSelect.value : 'relevance';
  }

  // No stock filter. powerindex enforced one with an unconditional "SHOW ONLY
  // IN STOCK" query rule, and this carried it over as filters:
  // 'inventory_available:true'. That made a product vanish from search the
  // moment it sold out rather than ranking last -- which is how "Intarsia Golf
  // Sweater" could return nothing while it was still selling. Customers who
  // can see a product on a collection page could not find it by name, and a
  // sold-out result is what drives the back-in-stock signup.
  //
  // The cost of removing it is one product today (371 -> 372), because the
  // index already floats in-stock records up by customRanking. To bring it
  // back, return 'inventory_available:true' here.
  //
  // activeFilters comes from the category checkboxes in the dropdown, which
  // only ever contain "products", so they add nothing to the query today.
  buildFilters() {
    return '';
  }

  buildSortParams(sortBy) {
    switch (sortBy) {
      case 'price-low':
        return { sortFacetBy: 'price', sortFacetValues: { price: ['asc'] } };
      case 'price-high':
        return { sortFacetBy: 'price', sortFacetValues: { price: ['desc'] } };
      case 'newest':
        return { sortFacetBy: 'created_at', sortFacetValues: { created_at: ['desc'] } };
      case 'popular':
        return { sortFacetBy: 'popularity', sortFacetValues: { popularity: ['desc'] } };
      default:
        return {};
    }
  }

  renderResults() {
    const resultsContainer = document.querySelector('[data-header-search-results]');
    const resultsList = document.querySelector('[data-search-results-list]');
    const resultsCount = document.querySelector('[data-search-results-count]');
    const paginationContainer = document.querySelector('[data-search-results-pagination]');

    if (!resultsContainer || !resultsList) {
      return;
    }

    const hits = this.currentResults?.hits || [];
    const totalHits = this.currentResults?.nbHits || 0;
    const totalPages = Math.ceil(totalHits / this.resultsPerPage);

    // Update results count
    if (resultsCount) {
      resultsCount.textContent = `${totalHits} result${totalHits !== 1 ? 's' : ''}`;
    }

    // Render results
    if (hits.length > 0) {
      resultsList.innerHTML = hits
        .map((hit, i) => this.renderResultItem(hit, (this.currentPage - 1) * this.resultsPerPage + i + 1))
        .join('');
      this.showResults();
    } else {
      resultsList.innerHTML = this.renderNoResults();
      this.showResults();
    }

    // Update pagination
    this.updatePagination(paginationContainer, totalPages);
  }

  renderResultItem(hit, position) {
    // product_image is the product's main image; image is the matched
    // variant's, kept as a fallback for products whose main image is unset.
    const image = hit.product_image || hit.image || '';
    const price = hit.variants_max_price ? `$${hit.variants_max_price}` : '';
    const comparePrice = hit.variants_min_price ? `$${hit.variants_min_price}` : '';
    const isOnSale = hit.variants_min_price && hit.variants_max_price < hit.variants_min_price;
    const url = this.getResultUrl(hit);

    const type = hit.objectType || 'product';

    return `
      <a href="${url}" class="search-result-item wweeee" data-object-id="${hit.objectID}" data-position="${position}" data-handle="${hit.handle}">
        <div class="search-result-image">
          ${
            image
              ? `<img src="${forayCdnImg(image, 300)}" alt="${hit.title}" width="80" height="80" loading="lazy" />`
              : `
            <div class="search-result-placeholder">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
              </svg>
            </div>
          `
          }
        </div>
        <div class="search-result-content">
          <h3 class="search-result-title">${this.highlightQuery(hit.title)}</h3>
          <div class="search-result-meta">
            <span class="search-result-type">${type}</span>
            ${
              price
                ? `<span class="search-result-price">
              ${isOnSale ? `<span class="search-result-compare-price">${comparePrice}</span>` : ''}
              ${price}
            </span>`
                : ''
            }
          </div>
        </div>
      </a>
    `;
  }

  renderNoResults() {
    return `
      <div class="search-no-results">
        <div class="search-no-results-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
        </div>
        <h3>No results found</h3>
        <p>Try adjusting your search terms or browse our categories</p>
      </div>
    `;
  }

  updatePagination(container, totalPages) {
    if (!container) return;

    const prevButton = container.querySelector('[data-search-pagination-prev]');
    const nextButton = container.querySelector('[data-search-pagination-next]');
    const currentSpan = container.querySelector('[data-search-pagination-current]');
    const totalSpan = container.querySelector('[data-search-pagination-total]');

    if (totalPages > 1) {
      container.style.display = 'flex';

      if (prevButton) prevButton.disabled = this.currentPage <= 1;
      if (nextButton) nextButton.disabled = this.currentPage >= totalPages;
      if (currentSpan) currentSpan.textContent = this.currentPage;
      if (totalSpan) totalSpan.textContent = totalPages;
    } else {
      container.style.display = 'none';
    }
  }

  getResultUrl(hit) {
    return `/products/${hit.handle}`;
  }

  highlightQuery(text) {
    if (!this.currentQuery || !text) return text;

    const regex = new RegExp(`(${this.currentQuery})`, 'gi');
    return text.replace(regex, '<mark>$1</mark>');
  }

  showResults() {
    const resultsContainer = document.querySelector('[data-header-search-results]');
    const emptyState = document.querySelector('.custom-search-empty-state');

    if (resultsContainer) {
      resultsContainer.style.display = 'block';
    }

    // Hide empty state when showing results
    if (emptyState) {
      emptyState.style.display = 'none';
    }
  }

  showEmptyState() {
    const resultsContainer = document.querySelector('[data-header-search-results]');
    const emptyState = document.querySelector('.custom-search-empty-state');

    if (resultsContainer) {
      resultsContainer.style.display = 'none';
    }

    // Show empty state when hiding results
    if (emptyState) {
      emptyState.style.display = 'block';
    }
  }

  hideResults() {
    const resultsContainer = document.querySelector('[data-header-search-results]');

    if (resultsContainer) {
      resultsContainer.style.display = 'none';
    }

    // Only show empty state if there's no current query
    if (!this.currentQuery || this.currentQuery.length < 2) {
      this.showEmptyState();
    }
  }

  setLoading(loading) {
    this.isLoading = loading;
    const resultsList = document.querySelector('[data-search-results-list]');

    if (loading && resultsList) {
      resultsList.innerHTML = `
        <div class="search-loading">
          <div class="search-loading-spinner"></div>
          <p>Searching...</p>
        </div>
      `;
      this.showResults();
    }
  }

  showError(message) {
    const resultsList = document.querySelector('[data-search-results-list]');
    if (resultsList) {
      resultsList.innerHTML = `
        <div class="search-error">
          <div class="search-error-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-1.41-1.41L10.59 12 8.59 10 7.17 11.41 9.17 13.41 7.59 15z"/>
            </svg>
          </div>
          <h3>Search Error</h3>
          <p>${message}</p>
          <button class="search-retry-button" onclick="window.location.reload()">Try Again</button>
        </div>
      `;
      this.showResults();
    }
  }

  toggleEmptyStateVisibility(hasQuery) {
    const widget = document.querySelector('.custom-search-widget');
    const emptyState = document.querySelector('.custom-search-empty-state');

    if (widget) {
      widget.setAttribute('data-has-query', hasQuery ? 'true' : 'false');
    }

    if (emptyState) {
      emptyState.style.display = hasQuery ? 'none' : 'block';
    }
  }

  clearResults() {
    this.currentQuery = '';
    this.currentResults = [];
    this.currentPage = 1;
    this.hideResults();
    this.showEmptyState(); // Explicitly show empty state when clearing

    // Clear search input
    const searchInput = document.querySelector('.custom-search-input, .search-input');
    if (searchInput) {
      searchInput.value = '';
    }

    // Reset empty state visibility when clearing
    this.toggleEmptyStateVisibility(false);

    // Reset filters
    const checkboxes = document.querySelectorAll('.search-filter-option input[type="checkbox"]');
    checkboxes.forEach((cb) => {
      if (cb.value === 'products') cb.checked = true;
      else cb.checked = false;
    });

    const sortSelect = document.querySelector('.search-sort-select');
    if (sortSelect) {
      sortSelect.value = 'relevance';
    }
  }
}

// --- Algolia results page ---------------------------------------------------
//
// /search?q= renders Shopify's own search server-side (sections/search.liquid);
// this upgrades it in place to Algolia's results. Shopify's search also matches
// description text, so "rib" returned 151 results against Algolia's 37 -- that
// noise is why the header dropdown and the results page used to disagree.
//
// The cards stay server-rendered: Algolia decides which products match, then
// templates/search.algolia.liquid renders those handles through the real
// product-card snippet. Rebuilding the card in JS would have meant
// reimplementing 368 lines of Liquid -- colour swatches, the additional-product
// metafield, Final Sale badges, responsive image sizes -- and watching it drift
// away from every other grid on the site.
//
// Every failure path leaves Shopify's server-rendered results untouched, so the
// page degrades to exactly what it does today rather than to an empty grid.

const SEARCH_PAGE_HITS = 24;
// Shopify's all_products limit per render; see fetchCards().
const CARD_BATCH = 20;

// Each sort is a separate Algolia index, not a query parameter: ranking is baked
// into an index's configuration, so a second order needs a replica. These are
// created and kept in sync by the Algolia Shopify app's sort-order setting --
// never by editing the primary index's ranking, which ranks every search on the
// site by that order and is how "socks" briefly returned a $175 shoe above the
// $12 socks.
const SEARCH_SORTS = [
  { id: 'relevance', label: 'Relevance', index: 'shopify_products' },
  {
    id: 'best-selling',
    label: 'Best Selling',
    index: 'shopify_products_recently_ordered_count_desc',
  },
  { id: 'price-asc', label: 'Price: Low to High', index: 'shopify_products_price_asc' },
  { id: 'price-desc', label: 'Price: High to Low', index: 'shopify_products_price_desc' },
  // published_at, not created_at. Records are per variant, so created_at is the
  // date each *variant* was made: the Rib V-Neck LS Polo carries four different
  // created_at values spanning 2024 to 2026 because colourways were added over
  // time, which would let a two-year-old product surface as "newest" because one
  // colour was restocked. published_at is identical across a product's variants,
  // so the dedupe is unambiguous.
  { id: 'newest', label: 'Newest', index: 'shopify_products_published_at_desc' },
];

// Records are per variant and the index dedupes to one per product, which makes
// both available facet counts wrong for colour and size. facetingAfterDistinct
// counts only each product's representative variant -- Navy reads 6 when
// filtering Navy actually returns 13 products -- and turning it off counts
// variants instead (72). Filtering is correct either way, because facetFilters
// apply before the dedupe, so the counts are simply not rendered for those two.
// product_type is a single value per product, so its counts add up and are kept.
const SEARCH_FACETS = [
  { attribute: 'options.color', label: 'Color', param: 'color', counts: false },
  { attribute: 'options.size', label: 'Size', param: 'size', counts: false },
  { attribute: 'product_type', label: 'Type', param: 'type', counts: true },
];

// Same order as size_rank in snippets/variant-selector.liquid, which is this
// store's source of truth for size order. The index also holds shoe sizes, dress
// sizes and kids' ages; anything unlisted sorts numerically, then alphabetically,
// after the named sizes.
const SEARCH_SIZE_RANK =
  'OS,ONE SIZE,XXXS,XXS,XS,S,SM,SMALL,M,MD,MEDIUM,ML,L,LG,LARGE,XL,XXL,2XL,3XL,4XL,5XL'.split(',');

function escapeHtml(value) {
  return String(value).replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c],
  );
}

function sortFacetValues(attribute, values) {
  if (attribute === 'options.size') {
    return values.sort((a, b) => {
      const ra = SEARCH_SIZE_RANK.indexOf(a.toUpperCase());
      const rb = SEARCH_SIZE_RANK.indexOf(b.toUpperCase());
      if (ra !== -1 && rb !== -1) return ra - rb;
      if (ra !== -1) return -1;
      if (rb !== -1) return 1;
      const na = parseFloat(a);
      const nb = parseFloat(b);
      if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
      return a.localeCompare(b);
    });
  }
  return values.sort((a, b) => a.localeCompare(b));
}

class AlgoliaSearchPage {
  constructor(root) {
    this.root = root;
    this.grid = root.querySelector('[data-algolia-grid]');
    this.facetsEl = root.querySelector('[data-algolia-facets]');
    this.barEl = root.querySelector('[data-algolia-bar]');
    this.pagerEl = root.querySelector('[data-algolia-pagination]');
    this.query = root.dataset.query || '';
    this.client = (0,_constants_algolia_js__WEBPACK_IMPORTED_MODULE_0__.createSearchClient)();
    this.refinements = {};
    this.page = 0;
    this.sort = SEARCH_SORTS[0].id;
    this.queryID = null;
    this.seq = 0;

    if (!this.client || !this.grid || !this.query) return;

    this.readStateFromUrl();
    this.bind();
    this.search();
  }

  // State lives in the URL so a filtered result set is shareable and the back
  // button steps through refinements instead of leaving the page.
  readStateFromUrl() {
    const params = new URLSearchParams(window.location.search);
    SEARCH_FACETS.forEach((facet) => {
      const raw = params.get(facet.param);
      this.refinements[facet.attribute] = raw ? raw.split(',').filter(Boolean) : [];
    });
    this.page = Math.max(0, (parseInt(params.get('page'), 10) || 1) - 1);
    const sort = params.get('sort');
    if (SEARCH_SORTS.some((s) => s.id === sort)) this.sort = sort;
  }

  writeStateToUrl(replace) {
    const params = new URLSearchParams(window.location.search);
    SEARCH_FACETS.forEach((facet) => {
      const values = this.refinements[facet.attribute];
      if (values && values.length) params.set(facet.param, values.join(','));
      else params.delete(facet.param);
    });
    if (this.page > 0) params.set('page', String(this.page + 1));
    else params.delete('page');
    if (this.sort !== SEARCH_SORTS[0].id) params.set('sort', this.sort);
    else params.delete('sort');
    // view=algolia is the fragment renderer's own parameter. If it ever leaked
    // into the address bar the customer would get a bare list of cards with no
    // layout, so it is stripped on the way out.
    params.delete('view');
    const url = `${window.location.pathname}?${params.toString()}`;
    if (replace) window.history.replaceState(null, '', url);
    else window.history.pushState(null, '', url);
  }

  bind() {
    this.root.addEventListener('change', (event) => {
      const checkbox = event.target.closest('[data-algolia-facet-value]');
      if (checkbox) {
        const attribute = checkbox.dataset.algoliaFacetAttribute;
        const value = checkbox.dataset.algoliaFacetValueName;
        const current = this.refinements[attribute] || [];
        this.refinements[attribute] = checkbox.checked
          ? [...current, value]
          : current.filter((v) => v !== value);
        this.page = 0;
        this.search();
        return;
      }

      const sort = event.target.closest('[data-algolia-sort]');
      if (sort) {
        this.sort = sort.value;
        this.page = 0;
        this.search();
      }
    });

    this.root.addEventListener('click', (event) => {
      const pageButton = event.target.closest('[data-algolia-page]');
      if (pageButton) {
        event.preventDefault();
        this.page = Number(pageButton.dataset.algoliaPage);
        this.search();
        this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const clear = event.target.closest('[data-algolia-clear]');
      if (clear) {
        event.preventDefault();
        SEARCH_FACETS.forEach((facet) => {
          this.refinements[facet.attribute] = [];
        });
        this.page = 0;
        this.search();
        return;
      }

      // Insights: the cards are Liquid-rendered, so the objectID is not on them.
      // The handle is, via the product link; search() mapped it back. Until this
      // page reported clicks, Algolia saw click-through for the dropdown only.
      const card = event.target.closest('product-card a[href*="/products/"]');
      if (card && this.queryID) {
        const handle = card.getAttribute('href').split('/products/')[1]?.split(/[?#]/)[0];
        if (!handle) return;
        rememberSearchHit(handle, this.queryID, this.index);
        const hit = this.hitsByHandle?.get(handle);
        if (hit) {
          aaSend('clickedObjectIDsAfterSearch', {
            index: this.index,
            eventName: 'Search Result Clicked',
            queryID: this.queryID,
            objectIDs: [String(hit.objectID)],
            positions: [hit.position],
          });
        }
      }
    });

    // Back/forward should restore the refinements the URL describes.
    window.addEventListener('popstate', () => {
      this.readStateFromUrl();
      this.search({ skipUrl: true });
    });
  }

  buildFacetFilters() {
    // Values within one facet are OR-ed (nested array), separate facets are
    // AND-ed -- Navy or White, and only if it is also a Top.
    return SEARCH_FACETS.map((facet) =>
      (this.refinements[facet.attribute] || []).map((v) => `${facet.attribute}:${v}`),
    ).filter((group) => group.length > 0);
  }

  async search(options = {}) {
    const seq = ++this.seq;
    this.root.setAttribute('data-algolia-loading', '');

    const indexName = (SEARCH_SORTS.find((s) => s.id === this.sort) || SEARCH_SORTS[0]).index;

    try {
      const response = await this.client.search([
        {
          indexName,
          params: {
            query: this.query,
            page: this.page,
            hitsPerPage: SEARCH_PAGE_HITS,
            facets: SEARCH_FACETS.map((f) => f.attribute),
            facetingAfterDistinct: true,
            facetFilters: this.buildFacetFilters(),
            clickAnalytics: true,
            attributesToRetrieve: ['handle'],
            attributesToHighlight: [],
          },
        },
      ]);
      if (seq !== this.seq) return;

      const result = response.results[0];
      this.queryID = result.queryID || null;
      this.index = indexName;

      // The cards are Liquid-rendered and carry only a handle, but a click event
      // needs the objectID and the 1-based position across all pages -- the
      // position is what Algolia's click-through and average-click-position
      // reports are built from. First record per handle, matching the dedupe
      // below.
      this.hitsByHandle = new Map();
      (result.hits || []).forEach((hit, i) => {
        if (hit.handle && !this.hitsByHandle.has(hit.handle)) {
          this.hitsByHandle.set(hit.handle, {
            objectID: hit.objectID,
            position: result.page * result.hitsPerPage + i + 1,
          });
        }
      });

      // Distinct should already give one record per product; de-duplicating
      // again keeps a settings change in the Algolia dashboard from silently
      // rendering the same card three times.
      const handles = [...new Set((result.hits || []).map((hit) => hit.handle).filter(Boolean))];

      const cards = handles.length ? await this.fetchCards(handles) : '';
      if (seq !== this.seq) return;

      this.grid.innerHTML = cards || this.renderEmpty();
      this.renderFacets(result.facets || {});
      this.renderBar(result.nbHits || 0);
      this.renderPagination(result.nbPages || 0);
      if (!options.skipUrl) this.writeStateToUrl(this.page === 0 && !this.hasRefinements());
      this.root.setAttribute('data-algolia-ready', '');
    } catch {
      // Leave Shopify's server-rendered results exactly where they are.
      this.root.removeAttribute('data-algolia-ready');
    } finally {
      if (seq === this.seq) this.root.removeAttribute('data-algolia-loading');
    }
  }

  hasRefinements() {
    return SEARCH_FACETS.some((f) => (this.refinements[f.attribute] || []).length > 0);
  }

  // Liquid renders the cards. See templates/search.algolia.liquid for why the
  // handles travel in `q`.
  //
  // Batches of 20 because all_products resolves at most 20 unique handles per
  // render, and past that it does not fail -- it silently repeats the 20th
  // product. With 24 hits per page, cards 21-24 of every results page were
  // four copies of card 20 until 2026-09-22.
  async fetchCards(handles) {
    const batches = [];
    for (let i = 0; i < handles.length; i += CARD_BATCH) batches.push(handles.slice(i, i + CARD_BATCH));
    const pages = await Promise.all(
      batches.map(async (batch) => {
        const url = `/search?q=${encodeURIComponent(batch.join(' '))}&view=algolia`;
        const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`card render failed: ${response.status}`);
        return response.text();
      }),
    );
    return pages.join('');
  }

  // Two different dead ends. With filters on, the query did match and a filter
  // emptied it, so the way out is removing one. Without filters the query
  // itself matched nothing, and "try removing a filter" pointed at controls
  // that were not there.
  renderEmpty() {
    if (this.hasRefinements()) {
      return `
        <div class="algolia-empty">
          <h2>No results found</h2>
          <p>No products match these filters. Try removing one.</p>
          <button type="button" class="algolia-clear" data-algolia-clear>Clear all filters</button>
        </div>
      `;
    }
    const links = this.root.querySelector('template[data-algolia-empty-links]')?.innerHTML || '';
    return `
      <div class="algolia-empty">
        <h2>No results for &ldquo;${escapeAttribute(this.query)}&rdquo;</h2>
        <p>Check the spelling, or try a more general word.</p>
        ${links}
      </div>
    `;
  }

  renderBar(total) {
    // The page heading carries Shopify's count, which disagrees with Algolia's.
    // Whichever results are actually on screen own that line.
    const countLine = document.querySelector('[data-algolia-count-line]');
    if (countLine) {
      const terms = countLine.dataset.terms || this.query;
      countLine.textContent = `${total} result${total === 1 ? '' : 's'} found for ${terms}`;
    }
    // The <title> carries Shopify's count too; keep it in step with the heading.
    document.title = document.title.replace(/\d+ results?/, `${total} result${total === 1 ? '' : 's'}`);

    if (!this.barEl) return;
    const options = SEARCH_SORTS.map(
      (s) =>
        `<option value="${s.id}"${s.id === this.sort ? ' selected' : ''}>${escapeHtml(s.label)}</option>`,
    ).join('');
    // No count here: the page heading above already states it, and the two sat
    // one line apart repeating each other.
    this.barEl.innerHTML = `
      <label class="algolia-sort">
        <span>Sort by</span>
        <select data-algolia-sort>${options}</select>
      </label>
    `;
    this.barEl.hidden = total === 0; // nothing to sort
  }

  renderFacets(facets) {
    if (!this.facetsEl) return;

    const groups = SEARCH_FACETS.map((facet) => {
      const values = facets[facet.attribute] || {};
      const selected = this.refinements[facet.attribute] || [];
      // A refinement the customer has already applied must stay listed even
      // when the narrowed result set no longer reports it as a facet value, or
      // the only control that could switch it back off disappears.
      const names = sortFacetValues(
        facet.attribute,
        [...new Set([...Object.keys(values), ...selected])],
      );
      if (!names.length) return '';

      const items = names
        .map((name) => {
          const checked = selected.includes(name);
          const count = facet.counts && values[name] ? ` <span class="algolia-facet__count">${values[name]}</span>` : '';
          return `
            <li class="algolia-facet__item">
              <label>
                <input
                  type="checkbox"
                  data-algolia-facet-value
                  data-algolia-facet-attribute="${escapeHtml(facet.attribute)}"
                  data-algolia-facet-value-name="${escapeHtml(name)}"
                  ${checked ? 'checked' : ''}
                >
                <span>${escapeHtml(name)}</span>${count}
              </label>
            </li>
          `;
        })
        .join('');

      return `
        <div class="algolia-facet">
          <h3 class="algolia-facet__title">${escapeHtml(facet.label)}</h3>
          <ul class="algolia-facet__list">${items}</ul>
        </div>
      `;
    }).join('');

    this.facetsEl.innerHTML =
      groups +
      (this.hasRefinements()
        ? '<button type="button" class="algolia-clear" data-algolia-clear>Clear all filters</button>'
        : '');
    this.facetsEl.hidden = !groups;
  }

  renderPagination(totalPages) {
    if (!this.pagerEl) return;
    if (totalPages <= 1) {
      this.pagerEl.innerHTML = '';
      this.pagerEl.hidden = true;
      return;
    }

    const button = (page, label, disabled) =>
      `<button type="button" class="algolia-page" data-algolia-page="${page}"${disabled ? ' disabled' : ''}>${label}</button>`;

    const numbers = Array.from({ length: totalPages }, (_, i) => i)
      .map(
        (i) =>
          `<button type="button" class="algolia-page${i === this.page ? ' is-current' : ''}" data-algolia-page="${i}"${i === this.page ? ' aria-current="page"' : ''}>${i + 1}</button>`,
      )
      .join('');

    this.pagerEl.innerHTML = `
      ${button(this.page - 1, 'Previous', this.page === 0)}
      <div class="algolia-pages">${numbers}</div>
      ${button(this.page + 1, 'Next', this.page >= totalPages - 1)}
    `;
    this.pagerEl.hidden = false;
  }
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', () => {
  new CustomSearchResults();

  const searchPage = document.querySelector('[data-algolia-search]');
  if (searchPage) new AlgoliaSearchPage(searchPage);
});

// Export for module usage
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomSearchResults);


//# sourceURL=webpack://liquid-starter/./src/components/custom-search-results.js?
;

/***/ }),

/***/ "./src/components/custom-search-widget.js":
/*!************************************************!*\
  !*** ./src/components/custom-search-widget.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);

// Shopify's image CDN resizes via a width param. These components build img
// tags in JS from raw CDN URLs, so without this they download the original
// upload at full resolution for thumbnails - one was 472 KB for an 80px slot.
// Idempotent, and leaves non-Shopify URLs untouched.
function forayCdnImg(url, w) { if (!url || typeof url !== 'string') return url; if (url.indexOf('width=') !== -1) return url; if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url; return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createCustomSearchRenderer: () => (/* binding */ createCustomSearchRenderer),
/* harmony export */   customSearch: () => (/* binding */ customSearch)
/* harmony export */ });
/* harmony import */ var _constants_events_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../constants/events.js */ "./src/constants/events.js");


/**
 * Header search widget: the input plus the empty-state links. Typing dispatches
 * EVENTS.SEARCH; custom-search-results.js runs the query and renders results.
 */

// Enter and "View all results" open the real results page rather than just
// re-running the dropdown query in place. Before this they called submit(),
// which re-rendered the same 10 suggestions and never navigated -- Enter was a
// dead key, and there was no way to see more than the dropdown's first page.
//
// /search?q= is Shopify's own search URL, so the result is shareable, works
// with the back button, and still renders server-side if JS or Algolia fails.
// sections/search.liquid upgrades that page to Algolia results in place.
function gotoSearchPage(query) {
  const q = (query || '').trim();
  if (!q) return;
  window.location.href = `/search?q=${encodeURIComponent(q)}`;
}

/**
 * Custom Search Widget Renderer
 * Creates the UI for the custom search widget
 */
function createCustomSearchRenderer({ container, cssClasses = {}, templates = {} }) {
  const containerNode =
    typeof container === 'string' ? document.querySelector(container) : container;

  if (!containerNode) {
    throw new Error(`CustomSearch: Could not find container: ${container}`);
  }

  // Default templates
  const defaultTemplates = {
    async emptyState() {
      // Try to fetch search links from dedicated page
      try {
        const response = await fetch('/pages/search-links');
        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const sectionContent = doc.querySelector('[data-search-links-section]');

          if (sectionContent) {
            return sectionContent.innerHTML;
          }
        }
      } catch {
        // Failed to fetch search links page
      }

      // Fallback to default content
      return `
        <div class="custom-search-empty-state" data-custom-search-empty-state>
          <div class="custom-search-layout">
            <div class="custom-search-collections">
              <div class="mega-menu-links">
                <a href="/collections/ss2025" class="mega-menu-link">New Arrivals</a>
                <a href="/collections/final-sale" class="mega-menu-link">Sale</a>
                <a href="/collections/all" class="mega-menu-link">View All</a>
              </div>
            </div>
            <div class="custom-search-categories">
              <div class="custom-category-group">
                <h5>Tops</h5>
                <div class="mega-menu-links">
                  <a href="/collections/tops">Tops</a>
                  <a href="/collections/t-shirts">T-Shirts</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    },

    suggestionItem({ item }) {
      const image = item.image || item.featured_image;
      const price = item.price ? `$${item.price}` : '';
      const comparePrice = item.compare_at_price ? `$${item.compare_at_price}` : '';
      const isOnSale = item.compare_at_price && item.price < item.compare_at_price;
      const highlightedTitle = item._highlightResult?.title?.value || item.title;

      // Generate the URL for the item
      let itemUrl = '#';
      if (item.handle) {
        if (item.objectType === 'product') {
          itemUrl = `/products/${item.handle}`;
        } else if (item.objectType === 'collection') {
          itemUrl = `/collections/${item.handle}`;
        } else if (item.objectType === 'page') {
          itemUrl = `/pages/${item.handle}`;
        } else {
          itemUrl = item.url || '#';
        }
      }

      return `
        <a href="${itemUrl}" class="custom-suggestion-item" data-object-id="${item.objectID}">
          <div class="custom-suggestion-image">
            ${
              image
                ? `<img src="${forayCdnImg(image, 120)}" alt="${item.title}" width="48" height="48" loading="lazy" />`
                : `
                <div class="custom-suggestion-placeholder">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
                  </svg>
                </div>
                `
            }
          </div>
          <div class="custom-suggestion-content">
            <div class="custom-suggestion-title">${highlightedTitle}</div>
            ${item.vendor ? `<div class="custom-suggestion-vendor">${item.vendor}</div>` : ''}
            ${item.product_type ? `<div class="custom-suggestion-type">${item.product_type}</div>` : ''}
            ${
              price
                ? `
                <div class="custom-suggestion-price">
                  ${isOnSale ? `<span class="custom-suggestion-compare-price">${comparePrice}</span>` : ''}
                  <span class="custom-suggestion-current-price">${price}</span>
                </div>
                `
                : ''
            }
          </div>
          <div class="custom-suggestion-arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
            </svg>
          </div>
        </a>
      `;
    },

    ...templates,
  };

  return {
    async render({ currentQuery, suggestions, refine, widgetParams }) {
      const { placeholder } = widgetParams;

      // Store current input focus state
      const currentInput = containerNode.querySelector('.custom-search-input');
      const wasFocused = currentInput === document.activeElement;
      const cursorPosition = wasFocused ? currentInput?.selectionStart : null;

      // Always get empty state content (async) but control visibility with data attribute
      const emptyStateContent = await defaultTemplates.emptyState();

      containerNode.innerHTML = `
        <div class="custom-search-widget">
          <div class="custom-search-form">
            <div class="custom-search-input-wrapper">
              <div class="custom-search-input-prefix">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
              </div>
              <input
                type="search"
                class="custom-search-input"
                placeholder="${placeholder}"
                value="${currentQuery}"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                maxlength="512"
              />
              <div class="custom-search-input-suffix">
                <button type="submit" class="custom-search-submit" title="Search">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          ${emptyStateContent}
          
          ${
            currentQuery && currentQuery.length >= 2
              ? suggestions.length > 0
                ? `
            <div class="custom-search-suggestions">
              <div class="custom-suggestions-header">
                <h4>Search Results</h4>
                <span class="custom-suggestions-count">${suggestions.length} results</span>
              </div>
              <div class="custom-suggestions-list">
                ${suggestions.map((item) => defaultTemplates.suggestionItem({ item, cssClasses })).join('')}
              </div>
              <div class="custom-suggestions-footer">
                <button class="custom-view-all-results" type="button">
                  View all results
                </button>
              </div>
            </div>
          `
                : `
            <div class="custom-search-no-results">
              <div class="custom-no-results-content">
                <h4>No results found</h4>
                <p>Try searching for something else or browse our collections.</p>
                <div class="custom-no-results-actions">
                  <button class="custom-view-all-results" type="button">
                    View all products
                  </button>
                </div>
              </div>
            </div>
          `
              : ''
          }
        </div>
      `;

      // Bind events
      const searchInput = containerNode.querySelector('.custom-search-input');
      const searchForm = containerNode.querySelector('.custom-search-form');
      const viewAllButton = containerNode.querySelector('.custom-view-all-results');

      // Restore focus and cursor position if input was previously focused
      if (searchInput && wasFocused) {
        searchInput.focus();
        if (cursorPosition !== null) {
          searchInput.setSelectionRange(cursorPosition, cursorPosition);
        }
      }

      // Input events
      if (searchInput) {
        searchInput.addEventListener('input', (e) => {
          // Just trigger search - custom-search-results.js will handle empty state visibility
          refine(e.target.value);
        });

        searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            gotoSearchPage(searchInput.value);
          }
        });
      }

      // Form submission
      if (searchForm) {
        searchForm.addEventListener('submit', (e) => {
          e.preventDefault();
          gotoSearchPage(searchInput.value);
        });
      }

      // Suggestion items are now proper links, no need for click handling

      // View all results (handles both "View all results" and "View all products" buttons)
      if (viewAllButton) {
        viewAllButton.addEventListener('click', () => {
          // If there's a current query, open the results page; otherwise go to
          // all products.
          const query = searchInput.value || '';
          if (query.trim().length >= 2) {
            gotoSearchPage(query);
          } else {
            // Navigate to all products page
            window.location.href = '/collections/all';
          }
        });
      }
    },

    dispose() {
      containerNode.innerHTML = '';
    },
  };
}

/**
 * Renders the widget once. It used to be an InstantSearch widget re-rendered on
 * every (stubbed, always empty) result, which fetched /pages/search-links twice
 * per pageview and could never show suggestions -- the query it rendered from
 * was never set.
 */
function customSearch({ container, placeholder, cssClasses = {}, templates = {} }) {
  const { render, dispose } = createCustomSearchRenderer({ container, cssClasses, templates });

  const refine = (query) => {
    document.dispatchEvent(
      new CustomEvent(_constants_events_js__WEBPACK_IMPORTED_MODULE_0__.EVENTS.SEARCH, {
        detail: { query, type: 'input' },
      }),
    );
  };

  render({ currentQuery: '', suggestions: [], refine, widgetParams: { placeholder } });
  return { dispose };
}


//# sourceURL=webpack://liquid-starter/./src/components/custom-search-widget.js?
;

/***/ }),

/***/ "./src/components/infinite-scroll.js":
/*!*******************************************!*\
  !*** ./src/components/infinite-scroll.js ***!
  \*******************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Simple Infinite Scroll Component
 * Uses Shopify's built-in pagination system
 */
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1; // Will be calculated in init()
    this.isLoading = false;
    this.hasMorePages = true;
    this.observer = null;
    this.sentinel = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    console.log('Infinite Scroll: Initializing component');

    // Determine current page from URL
    const urlPage = this.getCurrentPageFromUrl();

    // Calculate the effective page for AJAX requests
    // If initial page shows 40 products, we need to adjust
    this.currentPage = this.calculateAjaxPage(urlPage);

    console.log(
      `Infinite Scroll: URL page: ${urlPage}, AJAX page: ${this.currentPage}, Has more pages: ${this.hasMorePages}`,
    );

    this.createSentinel();
    this.observeSentinel();

    // Log initial product count
    const initialProducts = this.querySelectorAll('product-card[data-product-id]');
    console.log(`Infinite Scroll: Initial products loaded: ${initialProducts.length}`);
  }

  calculateAjaxPage(urlPage) {
    // The collection template uses one page size for both the initial
    // full-page render and subsequent AJAX fetches, so the next page to
    // load is simply the one after what is already on screen.
    return urlPage;
  }

  getCurrentPageFromUrl() {
    const url = new URL(window.location);
    const pageParam = url.searchParams.get('page');
    return pageParam ? parseInt(pageParam, 10) : 1;
  }

  createSentinel() {
    this.sentinel = document.createElement('div');
    this.sentinel.setAttribute('data-infinite-scroll-sentinel', '');
    this.sentinel.style.height = '1px';
    this.appendChild(this.sentinel);
  }

  observeSentinel() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isLoading && this.hasMorePages) {
            this.loadMoreProducts();
          } else {
            console.log('⏸️ Infinite Scroll: Not loading because:', {
              isIntersecting: entry.isIntersecting,
              isLoading: this.isLoading,
              hasMorePages: this.hasMorePages,
            });
          }
        });
      },
      { rootMargin: '200px' },
    );

    this.observer.observe(this.sentinel);
  }

  async loadMoreProducts() {
    if (this.isLoading || !this.hasMorePages) {
      console.log(
        '🚫 Infinite Scroll: Early return - isLoading:',
        this.isLoading,
        'hasMorePages:',
        this.hasMorePages,
      );
      return;
    }

    this.isLoading = true;
    this.setAttribute('data-loading', 'true');
    console.log('⏳ Infinite Scroll: Set loading state to true');

    // Add a small delay to prevent rapid-fire requests
    await new Promise((resolve) => setTimeout(resolve, 100));

    try {
      const nextPage = this.currentPage + 1;
      const url = this.buildPageUrl(nextPage);

      console.log(`🌐 Infinite Scroll: Loading page ${nextPage} from ${url}`);
      console.log(`📄 Infinite Scroll: Current page before request: ${this.currentPage}`);
      console.log(`🔗 Infinite Scroll: Built URL: ${url}`);

      const response = await fetch(url);
      console.log(
        `📡 Infinite Scroll: Fetch response status: ${response.status} ${response.statusText}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const html = await response.text();
      console.log(`📄 Infinite Scroll: Received response with ${html.length} characters`);
      console.log(`📄 Infinite Scroll: Response preview:`, html.substring(0, 200) + '...');

      // Parse the response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find product cards in the response
      const newProducts = doc.querySelectorAll('product-card[data-product-id]');
      console.log(`🛍️ Infinite Scroll: Found ${newProducts.length} product cards in response`);

      // Check if we've reached the end based on product count
      // If we get 0 products, we've reached the end
      // If we get any products, continue loading (regardless of count)
      console.log(
        `📊 Infinite Scroll: Checking pagination - received ${newProducts.length} products`,
      );

      if (newProducts.length === 0) {
        this.hasMorePages = false;
        console.log(`🏁 Infinite Scroll: End reached - received 0 products`);

        // Add end message
        const endMessage = document.createElement('div');
        endMessage.setAttribute('data-infinite-scroll-end', '');
        endMessage.textContent = "You've reached the end of the collection";
        this.insertBefore(endMessage, this.sentinel);
      } else {
        console.log(
          `➡️ Infinite Scroll: Continue loading - received ${newProducts.length} products`,
        );
      }

      // Only process if we have products to show
      if (newProducts.length > 0) {
        console.log(`🔄 Infinite Scroll: Processing ${newProducts.length} products for duplicates`);
        // Check for duplicates and only insert new products
        const existingProductIds = new Set();
        const existingProducts = this.querySelectorAll('product-card[data-product-id]');
        console.log(
          `🔍 Infinite Scroll: Found ${existingProducts.length} existing products in DOM`,
        );

        // Collect existing product IDs
        existingProducts.forEach((existingProduct) => {
          const productId = existingProduct.getAttribute('data-product-id');
          if (productId) {
            existingProductIds.add(productId);
          }
        });
        console.log(
          `📋 Infinite Scroll: Collected ${existingProductIds.size} existing product IDs`,
        );

        // Filter out duplicates and insert only new products
        const uniqueNewProducts = [];
        newProducts.forEach((product) => {
          const productId = product.getAttribute('data-product-id');
          if (productId && !existingProductIds.has(productId)) {
            uniqueNewProducts.push(product);
            existingProductIds.add(productId); // Add to set to prevent duplicates within this batch
          }
        });

        console.log(
          `✅ Infinite Scroll: After duplicate filtering - ${uniqueNewProducts.length} unique products out of ${newProducts.length} total`,
        );

        // Only insert unique new products
        uniqueNewProducts.forEach((product) => {
          this.insertBefore(product, this.sentinel);
        });

        // Debug logging
        console.log(
          `📈 Infinite Scroll: Loaded ${newProducts.length} products, ${uniqueNewProducts.length} unique, ${newProducts.length - uniqueNewProducts.length} duplicates filtered`,
        );

        // Only update page if we actually inserted new products
        if (uniqueNewProducts.length > 0) {
          const oldPage = this.currentPage;
          this.currentPage = nextPage;
          console.log(`📄 Infinite Scroll: Updated page from ${oldPage} to ${this.currentPage}`);
          // Enhance the new product cards
          this.enhanceNewProductCards(uniqueNewProducts);
        } else {
          console.log(
            `⚠️ Infinite Scroll: No unique products found, keeping page at ${this.currentPage}`,
          );
        }
        // If no unique products were found, we'll continue to the next page
        // (might be a page with all duplicates, but we'll stop when we get < 20 products)
      }
    } catch (error) {
      console.error('❌ Infinite Scroll: Error loading more products:', error);

      // Add error message
      const errorMessage = document.createElement('div');
      errorMessage.setAttribute('data-infinite-scroll-error', '');
      errorMessage.innerHTML = `
        <p>Failed to load more products</p>
        <button onclick="this.closest('infinite-scroll').retryLoad()">Try Again</button>
      `;
      this.insertBefore(errorMessage, this.sentinel);
    } finally {
      this.isLoading = false;
      this.removeAttribute('data-loading');
      console.log(
        `✅ Infinite Scroll: Reset loading state. Final state - currentPage: ${this.currentPage}, hasMorePages: ${this.hasMorePages}, isLoading: ${this.isLoading}`,
      );
    }
  }

  buildPageUrl(page) {
    const url = new URL(window.location);
    console.log(`🔧 Infinite Scroll: Building URL for page ${page} from base: ${url.toString()}`);

    // Set the page parameter
    url.searchParams.set('page', page);
    url.searchParams.set('view', 'ajax');

    const finalUrl = url.toString();
    console.log(`🔧 Infinite Scroll: Built final URL: ${finalUrl}`);
    return finalUrl;
  }

  async refresh() {
    // Reset state
    this.currentPage = 1;
    this.hasMorePages = true;
    this.isLoading = false;
    this.removeAttribute('data-loading');

    // Remove existing products and messages
    const existingProducts = this.querySelectorAll('product-card[data-product-id]');
    const endMessage = this.querySelector('[data-infinite-scroll-end]');
    const errorMessage = this.querySelector('[data-infinite-scroll-error]');
    const noResultsMessage = this.querySelector('[data-infinite-scroll-no-results]');

    existingProducts.forEach((product) => product.remove());
    if (endMessage) endMessage.remove();
    if (errorMessage) errorMessage.remove();
    if (noResultsMessage) noResultsMessage.remove();

    // Load first page with current filter state
    await this.loadFilteredProducts();

    // Update product cards with current filter state
    this.updateProductCardsWithFilters();
  }

  enhanceNewProductCards(newProducts) {
    // With web components, the enhancement happens automatically via connectedCallback
    // Just log for debugging
    console.log('New product cards inserted:', newProducts.length);
  }

  retryLoad() {
    // Remove error message
    const errorMessage = this.querySelector('[data-infinite-scroll-error]');
    if (errorMessage) {
      errorMessage.remove();
    }

    // Reset loading state and try again
    this.isLoading = false;

    // Check if we're on the first page (filtered results) or pagination
    if (this.currentPage === 1) {
      this.loadFilteredProducts().then(() => {
        this.updateProductCardsWithFilters();
      });
    } else {
      this.loadMoreProducts();
    }
  }

  /**
   * Handle filter changes by resetting state and loading filtered results
   */
  async handleFilterChange() {
    // Reset pagination state
    this.currentPage = 1;
    this.hasMorePages = true;

    // Clear existing products
    const existingProducts = this.querySelectorAll('product-card[data-product-id]');
    const endMessage = this.querySelector('[data-infinite-scroll-end]');
    const errorMessage = this.querySelector('[data-infinite-scroll-error]');
    const noResultsMessage = this.querySelector('[data-infinite-scroll-no-results]');

    existingProducts.forEach((product) => product.remove());
    if (endMessage) endMessage.remove();
    if (errorMessage) errorMessage.remove();
    if (noResultsMessage) noResultsMessage.remove();

    // Load first page with new filters
    await this.loadFilteredProducts();

    // Update product cards with current filter state
    this.updateProductCardsWithFilters();
  }

  /**
   * Update all product cards with current filter state
   */
  updateProductCardsWithFilters() {
    const productCards = this.querySelectorAll('product-card');
    const currentFilters = this.getCurrentFilters();

    productCards.forEach((card) => {
      if (card.updateWithFilters) {
        card.updateWithFilters(currentFilters);
      }
    });
  }

  /**
   * Get current filter state from URL
   */
  getCurrentFilters() {
    const url = new URL(window.location);
    const filters = {};

    // Parse filter parameters
    for (const [key, value] of url.searchParams.entries()) {
      if (key.startsWith('filter.v.option.')) {
        const optionName = key.replace('filter.v.option.', '');
        filters[optionName] = value;
      }
    }

    return filters;
  }

  /**
   * Load filtered products for the first page
   */
  async loadFilteredProducts() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.setAttribute('data-loading', 'true');

    try {
      const url = this.buildFilteredUrl();

      const response = await fetch(url);
      const html = await response.text();

      // Parse the response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find product cards in the response
      const newProducts = doc.querySelectorAll('product-card[data-product-id]');

      // For filtered results, if we get 0 products, show no results message
      if (newProducts.length === 0) {
        this.hasMorePages = false;

        // Add no results message
        const noResultsMessage = document.createElement('div');
        noResultsMessage.setAttribute('data-infinite-scroll-no-results', '');
        noResultsMessage.innerHTML = `
          <p>No products found matching your filters.</p>
          <button onclick="window.location.href='${window.location.pathname}'">Clear Filters</button>
        `;
        this.insertBefore(noResultsMessage, this.sentinel);
      } else {
        // Check for duplicates and only insert new products
        const existingProductIds = new Set();
        const existingProducts = this.querySelectorAll('product-card[data-product-id]');

        // Collect existing product IDs
        existingProducts.forEach((existingProduct) => {
          const productId = existingProduct.getAttribute('data-product-id');
          if (productId) {
            existingProductIds.add(productId);
          }
        });

        // Filter out duplicates and insert only new products
        const uniqueNewProducts = [];
        newProducts.forEach((product) => {
          const productId = product.getAttribute('data-product-id');
          if (productId && !existingProductIds.has(productId)) {
            uniqueNewProducts.push(product);
            existingProductIds.add(productId); // Add to set to prevent duplicates within this batch
          }
        });

        // Only insert unique new products
        uniqueNewProducts.forEach((product) => {
          this.insertBefore(product, this.sentinel);
        });

        // Enhance the new product cards
        this.enhanceNewProductCards(uniqueNewProducts);

        // Update product cards with current filter state
        this.updateProductCardsWithFilters();

        // For filtered results, we'll continue loading until we get 0 products
        // (no need to check page count since filters might have varying results)
      }
    } catch (error) {
      console.error('Error loading filtered products:', error);

      // Add error message
      const errorMessage = document.createElement('div');
      errorMessage.setAttribute('data-infinite-scroll-error', '');
      errorMessage.innerHTML = `
        <p>Failed to load filtered products</p>
        <button onclick="this.closest('infinite-scroll').retryLoad()">Try Again</button>
      `;
      this.insertBefore(errorMessage, this.sentinel);
    } finally {
      this.isLoading = false;
      this.removeAttribute('data-loading');
    }
  }

  buildFilteredUrl() {
    const url = new URL(window.location);
    url.searchParams.set('view', 'ajax');
    return url.toString();
  }

  cleanup() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Register the web component
customElements.define('infinite-scroll', InfiniteScroll);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InfiniteScroll);


//# sourceURL=webpack://liquid-starter/./src/components/infinite-scroll.js?
;

/***/ }),

/***/ "./src/components/instantsearch-integration.js":
/*!*****************************************************!*\
  !*** ./src/components/instantsearch-integration.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InstantSearchIntegration: () => (/* binding */ InstantSearchIntegration)
/* harmony export */ });
/* harmony import */ var _constants_algolia_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../constants/algolia.js */ "./src/constants/algolia.js");
/* harmony import */ var _custom_search_widget_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./custom-search-widget.js */ "./src/components/custom-search-widget.js");




// Algolia's standard search-insights loader, which the instantsearch insights
// middleware used to run for us: a queue stub first, so aa() calls made before
// the script arrives are replayed when it loads, then the script itself. Loaded
// eagerly, not on first event: a click on a dropdown result navigates away at
// once, and an event still sitting in the stub's queue dies with the page.
// custom-search-results.js calls aa('init') on first use (see ensureInsights).
const INSIGHTS_SRC = 'https://cdn.jsdelivr.net/npm/search-insights@2.17.2/dist/search-insights.min.js';

function loadInsights() {
  if (typeof window.aa === 'function') return; // a second instance, or already on the page
  window.AlgoliaAnalyticsObject = 'aa';
  window.aa = function () {
    (window.aa.queue = window.aa.queue || []).push(arguments);
  };
  const script = document.createElement('script');
  script.async = true;
  script.src = INSIGHTS_SRC;
  document.body.appendChild(script);
}

/**
 * Header search input. Renders the input and the empty-state links; the
 * dropdown results themselves are custom-search-results.js.
 */
class InstantSearchIntegration {
  constructor(container, options = {}) {
    this.container = container;
    this.options = {
      placeholder: 'Search products, collections, and more...',
      maxSuggestions: 10,
      showEmptyState: true,
      ...options,
    };

    this.search = null;
    this.init();
  }

  init() {
    console.log('InstantSearchIntegration: Initializing...');
    console.log('InstantSearchIntegration: Container:', this.container);

    const config = (0,_constants_algolia_js__WEBPACK_IMPORTED_MODULE_0__.getAlgoliaConfig)();
    console.log('InstantSearchIntegration: Algolia config:', config);

    if (!config) {
      console.warn(
        'InstantSearchIntegration: No Algolia config found, falling back to basic search',
      );
      this.createBasicSearch();
      return;
    }

    const searchClient = (0,_constants_algolia_js__WEBPACK_IMPORTED_MODULE_0__.createSearchClient)();
    console.log('InstantSearchIntegration: Search client:', searchClient);

    if (!searchClient) {
      console.warn(
        'InstantSearchIntegration: No search client available, falling back to basic search',
      );
      this.createBasicSearch();
      return;
    }

    // InstantSearch.js used to be bundled to render this input: ~540 KB of
    // library (instantsearch, algoliasearch-helper, qs), half of this file,
    // parsed on every page. Its client was stubbed so it never queried --
    // custom-search-results.js owns every real query -- and its only other job
    // was loading search-insights, which loadInsights() now does directly. The
    // class keeps its name because theme.js and search-results.js construct it.
    loadInsights();

    this.search = (0,_custom_search_widget_js__WEBPACK_IMPORTED_MODULE_1__.customSearch)({
      container: this.container,
      placeholder: this.options.placeholder,
    });

    console.log('InstantSearchIntegration: Initialized successfully');
  }

  createBasicSearch() {
    console.log('InstantSearchIntegration: Creating basic search fallback');

    this.container.innerHTML = `
      <div class="basic-search-fallback">
        <form action="/search" method="get" class="search-form">
          <div class="search-input-wrapper">
            <div class="search-input-prefix">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
              </svg>
            </div>
            <input
              type="search"
              name="q"
              placeholder="${this.options.placeholder}"
              class="search-input"
            />
            <div class="search-input-suffix">
              <button type="submit" class="search-submit" title="Search">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                </svg>
              </button>
            </div>
          </div>
        </form>
      </div>
    `;
  }

  destroy() {
    if (this.search) {
      this.search.dispose();
      this.search = null;
    }
  }
}


//# sourceURL=webpack://liquid-starter/./src/components/instantsearch-integration.js?
;

/***/ }),

/***/ "./src/components/product-card.js":
/*!****************************************!*\
  !*** ./src/components/product-card.js ***!
  \****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
// Whole-phrase match, punctuation as in snippets/variant-image-match.liquid, so
// descriptive alts can't match inside words ("tan" in "standing"). Copy kept
// identical in cart-addons.js; test-alt-mentions.mjs checks both.
const altMentions = (alt, value) => {
  const norm = (s) => ` ${String(s).toLowerCase().replace(/["'\/~\\_()[\]:;.,&+|-]/g, ' ').replace(/\s+/g, ' ').trim()} `;
  return Boolean(alt && value) && norm(alt).includes(norm(value));
};

// Product Card Web Component
class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.productData = null;
    this.currentColor = null;
    this.currentSize = null;
    this.currentLength = null;
    this.enhanced = false;
  }

  connectedCallback() {
    // Wait for the next tick to ensure all child elements are available
    requestAnimationFrame(() => {
      this.init();
    });
  }

  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    if (this.enhanced) {
      return;
    }

    const productId = this.dataset.productId;
    if (!productId) {
      return;
    }

    // Get product data from the hidden script tag
    const dataScript = this.querySelector('.product-data');
    if (!dataScript) {
      return;
    }

    try {
      this.productData = JSON.parse(dataScript.textContent);
    } catch {
      return;
    }

    this.setupEventListeners();
    this.setupQuickShop();
    this.initializeVariantSelection();
    this.enhanced = true;
  }

  setupEventListeners() {
    // Listen for variant option clicks
    this.addEventListener('click', (e) => {
      if (e.target.classList.contains('variant-option')) {
        e.preventDefault();
        const type = e.target.dataset.variantType;
        const value = e.target.dataset.variantValue;

        this.selectVariant(type, value);
      }
    });

    // Listen for variant changes from the main variant selector
    document.addEventListener('variant:changed', this.handleVariantChange.bind(this));

    // Listen for specific price change events
    document.addEventListener('variant:price-changed', this.handlePriceChange.bind(this));
  }

  initializeVariantSelection() {
    // Start on the length rendered active (the 17" collection opens cards on
    // Tall, see snippets/product-card.liquid), otherwise the first length —
    // but only a length with something in stock, so the highlighted button and
    // the ?variant= link agree. Either way the image, price, links and Quick
    // Shop sizes must follow it.
    const lengthOptions = [...this.querySelectorAll('[data-variant-type="length"]')];
    const inStock = (option) =>
      this.productData.variants.some(
        (variant) => variant.available && this.lengthMatches(variant, option.dataset.variantValue),
      );
    const activeLengthOption = lengthOptions.find((option) => option.dataset.active === 'true');
    const initialLengthOption =
      (activeLengthOption && inStock(activeLengthOption) ? activeLengthOption : null) ||
      lengthOptions.find(inStock) ||
      lengthOptions[0];
    if (initialLengthOption) {
      this.currentLength = initialLengthOption.dataset.variantValue;

      this.updateImage();
      this.updatePrice();
      this.updateProductUrls();

      setTimeout(() => {
        if (this.dataset.hasAdditionalProduct !== 'true') {
          this.updateQuickShopAvailability();
        }
      }, 10);
    }

    // Rendered active by snippets/product-card.liquid's selected_color (the
    // recommendations section opens hand-picked items on their picked colour).
    // The swatch highlight alone is not enough: the card would still show the
    // default colour's image and link.
    const activeColorOption = this.querySelector('[data-variant-type="color"][data-active="true"]');
    if (activeColorOption) {
      this.currentColor = activeColorOption.dataset.variantValue;
      this.updateImage();
      this.updatePrice();
    }

    const activeSizeOption = this.querySelector('[data-variant-type="size"][data-active="true"]');
    if (activeSizeOption) {
      this.currentSize = activeSizeOption.dataset.variantValue;
    }

    // Update UI to reflect initial selections
    this.updateVariantUI();
  }

  setupQuickShop() {
    // Skip Quick Shop setup if product has additional products
    if (this.dataset.hasAdditionalProduct === 'true') {
      return;
    }

    const quickShopTrigger = this.querySelector('[data-quick-shop-trigger]');
    const quickShopSizes = this.querySelector('[data-quick-shop-sizes]');

    if (!quickShopTrigger || !quickShopSizes) {
      return;
    }

    // Validate variant data structure
    this.validateVariantData();

    // Inject size buttons
    this.injectQuickShopSizes();

    // Handle quick shop size selection
    quickShopSizes.addEventListener('click', (e) => {
      if (e.target.classList.contains('quick-shop__size-option')) {
        e.preventDefault();
        e.stopPropagation();

        const size = e.target.dataset.size;
        const available = e.target.dataset.available === 'true';

        if (available && !e.target.classList.contains('loading')) {
          this.addQuickShopToCart(size);
        }
      }
    });
  }

  validateVariantData() {
    // Check for variants with missing color or size data
    // Validation logic removed - no action needed
  }

  selectVariant(type, value) {
    if (type === 'color') {
      this.currentColor = value;
      this.updateImage();
      this.updateQuickShopSizesForColor();
      this.updatePrice();

      setTimeout(() => {
        // Only update Quick Shop if product doesn't have additional products
        if (this.dataset.hasAdditionalProduct !== 'true') {
          this.updateQuickShopAvailability();
        }
      }, 10);
    } else if (type === 'size') {
      this.currentSize = value;
      this.updatePrice();
    } else if (type === 'length') {
      this.currentLength = value;
      this.updateImage();
      this.updatePrice();
      this.updateQuickShopSizesForLength();

      setTimeout(() => {
        // Only update Quick Shop if product doesn't have additional products
        if (this.dataset.hasAdditionalProduct !== 'true') {
          this.updateQuickShopAvailability();
        }
      }, 10);
    }

    this.updateVariantUI();
  }

  handleVariantChange(event) {
    // Only handle events for this product
    if (event.detail.productId && event.detail.productId.toString() !== this.dataset.productId) {
      return;
    }

    const variant = event.detail.variant;
    if (!variant) return;

    // Update current color and size based on the variant
    if (variant.options && variant.options.length > 0) {
      // Find color and size from variant options
      const { variants } = this.productData;
      const matchingVariant = variants.find((v) => v.id === variant.id);

      if (matchingVariant) {
        if (matchingVariant.color && matchingVariant.color !== this.currentColor) {
          this.currentColor = matchingVariant.color;
          this.updateImage();
          this.updateQuickShopSizesForColor();
        }

        if (matchingVariant.size && matchingVariant.size !== this.currentSize) {
          this.currentSize = matchingVariant.size;
        }

        if (matchingVariant.length && matchingVariant.length !== this.currentLength) {
          this.currentLength = matchingVariant.length;
        }
      }
    }

    // Update price and UI
    this.updatePrice();
    this.updateVariantUI();

    // Update Quick Shop availability if needed
    if (this.dataset.hasAdditionalProduct !== 'true') {
      setTimeout(() => {
        this.updateQuickShopAvailability();
      }, 10);
    }
  }

  handlePriceChange(event) {
    // Only handle events for this product
    if (event.detail.productId && event.detail.productId.toString() !== this.dataset.productId) {
      return;
    }

    // Update price immediately when price change event is received
    this.updatePrice();
  }

  async addQuickShopToCart(size) {
    if (!size) return;

    const sizeButton = this.querySelector(`[data-quick-shop-size="${size}"]`);
    if (!sizeButton) return;

    // Double-check availability before proceeding
    let isActuallyAvailable = false;
    if (this.currentColor && this.currentLength) {
      isActuallyAvailable = this.isSizeAvailableForColorAndLength(
        this.currentColor,
        size,
        this.currentLength,
      );
    } else if (this.currentColor) {
      isActuallyAvailable = this.isSizeAvailableForColorEnhanced(this.currentColor, size);
    } else if (this.currentLength) {
      isActuallyAvailable = this.isSizeAvailableForLength(size, this.currentLength);
    } else {
      isActuallyAvailable = this.isSizeAvailable(size);
    }

    if (!isActuallyAvailable) {
      sizeButton.classList.add('unavailable');
      sizeButton.disabled = true;
      sizeButton.dataset.available = 'false';
      sizeButton.title = `${size} is out of stock`;

      const originalText = sizeButton.textContent;
      sizeButton.textContent = '✗';
      sizeButton.title = 'This size is not available';

      setTimeout(() => {
        sizeButton.textContent = originalText;
        sizeButton.title = `${size} is out of stock`;
      }, 2000);

      return;
    }

    // Show loading state
    sizeButton.classList.add('loading');
    const originalText = sizeButton.textContent;
    sizeButton.textContent = '...';

    try {
      let variant;

      if (this.currentColor && this.currentLength) {
        variant = this.getVariantByColorSizeAndLength(this.currentColor, size, this.currentLength);
      } else if (this.currentColor) {
        variant = this.getVariantByColorAndSize(this.currentColor, size);
      } else if (this.currentLength) {
        variant = this.getVariantBySizeAndLength(size, this.currentLength);
      } else {
        variant = this.getVariantBySize(size);
      }

      if (!variant) {
        throw new Error('Variant not found');
      }

      if (!variant.available) {
        throw new Error(`Variant ${variant.title} is not available`);
      }

      if (!window.Cart) {
        throw new Error('Cart API not available');
      }

      await window.Cart.addLine(variant.id, 1, this.dataset.isFinalSale === 'true' ? { _isFinalSale: 'true' } : {});

      // Show success feedback
      sizeButton.textContent = '✓';

      // Wait a moment for cart data to update, then open cart
      setTimeout(() => {
        if (window.Cart.loadCart) {
          window.Cart.loadCart()
            .then(() => {
              if (window.Cart.open) {
                window.Cart.open();
              }
            })
            .catch(() => {
              if (window.Cart.open) {
                window.Cart.open();
              }
            });
        } else {
          if (window.Cart.open) {
            window.Cart.open();
          }
        }
      }, 500);

      setTimeout(() => {
        sizeButton.textContent = originalText;
        sizeButton.classList.remove('loading');
      }, 2000);
    } catch (error) {
      let userMessage = 'Failed to add item to cart';
      if (error.message.includes('422')) {
        userMessage = 'This item is no longer available. Please try a different size or color.';
      } else if (error.message.includes('not available')) {
        userMessage = 'This item is currently out of stock.';
      } else if (error.message.includes('Variant not found')) {
        userMessage = 'Product variant not found. Please try again.';
      }

      sizeButton.textContent = '✗';
      sizeButton.title = userMessage;

      setTimeout(() => {
        sizeButton.textContent = originalText;
        sizeButton.classList.remove('loading');
        sizeButton.title = '';
      }, 3000);
    }
  }

  injectQuickShopSizes() {
    // Skip if product has additional products
    if (this.dataset.hasAdditionalProduct === 'true') {
      return;
    }

    const quickShopSizes = this.querySelector('[data-quick-shop-sizes]');
    if (!quickShopSizes) {
      return;
    }

    // Clear existing sizes
    quickShopSizes.innerHTML = '';

    // Get all sizes for the product
    const allSizes = this.getAllSizes();

    if (allSizes.length === 0) {
      return;
    }

    // Create size buttons for all sizes
    allSizes.forEach((size) => {
      const sizeOption = document.createElement('button');
      sizeOption.className = 'quick-shop__size-option';
      sizeOption.dataset.size = size;
      sizeOption.dataset.quickShopSize = size;
      sizeOption.textContent = size;

      // Initially set as unavailable, will be updated by availability check
      sizeOption.classList.add('unavailable');
      sizeOption.disabled = true;
      sizeOption.dataset.available = 'false';

      quickShopSizes.appendChild(sizeOption);
    });

    // Force immediate availability check
    this.updateQuickShopAvailability();
  }

  updateQuickShopSizesForColor() {
    // Skip if product has additional products
    if (this.dataset.hasAdditionalProduct === 'true') {
      return;
    }
    this.refreshQuickShopAvailability();
  }

  updateQuickShopSizesForLength() {
    // Skip if product has additional products
    if (this.dataset.hasAdditionalProduct === 'true') {
      return;
    }
    this.refreshQuickShopAvailability();
  }

  refreshQuickShopAvailability() {
    // Skip if product has additional products
    if (this.dataset.hasAdditionalProduct === 'true') {
      return;
    }

    const sizeButtons = this.querySelectorAll('.quick-shop__size-option');

    if (sizeButtons.length === 0) {
      this.injectQuickShopSizes();
      return;
    }

    this.updateQuickShopAvailability();
  }

  forceRefreshAvailability() {
    // Skip if product has additional products
    if (this.dataset.hasAdditionalProduct === 'true') {
      return;
    }
    this.refreshQuickShopAvailability();
  }

  updateQuickShopAvailability() {
    // Skip if product has additional products
    if (this.dataset.hasAdditionalProduct === 'true') {
      return;
    }

    const sizeButtons = this.querySelectorAll('.quick-shop__size-option');

    sizeButtons.forEach((button) => {
      const size = button.dataset.size;
      let available = false;
      let variant = null;

      if (this.currentColor && this.currentLength) {
        available = this.isSizeAvailableForColorAndLength(
          this.currentColor,
          size,
          this.currentLength,
        );
        variant = this.getVariantByColorSizeAndLength(this.currentColor, size, this.currentLength);
      } else if (this.currentColor) {
        available = this.isSizeAvailableForColorEnhanced(this.currentColor, size);
        variant = this.getVariantByColorAndSize(this.currentColor, size);
      } else if (this.currentLength) {
        available = this.isSizeAvailableForLength(size, this.currentLength);
        variant = this.getVariantBySizeAndLength(size, this.currentLength);
      } else {
        // For products without color/length selection, show all available sizes
        available = this.isSizeAvailable(size);
        variant = this.getVariantBySize(size);
      }

      // Double-check the availability logic
      const doubleCheckAvailable = variant ? variant.available : false;

      // Only override if the availability check was false but we found an available variant
      // Don't override if availability check was true but variant is not available (might be a different variant)
      if (!available && doubleCheckAvailable) {
        available = doubleCheckAvailable;
      } else if (available && !doubleCheckAvailable) {
        // Keep the original availability result from the availability check
      }

      if (available) {
        button.classList.remove('unavailable');
        button.disabled = false;
        button.dataset.available = 'true';
        button.title = `Add ${size} to cart`;
      } else {
        button.classList.add('unavailable');
        button.disabled = true;
        button.dataset.available = 'false';
        button.title = variant ? `${size} is out of stock` : `${size} not available`;
      }
    });
  }

  getAllSizes() {
    const { variants } = this.productData;
    const sizes = new Set();

    variants.forEach((variant) => {
      if (variant.size) {
        sizes.add(variant.size);
      }
    });

    const sortedSizes = this.sortSizes(Array.from(sizes));
    return sortedSizes;
  }

  getAllSizesUnsorted() {
    const { variants } = this.productData;
    const sizes = new Set();

    variants.forEach((variant) => {
      if (variant.size) {
        sizes.add(variant.size);
      }
    });

    return Array.from(sizes).sort();
  }

  getSizesForColor(color) {
    const { variants } = this.productData;
    const sizes = new Set();

    variants.forEach((variant) => {
      if (variant.color === color && variant.size) {
        sizes.add(variant.size);
      }
    });

    return this.sortSizes(Array.from(sizes));
  }

  getAvailableSizes() {
    const { variants } = this.productData;
    const sizes = new Set();

    variants.forEach((variant) => {
      if (variant.available && variant.size) {
        sizes.add(variant.size);
      }
    });

    const result = this.sortSizes(Array.from(sizes));
    return result;
  }

  getAvailableSizesForColor(color) {
    const { variants } = this.productData;
    const sizes = new Set();

    variants.forEach((variant) => {
      if (variant.available && variant.color === color && variant.size) {
        sizes.add(variant.size);
      }
    });

    return this.sortSizes(Array.from(sizes));
  }

  isSizeAvailable(size) {
    const { variants } = this.productData;

    // First try exact match
    let availableVariants = variants.filter(
      (variant) => variant.size === size && variant.available,
    );

    // If no exact match, try case-insensitive match
    if (availableVariants.length === 0) {
      availableVariants = variants.filter(
        (variant) =>
          variant.size && variant.size.toLowerCase() === size.toLowerCase() && variant.available,
      );
    }

    // If still no match, try partial match (size contains the search term)
    // Only match if sizes have the same length to avoid false matches (e.g., "L" matching "XL" or "XXL")
    if (availableVariants.length === 0) {
      availableVariants = variants.filter(
        (variant) =>
          variant.size &&
          variant.size.toLowerCase() === size.toLowerCase().trim() &&
          variant.size.length === size.length &&
          variant.available,
      );
    }

    const result = availableVariants.length > 0;
    return result;
  }

  isSizeAvailableForColor(color, size) {
    const { variants } = this.productData;
    const matchingVariants = variants.filter(
      (variant) => variant.color === color && variant.size === size,
    );

    const availableVariant = matchingVariants.find((variant) => variant.available);

    return !!availableVariant;
  }

  findVariantByTitleAndAvailability(color, size, length = null) {
    const { variants } = this.productData;

    let titlePatterns = [];

    if (color && size && length) {
      titlePatterns = [
        `${color} / ${size} / ${length}`,
        `${color} - ${size} - ${length}`,
        `${color} / ${size} - ${length}`,
        `${color} - ${size} / ${length}`,
      ];
    } else if (color && size) {
      titlePatterns = [`${color} / ${size}`, `${color} - ${size}`];
    }

    let variant = variants.find((v) => {
      // Check exact title patterns first
      if (titlePatterns.some((pattern) => v.title === pattern)) {
        return true;
      }

      // Check if title contains all the required parts
      const titleLower = v.title.toLowerCase();
      const hasColor = !color || titleLower.includes(color.toLowerCase());
      const hasSize = !size || titleLower.includes(size.toLowerCase());
      const hasLength = !length || titleLower.includes(length.toLowerCase());

      return hasColor && hasSize && hasLength;
    });

    if (variant && variant.available) {
      return variant;
    }

    return null;
  }

  isSizeAvailableForColorEnhanced(color, size) {
    const standardAvailable = this.isSizeAvailableForColor(color, size);
    if (standardAvailable) {
      return true;
    }

    const fallbackVariant = this.findVariantByTitleAndAvailability(color, size);
    if (fallbackVariant) {
      return true;
    }

    return false;
  }

  getVariantByColorAndSize(color, size) {
    const { variants } = this.productData;
    let variant = variants.find((variant) => variant.color === color && variant.size === size);

    if (!variant) {
      variant = this.findVariantByTitleAndAvailability(color, size);
    }

    return variant || null;
  }

  getVariantBySize(size) {
    const { variants } = this.productData;

    // First try exact match
    let matchingVariants = variants.filter((variant) => variant.size === size);

    // If no exact match, try case-insensitive match
    if (matchingVariants.length === 0) {
      matchingVariants = variants.filter(
        (variant) => variant.size && variant.size.toLowerCase() === size.toLowerCase(),
      );
    }

    // If still no match, try partial match
    // Only match if sizes have the same length to avoid false matches (e.g., "L" matching "XL" or "XXL")
    if (matchingVariants.length === 0) {
      matchingVariants = variants.filter(
        (variant) =>
          variant.size &&
          variant.size.toLowerCase().includes(size.toLowerCase()) &&
          variant.size.length === size.length,
      );
    }

    // Return the first available variant, or the first variant if none are available
    const result =
      matchingVariants.find((variant) => variant.available) || matchingVariants[0] || null;
    return result;
  }

  // Rewrite the `width=` parameter on a Shopify CDN image URL. The URLs in the
  // card's JSON are emitted at width 400, so a candidate list has to re-ask for
  // each size rather than append a second `width=`.
  //
  // Both CDN URL shapes are matched on purpose: `/cdn/shop/...` from Liquid and
  // `cdn.shopify.com/s/files/...` from the Ajax cart and the Algolia index. A
  // guard that checks only one silently resizes nothing.
  cardImageUrl(src, width) {
    if (!src || typeof src !== 'string') return src;
    if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/shop/') === -1) return src;
    if (/[?&]width=\d+/.test(src)) {
      return src.replace(/([?&]width=)\d+/, '$1' + width);
    }
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  // Point one card image at a new image.
  //
  // Both card images carry a `srcset`, and a browser picks its file from
  // `srcset` and ignores `src` completely whenever one is present. Assigning
  // `src` alone — which is what this used to do — left the old colour on screen
  // with no error anywhere: the srcset has to be rebuilt too.
  //
  // Widths mirror the ones snippets/product-card.liquid asks Liquid for, capped
  // at the 600px base so no candidate claims a size Shopify won't render.
  // Returns true only when the image actually changed, so the caller can skip
  // waiting on a `load` event that will never fire.
  applyCardImage(img, image) {
    const srcset = [200, 300, 400, 600]
      .map((width) => this.cardImageUrl(image.src, width) + ' ' + width + 'w')
      .join(', ');
    const src = this.cardImageUrl(image.src, 600);

    // The hover image is lazy — until a pointer reaches the card it holds
    // data-src/data-srcset and has no real src at all (see
    // snippets/lazy-hover-images.liquid). Write to whichever pair is live, or
    // the first hover after a colour click would promote the old colour's URL.
    const lazy = img.hasAttribute('data-src');
    const srcAttr = lazy ? 'data-src' : 'src';
    const srcsetAttr = lazy ? 'data-srcset' : 'srcset';
    const changed = img.getAttribute(srcsetAttr) !== srcset || img.getAttribute(srcAttr) !== src;

    img.setAttribute(srcsetAttr, srcset);
    img.setAttribute(srcAttr, src);
    img.alt = image.alt || '';

    return changed;
  }

  updateImage() {
    const mainImageElement = this.querySelector('.product-card__image-main');
    const hoverImageElement = this.querySelector('.product-card__image-hover');

    if (!mainImageElement) return;

    const selectedImages = this.getSelectedImages();
    if (selectedImages.main) {
      const changed = this.applyCardImage(mainImageElement, selectedImages.main);

      // Only dim while a genuinely new file is on its way. Re-selecting the
      // colour that is already showing fires no `load` event, so an
      // unconditional dim would leave the card stuck at 0.7 opacity.
      if (changed) {
        mainImageElement.style.opacity = '0.7';
        const undim = () => {
          mainImageElement.style.opacity = '1';
        };
        mainImageElement.addEventListener('load', undim, { once: true });
        // An image that never arrives would otherwise leave the card dimmed for
        // the rest of the session.
        mainImageElement.addEventListener('error', undim, { once: true });
      } else {
        mainImageElement.style.opacity = '1';
      }
    }

    if (hoverImageElement && selectedImages.hover) {
      this.applyCardImage(hoverImageElement, selectedImages.hover);
    }
  }

  updatePrice() {
    const priceContainer = this.querySelector('.product-card__price');
    if (!priceContainer) {
      return;
    }

    // Don't update price if variant selection is unclear (no color or size selected)
    // This prevents incorrect prices from being shown during initialization
    if (!this.currentColor && !this.currentSize) {
      return;
    }

    const selectedVariant = this.getSelectedVariant();
    if (!selectedVariant) {
      return;
    }

    // Format prices using Shopify's money filter equivalent
    const formattedPrice = this.formatMoney(selectedVariant.price);
    const formattedCompareAtPrice = selectedVariant.compare_at_price
      ? this.formatMoney(selectedVariant.compare_at_price)
      : null;

    priceContainer.innerHTML = '';

    if (
      selectedVariant.compare_at_price &&
      selectedVariant.compare_at_price > selectedVariant.price
    ) {
      const newHTML = `
        <span class="product-card__price--sale">${formattedPrice}</span>
        <span class="product-card__price--compare">${formattedCompareAtPrice}</span>
      `;
      priceContainer.innerHTML = newHTML;
    } else {
      const newHTML = `
        <span class="product-card__price--regular">${formattedPrice}</span>
      `;
      priceContainer.innerHTML = newHTML;
    }
  }

  updateVariantUI() {
    const colorOptions = this.querySelectorAll('[data-variant-type="color"]');
    colorOptions.forEach((option) => {
      option.classList.toggle('selected', option.dataset.variantValue === this.currentColor);
    });

    const sizeOptions = this.querySelectorAll('[data-variant-type="size"]');
    sizeOptions.forEach((option) => {
      option.classList.toggle('selected', option.dataset.variantValue === this.currentSize);
    });

    const lengthOptions = this.querySelectorAll('[data-variant-type="length"]');
    lengthOptions.forEach((option) => {
      const isSelected = option.dataset.variantValue === this.currentLength;
      option.classList.toggle('selected', isSelected);
      option.setAttribute('data-active', isSelected.toString());
    });

    // Update product URLs with current variant
    this.updateProductUrls();
  }

  updateProductUrls() {
    const selectedVariant = this.getSelectedVariant();
    if (!selectedVariant) return;

    const baseUrl = this.productData.product.url;
    const variantId = selectedVariant.id;

    // Update all product links in the card (including those with collection URLs)
    const productLinks = this.querySelectorAll('a[href*="' + baseUrl + '"]');
    productLinks.forEach((link) => {
      const currentHref = link.getAttribute('href');

      // Parse the current URL to handle existing query parameters
      try {
        const url = new URL(currentHref, window.location.origin);
        url.searchParams.set('variant', variantId);
        const newUrl = url.pathname + url.search;
        link.setAttribute('href', newUrl);
      } catch {
        // Fallback: handle URLs that might have collection prefix
        // If the URL contains the product URL, append variant parameter
        if (currentHref.includes(baseUrl)) {
          const separator = currentHref.includes('?') ? '&' : '?';
          const urlWithVariant = `${currentHref}${separator}variant=${variantId}`;
          link.setAttribute('href', urlWithVariant);
        }
      }
    });
  }

  getSelectedImages() {
    const { product, variants } = this.productData;
    const currentColorLower = this.currentColor ? this.currentColor.toLowerCase() : null;
    const currentLengthLower = this.currentLength ? this.currentLength.toLowerCase() : null;

    let mainImage = null;
    let hoverImage = null;

    // Priority: Color + Length > Color only > Length only > Default
    if (this.currentColor && this.currentLength) {
      // Look for variants with both color and length
      const colorLengthVariant = variants.find(
        (variant) =>
          variant.color &&
          variant.color.toLowerCase() === currentColorLower &&
          variant.length &&
          variant.length.toLowerCase() === currentLengthLower,
      );

      let colorLengthImages = [];

      if (colorLengthVariant && colorLengthVariant.image) {
        colorLengthImages.push(colorLengthVariant.image);
      }

      // Also look for product images that match both color and length
      const matchingProductImages = product.images.filter(
        (image) =>
          altMentions(image.alt, currentColorLower) &&
          altMentions(image.alt, currentLengthLower),
      );

      colorLengthImages = [...colorLengthImages, ...matchingProductImages];

      const uniqueImages = colorLengthImages.filter(
        (image, index, self) => index === self.findIndex((img) => img.src === image.src),
      );

      if (uniqueImages.length > 0) {
        mainImage = uniqueImages[0];
        hoverImage = uniqueImages.length > 1 ? uniqueImages[1] : uniqueImages[0];
      }
    } else if (this.currentColor) {
      // Look for variants with color only
      const colorVariant = variants.find(
        (variant) => variant.color && variant.color.toLowerCase() === currentColorLower,
      );

      let colorImages = [];

      if (colorVariant && colorVariant.image) {
        colorImages.push(colorVariant.image);
      }

      const matchingProductImages = product.images.filter(
        (image) => altMentions(image.alt, currentColorLower),
      );

      colorImages = [...colorImages, ...matchingProductImages];

      const uniqueImages = colorImages.filter(
        (image, index, self) => index === self.findIndex((img) => img.src === image.src),
      );

      if (uniqueImages.length > 0) {
        mainImage = uniqueImages[0];
        hoverImage = uniqueImages.length > 1 ? uniqueImages[1] : uniqueImages[0];
      }
    } else if (this.currentLength) {
      // Look for variants with length only
      const lengthVariant = variants.find(
        (variant) => variant.length && variant.length.toLowerCase() === currentLengthLower,
      );

      let lengthImages = [];

      if (lengthVariant && lengthVariant.image) {
        lengthImages.push(lengthVariant.image);
      }

      // Also look for product images that match length
      const matchingProductImages = product.images.filter(
        (image) => altMentions(image.alt, currentLengthLower),
      );

      lengthImages = [...lengthImages, ...matchingProductImages];

      const uniqueImages = lengthImages.filter(
        (image, index, self) => index === self.findIndex((img) => img.src === image.src),
      );

      if (uniqueImages.length > 0) {
        mainImage = uniqueImages[0];
        hoverImage = uniqueImages.length > 1 ? uniqueImages[1] : uniqueImages[0];
      }
    }

    // Fallback to default product images if no specific variant images found
    if (!mainImage && product.images.length > 0) {
      mainImage = product.images[0];
      hoverImage = product.images.length > 1 ? product.images[1] : product.images[0];
    }

    return {
      main: mainImage,
      hover: hoverImage,
    };
  }

  // The card's length buttons lose the trailing " of values like `Tall 17"`
  // (data-variant-value is written unescaped), so compare with it stripped.
  // Used by initializeVariantSelection and getSelectedVariant.
  lengthMatches(variant, length) {
    const normalize = (value) => value.replace(/\\"/g, '"').replace(/"$/, '');
    return Boolean(variant.length && length) && normalize(variant.length) === normalize(length);
  }

  getSelectedVariant() {
    const { variants } = this.productData;
    const lengthMatch = (variant) =>
      !this.currentLength || this.lengthMatches(variant, this.currentLength);

    // First, try to find a variant that matches current color, size, and length
    let selectedVariant = variants.find((variant) => {
      const colorMatch = !this.currentColor || variant.color === this.currentColor;
      const sizeMatch = !this.currentSize || variant.size === this.currentSize;
      return colorMatch && sizeMatch && lengthMatch(variant);
    });

    // Prefer something in stock. Every tier below falls back to any matching
    // variant, but an available one wins, because this result is written into
    // the card's href as ?variant= — picking a sold-out variant sends the
    // shopper from a collection or the homepage straight to a Sold Out button.
    if (selectedVariant && !selectedVariant.available) {
      // Keep the length: a Tall shopper whose first Tall size is sold out
      // should land on another Tall size, not on Regular.
      const availableExact = variants.find(
        (variant) =>
          variant.available &&
          (!this.currentColor || variant.color === this.currentColor) &&
          (!this.currentSize || variant.size === this.currentSize) &&
          lengthMatch(variant),
      );
      if (availableExact) selectedVariant = availableExact;
    }

    // If no exact match, try to find a variant with just the current color
    if (!selectedVariant && this.currentColor) {
      selectedVariant =
        variants.find((variant) => variant.color === this.currentColor && variant.available) ||
        variants.find((variant) => variant.color === this.currentColor);
    }

    // If still no match, try to find a variant with just the current size
    if (!selectedVariant && this.currentSize) {
      selectedVariant = variants.find((variant) => variant.size === this.currentSize);
    }

    // If still no match, try to find a variant with just the current length
    if (!selectedVariant && this.currentLength) {
      selectedVariant =
        variants.find((variant) => variant.available && lengthMatch(variant)) ||
        variants.find(lengthMatch);
    }

    // If still no match, return the first available variant, or first variant
    if (!selectedVariant) {
      selectedVariant = variants.find((variant) => variant.available) || variants[0];
    }

    return selectedVariant || null;
  }

  getVariantByColor(color) {
    const { variants } = this.productData;
    return variants.find((variant) => variant.color === color) || null;
  }

  getVariantByLength(length) {
    const { variants } = this.productData;
    return variants.find((variant) => variant.length === length) || null;
  }

  getVariantByColorSizeAndLength(color, size, length) {
    const { variants } = this.productData;
    let variant = variants.find(
      (variant) => variant.color === color && variant.size === size && variant.length === length,
    );

    if (!variant) {
      // Fallback: try to find by title matching
      variant = this.findVariantByTitleAndAvailability(color, size, length);
    }

    return variant || null;
  }

  getVariantByColorAndLength(color, length) {
    const { variants } = this.productData;
    return variants.find((variant) => variant.color === color && variant.length === length) || null;
  }

  getVariantBySizeAndLength(size, length) {
    const { variants } = this.productData;

    // First try exact match
    let matchingVariants = variants.filter(
      (variant) => variant.size === size && variant.length === length,
    );

    // If no exact match, try case-insensitive match
    if (matchingVariants.length === 0) {
      matchingVariants = variants.filter(
        (variant) =>
          variant.size &&
          variant.size.toLowerCase() === size.toLowerCase() &&
          variant.length &&
          variant.length.toLowerCase() === length.toLowerCase(),
      );
    }

    // If still no match, try partial match
    // Only match if sizes have the same length to avoid false matches (e.g., "L" matching "XL" or "XXL")
    if (matchingVariants.length === 0) {
      matchingVariants = variants.filter(
        (variant) =>
          variant.size &&
          variant.size.toLowerCase().includes(size.toLowerCase()) &&
          variant.size.length === size.length &&
          variant.length &&
          variant.length.toLowerCase().includes(length.toLowerCase()),
      );
    }

    // Return the first available variant, or the first variant if none are available
    const result =
      matchingVariants.find((variant) => variant.available) || matchingVariants[0] || null;
    return result;
  }

  isSizeAvailableForColorAndLength(color, size, length) {
    const { variants } = this.productData;
    const matchingVariants = variants.filter(
      (variant) => variant.color === color && variant.size === size && variant.length === length,
    );

    const availableVariant = matchingVariants.find((variant) => variant.available);
    return !!availableVariant;
  }

  isSizeAvailableForLength(size, length) {
    const { variants } = this.productData;

    // First try exact match
    let matchingVariants = variants.filter(
      (variant) => variant.size === size && variant.length === length,
    );

    // If no exact match, try case-insensitive match
    if (matchingVariants.length === 0) {
      matchingVariants = variants.filter(
        (variant) =>
          variant.size &&
          variant.size.toLowerCase() === size.toLowerCase() &&
          variant.length &&
          variant.length.toLowerCase() === length.toLowerCase(),
      );
    }

    // If still no match, try partial match
    // Only match if sizes have the same length to avoid false matches (e.g., "L" matching "XL" or "XXL")
    if (matchingVariants.length === 0) {
      matchingVariants = variants.filter(
        (variant) =>
          variant.size &&
          variant.size.toLowerCase().includes(size.toLowerCase()) &&
          variant.size.length === size.length &&
          variant.length &&
          variant.length.toLowerCase().includes(length.toLowerCase()),
      );
    }

    const availableVariant = matchingVariants.find((variant) => variant.available);
    const result = !!availableVariant;
    return result;
  }

  sortSizes(sizes) {
    const sizeOrder = [
      'os',
      'OS',
      'one size',
      'One Size',
      'ONE SIZE',
      'xxxs',
      'xxs',
      'xs',
      's',
      'sm',
      'small',
      'm',
      'md',
      'medium',
      'ml',
      'l',
      'lg',
      'large',
      'xl',
      'xxl',
      '2xl',
      '3xl',
      '4xl',
      '5xl',
      '6xl',
      '7xl',
      '8xl',
      '9xl',
      '10xl',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
      '32',
      '33',
      '34',
      '35',
      '36',
      '37',
      '38',
      '39',
      '40',
      '41',
      '42',
      '43',
      '44',
      '45',
      '46',
      '47',
      '48',
      '49',
      '50',
    ];

    return sizes.sort((a, b) => {
      const aIndex = sizeOrder.indexOf(a.toLowerCase());
      const bIndex = sizeOrder.indexOf(b.toLowerCase());

      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;

      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
  }

  formatMoney(cents) {
    // Delegates to the single currency-aware formatter defined in
    // layout/theme.liquid. This used to hardcode "$" and USD's two decimals,
    // which mislabelled every non-USD presentment currency.
    return window.Shopify.formatMoney(cents);
  }

  /**
   * Update product card with current filter state
   * This method is called by the infinite scroll component when filters change
   */
  updateWithFilters(filters) {
    if (!filters || Object.keys(filters).length === 0) {
      // No filters applied, reset to default state
      this.currentColor = null;
      this.updateImage();
      this.updatePrice();
      this.updateVariantUI();
      // Only update Quick Shop if product doesn't have additional products
      if (this.dataset.hasAdditionalProduct !== 'true') {
        this.updateQuickShopAvailability();
      }
      return;
    }

    // Check for color filters
    const colorFilters = this.getColorFilters(filters);
    if (colorFilters.length > 0) {
      // Find the first matching color variant
      const matchingColor = this.findMatchingColor(colorFilters);
      if (matchingColor && matchingColor !== this.currentColor) {
        this.currentColor = matchingColor;
        this.updateImage();
        this.updatePrice();
        this.updateVariantUI();
        // Only update Quick Shop if product doesn't have additional products
        if (this.dataset.hasAdditionalProduct !== 'true') {
          this.updateQuickShopAvailability();
        }
      }
    }

    // Check for length filters
    const lengthFilters = this.getLengthFilters(filters);
    if (lengthFilters.length > 0) {
      // Find the first matching length variant
      const matchingLength = this.findMatchingLength(lengthFilters);
      if (matchingLength && matchingLength !== this.currentLength) {
        this.currentLength = matchingLength;
        this.updatePrice();
        this.updateVariantUI();
      }
    }
  }

  /**
   * Extract color-related filters from the filter object
   */
  getColorFilters(filters) {
    const colorFilters = [];

    // Check for common color option names
    const colorOptionNames = ['color', 'colour', 'Color', 'Colour', 'COLOR', 'COLOUR'];

    for (const [optionName, value] of Object.entries(filters)) {
      if (
        colorOptionNames.includes(optionName) ||
        optionName.toLowerCase().includes('color') ||
        optionName.toLowerCase().includes('colour')
      ) {
        colorFilters.push(value);
      }
    }

    return colorFilters;
  }

  /**
   * Extract length-related filters from the filter object
   */
  getLengthFilters(filters) {
    const lengthFilters = [];

    // Check for common length option names
    const lengthOptionNames = ['length', 'Length', 'LENGTH'];

    for (const [optionName, value] of Object.entries(filters)) {
      if (lengthOptionNames.includes(optionName) || optionName.toLowerCase().includes('length')) {
        lengthFilters.push(value);
      }
    }

    return lengthFilters;
  }

  /**
   * Find a matching color variant based on filter values
   */
  findMatchingColor(colorFilters) {
    if (!this.productData || !this.productData.variants) return null;

    const { variants } = this.productData;

    // First, try exact matches
    for (const filterColor of colorFilters) {
      const exactMatch = variants.find(
        (variant) => variant.color && variant.color.toLowerCase() === filterColor.toLowerCase(),
      );
      if (exactMatch) return exactMatch.color;
    }

    // Then try color family matches
    for (const filterColor of colorFilters) {
      // Check if this is a color family
      const familyMatch = this.findBestColorVariantForFamily(filterColor);
      if (familyMatch) return familyMatch;
    }

    // Then try partial matches
    for (const filterColor of colorFilters) {
      const partialMatch = variants.find(
        (variant) =>
          variant.color && variant.color.toLowerCase().includes(filterColor.toLowerCase()),
      );
      if (partialMatch) return partialMatch.color;
    }

    // Finally, try reverse partial matches (filter contains variant color)
    for (const filterColor of colorFilters) {
      const reverseMatch = variants.find(
        (variant) =>
          variant.color && filterColor.toLowerCase().includes(variant.color.toLowerCase()),
      );
      if (reverseMatch) return reverseMatch.color;
    }

    return null;
  }

  /**
   * Find a matching length variant based on filter values
   */
  findMatchingLength(lengthFilters) {
    if (!this.productData || !this.productData.variants) return null;

    const { variants } = this.productData;

    // First, try exact matches
    for (const filterLength of lengthFilters) {
      const exactMatch = variants.find(
        (variant) => variant.length && variant.length.toLowerCase() === filterLength.toLowerCase(),
      );
      if (exactMatch) return exactMatch.length;
    }

    // Then try partial matches
    for (const filterLength of lengthFilters) {
      const partialMatch = variants.find(
        (variant) =>
          variant.length && variant.length.toLowerCase().includes(filterLength.toLowerCase()),
      );
      if (partialMatch) return partialMatch.length;
    }

    // Finally, try reverse partial matches (filter contains variant length)
    for (const filterLength of lengthFilters) {
      const reverseMatch = variants.find(
        (variant) =>
          variant.length && filterLength.toLowerCase().includes(variant.length.toLowerCase()),
      );
      if (reverseMatch) return reverseMatch.length;
    }

    return null;
  }

  cleanup() {
    // Clean up any intervals or event listeners
    if (this.availabilityCheckInterval) {
      clearInterval(this.availabilityCheckInterval);
      this.availabilityCheckInterval = null;
    }

    // Remove variant change event listeners
    document.removeEventListener('variant:changed', this.handleVariantChange.bind(this));
    document.removeEventListener('variant:price-changed', this.handlePriceChange.bind(this));
  }

  /**
   * Simple color family mappings
   */
  static getColorFamilyMappings() {
    return {
      'Black Family': [
        'Black',
        'Jet Black',
        'Onyx',
        'Charcoal',
        'Dark Gray',
        'Navy Black',
        'Black Matte',
        'Black Gloss',
      ],
      'White Family': [
        'White',
        'Pearl White',
        'Ivory',
        'Cream',
        'Off White',
        'Pure White',
        'White Matte',
        'White Gloss',
      ],
      'Blue Family': [
        'Blue',
        'Navy Blue',
        'Royal Blue',
        'Sky Blue',
        'Light Blue',
        'Dark Blue',
        'Cobalt Blue',
        'Sapphire Blue',
      ],
      'Red Family': [
        'Red',
        'Crimson Red',
        'Burgundy',
        'Scarlet',
        'Ruby Red',
        'Cherry Red',
        'Fire Red',
        'Brick Red',
      ],
      'Green Family': [
        'Green',
        'Forest Green',
        'Emerald Green',
        'Olive Green',
        'Sage Green',
        'Mint Green',
        'Hunter Green',
        'Kelly Green',
      ],
      'Yellow Family': [
        'Yellow',
        'Golden Yellow',
        'Lemon Yellow',
        'Mustard Yellow',
        'Sunshine Yellow',
        'Butter Yellow',
        'Amber Yellow',
      ],
      'Purple Family': [
        'Purple',
        'Royal Purple',
        'Lavender',
        'Violet',
        'Plum',
        'Amethyst',
        'Grape Purple',
        'Deep Purple',
      ],
      'Pink Family': [
        'Pink',
        'Rose Pink',
        'Hot Pink',
        'Blush Pink',
        'Fuchsia',
        'Magenta',
        'Salmon Pink',
        'Coral Pink',
      ],
      'Orange Family': [
        'Orange',
        'Tangerine',
        'Peach',
        'Coral',
        'Rust',
        'Burnt Orange',
        'Sunset Orange',
        'Pumpkin Orange',
      ],
      'Brown Family': [
        'Brown',
        'Chocolate Brown',
        'Tan',
        'Beige',
        'Camel',
        'Caramel',
        'Mocha',
        'Espresso',
      ],
      'Gray Family': [
        'Gray',
        'Silver Gray',
        'Charcoal Gray',
        'Light Gray',
        'Medium Gray',
        'Dark Gray',
        'Steel Gray',
        'Platinum Gray',
      ],
      'Gold Family': [
        'Gold',
        'Yellow Gold',
        'Rose Gold',
        'White Gold',
        'Antique Gold',
        'Champagne Gold',
        'Brass Gold',
      ],
      'Silver Family': [
        'Silver',
        'Platinum Silver',
        'Sterling Silver',
        'Chrome Silver',
        'Metallic Silver',
        'Brushed Silver',
        'Polished Silver',
      ],
      'Neutral Family': ['Neutral', 'Beige', 'Cream', 'Taupe', 'Khaki', 'Stone', 'Sand', 'Ecru'],
      'Metallic Family': [
        'Metallic',
        'Chrome',
        'Brass',
        'Copper',
        'Bronze',
        'Nickel',
        'Titanium',
        'Aluminum',
      ],
      'Pastel Family': [
        'Pastel Blue',
        'Pastel Pink',
        'Pastel Green',
        'Pastel Yellow',
        'Pastel Purple',
        'Pastel Orange',
        'Pastel Mint',
        'Pastel Lavender',
      ],
      'Earth Tones Family': [
        'Earth Tones',
        'Terra Cotta',
        'Sienna',
        'Umber',
        'Ochre',
        'Sepia',
        'Burnt Sienna',
        'Raw Umber',
      ],
    };
  }

  /**
   * Get colors in a family
   */
  static getColorsInFamily(familyName) {
    const mappings = this.getColorFamilyMappings();
    return mappings[familyName] || [];
  }

  /**
   * Find the best matching color variant for a color family
   */
  findBestColorVariantForFamily(familyName) {
    if (!this.productData || !this.productData.variants) return null;

    const { variants } = this.productData;
    const familyColors = ProductCard.getColorsInFamily(familyName);

    // First, try exact matches
    for (const familyColor of familyColors) {
      const exactMatch = variants.find(
        (variant) => variant.color && variant.color.toLowerCase() === familyColor.toLowerCase(),
      );
      if (exactMatch) return exactMatch.color;
    }

    // Then try partial matches
    for (const familyColor of familyColors) {
      const partialMatch = variants.find(
        (variant) =>
          variant.color && variant.color.toLowerCase().includes(familyColor.toLowerCase()),
      );
      if (partialMatch) return partialMatch.color;
    }

    // Finally, try reverse matches (variant contains family base color)
    const baseColor = familyName.replace(' Family', '').toLowerCase();
    const reverseMatch = variants.find(
      (variant) => variant.color && variant.color.toLowerCase().includes(baseColor),
    );
    if (reverseMatch) return reverseMatch.color;

    return null;
  }
}

// Register the web component
customElements.define('product-card', ProductCard);

// Legacy ProductCardEnhancer for backward compatibility
class ProductCardEnhancer {
  constructor() {
    this.productCards = new Map();
    this.init();
  }

  init() {
    // Enhance existing product cards
    this.enhanceProductCards();

    // Listen for new product cards (for backward compatibility)
    this.observeNewCards();
  }

  enhanceProductCards() {
    const cards = document.querySelectorAll('.product-card:not([data-enhanced])');
    cards.forEach((card) => this.enhanceCard(card));
  }

  enhanceCard(card) {
    const productId = card.dataset.productId;
    if (!productId) return;

    if (this.productCards.has(productId)) return;

    if (!document.contains(card)) return;

    // Mark as enhanced to prevent double processing
    card.setAttribute('data-enhanced', 'true');
  }

  observeNewCards() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && node.classList.contains('product-card')) {
              this.enhanceCard(node);
            }
            const cards = node.querySelectorAll ? node.querySelectorAll('.product-card') : [];
            if (cards.length > 0) {
              cards.forEach((card) => this.enhanceCard(card));
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    this.mutationObserver = observer;
  }

  refreshAllProductCards() {
    const cards = document.querySelectorAll('product-card');
    cards.forEach((card) => {
      if (card.forceRefreshAvailability) {
        card.forceRefreshAvailability();
      }
    });
  }

  getDebugInfo() {
    const cards = document.querySelectorAll('product-card');
    const debugInfo = {
      totalProductCards: cards.length,
      productCards: [],
    };

    cards.forEach((card) => {
      if (card.productData) {
        debugInfo.productCards.push({
          productId: card.dataset.productId,
          productTitle: card.productData.product.title,
          currentColor: card.currentColor,
          currentSize: card.currentSize,
          currentLength: card.currentLength,
          variants: card.productData.variants.length,
          availableVariants: card.productData.variants.filter((v) => v.available).length,
        });
      }
    });

    return debugInfo;
  }

  enhanceAllUnenhancedCards() {
    const allCards = document.querySelectorAll('.product-card:not([data-enhanced])');
    let enhancedCount = 0;

    allCards.forEach((card) => {
      this.enhanceCard(card);
      enhancedCount++;
    });

    return enhancedCount;
  }

  refreshProductCard(productId) {
    const card = document.querySelector(`product-card[data-product-id="${productId}"]`);
    if (card && card.forceRefreshAvailability) {
      card.forceRefreshAvailability();
    }
  }

  destroy() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }

    this.productCards.clear();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.productCardEnhancer = new ProductCardEnhancer();
});

// Handle dynamic content loading (Shopify sections)
document.addEventListener('shopify:section:load', (event) => {
  const cards = event.target.querySelectorAll('.product-card');
  cards.forEach((card) => {
    if (window.productCardEnhancer) {
      window.productCardEnhancer.enhanceCard(card);
    }
  });
});

// Export for potential external use
window.ProductCardEnhancer = ProductCardEnhancer;

// Add global debugging methods
window.refreshAllProductCards = () => {
  if (window.productCardEnhancer) {
    window.productCardEnhancer.refreshAllProductCards();
  }
};

window.getProductCardDebugInfo = () => {
  if (window.productCardEnhancer) {
    return window.productCardEnhancer.getDebugInfo();
  }
  return null;
};

window.enhanceAllProductCards = () => {
  if (window.productCardEnhancer) {
    return window.productCardEnhancer.enhanceAllUnenhancedCards();
  }
  return 0;
};

window.checkProductCardAvailability = () => {
  // Debug functionality removed
};

window.debugColorFilterFunctionality = () => {
  // Debug functionality removed
};

window.testColorFilterUpdate = (colorFilter) => {
  const infiniteScroll = document.querySelector('infinite-scroll');
  if (!infiniteScroll) {
    return;
  }

  // Simulate a color filter
  const testFilters = { Color: colorFilter };

  const cards = document.querySelectorAll('product-card');
  cards.forEach((card) => {
    card.updateWithFilters(testFilters);
  });
};

window.testColorFamilyMatching = (familyName) => {
  const cards = document.querySelectorAll('product-card');
  cards.forEach((card) => {
    if (card.productData && card.productData.variants) {
      card.findBestColorVariantForFamily(familyName);
    }
  });
};

window.debugColorFamilies = () => {
  // Debug functionality removed
};

window.debugProductCardSizes = () => {
  // Debug functionality removed
};

window.debugProductCardPrices = () => {
  // Debug functionality removed
};

window.testProductCardPriceUpdate = (productId) => {
  const card = document.querySelector(`product-card[data-product-id="${productId}"]`);
  if (!card) {
    return;
  }

  card.updatePrice();
};

window.debugInfiniteScrollEnhancement = () => {
  // Debug functionality removed
};


//# sourceURL=webpack://liquid-starter/./src/components/product-card.js?
;

/***/ }),

/***/ "./src/components/product-gallery.js":
/*!*******************************************!*\
  !*** ./src/components/product-gallery.js ***!
  \*******************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Product Gallery Web Component
 * Handles product image gallery with thumbnail navigation and variant-aware filtering
 */
class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('data-product-id');
    this.currentVariant = null;
    this.thumbnails = [];
    this.mainImageContainer = null;
    this.thumbnailList = null;
    this.colorOptionIndex = null;

    this.init();
  }

  init() {
    this.setupElements();
    this.bindEvents();
    this.setupVariantListener();
    this.initializeWithCurrentVariant();
  }

  setupElements() {
    this.mainImageContainer = this.querySelector('[id^="main-image-"]');
    this.thumbnails = Array.from(this.querySelectorAll('[data-trigger="gallery-thumbnail"]'));
    this.thumbnailList = this.querySelector('ul');
  }

  bindEvents() {
    // Handle thumbnail clicks using event delegation
    this.addEventListener('click', this.handleThumbnailClick.bind(this));
  }

  /**
   * BULLETPROOF: Find the color option index dynamically
   * This handles cases where color might be first, second, or third option
   */
  findColorOptionIndex() {
    if (this.colorOptionIndex !== null) {
      return this.colorOptionIndex;
    }

    // Get the variant selector to find color option
    const variantSelector = document.querySelector(
      `variant-selector[data-product-id="${this.productId}"]`,
    );

    if (variantSelector && variantSelector.currentVariant) {
      // Look for color option in the variant selector DOM
      const colorOptions = variantSelector.querySelectorAll('.variant-selector__color-option');
      if (colorOptions.length > 0) {
        const firstColorOption = colorOptions[0];
        this.colorOptionIndex = parseInt(firstColorOption.getAttribute('data-option-index'));
        console.log('🎨 Found color option at index:', this.colorOptionIndex);
        return this.colorOptionIndex;
      }
    }

    // Fallback: assume first option is color (original behavior)
    console.log('🎨 Using fallback: assuming color is at index 0');
    this.colorOptionIndex = 0;
    return this.colorOptionIndex;
  }

  /**
   * BULLETPROOF: Get the current color value from variant
   */
  getCurrentColorValue(variant) {
    if (!variant || !variant.options) return '';

    const colorIndex = this.findColorOptionIndex();
    const colorValue = variant.options[colorIndex];

    return colorValue ? colorValue.toLowerCase() : '';
  }

  initializeWithCurrentVariant() {
    // Get the current variant from the variant selector
    const variantSelector = document.querySelector(
      `variant-selector[data-product-id="${this.productId}"]`,
    );

    if (variantSelector && variantSelector.currentVariant) {
      console.log('🎨 Initializing gallery with variant:', variantSelector.currentVariant.options);
      this.updateImagesForVariant(variantSelector.currentVariant);
    } else {
      // Fallback: show all images if no variant selector found
      console.log('🎨 No variant selector found, showing all images');
      this.updateImagesForVariant(null);
    }

    console.log('🔧 Product Gallery initializeWithCurrentVariant completed');
  }

  handleThumbnailClick(event) {
    const thumbnail = event.target.closest('[data-trigger="gallery-thumbnail"]');
    if (!thumbnail) return;

    event.preventDefault();

    this.updateMainImage(thumbnail);
  }

  updateMainImage(thumbnail) {
    // Update active thumbnail
    this.thumbnails.forEach((thumb) => {
      thumb.setAttribute('data-active', 'false');
    });
    thumbnail.setAttribute('data-active', 'true');

    // Update main image
    const imageUrl = thumbnail.getAttribute('data-image-url');
    const imageSrcset = thumbnail.getAttribute('data-image-srcset');
    const imageAlt = thumbnail.getAttribute('data-image-alt');
    const imageId = thumbnail.getAttribute('data-image-id');

    // setupElements() caches this once from the constructor. If the element was
    // upgraded before its children existed (or a third-party script replaced the
    // markup) the cache is null and this used to throw on every thumbnail click.
    if (!this.mainImageContainer) {
      console.warn('[product-gallery] main image container missing; skipping image swap');
      return;
    }

    const mainImage = this.mainImageContainer.querySelector('img');
    if (mainImage && imageUrl) {
      // Keep a responsive srcset so the browser fetches a size that matches
      // the shopper's screen instead of always downloading a fixed-width image
      mainImage.src = imageUrl;
      if (imageSrcset) {
        mainImage.srcset = imageSrcset;
        mainImage.sizes = '(max-width: 768px) 100vw, 500px';
      } else {
        mainImage.removeAttribute('srcset');
      }

      mainImage.alt = imageAlt || '';
      this.mainImageContainer.setAttribute('data-active-image', imageId);

      // Add loading state
      mainImage.style.opacity = '0.7';
      mainImage.onload = () => {
        mainImage.style.opacity = '1';
        console.log('🖼️ Main image loaded successfully');
      };
      mainImage.onerror = () => {
        console.error('Failed to load image:', imageUrl);
        mainImage.style.opacity = '1';
      };
    } else {
      console.error('Main image or image URL not found:', {
        mainImage,
        imageUrl,
        mainImageContainer: this.mainImageContainer,
        containerHTML: this.mainImageContainer?.innerHTML,
      });
    }
  }

  setupVariantListener() {
    // Listen for variant changes from the variant selector
    document.addEventListener('variant:changed', (event) => {
      if (event.detail.productId == this.productId) {
        this.handleVariantChange(
          event.detail.variant,
          event.detail.previousVariant,
          event.detail.changedOptionIndex,
          event.detail.changedOptionValue,
        );
      }
    });
  }

  handleVariantChange(variant, previousVariant, changedOptionIndex, changedOptionValue) {
    if (!variant || !variant.options) {
      console.log('❌ Invalid variant data');
      return;
    }

    // Check if the changed option is a size option
    if (changedOptionValue) {
      const cleanOptionValue = changedOptionValue.toLowerCase().replace(/"/g, '');
      const isSizeOption = /xs|^s$|^m$|^l$|xl|xxl/i.test(cleanOptionValue);

      console.log('🎨 Option change analysis:', {
        changedOptionValue,
        cleanOptionValue,
        isSizeOption,
        changedOptionIndex,
      });

      if (isSizeOption) {
        console.log('🎨 Size option changed, skipping gallery update');
        return;
      } else {
        console.log('🎨 Non-size option changed, updating gallery');
        this.updateImagesForVariant(variant);
      }
    } else {
      // Fallback: if we don't have option info, use the old logic
      console.log('🎨 No option info available, using fallback logic');

      // Check if any non-size variant option changed
      const currentNonSizeOptions = variant.options
        .filter((option, index) => {
          const cleanOption = option.toLowerCase().replace(/"/g, '');
          // Skip size options (XS, S, M, L, XL, etc.)
          const isSize = /xs|^s$|^m$|^l$|xl|xxl/i.test(cleanOption);
          return !isSize;
        })
        .join('|')
        .toLowerCase();

      const previousNonSizeOptions = previousVariant
        ? previousVariant.options
            .filter((option, index) => {
              const cleanOption = option.toLowerCase().replace(/"/g, '');
              // Skip size options (XS, S, M, L, XL, etc.)
              const isSize = /xs|^s$|^m$|^l$|xl|xxl/i.test(cleanOption);
              return !isSize;
            })
            .join('|')
            .toLowerCase()
        : '';

      const nonSizeOptionsChanged = currentNonSizeOptions !== previousNonSizeOptions;

      console.log('🎨 Fallback non-size options change detection:', {
        currentNonSizeOptions,
        previousNonSizeOptions,
        nonSizeOptionsChanged,
        allCurrentOptions: variant.options,
        allPreviousOptions: previousVariant?.options,
      });

      if (nonSizeOptionsChanged) {
        console.log('🎨 Non-size options changed, calling updateImagesForVariant');
        this.updateImagesForVariant(variant);
      } else {
        console.log('🎨 Only size options changed (or no change), skipping gallery update');
      }
    }
  }

  updateImagesForVariant(variant) {
    console.log('🔄 Product Gallery updateImagesForVariant called:', {
      variant: variant?.options,
      allImageLisCount: this.querySelectorAll('[data-variant-image="true"]').length,
    });

    // Get all li elements with variant images
    const allImageLis = this.querySelectorAll('[data-variant-image="true"]');
    let matchingThumbnails = [];
    let firstVisibleThumbnail = null;

    console.log('🔍 Processing', allImageLis.length, 'image list items');

    allImageLis.forEach((li, index) => {
      const imageVariant = li.getAttribute('data-image-variant');
      const thumbnail = li.querySelector('[data-trigger="gallery-thumbnail"]');

      if (!thumbnail) {
        console.log(`❌ No thumbnail found for li ${index}`);
        return;
      }

      // data-image-variant holds the option values Liquid resolved this image
      // to - '|'-separated, or '*' for a product with nothing to tell apart.
      // It is no longer the raw alt text, so an exact compare is right here:
      // the alt-text parsing (word boundaries, "Navy" vs "White/Navy") all
      // happens once in snippets/variant-image-match.liquid.
      let isVisible = false;
      if (imageVariant && variant?.options) {
        const imageColors = imageVariant.toLowerCase().split('|').filter(Boolean);
        isVisible =
          imageVariant === '*' ||
          variant.options.some((option) => imageColors.includes(option.toLowerCase()));
      }

      // Show/hide the li element
      li.style.display = isVisible ? 'block' : 'none';

      if (isVisible) {
        matchingThumbnails.push(thumbnail);
        if (!firstVisibleThumbnail) {
          firstVisibleThumbnail = thumbnail;
        }
      }
    });

    // If no matching images found, show all images
    if (matchingThumbnails.length === 0) {
      console.log('🖼️ No matching images found, showing all images');
      allImageLis.forEach((li) => {
        li.style.display = 'block';
        const thumbnail = li.querySelector('[data-trigger="gallery-thumbnail"]');
        if (thumbnail) {
          matchingThumbnails.push(thumbnail);
          if (!firstVisibleThumbnail) {
            firstVisibleThumbnail = thumbnail;
          }
        }
      });
    }

    // Update main image to first matching thumbnail
    if (firstVisibleThumbnail) {
      console.log('🖼️ Updating main image to first visible thumbnail');
      this.updateMainImage(firstVisibleThumbnail);
    } else {
      console.log('❌ No visible thumbnails found');
    }

    // Scroll thumbnail container to the top
    if (this.thumbnailList) {
      this.thumbnailList.scrollTop = 0;
    }

    console.log('🔄 Product Gallery updateImagesForVariant completed');
  }
}

// Register the web component
customElements.define('product-gallery', ProductGallery);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductGallery);


//# sourceURL=webpack://liquid-starter/./src/components/product-gallery.js?
;

/***/ }),

/***/ "./src/components/product-image-slider.js":
/*!************************************************!*\
  !*** ./src/components/product-image-slider.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var embla_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! embla-carousel */ "./node_modules/.pnpm/embla-carousel@8.6.0/node_modules/embla-carousel/esm/embla-carousel.esm.js");


/**
 * Product Image Slider Web Component
 * Handles product image slider with Embla Carousel and variant-aware filtering
 */
class ProductImageSlider extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('data-product-id');
    this.currentVariant = null;
    this.embla = null;
    this.allSlides = [];
    this.containerNode = null;
    this.viewportNode = null;
    this.colorOptionIndex = null;

    this.init();
  }

  init() {
    this.setupElements();
    this.bindEvents();
    this.setupVariantListener();

    // Use a small delay to ensure DOM is ready
    setTimeout(() => {
      this.initializeWithCurrentVariant();
    }, 100);
  }

  setupElements() {
    this.containerNode = this.querySelector('.embla__container');
    this.viewportNode = this.querySelector('.embla__viewport');
    this.allSlides = Array.from(this.querySelectorAll('.embla__slide'));
  }

  /**
   * BULLETPROOF: Find the color option index dynamically
   * This handles cases where color might be first, second, or third option
   */
  findColorOptionIndex() {
    if (this.colorOptionIndex !== null) {
      return this.colorOptionIndex;
    }

    // Get the variant selector to find color option
    const variantSelector = document.querySelector(
      `variant-selector[data-product-id="${this.productId}"]`,
    );

    if (variantSelector && variantSelector.currentVariant) {
      // Look for color option in the variant selector DOM
      const colorOptions = variantSelector.querySelectorAll('.variant-selector__color-option');
      if (colorOptions.length > 0) {
        const firstColorOption = colorOptions[0];
        this.colorOptionIndex = parseInt(firstColorOption.getAttribute('data-option-index'));
        console.log('🎨 Found color option at index:', this.colorOptionIndex);
        return this.colorOptionIndex;
      }
    }

    // Fallback: assume first option is color (original behavior)
    console.log('🎨 Using fallback: assuming color is at index 0');
    this.colorOptionIndex = 0;
    return this.colorOptionIndex;
  }

  /**
   * BULLETPROOF: Get the current color value from variant
   */
  getCurrentColorValue(variant) {
    if (!variant || !variant.options) return '';

    const colorIndex = this.findColorOptionIndex();
    const colorValue = variant.options[colorIndex];

    return colorValue ? colorValue.toLowerCase() : '';
  }

  shouldInitializeSlider() {
    return this.allSlides.length > 1;
  }

  handleResize() {
    if (this.embla) {
      this.embla.reInit();
    }
  }

  bindEvents() {
    // Handle button clicks using event delegation
    this.addEventListener('click', this.handleButtonClick.bind(this));

    // Handle window resize
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  initializeWithCurrentVariant() {
    // Set up initial slides based on current variant
    this.setupInitialSlides();

    // Initialize Embla if needed
    if (this.shouldInitializeSlider()) {
      this.initEmbla();
    }
  }

  handleButtonClick(event) {
    const button = event.target.closest('.embla__button');
    if (!button || !this.embla || !this.shouldInitializeSlider()) {
      console.log('❌ Button click ignored:', {
        button: !!button,
        embla: !!this.embla,
        shouldInitialize: this.shouldInitializeSlider(),
      });
      return;
    }

    event.preventDefault();
    console.log(
      '🖱️ Button clicked:',
      button.classList.contains('embla__button--prev') ? 'prev' : 'next',
    );

    if (button.classList.contains('embla__button--prev')) {
      console.log('⬅️ Calling embla.scrollPrev()');
      this.embla.scrollPrev();
    } else if (button.classList.contains('embla__button--next')) {
      console.log('➡️ Calling embla.scrollNext()');
      this.embla.scrollNext();
    }
  }

  setupVariantListener() {
    // Listen for variant changes from the variant selector
    document.addEventListener('variant:changed', (event) => {
      if (event.detail.productId == this.productId) {
        this.handleVariantChange(
          event.detail.variant,
          event.detail.previousVariant,
          event.detail.changedOptionIndex,
          event.detail.changedOptionValue,
        );
      }
    });
  }

  handleVariantChange(variant, previousVariant, changedOptionIndex, changedOptionValue) {
    if (!variant || !variant.options) {
      console.log('❌ Invalid variant data');
      return;
    }

    // Check if the changed option is a size option
    if (changedOptionValue) {
      const cleanOptionValue = changedOptionValue.toLowerCase().replace(/"/g, '');
      const isSizeOption = /xs|^s$|^m$|^l$|xl|xxl/i.test(cleanOptionValue);

      if (isSizeOption) {
        console.log('🎨 Size option changed, skipping slider update');
        return;
      } else {
        console.log('🎨 Non-size option changed, updating slider');
        this.updateImagesForVariant(variant);
      }
    } else {
      // Fallback: if we don't have option info, use the old logic
      console.log('🎨 No option info available, using fallback logic');

      // Check if any variant option changed
      const currentOptions = variant.options.join('|').toLowerCase();
      const previousOptions = previousVariant
        ? previousVariant.options.join('|').toLowerCase()
        : '';

      const optionsChanged = currentOptions !== previousOptions;
      console.log('🎨 Fallback options change detected:', {
        currentOptions,
        previousOptions,
        optionsChanged,
      });

      if (optionsChanged) {
        console.log('🎨 Options changed, calling updateImagesForVariant');
        this.updateImagesForVariant(variant);
      } else {
        console.log('🎨 No options changed, skipping update');
      }
    }
  }

  updateImagesForVariant(variant) {
    console.log('🔄 updateImagesForVariant called with variant:', variant);

    // Destroy existing Embla instance
    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }

    // Get slides for current variant
    let visibleSlides = [];
    this.allSlides.forEach((slide) => {
      const imageVariant = slide.getAttribute('data-image-variant');

      // data-image-variant holds the option values Liquid resolved this image
      // to - '|'-separated, or '*' for a product with nothing to tell apart.
      // It is no longer the raw alt text, so an exact compare is right here:
      // the alt-text parsing (word boundaries, "Navy" vs "White/Navy") all
      // happens once in snippets/variant-image-match.liquid.
      let isVisible = false;
      if (imageVariant && variant.options) {
        const imageColors = imageVariant.toLowerCase().split('|').filter(Boolean);
        isVisible =
          imageVariant === '*' ||
          variant.options.some((option) => imageColors.includes(option.toLowerCase()));
      }

      if (isVisible) {
        visibleSlides.push(slide);
      }
    });

    console.log('🖼️ Found', visibleSlides.length, 'matching slides');

    // If no matching images found, use all slides
    if (visibleSlides.length === 0) {
      console.log('🖼️ No matching slides found, using all slides');
      visibleSlides = [...this.allSlides];
    }

    // Do NOT recover by re-running setupElements() here: it also re-captures
    // this.allSlides, which by now holds only the visible subset, permanently
    // losing the other colourways' slides for the rest of the pageview.
    if (!this.containerNode) {
      console.warn('[product-image-slider] embla container missing; skipping slide injection');
      return;
    }

    // Clear the container
    this.containerNode.innerHTML = '';

    // Inject only visible slides into container
    visibleSlides.forEach((slide) => {
      this.containerNode.appendChild(slide);
      // Remove any display: none that Liquid template might have set
      slide.style.display = '';
    });

    console.log('🔄 Injected', visibleSlides.length, 'slides into container');

    // Only initialize Embla if slider should be active
    if (this.shouldInitializeSlider()) {
      // Reinitialize Embla with new slides
      this.embla = (0,embla_carousel__WEBPACK_IMPORTED_MODULE_0__["default"])(this.viewportNode, {
        loop: true,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        slidesToScroll: 1,
        breakpoints: {
          '(min-width: 1024px)': { slidesToShow: 4 },
          '(min-width: 768px)': { slidesToShow: 3 },
          '(min-width: 480px)': { slidesToShow: 2 },
          '(max-width: 479px)': { slidesToShow: 1 },
        },
      });

      this.setupEmblaEvents();
      this.updateButtonStates();
    }
  }

  async initEmbla() {
    // Only initialize if slider should be active
    if (!this.shouldInitializeSlider()) {
      return;
    }

    // Destroy existing Embla instance if it exists
    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }

    // Wait for DOM updates
    await this.waitForDOMUpdate();

    // Initialize Embla with loop enabled and responsive slides
    this.embla = (0,embla_carousel__WEBPACK_IMPORTED_MODULE_0__["default"])(this.viewportNode, {
      loop: true,
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: false,
      slidesToScroll: 1,
      breakpoints: {
        '(min-width: 1024px)': { slidesToShow: 4 },
        '(min-width: 768px)': { slidesToShow: 3 },
        '(min-width: 480px)': { slidesToShow: 2 },
        '(max-width: 479px)': { slidesToShow: 1 },
      },
    });

    this.setupEmblaEvents();
    this.updateButtonStates();
  }

  setupInitialSlides() {
    console.log('🔄 Setting up initial slides...');

    // Get current variant to determine which slides to show
    const variantSelector = document.querySelector(
      `variant-selector[data-product-id="${this.productId}"]`,
    );

    let currentVariant = null;
    if (variantSelector && variantSelector.currentVariant) {
      currentVariant = variantSelector.currentVariant;
    }

    // Check if we should skip JavaScript processing if Liquid already set up the slides correctly
    const liquidVisibleSlides = this.allSlides.filter((slide) => slide.style.display !== 'none');

    // If Liquid template already filtered correctly, don't override it
    if (liquidVisibleSlides.length > 0 && liquidVisibleSlides.length < this.allSlides.length) {
      return;
    }

    // Get slides for current variant
    let visibleSlides = [];
    this.allSlides.forEach((slide, index) => {
      const imageVariant = slide.getAttribute('data-image-variant');

      // data-image-variant holds the option values Liquid resolved this image
      // to - '|'-separated, or '*' for a product with nothing to tell apart.
      // It is no longer the raw alt text, so an exact compare is right here:
      // the alt-text parsing (word boundaries, "Navy" vs "White/Navy") all
      // happens once in snippets/variant-image-match.liquid.
      let isVisible = false;
      if (imageVariant && currentVariant?.options) {
        const imageColors = imageVariant.toLowerCase().split('|').filter(Boolean);
        isVisible =
          imageVariant === '*' ||
          currentVariant.options.some((option) => imageColors.includes(option.toLowerCase()));
      }

      if (isVisible) {
        visibleSlides.push(slide);
      }
    });

    // If no matching images found, use all slides
    if (visibleSlides.length === 0) {
      console.log('🔄 No matching slides found, using all slides');
      visibleSlides = [...this.allSlides];
    }

    // See the note in the sibling method above: guard, never re-run setupElements().
    if (!this.containerNode) {
      console.warn('[product-image-slider] embla container missing; skipping slide injection');
      return;
    }

    // Remove all slides from container
    this.containerNode.innerHTML = '';

    // Inject only visible slides into container
    visibleSlides.forEach((slide) => {
      this.containerNode.appendChild(slide);
      // Remove any display: none that Liquid template might have set
      slide.style.display = '';
    });
  }

  setupEmblaEvents() {
    if (!this.embla) return;

    this.embla.on('select', () => {
      this.updateButtonStates();
    });

    this.embla.on('init', () => {
      this.updateButtonStates();
    });

    this.embla.on('reInit', () => {
      this.updateButtonStates();
    });
  }

  updateButtonStates() {
    if (!this.embla || !this.shouldInitializeSlider()) return;

    if (this.prevButton) {
      this.prevButton.disabled = !this.embla.canScrollPrev();
    }

    if (this.nextButton) {
      this.nextButton.disabled = !this.embla.canScrollNext();
    }
  }

  waitForDOMUpdate() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });
  }

  handleDebugClick(event) {
    const debugButton = event.target.closest('[data-debug]');
    if (!debugButton) return;

    event.preventDefault();
    const debugType = debugButton.getAttribute('data-debug');

    switch (debugType) {
      case 'info':
        this.logDebugInfo();
        break;
      case 'scroll-prev':
        this.forceScrollPrev();
        break;
      case 'scroll-next':
        this.forceScrollNext();
        break;
      case 'reinit':
        this.forceReinit();
        break;
      case 'update-buttons':
        this.forceUpdateButtonStates();
        break;
    }
  }

  logDebugInfo() {
    console.log('🔍 === DEBUG INFO ===');
    console.log('Embla instance:', !!this.embla);

    if (this.embla) {
      console.log('Selected index:', this.embla.selectedScrollSnap());
      console.log('Slide count:', this.embla.slideNodes().length);
      console.log('Can scroll prev:', this.embla.canScrollPrev());
      console.log('Can scroll next:', this.embla.canScrollNext());
      console.log('Scroll progress:', this.embla.scrollProgress());
      console.log('Scroll snap list:', this.embla.scrollSnapList());

      // Log visible slides
      const visibleSlides = this.allSlides.filter((slide) => slide.style.display !== 'none');
      console.log('Visible slides:', visibleSlides.length);
      visibleSlides.forEach((slide, index) => {
        console.log(`  Slide ${index}:`, {
          display: slide.style.display,
          offsetWidth: slide.offsetWidth,
          offsetHeight: slide.offsetHeight,
        });
      });
    }

    console.log('Viewport:', {
      offsetWidth: this.viewportNode?.offsetWidth,
      offsetHeight: this.viewportNode?.offsetHeight,
      scrollWidth: this.viewportNode?.scrollWidth,
    });

    console.log('Container:', {
      offsetWidth: this.containerNode?.offsetWidth,
      offsetHeight: this.containerNode?.offsetHeight,
      scrollWidth: this.containerNode?.scrollWidth,
    });
    console.log('🔍 === END DEBUG INFO ===');
  }

  forceScrollPrev() {
    if (!this.embla) {
      console.log('❌ No Embla instance for force scroll prev');
      return;
    }
    console.log('🔄 Force scrolling prev...');
    console.log('Before scroll - Selected index:', this.embla.selectedScrollSnap());
    this.embla.scrollPrev();
    setTimeout(() => {
      console.log('After scroll - Selected index:', this.embla.selectedScrollSnap());
    }, 100);
  }

  forceScrollNext() {
    if (!this.embla) {
      console.log('❌ No Embla instance for force scroll next');
      return;
    }
    console.log('🔄 Force scrolling next...');
    console.log('Before scroll - Selected index:', this.embla.selectedScrollSnap());
    this.embla.scrollNext();
    setTimeout(() => {
      console.log('After scroll - Selected index:', this.embla.selectedScrollSnap());
    }, 100);
  }

  forceReinit() {
    console.log('🔄 Force reinitializing Embla...');
    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }
    this.initEmbla();
  }

  forceUpdateButtonStates() {
    console.log('🔘 Force updating button states...');
    console.log('Embla instance exists:', !!this.embla);

    if (this.embla) {
      console.log('Before update - Can scroll prev:', this.embla.canScrollPrev());
      console.log('Before update - Can scroll next:', this.embla.canScrollNext());
      console.log('Before update - Selected index:', this.embla.selectedScrollSnap());
      console.log('Before update - Slide count:', this.embla.slideNodes().length);
    }

    this.updateButtonStates();

    if (this.embla) {
      setTimeout(() => {
        console.log('After update - Can scroll prev:', this.embla.canScrollPrev());
        console.log('After update - Can scroll next:', this.embla.canScrollNext());
        console.log('After update - Selected index:', this.embla.selectedScrollSnap());
      }, 100);
    }
  }

  disconnectedCallback() {
    // Clean up event listeners and Embla instance
    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }

    window.removeEventListener('resize', this.handleResize.bind(this));
  }
}

// Register the web component
customElements.define('product-image-slider', ProductImageSlider);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductImageSlider);


//# sourceURL=webpack://liquid-starter/./src/components/product-image-slider.js?
;

/***/ }),

/***/ "./src/components/search-results.js":
/*!******************************************!*\
  !*** ./src/components/search-results.js ***!
  \******************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SearchResults: () => (/* binding */ SearchResults)
/* harmony export */ });
/* harmony import */ var _instantsearch_integration_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./instantsearch-integration.js */ "./src/components/instantsearch-integration.js");
/* harmony import */ var _constants_events_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants/events.js */ "./src/constants/events.js");



/**
 * Search Results Component
 *
 * Handles the search page functionality including:
 * - Empty state management
 * - Search results display
 * - Integration with Algolia search
 */
class SearchResults {
  constructor(container, options = {}) {
    this.container = container;
    this.options = {
      placeholder: 'Search products, collections, and more...',
      maxResults: 20,
      ...options,
    };

    this.searchAutocomplete = null;
    this.emptyState = null;
    this.resultsContainer = null;
    this.currentQuery = '';
    this.isSearching = false;

    this.init();
  }

  init() {
    this.setupElements();
    this.initializeSearchAutocomplete();
    this.bindEvents();
    this.setInitialState();
  }

  setupElements() {
    this.emptyState = this.container.querySelector('[data-search-empty-state]');
    this.resultsContainer = this.container.querySelector('[data-search-results]');
    this.searchAutocompleteContainer = this.container.querySelector('[data-search-autocomplete]');

    if (!this.emptyState) {
      console.warn('SearchResults: Could not find empty state element');
    }

    if (!this.resultsContainer) {
      console.warn('SearchResults: Could not find results container element');
    }

    if (!this.searchAutocompleteContainer) {
      console.warn('SearchResults: Could not find search autocomplete container');
    }
  }

  initializeSearchAutocomplete() {
    if (this.searchAutocompleteContainer) {
      this.searchAutocomplete = new _instantsearch_integration_js__WEBPACK_IMPORTED_MODULE_0__.InstantSearchIntegration(this.searchAutocompleteContainer, {
        placeholder: this.options.placeholder,
        maxSuggestions: this.options.maxResults,
      });
    }
  }

  bindEvents() {
    // Listen for search submission events
    document.addEventListener('search-autocomplete:submit', this.handleSearchSubmit.bind(this));

    // Listen for search events from other components
    document.addEventListener(_constants_events_js__WEBPACK_IMPORTED_MODULE_1__.EVENTS.SEARCH, this.handleSearchEvent.bind(this));

    // Handle URL search parameters on page load
    this.handleURLSearchParams();
  }

  handleURLSearchParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');

    if (query) {
      this.performSearch(query);
    }
  }

  handleSearchSubmit(event) {
    const { query, source } = event.detail;
    console.log('SearchResults: Search submitted:', query, 'from:', source);

    if (query && query.trim()) {
      this.performSearch(query.trim());
    }
  }

  handleSearchEvent(event) {
    const { query, type } = event.detail;
    console.log('SearchResults: Search event received:', type, query);

    if (type === 'submit' && query) {
      this.performSearch(query);
    }
  }

  async performSearch(query) {
    console.log('SearchResults: Performing search for:', query);

    this.currentQuery = query;
    this.isSearching = true;

    // Update URL
    this.updateURL(query);

    // Show loading state
    this.showLoadingState();

    try {
      // Hide empty state
      this.hideEmptyState();

      // Show results container
      this.showResultsContainer();

      // Perform the actual search
      await this.executeSearch(query);
    } catch (error) {
      console.error('SearchResults: Search error:', error);
      this.showErrorState(error);
    } finally {
      this.isSearching = false;
    }
  }

  async executeSearch(query) {
    // This would integrate with Algolia or your search backend
    // For now, we'll simulate a search and show results

    console.log('SearchResults: Executing search for:', query);

    // Simulate search delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Show mock results for demonstration
    this.showMockResults(query);
  }

  showMockResults(query) {
    if (!this.resultsContainer) return;

    const resultsHTML = `
      <div class="search-results-header">
        <h2>Search Results for "${query}"</h2>
        <p>Showing 12 results</p>
      </div>
      
      <div class="search-results-grid">
        ${this.generateMockProductCards()}
      </div>
      
      <div class="search-results-footer">
        <p>These are mock results. In production, this would show real search results from Algolia.</p>
      </div>
    `;

    this.resultsContainer.innerHTML = resultsHTML;
    this.resultsContainer.style.display = 'block';
  }

  generateMockProductCards() {
    const mockProducts = [
      {
        title: 'Premium Cotton T-Shirt',
        price: '$29.99',
        image: 'https://via.placeholder.com/300x300/f3f4f6/6b7280?text=Product+1',
        url: '/products/mock-product-1',
      },
      {
        title: 'Denim Jacket',
        price: '$89.99',
        image: 'https://via.placeholder.com/300x300/f3f4f6/6b7280?text=Product+2',
        url: '/products/mock-product-2',
      },
      {
        title: 'Leather Wallet',
        price: '$49.99',
        image: 'https://via.placeholder.com/300x300/f3f4f6/6b7280?text=Product+3',
        url: '/products/mock-product-3',
      },
      {
        title: 'Sneakers',
        price: '$129.99',
        image: 'https://via.placeholder.com/300x300/f3f4f6/6b7280?text=Product+4',
        url: '/products/mock-product-4',
      },
    ];

    return mockProducts
      .map(
        (product) => `
      <div class="search-result-item">
        <div class="search-result-image">
          <a href="${product.url}">
            <img src="${product.image}" alt="${product.title}" width="300" height="300" loading="lazy">
          </a>
        </div>
        <div class="search-result-content">
          <h3 class="search-result-title">
            <a href="${product.url}">${product.title}</a>
          </h3>
          <div class="search-result-price">${product.price}</div>
          <p class="search-result-description">
            High-quality product with premium materials and excellent craftsmanship.
          </p>
        </div>
      </div>
    `,
      )
      .join('');
  }

  showLoadingState() {
    if (!this.resultsContainer) return;

    this.resultsContainer.innerHTML = `
      <div class="search-loading">
        <div class="search-loading-spinner"></div>
        <p>Searching for "${this.currentQuery}"...</p>
      </div>
    `;
    this.resultsContainer.style.display = 'block';
  }

  showErrorState(error) {
    if (!this.resultsContainer) return;

    this.resultsContainer.innerHTML = `
      <div class="search-error">
        <div class="search-error-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <h3>Search Error</h3>
        <p>Sorry, we encountered an error while searching. Please try again.</p>
        <button class="search-retry-button" onclick="window.location.reload()">
          Try Again
        </button>
      </div>
    `;
    this.resultsContainer.style.display = 'block';
  }

  hideEmptyState() {
    if (this.emptyState) {
      this.emptyState.style.display = 'none';
    }
  }

  showEmptyState() {
    if (this.emptyState) {
      this.emptyState.style.display = 'block';
    }
  }

  showResultsContainer() {
    if (this.resultsContainer) {
      this.resultsContainer.style.display = 'block';
    }
  }

  hideResultsContainer() {
    if (this.resultsContainer) {
      this.resultsContainer.style.display = 'none';
    }
  }

  updateURL(query) {
    const url = new URL(window.location);
    url.searchParams.set('q', query);
    window.history.pushState({}, '', url);
  }

  setInitialState() {
    // Check if we have a search query in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');

    if (query) {
      // We have a search query, show results
      this.hideEmptyState();
      this.showResultsContainer();
      this.performSearch(query);
    } else {
      // No search query, show empty state
      this.showEmptyState();
      this.hideResultsContainer();
    }
  }

  clearSearch() {
    this.currentQuery = '';
    this.showEmptyState();
    this.hideResultsContainer();

    // Clear URL parameters
    const url = new URL(window.location);
    url.searchParams.delete('q');
    window.history.pushState({}, '', url);

    // Clear search input
    if (this.searchAutocomplete) {
      this.searchAutocomplete.clearInput();
    }
  }

  destroy() {
    if (this.searchAutocomplete) {
      this.searchAutocomplete.destroy();
    }
  }
}


//# sourceURL=webpack://liquid-starter/./src/components/search-results.js?
;

/***/ }),

/***/ "./src/constants/algolia.js":
/*!**********************************!*\
  !*** ./src/constants/algolia.js ***!
  \**********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ALGOLIA_CONFIG: () => (/* binding */ ALGOLIA_CONFIG),
/* harmony export */   createSearchClient: () => (/* binding */ createSearchClient),
/* harmony export */   getAlgoliaConfig: () => (/* binding */ getAlgoliaConfig)
/* harmony export */ });
/**
 * Algolia Search Configuration
 *
 * This file contains the configuration for Algolia search integration.
 * Replace the placeholder values with your actual Algolia credentials.
 */

const ALGOLIA_CONFIG = {
  // Replace with your Algolia Application ID
  appId: 'H1KL5G36DN',

  // Replace with your Algolia Search-Only API Key (public key)
  searchApiKey: '8ed58e18920009652f19c5c5e3de1331',

  // Replace with your Algolia Admin API Key (private key - for indexing)
  adminApiKey: 'YOUR_ALGOLIA_ADMIN_API_KEY',

  // Maintained automatically by the Algolia Shopify app, one record per
  // variant, deduplicated to one result per product by the index's
  // attributeForDistinct: "id". Replaced 'powerindex', which a Node script had
  // to be run by hand to refresh -- twice in two months, so search missed
  // products the store actually stocked and kept returning ones it had
  // unpublished. Products tagged algolia-ignore in Shopify are skipped by the
  // app, so that exclusion still works.
  indexName: 'shopify_products',


  // Facets configuration
  facets: {
    product_type: {
      label: 'Product Type',
      type: 'list',
    },
    vendor: {
      label: 'Brand',
      type: 'list',
    },
    price_range: {
      label: 'Price',
      type: 'range',
    },
    tags: {
      label: 'Tags',
      type: 'list',
    },
  },

  // Autocomplete configuration
  autocomplete: {
    hitsPerPage: 5,
    maxSuggestions: 10,
  },
};

/**
 * Get Algolia configuration with dynamic values from Shopify
 */
function getAlgoliaConfig() {
  // Use the default index name instead of dynamic domain-based name
  // This ensures we're searching the correct index
  const indexName = ALGOLIA_CONFIG.indexName;
  console.log('getAlgoliaConfig: Using index name:', indexName);
  console.log('getAlgoliaConfig: Shopify shop domain:', window.Shopify?.shop?.permanent_domain);

  return {
    ...ALGOLIA_CONFIG,
    indexName: indexName,
    currency: window.Shopify?.currency?.active || 'USD',
  };
}

/**
 * Initialize Algolia search client
 */
function createSearchClient() {
  const config = getAlgoliaConfig();

  if (!config.appId || !config.searchApiKey) {
    console.warn(
      'createSearchClient: Algolia configuration missing. Please set your Algolia credentials.',
    );
    return null;
  }

  // The vendored asset is algoliasearch v5's lite build, whose UMD assigns
  // window['algoliasearch/lite'] and exports liteClient. v5's full build assigns
  // an object (not a callable) at window.algoliasearch, and v4 assigned the
  // factory itself. All three shapes are resolved here, so replacing the asset --
  // or an app that loads its own client and wins the global -- cannot silently
  // drop site search into the no-client fallback.
  const factory =
    typeof window === 'undefined'
      ? null
      : window['algoliasearch/lite']?.liteClient ||
        (typeof window.algoliasearch === 'function'
          ? window.algoliasearch
          : window.algoliasearch?.algoliasearch);

  // No dynamic CDN fallback: the client is vendored into assets/ precisely so
  // site search does not depend on a third-party origin being reachable, and
  // nothing listened for the 'algolia-loaded' event it used to dispatch.
  if (!factory) {
    console.error('createSearchClient: algoliasearch is not loaded, site search is unavailable.');
    return null;
  }

  try {
    console.log('createSearchClient: Creating Algolia client with appId:', config.appId);
    const client = factory(config.appId, config.searchApiKey);
    console.log('createSearchClient: Algolia client created successfully:', client);
    return client;
  } catch (error) {
    console.error('createSearchClient: Error creating Algolia client:', error);
    return null;
  }
}



//# sourceURL=webpack://liquid-starter/./src/constants/algolia.js?
;

/***/ }),

/***/ "./src/constants/events.js":
/*!*********************************!*\
  !*** ./src/constants/events.js ***!
  \*********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EVENTS: () => (/* binding */ EVENTS)
/* harmony export */ });
/**
 * Defines custom event names for various e-commerce interactions and Shopify
 * theme editor events.
 *
 * @constant
 * @type {object}
 */
const EVENTS = {
    // E-commerce events
    CART_ADD: "cart-add",
    CART_REMOVE: "cart-remove",
    CART_UPDATE: "cart-update",
    SEARCH: "search",
    FILTER_APPLY: "filter-apply",
    FILTER_REMOVE: "filter-remove",
    FILTER_RESET: "filter-reset",
    FILTER_SORT: "filter-sort",

    VARIANT_CHANGE: "variant-change",
  
    // Shopify theme editor events
    SHOPIFY_INSPECTOR_ACTIVATE: "shopify:inspector:activate",
    SHOPIFY_INSPECTOR_DEACTIVATE: "shopify:inspector:deactivate",
    SHOPIFY_SECTION_LOAD: "shopify:section:load",
    SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
    SHOPIFY_SECTION_SELECT: "shopify:section:select",
    SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
    SHOPIFY_SECTION_REORDER: "shopify:section:reorder",
    SHOPIFY_BLOCK_SELECT: "shopify:block:select",
    SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  };
  

//# sourceURL=webpack://liquid-starter/./src/constants/events.js?
;

/***/ }),

/***/ "./src/sections/custom-items-slider.js":
/*!*********************************************!*\
  !*** ./src/sections/custom-items-slider.js ***!
  \*********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
// Custom Items Slider with Embla Carousel
class CustomItemsSlider {
  constructor(element) {
    this.element = element;
    this.sliderId = element.dataset.sliderId;
    this.emblaNode = element.querySelector('.embla');
    this.viewportNode = element.querySelector('.embla__viewport');
    this.containerNode = element.querySelector('.embla__container');
    this.slides = element.querySelectorAll('.embla__slide');
    this.prevButton = element.querySelector('.embla__button--prev');
    this.nextButton = element.querySelector('.embla__button--next');
    this.dots = element.querySelectorAll('.embla__dot');
    this.controls = element.querySelector('.embla__controls');

    // Get section settings from data attributes
    this.settings = this.getSettings();

    // Initialize Embla
    this.initEmbla();

    // Setup event listeners
    this.setupEventListeners();

    // Apply responsive settings
    this.applyResponsiveSettings();

    // Mark as loaded
    this.element.classList.remove('loading');
    this.element.classList.add('loaded');
  }

  getSettings() {
    // Get settings from data attributes
    return {
      autoplay: this.element.dataset.autoplay === 'true',
      autoplaySpeed: parseInt(this.element.dataset.autoplaySpeed || '5') * 1000,
      showDots: this.element.dataset.showDots === 'true',
      showArrows: this.element.dataset.showArrows === 'true',
      itemsPerRow: parseInt(this.element.dataset.itemsPerRow || '4'),
    };
  }

  initEmbla() {
    // Import Embla dynamically
    this.loadEmbla().then(() => {
      // Initialize Embla with responsive settings
      // eslint-disable-next-line no-undef
      this.embla = EmblaCarousel(this.viewportNode, {
        loop: false,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        skipSnaps: false,
        inViewThreshold: 0.7,
        slidesToScroll: 1,
        breakpoints: {
          '(min-width: 1024px)': {
            slidesToScroll: Math.min(2, this.settings.itemsPerRow),
            containScroll: 'trimSnaps',
          },
          '(min-width: 768px)': {
            slidesToScroll: 2,
            containScroll: 'trimSnaps',
          },
          '(min-width: 480px)': {
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
          },
        },
      });

      // Setup autoplay
      if (this.settings.autoplay) {
        this.setupAutoplay();
      }

      // Setup navigation
      this.setupNavigation();

      // Setup dots
      if (this.settings.showDots) {
        this.setupDots();
      }

      // Show/hide controls based on settings
      this.updateControlsVisibility();

      // Setup responsive behavior
      this.setupResponsiveBehavior();
    });
  }

  async loadEmbla() {
    // Check if Embla is already loaded
    if (window.EmblaCarousel) {
      return Promise.resolve();
    }

    // Load Embla from CDN
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/embla-carousel/embla-carousel.umd.js';
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  setupAutoplay() {
    let autoplayInterval;

    const startAutoplay = () => {
      autoplayInterval = setInterval(() => {
        if (this.embla.canScrollNext()) {
          this.embla.scrollNext();
        } else {
          this.embla.scrollTo(0);
        }
      }, this.settings.autoplaySpeed);
    };

    const stopAutoplay = () => {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    };

    // Start autoplay
    startAutoplay();

    // Pause on hover
    this.element.addEventListener('mouseenter', stopAutoplay);
    this.element.addEventListener('mouseleave', startAutoplay);

    // Pause on focus
    this.element.addEventListener('focusin', stopAutoplay);
    this.element.addEventListener('focusout', startAutoplay);

    // Pause on touch
    this.element.addEventListener('touchstart', stopAutoplay);
    this.element.addEventListener('touchend', startAutoplay);
  }

  setupNavigation() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.embla.scrollPrev();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.embla.scrollNext();
      });
    }

    // Update button states
    const updateButtons = () => {
      if (this.prevButton) {
        this.prevButton.disabled = !this.embla.canScrollPrev();
      }
      if (this.nextButton) {
        this.nextButton.disabled = !this.embla.canScrollNext();
      }
    };

    this.embla.on('select', updateButtons);
    this.embla.on('init', updateButtons);
    updateButtons();
  }

  setupDots() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.embla.scrollTo(index);
      });
    });

    // Update dots
    const updateDots = () => {
      const selectedIndex = this.embla.selectedScrollSnap();

      this.dots.forEach((dot, index) => {
        if (index === selectedIndex) {
          dot.classList.add('is-selected');
        } else {
          dot.classList.remove('is-selected');
        }
      });
    };

    this.embla.on('select', updateDots);
    this.embla.on('init', updateDots);
    updateDots();
  }

  applyResponsiveSettings() {
    this.element.setAttribute('data-items-per-row', this.settings.itemsPerRow);
  }

  setupResponsiveBehavior() {
    // Handle window resize
    let resizeTimeout;

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (this.embla) {
          this.embla.reInit();
        }
      }, 250);
    };

    window.addEventListener('resize', handleResize);
  }

  updateControlsVisibility() {
    if (this.controls) {
      this.controls.setAttribute('data-show-arrows', this.settings.showArrows);
      this.controls.setAttribute('data-show-dots', this.settings.showDots);
    }
  }

  setupEventListeners() {
    // Handle section re-render (Shopify theme editor)
    if (window.shopify?.section?.register) {
      window.shopify.section.register(this.sliderId, {
        onLoad: () => {
          // Section loaded in theme editor
        },
        onUnload: () => {
          // Clean up when section is unloaded
          if (this.embla) {
            this.embla.destroy();
          }
        },
        onBlockSelect: () => {
          // Block selected in theme editor
        },
        onBlockDeselect: () => {
          // Block deselected in theme editor
        },
      });
    }
  }

  destroy() {
    if (this.embla) {
      this.embla.destroy();
    }
  }
}

// Initialize all custom items sliders when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.custom-items-slider');
  sliders.forEach((slider) => {
    new CustomItemsSlider(slider);
  });
});

// Handle dynamic content loading (Shopify sections)
document.addEventListener('shopify:section:load', (event) => {
  const slider = event.target.querySelector('.custom-items-slider');
  if (slider) {
    new CustomItemsSlider(slider);
  }
});

// Handle section re-renders
document.addEventListener('shopify:section:reorder', (event) => {
  const slider = event.target.querySelector('.custom-items-slider');
  if (slider) {
    // Reinitialize slider
    const existingSlider = slider.customItemsSlider;
    if (existingSlider) {
      existingSlider.destroy();
    }
    slider.customItemsSlider = new CustomItemsSlider(slider);
  }
});

// Export for potential external use
window.CustomItemsSlider = CustomItemsSlider;


//# sourceURL=webpack://liquid-starter/./src/sections/custom-items-slider.js?
;

/***/ }),

/***/ "./src/sections/email-cta.js":
/*!***********************************!*\
  !*** ./src/sections/email-cta.js ***!
  \***********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/**
 * Email CTA Component
 * Handles form submission, validation, and state management for email signup
 */
class EmailCTAComponent {
  constructor(element) {
    this.element = element;
    this.form = element.querySelector('[data-email-cta-form]');
    this.emailInput = element.querySelector('[data-email-input]');
    this.submitButton = element.querySelector('[data-submit-button]');
    this.successMessage = element.querySelector('[data-success-message]');
    this.errorMessage = element.querySelector('[data-error-message]');

    this.init();
  }

  init() {
    if (!this.form || !this.emailInput || !this.submitButton) {
      console.warn('Email CTA: Required elements not found');
      return;
    }

    this.bindEvents();
    this.setInitialState();
  }

  bindEvents() {
    // Form submission
    this.form.addEventListener('submit', this.handleSubmit.bind(this));

    // Real-time validation
    this.emailInput.addEventListener('input', this.handleInput.bind(this));
    this.emailInput.addEventListener('blur', this.handleBlur.bind(this));

    // Keyboard navigation
    this.emailInput.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  setInitialState() {
    this.element.setAttribute('data-state', 'idle');
    this.hideMessages();
  }

  handleSubmit(event) {
    event.preventDefault();

    const email = this.emailInput.value.trim();

    if (!this.validateEmail(email)) {
      this.showError();
      this.emailInput.focus();
      return;
    }

    this.submitForm(email);
  }

  handleInput(event) {
    const email = event.target.value.trim();

    // Clear error state on input
    if (this.element.getAttribute('data-state') === 'error') {
      this.hideMessages();
      this.element.setAttribute('data-state', 'idle');
    }

    // Real-time validation feedback
    if (email && !this.validateEmail(email)) {
      this.emailInput.setAttribute('data-invalid', 'true');
    } else {
      this.emailInput.removeAttribute('data-invalid');
    }
  }

  handleBlur(event) {
    const email = event.target.value.trim();

    if (email && !this.validateEmail(email)) {
      this.emailInput.setAttribute('data-invalid', 'true');
    }
  }

  handleKeydown(event) {
    // Submit on Enter key
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.form.dispatchEvent(new Event('submit'));
    }
  }

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  async submitForm(email) {
    this.setLoadingState(true);

    try {
      // Create form data
      const formData = new FormData();
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');
      formData.append('contact[email]', email);
      formData.append('contact[tags]', 'newsletter');

      // Submit to Shopify's contact form endpoint
      const response = await fetch('/contact#contact_form', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        this.showSuccess();
        this.resetForm();
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      console.error('Email CTA submission error:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  setLoadingState(loading) {
    if (loading) {
      this.element.setAttribute('data-loading', 'true');
      this.element.setAttribute('data-state', 'loading');
      this.submitButton.disabled = true;
    } else {
      this.element.removeAttribute('data-loading');
      this.element.setAttribute('data-state', 'idle');
      this.submitButton.disabled = false;
    }
  }

  showSuccess() {
    this.element.setAttribute('data-state', 'success');
    this.hideMessages();
    this.successMessage.hidden = false;

    // Auto-hide success message after 5 seconds
    setTimeout(() => {
      if (this.element.getAttribute('data-state') === 'success') {
        this.hideMessages();
        this.element.setAttribute('data-state', 'idle');
      }
    }, 5000);
  }

  showError() {
    this.element.setAttribute('data-state', 'error');
    this.hideMessages();
    this.errorMessage.hidden = false;
  }

  hideMessages() {
    if (this.successMessage) this.successMessage.hidden = true;
    if (this.errorMessage) this.errorMessage.hidden = true;
  }

  resetForm() {
    this.form.reset();
    this.emailInput.removeAttribute('data-invalid');
    this.hideMessages();
  }

  // Public methods for external control
  focus() {
    this.emailInput.focus();
  }

  setEmail(email) {
    this.emailInput.value = email;
    this.handleInput({ target: this.emailInput });
  }
}

// Auto-initialize email CTA components
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="email-cta"]').forEach((element) => {
    new EmailCTAComponent(element);
  });
});

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
  module.exports = EmailCTAComponent;
}


//# sourceURL=webpack://liquid-starter/./src/sections/email-cta.js?
;

/***/ }),

/***/ "./src/sections/faq.js":
/*!*****************************!*\
  !*** ./src/sections/faq.js ***!
  \*****************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
class FAQComponent {
  constructor(element) {
    this.element = element;
    this.faqId = element.getAttribute('data-faq-id');
    this.currentCategory = null;
    this.init();
  }

  init() {
    this.bindEvents();
    this.setInitialState();
  }

  bindEvents() {
    // Handle category navigation
    document.addEventListener('click', this.handleCategoryClick.bind(this));

    // Handle keyboard navigation for categories
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleCategoryClick(event) {
    const categoryButton = event.target.closest('[data-trigger="faq-category"]');
    if (!categoryButton || !this.element.contains(categoryButton)) return;

    event.preventDefault();
    this.switchCategory(categoryButton);
  }

  handleKeydown(event) {
    const categoryButton = event.target.closest('[data-trigger="faq-category"]');
    if (!categoryButton || !this.element.contains(categoryButton)) return;

    const categoryButtons = Array.from(
      this.element.querySelectorAll('[data-trigger="faq-category"]'),
    );
    const currentIndex = categoryButtons.indexOf(categoryButton);

    let nextIndex;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        nextIndex = (currentIndex + 1) % categoryButtons.length;
        categoryButtons[nextIndex].focus();
        break;
      case 'ArrowUp':
        event.preventDefault();
        nextIndex = (currentIndex - 1 + categoryButtons.length) % categoryButtons.length;
        categoryButtons[nextIndex].focus();
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.switchCategory(categoryButton);
        break;
      case 'Home':
        event.preventDefault();
        categoryButtons[0].focus();
        break;
      case 'End':
        event.preventDefault();
        categoryButtons[categoryButtons.length - 1].focus();
        break;
    }
  }

  switchCategory(button) {
    const targetId = button.getAttribute('data-target');
    const categoryId = button.getAttribute('data-category-id');
    const targetCategory = document.getElementById(targetId);

    if (!targetCategory) return;

    // Update button states
    this.updateButtonStates(button);

    // Update category visibility
    this.updateCategoryVisibility(targetCategory);

    // Update ARIA states
    this.updateAriaStates(button, targetCategory);

    // Store current category
    this.currentCategory = categoryId;

    // Trigger custom event for analytics or other integrations
    this.triggerCategoryChangeEvent(categoryId);
  }

  updateButtonStates(activeButton) {
    // Remove active state from all buttons
    this.element.querySelectorAll('[data-trigger="faq-category"]').forEach((button) => {
      button.classList.remove('faq-nav-button--active');
      button.setAttribute('aria-selected', 'false');
    });

    // Add active state to clicked button
    activeButton.classList.add('faq-nav-button--active');
    activeButton.setAttribute('aria-selected', 'true');
  }

  updateCategoryVisibility(activeCategory) {
    // Hide all categories
    this.element.querySelectorAll('[data-faq-category]').forEach((category) => {
      category.classList.remove('faq-category--active');
      category.setAttribute('data-active', 'false');
    });

    // Show active category
    activeCategory.classList.add('faq-category--active');
    activeCategory.setAttribute('data-active', 'true');
  }

  updateAriaStates(button, category) {
    // Update button ARIA attributes
    const categoryButtons = this.element.querySelectorAll('[data-trigger="faq-category"]');
    categoryButtons.forEach((btn) => {
      const btnCategory = document.getElementById(btn.getAttribute('data-target'));
      if (btnCategory) {
        btnCategory.setAttribute('aria-labelledby', btn.getAttribute('data-target'));
      }
    });

    // Ensure proper ARIA relationships
    category.setAttribute('aria-labelledby', button.getAttribute('data-target'));
  }

  setInitialState() {
    // Set the first category as active by default
    const firstButton = this.element.querySelector('[data-trigger="faq-category"]');
    const firstCategory = this.element.querySelector('[data-faq-category]');

    if (firstButton && firstCategory) {
      this.currentCategory = firstButton.getAttribute('data-category-id');
      this.updateButtonStates(firstButton);
      this.updateCategoryVisibility(firstCategory);
      this.updateAriaStates(firstButton, firstCategory);
    }
  }

  triggerCategoryChangeEvent(categoryId) {
    const event = new CustomEvent('faqCategoryChange', {
      detail: {
        faqId: this.faqId,
        categoryId: categoryId,
        element: this.element,
      },
      bubbles: true,
    });

    this.element.dispatchEvent(event);
  }

  // Public method to programmatically switch categories
  switchToCategory(categoryId) {
    const button = this.element.querySelector(`[data-category-id="${categoryId}"]`);
    if (button) {
      this.switchCategory(button);
    }
  }

  // Public method to get current category
  getCurrentCategory() {
    return this.currentCategory;
  }

  // Public method to get all categories
  getCategories() {
    const buttons = this.element.querySelectorAll('[data-trigger="faq-category"]');
    return Array.from(buttons).map((button) => ({
      id: button.getAttribute('data-category-id'),
      name: button.querySelector('.faq-nav-text').textContent,
      count: button.querySelector('.faq-nav-count').textContent,
    }));
  }
}

// Auto-initialize FAQ components
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="faq"]').forEach((faq) => {
    new FAQComponent(faq);
  });
});

// Export for potential use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = FAQComponent;
}


//# sourceURL=webpack://liquid-starter/./src/sections/faq.js?
;

/***/ }),

/***/ "./src/sections/friends-of-foray-form.js":
/*!***********************************************!*\
  !*** ./src/sections/friends-of-foray-form.js ***!
  \***********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Friends of Foray Form Component
 * Handles form submission, validation, and state management
 */
class FriendsOfForayFormComponent {
  constructor(element) {
    this.element = element;
    this.form = this.element.querySelector('[data-component="friends-of-foray-form"] form');
    this.init();
  }

  init() {
    this.bindEvents();
    this.checkFormSubmission();
    // Show the component after determining the state
    this.element.setAttribute('data-ready', 'true');
  }

  bindEvents() {
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.form.addEventListener('input', this.handleInput.bind(this));
    }
  }

  checkFormSubmission() {
    // Check if form was submitted via URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('form-submitted')) {
      this.showSuccessState();
    }

    // Also check for Mailchimp success parameters
    if (urlParams.has('success') || urlParams.has('subscribed')) {
      this.showSuccessState();
    }

    // Check for hash parameter (for direct navigation to success state)
    if (window.location.hash === '#form-submitted') {
      this.showSuccessState();
    }
  }

  handleInput(event) {
    const input = event.target;
    if (input.classList.contains('friends-of-foray-form__input')) {
      // Only validate after user has interacted with the field
      input.setAttribute('data-touched', 'true');
      this.validateField(input);
    }
  }

  validateField(field) {
    const isValid = field.checkValidity();
    const isTouched = field.getAttribute('data-touched') === 'true';

    // Only show error if field has been touched and is invalid
    if (isValid || !isTouched) {
      field.removeAttribute('data-error');
    } else {
      field.setAttribute('data-error', 'true');
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.form) return;

    // Validate all fields
    const inputs = this.form.querySelectorAll('.friends-of-foray-form__input');
    let isValid = true;

    inputs.forEach((input) => {
      // Mark all fields as touched when form is submitted
      input.setAttribute('data-touched', 'true');
      this.validateField(input);
      if (!input.checkValidity()) {
        isValid = false;
      }
    });

    if (!isValid) {
      return;
    }

    // Set loading state
    this.element.setAttribute('data-loading', 'true');

    // For Mailchimp forms, we'll let the form submit naturally
    // and handle the success state via URL parameters
    // The form will redirect to a success page, so we need to handle this differently

    // Submit the form normally (this will redirect to Mailchimp's success page)
    this.form.submit();
  }

  showSuccessState() {
    // Update the description text to show success message
    const description = this.element.querySelector('.friends-of-foray-form__description');
    if (description) {
      const successMessage =
        this.element.getAttribute('data-success-message') ||
        'Thank you for your submission. We will review it shortly.';
      description.textContent = successMessage;
    }

    // Hide the form
    if (this.form) {
      this.form.style.display = 'none';
    }
  }

  showErrorState() {
    // Show error message
    const description = this.element.querySelector('.friends-of-foray-form__description');
    if (description) {
      const errorMessage =
        this.element.getAttribute('data-error-message') ||
        'There was an error submitting your form. Please try again.';
      description.textContent = errorMessage;
      description.style.color = '#e74c3c';
    }
  }
}

// Auto-initialize component
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="friends-of-foray-form"]').forEach((element) => {
    new FriendsOfForayFormComponent(element);
  });
});

// Export for potential use in other modules
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FriendsOfForayFormComponent);


//# sourceURL=webpack://liquid-starter/./src/sections/friends-of-foray-form.js?
;

/***/ }),

/***/ "./src/sections/full-width-slider.js":
/*!*******************************************!*\
  !*** ./src/sections/full-width-slider.js ***!
  \*******************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
// Full Width Slider with Embla Carousel
class FullWidthSlider {
  constructor(element) {
    this.element = element;
    this.sliderId = element.dataset.sliderId;
    this.emblaNode = element.querySelector('.embla');
    this.viewportNode = element.querySelector('.embla__viewport');
    this.containerNode = element.querySelector('.embla__container');
    this.slides = element.querySelectorAll('.embla__slide');
    this.prevButton = element.querySelector('.embla__button--prev');
    this.nextButton = element.querySelector('.embla__button--next');
    this.dots = element.querySelectorAll('.embla__dot');
    this.controls = element.querySelector('.embla__controls');

    // Get section settings from data attributes
    this.settings = this.getSettings();

    // Initialize Embla
    this.initEmbla();

    // Setup event listeners
    this.setupEventListeners();

    // Mark as loaded
    this.element.classList.remove('loading');
    this.element.classList.add('loaded');
  }

  getSettings() {
    // Get settings from data attributes
    return {
      autoplay: this.element.dataset.autoplay === 'true',
      autoplaySpeed: parseInt(this.element.dataset.autoplaySpeed || '5') * 1000,
      showDots: this.element.dataset.showDots === 'true',
      showArrows: this.element.dataset.showArrows === 'true',
      slideHeight: this.element.dataset.slideHeight || 'medium',
    };
  }

  initEmbla() {
    // Import Embla and fade plugin dynamically
    this.loadEmbla().then(() => {
      // Initialize Embla with fade plugin
      // eslint-disable-next-line no-undef
      this.embla = EmblaCarousel(
        this.viewportNode,
        {
          loop: true,
          align: 'start',
          containScroll: 'trimSnaps',
          dragFree: false,
          skipSnaps: false,
          inViewThreshold: 0.7,
          slidesToScroll: 1,
          breakpoints: {
            '(min-width: 768px)': { slidesToScroll: 1 },
          },
        },
        [
          // eslint-disable-next-line no-undef
          EmblaCarouselFade(),
        ],
      );

      // Setup autoplay
      if (this.settings.autoplay) {
        this.setupAutoplay();
      }

      // Setup navigation
      this.setupNavigation();

      // Setup dots
      if (this.settings.showDots) {
        this.setupDots();
      }

      // Apply slide height
      this.applySlideHeight();

      // Show/hide controls based on settings
      this.updateControlsVisibility();
    });
  }

  async loadEmbla() {
    // Check if Embla and fade plugin are already loaded
    if (window.EmblaCarousel && window.EmblaCarouselFade) {
      return Promise.resolve();
    }

    // Load Embla and fade plugin from CDN
    return new Promise((resolve, reject) => {
      // Load Embla core
      const emblaScript = document.createElement('script');
      emblaScript.src = 'https://unpkg.com/embla-carousel/embla-carousel.umd.js';

      // Load fade plugin
      const fadeScript = document.createElement('script');
      fadeScript.src = 'https://unpkg.com/embla-carousel-fade/embla-carousel-fade.umd.js';

      let loadedCount = 0;
      const checkComplete = () => {
        loadedCount++;
        if (loadedCount === 2) {
          resolve();
        }
      };

      emblaScript.onload = checkComplete;
      emblaScript.onerror = reject;
      fadeScript.onload = checkComplete;
      fadeScript.onerror = reject;

      document.head.appendChild(emblaScript);
      document.head.appendChild(fadeScript);
    });
  }

  setupAutoplay() {
    let autoplayInterval;

    const startAutoplay = () => {
      autoplayInterval = setInterval(() => {
        if (this.embla.canScrollNext()) {
          this.embla.scrollNext();
        } else {
          this.embla.scrollTo(0);
        }
      }, this.settings.autoplaySpeed);
    };

    const stopAutoplay = () => {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    };

    // Start autoplay
    startAutoplay();

    // Pause on hover
    this.element.addEventListener('mouseenter', stopAutoplay);
    this.element.addEventListener('mouseleave', startAutoplay);

    // Pause on focus
    this.element.addEventListener('focusin', stopAutoplay);
    this.element.addEventListener('focusout', startAutoplay);

    // Pause on touch
    this.element.addEventListener('touchstart', stopAutoplay);
    this.element.addEventListener('touchend', startAutoplay);
  }

  setupNavigation() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.embla.scrollPrev();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.embla.scrollNext();
      });
    }

    // Update button states
    const updateButtons = () => {
      if (this.prevButton) {
        this.prevButton.disabled = !this.embla.canScrollPrev();
      }
      if (this.nextButton) {
        this.nextButton.disabled = !this.embla.canScrollNext();
      }
    };

    this.embla.on('select', updateButtons);
    this.embla.on('init', updateButtons);
    updateButtons();
  }

  setupDots() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.embla.scrollTo(index);
      });
    });

    // Update dots
    const updateDots = () => {
      const selectedIndex = this.embla.selectedScrollSnap();

      this.dots.forEach((dot, index) => {
        if (index === selectedIndex) {
          dot.classList.add('is-selected');
        } else {
          dot.classList.remove('is-selected');
        }
      });
    };

    this.embla.on('select', updateDots);
    this.embla.on('init', updateDots);
    updateDots();
  }

  applySlideHeight() {
    this.element.setAttribute('data-slide-height', this.settings.slideHeight);
  }

  updateControlsVisibility() {
    if (this.controls) {
      this.controls.setAttribute('data-show-arrows', this.settings.showArrows);
      this.controls.setAttribute('data-show-dots', this.settings.showDots);
    }
  }

  setupEventListeners() {
    // Handle window resize
    window.addEventListener('resize', () => {
      if (this.embla) {
        this.embla.reInit();
      }
    });

    // Handle section re-render (Shopify theme editor)
    if (window.shopify?.section?.register) {
      window.shopify.section.register(this.sliderId, {
        onLoad: () => {
          // Section loaded in theme editor
        },
        onUnload: () => {
          // Clean up when section is unloaded
          if (this.embla) {
            this.embla.destroy();
          }
        },
        onBlockSelect: () => {
          // Block selected in theme editor
        },
        onBlockDeselect: () => {
          // Block deselected in theme editor
        },
      });
    }
  }

  destroy() {
    if (this.embla) {
      this.embla.destroy();
    }
  }
}

// Initialize all sliders when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.full-width-slider');
  sliders.forEach((slider) => {
    new FullWidthSlider(slider);
  });
});

// Handle dynamic content loading (Shopify sections)
document.addEventListener('shopify:section:load', (event) => {
  const slider = event.target.querySelector('.full-width-slider');
  if (slider) {
    new FullWidthSlider(slider);
  }
});

// Handle section re-renders
document.addEventListener('shopify:section:reorder', (event) => {
  const slider = event.target.querySelector('.full-width-slider');
  if (slider) {
    // Reinitialize slider
    const existingSlider = slider.fullWidthSlider;
    if (existingSlider) {
      existingSlider.destroy();
    }
    slider.fullWidthSlider = new FullWidthSlider(slider);
  }
});

// Export for potential external use
window.FullWidthSlider = FullWidthSlider;


//# sourceURL=webpack://liquid-starter/./src/sections/full-width-slider.js?
;

/***/ }),

/***/ "./src/sections/header.js":
/*!********************************!*\
  !*** ./src/sections/header.js ***!
  \********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_freeze_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/freeze.js */ "./src/utils/freeze.js");


/**
 * Header Web Component
 * Handles scroll-based animations and header behavior
 */
class HeaderComponent extends HTMLElement {
  constructor() {
    super();
    this.scrollThreshold = 25; // Pixels to scroll before animation triggers
    this.lastScrollY = 0;
    this.isScrolled = false;
    this.isAnimating = false;
    this.scrollDirection = 'down';
    this.headerElement = null;
    this.topBarElement = null;

    this.init();
  }

  init() {
    this.headerElement = this.querySelector('.header-outer-container');
    this.topBarElement = this.querySelector('.top-bar');

    if (!this.headerElement) {
      console.warn('Header component: Could not find .header-outer-container element');
      return;
    }

    this.bindEvents();
    this.setInitialState();
  }

  bindEvents() {
    // Use passive listener for better performance
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });

    // Handle resize events to recalculate positions
    window.addEventListener('resize', this.handleResize.bind(this), { passive: true });

    // Handle search form interactions
    document.addEventListener('click', this.handleSearchToggle.bind(this));

    // Handle tilt-burger mobile menu interactions
    this.handleTiltBurgerEvents();
  }

  handleScroll() {
    const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDelta = currentScrollY - this.lastScrollY;

    // Determine scroll direction
    this.scrollDirection = scrollDelta > 0 ? 'down' : 'up';

    // Check if we've crossed the threshold
    const shouldAnimate = currentScrollY > this.scrollThreshold;

    if (shouldAnimate !== this.isScrolled) {
      this.isScrolled = shouldAnimate;
      this.updateHeaderState();
    }

    // Handle scroll direction changes for smooth animations
    if (this.isScrolled) {
      this.updateScrollDirection();
    }

    this.lastScrollY = currentScrollY;
  }

  handleResize() {
    // Recalculate positions after resize
    this.updateHeaderState();
  }

  handleSearchToggle(event) {
    const searchButton = event.target.closest('.search-button');
    if (searchButton) {
      this.toggleSearchForm();
    }
  }

  handleTiltBurgerEvents() {
    const burger = document.querySelector('tilt-burger');
    if (burger) {
      burger.addEventListener('pressed-changed', (event) => {
        const pressed = event.detail.value;
        console.log('Tilt burger pressed:', pressed);
        this.toggleMobileMenu(burger, pressed);
      });
    }
  }

  toggleMobileMenu(burger, pressed) {
    console.log('toggleMobileMenu called with pressed:', pressed);
    const mobileMenu = document.querySelector('mobile-menu');
    console.log('Mobile menu element:', mobileMenu);
    if (!mobileMenu) {
      console.log('No mobile menu found!');
      return;
    }

    if (pressed) {
      mobileMenu.open();
    } else {
      mobileMenu.close();
    }
  }

  setInitialState() {
    // Check initial scroll position
    const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
    const shouldBeScrolled = currentScrollY > this.scrollThreshold;

    // Set initial data attributes based on current scroll position
    this.headerElement.setAttribute('data-scroll-state', shouldBeScrolled ? 'scrolled' : 'initial');
    this.headerElement.setAttribute('data-scroll-direction', 'down');

    // Update internal state
    this.isScrolled = shouldBeScrolled;
    this.lastScrollY = currentScrollY;

    // Add transition class for smooth animations
    this.headerElement.classList.add('header-transition');
  }

  updateHeaderState() {
    if (this.isAnimating) return;

    this.isAnimating = true;

    if (this.isScrolled) {
      this.headerElement.setAttribute('data-scroll-state', 'scrolled');
      this.headerElement.setAttribute('data-scrolled', 'true');
    } else {
      this.headerElement.setAttribute('data-scroll-state', 'initial');
      this.headerElement.removeAttribute('data-scrolled');
    }

    // Use requestAnimationFrame for smooth transitions
    requestAnimationFrame(() => {
      this.isAnimating = false;
    });
  }

  updateScrollDirection() {
    this.headerElement.setAttribute('data-scroll-direction', this.scrollDirection);
  }

  toggleSearchForm() {
    const searchForm = document.querySelector('.header-search-form');
    if (!searchForm) return;

    const isOpen = searchForm.classList.contains('search-form-open');

    if (isOpen) {
      this.closeSearchForm();
    } else {
      this.openSearchForm();
    }
  }

  openSearchForm() {
    const searchForm = document.querySelector('.header-search-form');
    const searchInput = searchForm?.querySelector('.search-input');
    const emptyState = searchForm?.querySelector('[data-header-search-empty-state]');

    if (searchForm) {
      // Create overlay if it doesn't exist
      this.createSearchOverlay();

      // Add header border radius attribute (same pattern as mega menu)
      const header = document.querySelector('.header');
      if (header) {
        console.log('Setting data-search-open="true" on header element');
        header.setAttribute('data-search-open', 'true');
      } else {
        console.warn('Could not find .header element');
      }

      // Prevent body scroll using freezeManager
      _utils_freeze_js__WEBPACK_IMPORTED_MODULE_0__["default"].freeze();

      searchForm.style.display = 'block';

      // Trigger animation on next frame
      requestAnimationFrame(() => {
        searchForm.classList.add('search-form-open');

        // Show empty state by default
        if (emptyState) {
          emptyState.style.display = 'block';
        }

        // Focus search input
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 300);
        }
      });
    }
  }

  closeSearchForm() {
    const searchForm = document.querySelector('.header-search-form');
    const searchInput = searchForm?.querySelector('.search-input');
    const emptyState = searchForm?.querySelector('[data-header-search-empty-state]');

    if (searchForm) {
      searchForm.classList.remove('search-form-open');

      // Remove header border radius attribute (same pattern as mega menu)
      const header = document.querySelector('.header');
      if (header) {
        console.log('Removing data-search-open attribute from header element');
        header.removeAttribute('data-search-open');
      } else {
        console.warn('Could not find .header element');
      }

      // Remove overlay
      this.removeSearchOverlay();

      // Restore body scroll using freezeManager
      _utils_freeze_js__WEBPACK_IMPORTED_MODULE_0__["default"].unfreeze();

      // Clear search input
      if (searchInput) {
        searchInput.value = '';
      }

      // Hide empty state
      if (emptyState) {
        emptyState.style.display = 'none';
      }

      // Hide after animation completes
      setTimeout(() => {
        if (!searchForm.classList.contains('search-form-open')) {
          searchForm.style.display = 'none';
        }
      }, 300);
    }
  }

  // Public method to get current scroll state
  getScrollState() {
    return {
      isScrolled: this.isScrolled,
      scrollDirection: this.scrollDirection,
      scrollY: this.lastScrollY,
    };
  }

  // Public method to manually trigger header state
  setScrollState(scrolled) {
    this.isScrolled = scrolled;
    this.updateHeaderState();
  }
  // Search Overlay

  createSearchOverlay() {
    // Remove existing overlay if it exists
    this.removeSearchOverlay();

    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'search-overlay';
    overlay.setAttribute('data-search-overlay', '');

    // Add click handler to close search
    overlay.addEventListener('click', () => {
      this.closeSearchForm();
    });

    document.body.appendChild(overlay);

    // Trigger animation on next frame
    requestAnimationFrame(() => {
      overlay.classList.add('search-overlay-active');
    });
  }

  removeSearchOverlay() {
    const overlay = document.querySelector('[data-search-overlay]');
    if (overlay) {
      overlay.classList.remove('search-overlay-active');

      // Remove after animation completes
      setTimeout(() => {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }, 300);
    }
  }
}

// Register the web component
customElements.define('header-component', HeaderComponent);

// Auto-initialize existing headers
document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('.header-outer-container');
  headers.forEach((header) => {
    if (!header.closest('header-component')) {
      const headerComponent = document.createElement('header-component');
      headerComponent.appendChild(header.cloneNode(true));
      header.parentNode.replaceChild(headerComponent, header);
    }
  });
});

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = HeaderComponent;
}


//# sourceURL=webpack://liquid-starter/./src/sections/header.js?
;

/***/ }),

/***/ "./src/sections/product-recommendations.js":
/*!*************************************************!*\
  !*** ./src/sections/product-recommendations.js ***!
  \*************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);

// Product recommendations. See sections/product-recommendations.liquid: the
// hand-picked cards are already server-rendered with the real product-card
// snippet, so this only fills the slots they left empty, from Shopify's
// recommendations rendered through the same section (Section Rendering API).
//
// Replaced a ~780-line component that built cards by hand, downloaded
// /products.json to turn product IDs into handles, linked picks to sold-out
// variants, and never asked for "related" when "complementary" came back empty.

async function fetchRecommendationCards(el, intent, limit) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const params = new URLSearchParams({
    product_id: el.dataset.productId,
    limit: String(limit),
    intent,
    section_id: el.dataset.sectionId,
  });
  const response = await fetch(`${root}recommendations/products?${params}`);
  if (!response.ok) return [];
  const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
  return [...doc.querySelectorAll('[data-recommendations-response] .product-recommendations__item')];
}

async function fillRecommendations(el) {
  const missing = Number(el.dataset.missing) || 0;
  if (missing <= 0) return;

  const exclude = el.dataset.exclude || ',';
  const grid = el.querySelector('[data-recommendations-container]');
  const hadPicks = grid.children.length > 0;
  // By title as well as id, matching the Liquid: some garments are one product
  // per colourway under the same title.
  const titleOf = (item) => item.querySelector('.product-card__title')?.textContent.trim();
  const titles = new Set([el.dataset.productTitle, ...[...grid.children].map(titleOf)]);
  // Always Shopify's maximum of 10, not just the empty slots: the filtering
  // below routinely discards most of the answer. On Mesh Inset LS Polo,
  // "related" is mostly the other same-titled Mesh Inset LS Polo products, and
  // asking for 5 left one usable card. Still one request either way.
  const limit = 10;

  // Complementary only returns products configured in the Search & Discovery
  // app, so for most of the catalogue it is empty and "related" (Shopify's
  // order-history picks) is what actually fills the section.
  const intents = [...new Set([el.dataset.intent || 'complementary', 'related'])];
  let items = [];
  let usedIntent = null;
  try {
    for (const intent of intents) {
      items = (await fetchRecommendationCards(el, intent, limit)).filter((item) => {
        const title = titleOf(item);
        if (exclude.includes(`,${item.dataset.productId},`) || titles.has(title)) return false;
        titles.add(title);
        return true;
      });
      if (items.length) {
        usedIntent = intent;
        break;
      }
    }
  } catch {
    return; // Hand-picked cards, if any, stay exactly as rendered.
  }
  if (!items.length) return;

  items.slice(0, missing).forEach((item) => grid.appendChild(item));
  // "Pairs well with:" suits hand-picked outfits and complementary products;
  // Shopify's related picks are usually similar items instead.
  if (!hadPicks && usedIntent === 'related') {
    const title = el.querySelector('[data-recommendations-title]');
    if (title && el.dataset.fallbackTitle) title.textContent = el.dataset.fallbackTitle;
  }
  el.hidden = false;
}

// The section sits below the product details, so the request waits until the
// shopper is heading that way instead of firing on every product view.
//
// What is observed is Shopify's section wrapper, not the component: with no
// hand-picked cards the component is `hidden`, and a display:none element never
// intersects. The wrapper is zero-height then, which still counts.
document.addEventListener('DOMContentLoaded', () => {
  const sections = [...document.querySelectorAll('[data-component="product-recommendations"]')];
  if (!('IntersectionObserver' in window)) {
    sections.forEach(fillRecommendations);
    return;
  }
  const byTarget = new Map(sections.map((el) => [el.parentElement || el, el]));
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        fillRecommendations(byTarget.get(entry.target));
      });
    },
    { rootMargin: '600px 0px' },
  );
  byTarget.forEach((_, target) => observer.observe(target));
});


//# sourceURL=webpack://liquid-starter/./src/sections/product-recommendations.js?
;

/***/ }),

/***/ "./src/sections/product-reviews.js":
/*!*****************************************!*\
  !*** ./src/sections/product-reviews.js ***!
  \*****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/**
 * Product Reviews Component
 * Handles fetching and displaying product reviews with pagination
 */

class ProductReviewsComponent {
  constructor(element) {
    this.element = element;
    this.productHandle = element.getAttribute('data-product-handle');
    this.reviewsShowing = parseInt(element.getAttribute('data-reviews-showing')) || 3;
    this.productReviews = [];
    this.apiEndpoint =
      'https://foray-dashboard-prisma.vercel.app/api/public/getProductReviewsByHandle';

    this.init();
  }

  init() {
    console.log('ProductReviewsComponent initializing...');
    console.log('Product handle:', this.productHandle);
    console.log('Reviews showing:', this.reviewsShowing);

    this.bindEvents();
    this.fetchProductReviews();

    console.log('ProductReviewsComponent initialized');
  }

  bindEvents() {
    console.log('Binding events for ProductReviewsComponent...');
    // Event delegation for load more reviews button
    document.addEventListener('click', this.handleClick.bind(this));
    console.log('Click event listener bound to document');
  }

  handleClick(event) {
    console.log('ProductReviewsComponent click event:', event.target);

    const loadMoreTrigger = event.target.closest('[data-trigger="load-more-reviews"]');
    const openReviewTrigger = event.target.closest('[data-trigger="open-review-form"]');

    console.log('Load more trigger found:', !!loadMoreTrigger);
    console.log('Open review trigger found:', !!openReviewTrigger);

    if (loadMoreTrigger && this.element.contains(loadMoreTrigger)) {
      console.log('Loading more reviews...');
      this.loadMoreReviews();
    }

    if (openReviewTrigger && this.element.contains(openReviewTrigger)) {
      console.log('Opening review form...');
      this.openReviewForm();
    }
  }

  async fetchProductReviews() {
    try {
      const response = await fetch(this.apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          payload: {
            handle: this.productHandle,
            origin: window.location.origin,
          },
        }),
      });

      const reviews = await response.json();

      if (reviews && reviews.length > 0) {
        this.productReviews = this.sortByCreatedAt(reviews);
        this.renderReviews();
      } else {
        this.showNoReviews();
      }
    } catch (error) {
      console.error('Error fetching product reviews:', error);
      this.showNoReviews();
    }
  }

  sortByCreatedAt(items) {
    return items.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);

      if (dateA < dateB) {
        return 1; // a comes after b
      } else if (dateA > dateB) {
        return -1; // a comes before b
      } else {
        return 0; // a and b are equal
      }
    });
  }

  renderReviews() {
    const reviewsContainer = this.element.querySelector('[data-reviews-container]');
    const noReviewsContainer = this.element.querySelector('[data-no-reviews-container]');
    const moreReviewsContainer = this.element.querySelector('[data-more-reviews-container]');

    // Hide no reviews message
    noReviewsContainer.style.display = 'none';

    // Get reviews to show
    const reviewsToShow = this.productReviews.slice(0, this.reviewsShowing);

    // Generate HTML for reviews
    const reviewsHTML = reviewsToShow
      .map((review, index) => {
        const stars = this.generateStars(review.reviewStarRating);
        const formattedDate = this.formatDate(review.createdAt);
        const authorName = review.reviewAuthorName
          ? review.reviewAuthorName.split(' ')[0]
          : 'Anonymous';

        return `
        <div class="product-reviews__review-item">
          <div class="product-reviews__review-inner">
            <div class="product-reviews__review-title">
              <div class="product-reviews__stars-container">
                ${stars}
              </div>
              <h4>
                ${review.reviewTitle}
                <span>${formattedDate}</span>
              </h4>
            </div>
            <div class="product-reviews__review-body">
              <p>${review.reviewBody}</p>
              <p><strong>${authorName}</strong></p>
            </div>
          </div>
        </div>
      `;
      })
      .join('');

    reviewsContainer.innerHTML = reviewsHTML;

    // Show/hide load more button
    if (this.productReviews.length > this.reviewsShowing) {
      moreReviewsContainer.style.display = 'block';
    } else {
      moreReviewsContainer.style.display = 'none';
    }
  }

  generateStars(rating) {
    const stars = [];
    for (let i = 0; i < rating; i++) {
      stars.push(
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M8 0l2.5 5.5L16 6l-4 4 1 6L8 13.5 3 16l1-6-4-4 5.5-.5z"/></svg>',
      );
    }
    return stars.join('');
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    });
  }

  loadMoreReviews() {
    this.reviewsShowing += 3;
    this.element.setAttribute('data-reviews-showing', this.reviewsShowing.toString());
    this.renderReviews();
  }

  showNoReviews() {
    const reviewsContainer = this.element.querySelector('[data-reviews-container]');
    const noReviewsContainer = this.element.querySelector('[data-no-reviews-container]');
    const moreReviewsContainer = this.element.querySelector('[data-more-reviews-container]');

    reviewsContainer.innerHTML = '';
    noReviewsContainer.style.display = 'block';
    moreReviewsContainer.style.display = 'none';
  }

  openReviewForm() {
    console.log('Opening review form...');

    // Get product data from the page
    const productData = {
      productHandle: this.productHandle,
      productId: this.element.getAttribute('data-product-id') || '',
      productName: this.element.getAttribute('data-product-name') || '',
    };

    console.log('Product data:', productData);

    // Try to find the review form component
    const reviewForm = document.querySelector('[data-component="review-form"]');
    console.log('Review form element found:', !!reviewForm);
    console.log('Window review form component:', !!window.reviewFormComponent);

    if (reviewForm && window.reviewFormComponent) {
      window.reviewFormComponent.open(productData);
    } else {
      console.error(
        'Review form component not found. Review form element:',
        !!reviewForm,
        'Window component:',
        !!window.reviewFormComponent,
      );

      // Fallback: try to initialize the review form if it exists but component isn't ready
      if (reviewForm && !window.reviewFormComponent) {
        console.log('Attempting to initialize review form component...');
        try {
          const ReviewFormComponent =
            window.ReviewFormComponent ||
            (() => {
              // Try to find the component class
              const scripts = document.querySelectorAll('script');
              for (let script of scripts) {
                if (script.textContent.includes('class ReviewFormComponent')) {
                  console.log('Found ReviewFormComponent in script');
                  return true;
                }
              }
              return false;
            })();

          if (ReviewFormComponent) {
            window.reviewFormComponent = new ReviewFormComponent(reviewForm);
            window.reviewFormComponent.open(productData);
          }
        } catch (error) {
          console.error('Failed to initialize review form component:', error);
        }
      }
    }
  }
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="product-reviews"]').forEach((element) => {
    new ProductReviewsComponent(element);
  });
});


//# sourceURL=webpack://liquid-starter/./src/sections/product-reviews.js?
;

/***/ }),

/***/ "./src/sections/product-slider.js":
/*!****************************************!*\
  !*** ./src/sections/product-slider.js ***!
  \****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
// Product Slider with Embla Carousel
class ProductSlider {
  constructor(element) {
    this.element = element;
    this.sliderId = element.dataset.sliderId;
    this.emblaNode = element.querySelector('.embla');
    this.viewportNode = element.querySelector('.embla__viewport');
    this.containerNode = element.querySelector('.embla__container');
    this.slides = element.querySelectorAll('.embla__slide');
    this.prevButton = element.querySelector('.embla__button--prev');
    this.nextButton = element.querySelector('.embla__button--next');
    this.dots = element.querySelectorAll('.embla__dot');
    this.controls = element.querySelector('.embla__controls');

    // Get section settings from data attributes
    this.settings = this.getSettings();

    // Initialize Embla
    this.initEmbla();

    // Setup event listeners
    this.setupEventListeners();

    // Apply responsive settings
    this.applyResponsiveSettings();

    // Mark as loaded
    this.element.classList.remove('loading');
    this.element.classList.add('loaded');
  }

  getSettings() {
    // Get settings from data attributes
    return {
      autoplay: this.element.dataset.autoplay === 'true',
      autoplaySpeed: parseInt(this.element.dataset.autoplaySpeed || '5') * 1000,
      showDots: this.element.dataset.showDots === 'true',
      showArrows: this.element.dataset.showArrows === 'true',
      productsPerRow: parseInt(this.element.dataset.productsPerRow || '4'),
    };
  }

  initEmbla() {
    // Import Embla dynamically
    this.loadEmbla().then(() => {
      // Initialize Embla with responsive settings
      // eslint-disable-next-line no-undef
      this.embla = EmblaCarousel(this.viewportNode, {
        loop: false,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        skipSnaps: false,
        inViewThreshold: 0.7,
        slidesToScroll: 1,
        breakpoints: {
          '(min-width: 1024px)': {
            slidesToScroll: Math.min(2, this.settings.productsPerRow),
            containScroll: 'trimSnaps',
          },
          '(min-width: 768px)': {
            slidesToScroll: 2,
            containScroll: 'trimSnaps',
          },
          '(min-width: 480px)': {
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
          },
        },
      });

      // Setup autoplay
      if (this.settings.autoplay) {
        this.setupAutoplay();
      }

      // Setup navigation
      this.setupNavigation();

      // Setup dots
      if (this.settings.showDots) {
        this.setupDots();
      }

      // Show/hide controls based on settings
      this.updateControlsVisibility();

      // Setup responsive behavior
      this.setupResponsiveBehavior();
    });
  }

  async loadEmbla() {
    // Check if Embla is already loaded
    if (window.EmblaCarousel) {
      return Promise.resolve();
    }

    // Load Embla from CDN
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/embla-carousel/embla-carousel.umd.js';
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  setupAutoplay() {
    let autoplayInterval;

    const startAutoplay = () => {
      autoplayInterval = setInterval(() => {
        if (this.embla.canScrollNext()) {
          this.embla.scrollNext();
        } else {
          this.embla.scrollTo(0);
        }
      }, this.settings.autoplaySpeed);
    };

    const stopAutoplay = () => {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    };

    // Start autoplay
    startAutoplay();

    // Pause on hover
    this.element.addEventListener('mouseenter', stopAutoplay);
    this.element.addEventListener('mouseleave', startAutoplay);

    // Pause on focus
    this.element.addEventListener('focusin', stopAutoplay);
    this.element.addEventListener('focusout', startAutoplay);

    // Pause on touch
    this.element.addEventListener('touchstart', stopAutoplay);
    this.element.addEventListener('touchend', startAutoplay);
  }

  setupNavigation() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.embla.scrollPrev();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.embla.scrollNext();
      });
    }

    // Update button states
    const updateButtons = () => {
      if (this.prevButton) {
        this.prevButton.disabled = !this.embla.canScrollPrev();
      }
      if (this.nextButton) {
        this.nextButton.disabled = !this.embla.canScrollNext();
      }
    };

    this.embla.on('select', updateButtons);
    this.embla.on('init', updateButtons);
    updateButtons();
  }

  setupDots() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.embla.scrollTo(index);
      });
    });

    // Update dots
    const updateDots = () => {
      const selectedIndex = this.embla.selectedScrollSnap();

      this.dots.forEach((dot, index) => {
        if (index === selectedIndex) {
          dot.classList.add('is-selected');
        } else {
          dot.classList.remove('is-selected');
        }
      });
    };

    this.embla.on('select', updateDots);
    this.embla.on('init', updateDots);
    updateDots();
  }

  applyResponsiveSettings() {
    this.element.setAttribute('data-products-per-row', this.settings.productsPerRow);
  }

  setupResponsiveBehavior() {
    // Handle window resize
    let resizeTimeout;

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (this.embla) {
          this.embla.reInit();
        }
      }, 250);
    };

    window.addEventListener('resize', handleResize);
  }

  updateControlsVisibility() {
    if (this.controls) {
      this.controls.setAttribute('data-show-arrows', this.settings.showArrows);
      this.controls.setAttribute('data-show-dots', this.settings.showDots);
    }
  }

  setupEventListeners() {
    // Handle section re-render (Shopify theme editor)
    if (window.shopify?.section?.register) {
      window.shopify.section.register(this.sliderId, {
        onLoad: () => {
          // Section loaded in theme editor
        },
        onUnload: () => {
          // Clean up when section is unloaded
          if (this.embla) {
            this.embla.destroy();
          }
        },
        onBlockSelect: () => {
          // Block selected in theme editor
        },
        onBlockDeselect: () => {
          // Block deselected in theme editor
        },
      });
    }
  }

  destroy() {
    if (this.embla) {
      this.embla.destroy();
    }
  }
}

// Initialize all product sliders when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.product-slider');
  sliders.forEach((slider) => {
    new ProductSlider(slider);
  });
});

// Handle dynamic content loading (Shopify sections)
document.addEventListener('shopify:section:load', (event) => {
  const slider = event.target.querySelector('.product-slider');
  if (slider) {
    new ProductSlider(slider);
  }
});

// Handle section re-renders
document.addEventListener('shopify:section:reorder', (event) => {
  const slider = event.target.querySelector('.product-slider');
  if (slider) {
    // Reinitialize slider
    const existingSlider = slider.productSlider;
    if (existingSlider) {
      existingSlider.destroy();
    }
    slider.productSlider = new ProductSlider(slider);
  }
});

// Export for potential external use
window.ProductSlider = ProductSlider;


//# sourceURL=webpack://liquid-starter/./src/sections/product-slider.js?
;

/***/ }),

/***/ "./src/sections/sourcing.js":
/*!**********************************!*\
  !*** ./src/sections/sourcing.js ***!
  \**********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
class SourcingSection {
  constructor(element) {
    this.element = element;
    this.form = element.querySelector('[data-component="sourcing"] form');
    this.init();
  }

  init() {
    if (this.form) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));

    // Add input validation
    const inputs = this.form.querySelectorAll('input, textarea');
    inputs.forEach((input) => {
      input.addEventListener('blur', this.validateField.bind(this));
      input.addEventListener('input', this.clearFieldError.bind(this));
    });
  }

  validateField(event) {
    const field = event.target;
    const isValid = field.checkValidity();

    if (!isValid) {
      this.showFieldError(field);
    } else {
      this.clearFieldError(field);
    }
  }

  showFieldError(field) {
    field.setAttribute('data-error', 'true');
  }

  clearFieldError(field) {
    field.removeAttribute('data-error');
  }

  async handleSubmit(event) {
    event.preventDefault();

    // Set loading state
    this.element.setAttribute('data-loading', 'true');

    try {
      const formData = new FormData(this.form);
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        // Redirect to success page
        const successUrl = new URL(this.form.querySelector('input[name="success_url"]').value);
        window.location.href = successUrl.toString();
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      // Reset loading state
      this.element.removeAttribute('data-loading');

      // Show error message to user
      this.showErrorMessage('There was an error submitting the form. Please try again.');
    }
  }

  showErrorMessage(message) {
    // Create error message element
    const errorDiv = document.createElement('div');
    errorDiv.className = 'sourcing__error-message';
    errorDiv.textContent = message;
    errorDiv.style.cssText = `
      padding: 1rem;
      background-color: #f8d7da;
      border: 1px solid #f5c6cb;
      border-radius: 4px;
      color: #721c24;
      font-size: 1rem;
      line-height: 1.5;
      margin-bottom: 1rem;
    `;

    // Insert before form
    this.form.parentNode.insertBefore(errorDiv, this.form);

    // Remove error message after 5 seconds
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.parentNode.removeChild(errorDiv);
      }
    }, 5000);
  }
}

// Auto-initialize sourcing sections
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="sourcing"]').forEach((element) => {
    new SourcingSection(element);
  });
});


//# sourceURL=webpack://liquid-starter/./src/sections/sourcing.js?
;

/***/ }),

/***/ "./src/sections/text-marquee.js":
/*!**************************************!*\
  !*** ./src/sections/text-marquee.js ***!
  \**************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var embla_carousel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! embla-carousel */ "./node_modules/.pnpm/embla-carousel@8.6.0/node_modules/embla-carousel/esm/embla-carousel.esm.js");
/* harmony import */ var embla_carousel_auto_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! embla-carousel-auto-scroll */ "./node_modules/.pnpm/embla-carousel-auto-scroll@8.6.0_embla-carousel@8.6.0/node_modules/embla-carousel-auto-scroll/esm/embla-carousel-auto-scroll.esm.js");



class TextMarquee extends HTMLElement {
  constructor() {
    super();
    this.embla = null;
    this.autoScroll = null;
    this.playBtn = null;
    this.loopMonitor = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    const viewportNode = this.querySelector('.embla__viewport');
    this.playBtn = this.querySelector('.text-marquee__play-btn');

    if (!viewportNode) {
      console.warn('TextMarquee: Viewport element not found');
      return;
    }

    try {
      // Get configuration from data attributes
      const speed = this.getAttribute('data-speed') || 'normal';
      const pauseOnHover = this.getAttribute('data-pause-on-hover') === 'true';

      // Initialize auto scroll plugin
      this.autoScroll = (0,embla_carousel_auto_scroll__WEBPACK_IMPORTED_MODULE_0__["default"])({
        playOnInit: true,
      });

      // Initialize Embla with loop enabled
      this.embla = (0,embla_carousel__WEBPACK_IMPORTED_MODULE_1__["default"])(
        viewportNode,
        {
          loop: true,
          align: 'start',
          containScroll: false,
          dragFree: true,
          skipSnaps: true,
        },
        [this.autoScroll],
      );

      const button = this.querySelector('.text-marquee__reset-btn');

      button.addEventListener('click', () => {
        console.log('reset', this.embla);
        return this.embla.reInit();
      });

      console.log('embla', this.embla);

      // Set up event listeners after initialization
      this.embla.on('init', () => {
        this.setupEventListeners(pauseOnHover);
        this.startLoopMonitor();
      });

      // Handle re-initialization
      this.embla.on('reInit', () => {
        this.setupEventListeners(pauseOnHover);
        this.startLoopMonitor();
      });
    } catch (error) {
      console.error('TextMarquee: Error initializing carousel:', error);
    }
  }

  getSpeedValue(speed) {
    const speedMap = {
      slow: 0.5,
      normal: 1,
      fast: 2,
    };
    return speedMap[speed] || 1;
  }

  startLoopMonitor() {
    // Clear any existing monitor
    if (this.loopMonitor) {
      clearInterval(this.loopMonitor);
    }

    // Monitor the auto-scroll every 500ms to ensure it's running
    this.loopMonitor = setInterval(() => {
      if (!this.autoScroll) return;

      try {
        // Check if auto-scroll is playing
        const isPlaying = this.autoScroll.isPlaying ? this.autoScroll.isPlaying() : false;

        // If it's not playing and we're not paused, restart it
        if (!isPlaying && !this.isPaused) {
          this.autoScroll.play();
        }
      } catch (error) {
        // If there's an error, try to restart the auto-scroll
        if (this.autoScroll && typeof this.autoScroll.play === 'function') {
          this.autoScroll.play();
        }
      }
    }, 500);
  }

  setupEventListeners(pauseOnHover) {
    // Set up play button if it exists
    if (this.playBtn) {
      this.setupPlayButton();
    }

    // Set up hover pause if enabled
    if (pauseOnHover) {
      this.setupHoverPause();
    }
  }

  setupPlayButton() {
    const togglePlayBtnState = () => {
      if (!this.autoScroll) return;

      const playIcon = this.playBtn.querySelector('.text-marquee__play-icon');
      const pauseIcon = this.playBtn.querySelector('.text-marquee__pause-icon');

      if (!playIcon || !pauseIcon) {
        console.warn('TextMarquee: Play/pause icons not found');
        return;
      }

      try {
        const isPlaying = this.autoScroll.isPlaying ? this.autoScroll.isPlaying() : false;

        if (isPlaying) {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        } else {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        }
      } catch (error) {
        console.error('TextMarquee: Error checking auto scroll state:', error);
      }
    };

    const onPlayBtnClick = () => {
      if (!this.autoScroll) {
        console.warn('TextMarquee: Auto scroll plugin not available');
        return;
      }

      try {
        if (this.autoScroll.isPlaying && this.autoScroll.isPlaying()) {
          this.autoScroll.stop();
          this.isPaused = true;
        } else {
          this.autoScroll.play();
          this.isPaused = false;
        }
      } catch (error) {
        console.error('TextMarquee: Error toggling auto scroll:', error);
      }
    };

    this.playBtn.addEventListener('click', onPlayBtnClick);

    // Listen for auto-scroll events
    this.embla
      .on('autoplay:play', togglePlayBtnState)
      .on('autoplay:stop', togglePlayBtnState)
      .on('reInit', togglePlayBtnState);

    // Set initial state
    togglePlayBtnState();
  }

  setupHoverPause() {
    if (!this.autoScroll) return;

    this.addEventListener('mouseenter', () => {
      this.isPaused = true;
      if (this.autoScroll && typeof this.autoScroll.stop === 'function') {
        this.autoScroll.stop();
      }
    });

    this.addEventListener('mouseleave', () => {
      this.isPaused = false;
      if (this.autoScroll && typeof this.autoScroll.play === 'function') {
        this.autoScroll.play();
      }
    });
  }

  destroy() {
    try {
      // Clear the loop monitor
      if (this.loopMonitor) {
        clearInterval(this.loopMonitor);
        this.loopMonitor = null;
      }

      if (this.autoScroll && typeof this.autoScroll.stop === 'function') {
        this.autoScroll.stop();
      }
      if (this.embla && typeof this.embla.destroy === 'function') {
        this.embla.destroy();
      }
    } catch (error) {
      console.error('TextMarquee: Error destroying carousel:', error);
    }
  }
}

// Define the custom element
customElements.define('text-marquee', TextMarquee);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TextMarquee);


//# sourceURL=webpack://liquid-starter/./src/sections/text-marquee.js?
;

/***/ }),

/***/ "./src/snippets/accordion.js":
/*!***********************************!*\
  !*** ./src/snippets/accordion.js ***!
  \***********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
class AccordionComponent {
  constructor(element) {
    this.element = element;
    this.allowMultiple = element.getAttribute('data-allow-multiple') === 'true';
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const trigger = event.target.closest('[data-trigger="accordion-item"]');
    if (!trigger || !this.element.contains(trigger)) return;

    event.preventDefault();

    const targetId = trigger.getAttribute('data-target');
    const content = document.getElementById(targetId);
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    if (!this.allowMultiple) {
      this.collapseAll();
    }

    if (isExpanded) {
      this.collapse(trigger, content);
    } else {
      this.expand(trigger, content);
    }
  }

  expand(trigger, content) {
    // Add a subtle ripple effect
    this.addRippleEffect(trigger);

    trigger.setAttribute('aria-expanded', 'true');
    content.setAttribute('data-state', 'expanded');
    content.setAttribute('aria-hidden', 'false');

    // Add a subtle bounce effect to the icon
    const icon = trigger.querySelector('.accordion-icon');
    if (icon) {
      icon.style.transform = 'rotate(90deg) scale(1.1)';
    }
  }

  collapse(trigger, content) {
    trigger.setAttribute('aria-expanded', 'false');
    content.setAttribute('data-state', 'collapsed');
    content.setAttribute('aria-hidden', 'true');

    // Reset icon transform
    const icon = trigger.querySelector('.accordion-icon');
    if (icon) {
      icon.style.transform = 'rotate(0deg) scale(1)';
    }
  }

  addRippleEffect(element) {
    const ripple = document.createElement('span');
    ripple.style.position = 'absolute';
    ripple.style.borderRadius = '50%';
    ripple.style.background = 'rgba(0, 0, 0, 0.08)';
    ripple.style.transform = 'scale(0)';
    ripple.style.animation = 'ripple 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    ripple.style.left = '50%';
    ripple.style.top = '50%';
    ripple.style.width = '24px';
    ripple.style.height = '24px';
    ripple.style.marginLeft = '-12px';
    ripple.style.marginTop = '-12px';
    ripple.style.pointerEvents = 'none';

    element.style.position = 'relative';
    element.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 800);
  }

  collapseAll() {
    const triggers = this.element.querySelectorAll('[data-trigger="accordion-item"]');
    const contents = this.element.querySelectorAll('[data-accordion-content]');

    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    contents.forEach((content) => {
      content.setAttribute('data-state', 'collapsed');
      content.setAttribute('aria-hidden', 'true');
    });
  }
}

// Auto-initialize accordion components
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="accordion"]').forEach((accordion) => {
    new AccordionComponent(accordion);
  });
});


//# sourceURL=webpack://liquid-starter/./src/snippets/accordion.js?
;

/***/ }),

/***/ "./src/snippets/mega-menu.js":
/*!***********************************!*\
  !*** ./src/snippets/mega-menu.js ***!
  \***********************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
// Global Mega Menu Manager
class MegaMenuManager {
  constructor() {
    this.openMenu = null;
    this.hoverTimeout = null;
    this.isTransitioning = false;
    this.init();
  }

  init() {
    // Set header height CSS variable
    this.setHeaderHeight();

    // Listen for custom events from menu triggers
    document.addEventListener('mega-menu-open', (e) => {
      this.openMenuComponent(e.detail.menuId);
    });

    document.addEventListener('mega-menu-close', (e) => {
      this.closeMenuComponent(e.detail.menuId);
    });

    // Close all menus when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mega-menu') && !e.target.closest('[data-mega-menu-trigger]')) {
        this.closeAllMenus();
      }
    });

    // Close menus when clicking overlay
    const overlay = document.querySelector('.header-overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.closeAllMenus();
      });

      // Close menu when mouse enters overlay (mouseout from mega menu)
      overlay.addEventListener('mouseenter', () => {
        if (this.openMenu) {
          this.closeMenuComponent(this.openMenu);
        }
      });
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllMenus();
      }
    });

    // Update header height on resize
    window.addEventListener('resize', () => {
      this.setHeaderHeight();
    });
  }

  setHeaderHeight() {
    const header = document.querySelector('.header');
    if (header) {
      const height = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }

  openMenuComponent(menuId) {
    if (this.isTransitioning) return;

    // Close any currently open menu
    if (this.openMenu && this.openMenu !== menuId) {
      this.closeMenuComponent(this.openMenu);
    }

    // Open the new menu
    this.openMenu = menuId;

    // Find the menu and trigger elements
    const menu = document.querySelector(`[data-mega-menu][data-menu-id="${menuId}"]`);
    const trigger = document.querySelector(`[data-mega-menu-trigger][data-menu-id="${menuId}"]`);

    if (menu && trigger) {
      this.isTransitioning = true;

      menu.setAttribute('data-state', 'open');
      trigger.setAttribute('aria-expanded', 'true');

      // Add mega-menu-open class and data attribute to header
      const header = document.querySelector('.header');
      if (header) {
        header.classList.add('mega-menu-open');
        header.setAttribute('data-mega-menu-open', 'true');
      }

      // Show overlay immediately without delay
      const overlay = document.querySelector('.header-overlay');
      if (overlay) {
        overlay.style.display = 'block';
        overlay.classList.add('overlay-visible');
      }

      // Reset transition flag after animation completes
      setTimeout(() => {
        this.isTransitioning = false;
      }, 300);
    }
  }

  closeMenuComponent(menuId) {
    if (this.isTransitioning) return;

    if (this.openMenu === menuId) {
      this.openMenu = null;
    }

    const menu = document.querySelector(`[data-mega-menu][data-menu-id="${menuId}"]`);
    const trigger = document.querySelector(`[data-mega-menu-trigger][data-menu-id="${menuId}"]`);

    if (menu && trigger) {
      this.isTransitioning = true;

      menu.setAttribute('data-state', 'closed');
      trigger.setAttribute('aria-expanded', 'false');

      // Remove mega-menu-open class and data attribute from header
      const header = document.querySelector('.header');
      if (header) {
        header.classList.remove('mega-menu-open');
        header.removeAttribute('data-mega-menu-open');
      }

      // Hide overlay with proper timing
      const overlay = document.querySelector('.header-overlay');
      if (overlay) {
        overlay.classList.remove('overlay-visible');
        setTimeout(() => {
          if (!overlay.classList.contains('overlay-visible')) {
            overlay.style.display = 'none';
          }
          this.isTransitioning = false;
        }, 300);
      } else {
        this.isTransitioning = false;
      }
    }
  }

  closeAllMenus() {
    if (this.openMenu) {
      this.closeMenuComponent(this.openMenu);
    }

    // Ensure header class and data attribute are removed
    const header = document.querySelector('.header');
    if (header) {
      header.classList.remove('mega-menu-open');
      header.removeAttribute('data-mega-menu-open');
    }

    // Ensure overlay is hidden
    const overlay = document.querySelector('.header-overlay');
    if (overlay) {
      overlay.classList.remove('overlay-visible');
      overlay.style.display = 'none';
    }
  }
}

// Menu Link Handler
class MenuLinkHandler {
  constructor() {
    this.hoverTimeout = null;
    this.currentHoverTarget = null;
    this.init();
  }

  init() {
    // Find all menu triggers
    const triggers = document.querySelectorAll('[data-mega-menu-trigger]');

    triggers.forEach((trigger) => {
      const menuId = trigger.getAttribute('data-menu-id');

      // Mouse events for hover with improved handling
      trigger.addEventListener('mouseenter', (e) => {
        this.currentHoverTarget = menuId;
        this.requestOpen(menuId);
      });

      trigger.addEventListener('mouseleave', (e) => {
        // Only close if we're not hovering over the mega menu
        const relatedTarget = e.relatedTarget;
        if (!relatedTarget || !relatedTarget.closest('.mega-menu')) {
          this.currentHoverTarget = null;
          this.requestClose(menuId);
        }
      });

      // Click events: desktop lets the link navigate normally since hover
      // already discloses the panel; touch uses tap-to-open, then tap-through-to-navigate.
      trigger.addEventListener('click', (e) => {
        const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

        if (!isTouch) {
          this.setLinkLoading(trigger, e);
          return;
        }

        const isOpen = window.megaMenuManager && window.megaMenuManager.openMenu === menuId;

        if (!isOpen) {
          e.preventDefault();
          this.requestOpen(menuId);
          return;
        }

        this.setLinkLoading(trigger, e);
      });

      // Keyboard accessibility
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleMenu(menuId);
        }
      });
    });

    // Handle mega menu hover with improved logic
    const megaMenus = document.querySelectorAll('.mega-menu');

    megaMenus.forEach((menu) => {
      const menuId = menu.getAttribute('data-menu-id');

      menu.addEventListener('mouseenter', () => {
        // Keep current menu open when hovering over mega menu
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
        this.currentHoverTarget = menuId;
      });

      menu.addEventListener('mouseleave', (e) => {
        // Only close if we're not moving to the trigger
        const relatedTarget = e.relatedTarget;
        if (!relatedTarget || !relatedTarget.closest('[data-mega-menu-trigger]')) {
          this.currentHoverTarget = null;
          this.requestClose(menuId);
        }
      });
    });

    // Plain (non-mega) menu links get no other JS today; add the same
    // navigating affordance for consistency.
    const plainLinks = document.querySelectorAll('.menu-link:not([data-mega-menu-trigger])');
    plainLinks.forEach((link) => {
      link.addEventListener('click', (e) => this.setLinkLoading(link, e));
    });
  }

  requestOpen(menuId) {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    // Dispatch event to manager
    document.dispatchEvent(
      new CustomEvent('mega-menu-open', {
        detail: { menuId: menuId },
      }),
    );
  }

  requestClose(menuId) {
    // Only close if this is still the current hover target
    if (this.currentHoverTarget !== menuId) return;

    this.hoverTimeout = setTimeout(() => {
      // Double-check that we're still not hovering over anything
      if (this.currentHoverTarget !== menuId) return;

      document.dispatchEvent(
        new CustomEvent('mega-menu-close', {
          detail: { menuId: menuId },
        }),
      );
    }, 50); // Reduced delay for smoother experience
  }

  toggleMenu(menuId) {
    if (window.megaMenuManager && window.megaMenuManager.openMenu === menuId) {
      document.dispatchEvent(
        new CustomEvent('mega-menu-close', {
          detail: { menuId: menuId },
        }),
      );
    } else {
      this.requestOpen(menuId);
    }
  }

  setLinkLoading(link, e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    link.setAttribute('data-loading', 'true');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.megaMenuManager = new MegaMenuManager();
    new MenuLinkHandler();
  });
} else {
  window.megaMenuManager = new MegaMenuManager();
  new MenuLinkHandler();
}


//# sourceURL=webpack://liquid-starter/./src/snippets/mega-menu.js?
;

/***/ }),

/***/ "./src/snippets/mobile-menu.js":
/*!*************************************!*\
  !*** ./src/snippets/mobile-menu.js ***!
  \*************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
// Mobile Menu Web Component
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.currentPane = 'main';
    this.paneHistory = ['main'];
    this.init();
  }

  init() {
    console.log('Mobile menu component initialized');
    this.bindEvents();
    this.setInitialState();
  }

  bindEvents() {
    // Handle close button and overlay clicks
    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-close="mobile-menu"]');
      const overlay = e.target.closest('[data-mobile-menu-overlay]');
      const paneTrigger = e.target.closest('[data-trigger="mobile-pane"]');

      if (closeBtn) {
        e.preventDefault();
        this.close();
      }

      if (closeBtn) {
        e.preventDefault();
        this.close();
      }

      // Handle pane navigation
      if (paneTrigger) {
        e.preventDefault();
        const targetPane = paneTrigger.getAttribute('data-target');
        console.log('Pane trigger clicked, target:', targetPane);
        this.navigateToPane(targetPane);
      }

      // Close when clicking overlay (but not content)
      if (overlay && e.target === overlay) {
        this.close();
      }
    });

    // Handle escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        if (this.currentPane !== 'main') {
          this.navigateToPane('main');
        } else {
          this.close();
        }
      }
    });

    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth > 992 && this.isOpen) {
        this.close();
      }
    });

    // Handle page visibility change (when user switches tabs)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && this.isOpen) {
        this.close();
      }
    });
  }

  setInitialState() {
    this.setAttribute('data-state', 'closed');
    document.body.removeAttribute('data-mobile-menu-open');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    this.currentPane = 'main';
    this.paneHistory = ['main'];

    // Initialize all panes as inactive except main
    const panes = this.querySelectorAll('[data-pane]');
    console.log(
      'Found',
      panes.length,
      'panes:',
      Array.from(panes).map((p) => p.getAttribute('data-pane')),
    );

    panes.forEach((pane) => {
      const isMain = pane.getAttribute('data-pane') === 'main';
      pane.setAttribute('data-active', isMain.toString());
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.setAttribute('data-state', 'open');
    document.body.setAttribute('data-mobile-menu-open', 'true');
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');

    // Set header state
    const headerContainer = document.querySelector('.header-outer-container');
    if (headerContainer) {
      headerContainer.setAttribute('data-mobile-menu-open', 'true');
    }

    // Set tilt-burger state
    const burger = document.querySelector('tilt-burger');
    if (burger) {
      burger.pressed = true;
    }

    // Focus management
    const closeBtn = this.querySelector('[data-close="mobile-menu"]');
    if (closeBtn) {
      closeBtn.focus();
    }

    // Trap focus
    this.trapFocus();
  }

  close() {
    this.isOpen = false;
    this.setAttribute('data-state', 'closed');
    document.body.removeAttribute('data-mobile-menu-open');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');

    // Reset header state
    const headerContainer = document.querySelector('.header-outer-container');
    if (headerContainer) {
      headerContainer.removeAttribute('data-mobile-menu-open');
    }

    // Reset to main pane
    this.navigateToPane('main', false);

    // Reset tilt-burger state
    const burger = document.querySelector('tilt-burger');
    if (burger) {
      burger.pressed = false;
    }
  }

  navigateToPane(targetPane, addToHistory = true) {
    const currentPaneElement = this.querySelector(`[data-pane="${this.currentPane}"]`);
    const targetPaneElement = this.querySelector(`[data-pane="${targetPane}"]`);

    if (!targetPaneElement) {
      console.log('Target pane not found:', targetPane);
      return;
    }

    console.log('Navigating from', this.currentPane, 'to', targetPane);

    // Update pane states with proper timing
    if (currentPaneElement && currentPaneElement !== targetPaneElement) {
      currentPaneElement.setAttribute('data-active', 'false');
    }

    // Small delay to ensure smooth transition
    requestAnimationFrame(() => {
      targetPaneElement.setAttribute('data-active', 'true');
    });

    // Update current pane
    this.currentPane = targetPane;

    // Update history
    if (addToHistory) {
      this.paneHistory.push(targetPane);
    } else {
      this.paneHistory = [targetPane];
    }

    // Update ARIA states
    this.updateAriaStates();

    // Update breadcrumb navigation
    this.updateBreadcrumb(targetPane);

    // Focus management
    if (targetPane === 'main') {
      const closeBtn = this.querySelector('[data-close="mobile-menu"]');
      if (closeBtn) closeBtn.focus();
    } else {
      const backBtn = targetPaneElement.querySelector('.mobile-menu-back');
      if (backBtn) backBtn.focus();
    }
  }

  updateBreadcrumb(targetPane) {
    // Find the trigger that led to this pane to get the title
    const trigger = this.querySelector(`[data-trigger="mobile-pane"][data-target="${targetPane}"]`);
    if (trigger) {
      const title = trigger.getAttribute('data-title');
      if (title) {
        // Update the pane title
        const targetPaneElement = this.querySelector(`[data-pane="${targetPane}"]`);
        const titleElement = targetPaneElement?.querySelector('.mobile-menu-pane-title');
        if (titleElement) {
          titleElement.textContent = title;
        }
      }
    }

    // Handle single-child menu back button text
    const targetPaneElement = this.querySelector(`[data-pane="${targetPane}"]`);
    if (targetPaneElement && targetPaneElement.hasAttribute('data-single-child')) {
      const backButton = targetPaneElement.querySelector('.mobile-menu-back');
      if (backButton) {
        // For single-child menus, the back button should go to main menu
        backButton.setAttribute('data-target', 'main');
        backButton.setAttribute('data-title', 'Menu');
        const backText = backButton.querySelector('span');
        if (backText) {
          backText.textContent = 'Back';
        }
      }
    }
  }

  updateAriaStates() {
    // Update all pane triggers
    const triggers = this.querySelectorAll('[data-trigger="mobile-pane"]');
    triggers.forEach((trigger) => {
      const target = trigger.getAttribute('data-target');
      const isExpanded = target === this.currentPane;
      trigger.setAttribute('aria-expanded', isExpanded.toString());
    });
  }

  trapFocus() {
    const focusableElements = this.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    });
  }
}

// Register the web component
customElements.define('mobile-menu', MobileMenu);


//# sourceURL=webpack://liquid-starter/./src/snippets/mobile-menu.js?
;

/***/ }),

/***/ "./src/snippets/modal.js":
/*!*******************************!*\
  !*** ./src/snippets/modal.js ***!
  \*******************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var focus_trap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! focus-trap */ "./node_modules/.pnpm/focus-trap@7.6.5/node_modules/focus-trap/dist/focus-trap.esm.js");


const ATTR = {
  MODAL_COMPONENT: 'data-modal-component',
  MODAL_OVERLAY: 'data-modal-overlay',
  MODAL_CLOSE: 'data-modal-close',
  MODAL_TRIGGER: 'data-modal-trigger',
};

/**
 * Modal web component for handling modal dialogs with focus trap and accessibility features.
 */
class Modal extends HTMLElement {
  /**
   * @private
   * Constructs the Modal component and initializes properties and event handlers.
   */
  constructor() {
    super();

    this.modal = this.querySelector(`[${ATTR.MODAL_COMPONENT}]`);
    this.overlay = this.querySelector(`[${ATTR.MODAL_OVERLAY}]`);
    this.closeBtn = this.querySelector(`[${ATTR.MODAL_CLOSE}]`);
    this.body = document.body;
    this.focusTrap = (0,focus_trap__WEBPACK_IMPORTED_MODULE_0__.createFocusTrap)(this, {
      escapeDeactivates: false,
      clickOutsideDeactivates: false,
      fallbackFocus: this,
    });

    this.handleOverlayClick = this.close.bind(this);
    this.handleCloseClick = this.close.bind(this);
    this.handleKeyDown = this.onKeyDown.bind(this);

    this.overlay.addEventListener('click', this.handleOverlayClick);
    this.closeBtn.addEventListener('click', this.handleCloseClick);
  }

  /**
   * @private
   * Called when the element is connected to the DOM.
   * Sets up the modal component.
   */
  connectedCallback() {
    this.setAttribute('aria-hidden', 'true');
    document.addEventListener('click', this.handleTriggerClick.bind(this));
    document.addEventListener('keydown', this.handleKeyDown);
  }

  /**
   * @private
   * Called when the element is disconnected from the DOM.
   * Cleans up the modal component.
   */
  disconnectedCallback() {
    document.removeEventListener('click', this.handleTriggerClick.bind(this));
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  /**
   * @private
   * Called when the user clicks on a trigger button.
   * Opens the modal if the trigger matches this modal's id.
   * @param {MouseEvent} e - The click event.
   * @returns {void}
   */
  handleTriggerClick(e) {
    const trigger = e.target.closest(`[${ATTR.MODAL_TRIGGER}]`);
    if (trigger) {
      const modalId = trigger.getAttribute(ATTR.MODAL_TRIGGER);
      if (modalId === this.id) {
        this.open();
      }
    }
  }

  /**
   * Opens the modal, activates the focus trap, and focuses the first focusable element.
   * @returns {void}
   */
  open() {
    this.setAttribute(ATTR.MODAL_COMPONENT, 'show');
    this.setAriaAttributes();
    this.focusTrap.activate();
    this.body.style.overflow = 'hidden';
  }

  /**
   * Closes the modal and deactivates the focus trap.
   * @returns {void}
   */
  close() {
    this.setAttribute(ATTR.MODAL_COMPONENT, '');
    this.focusTrap.deactivate();
    this.body.style.overflow = 'auto';
  }

  /**
   * @private
   * Handles keydown events to close the modal on Escape key.
   * @param {KeyboardEvent} e - The keydown event.
   * @returns {void}
   */
  onKeyDown(e) {
    if (e.key === 'Escape' && this.getAttribute(ATTR.MODAL_COMPONENT) === 'show') {
      this.close();
    }
  }

  /**
   * Dynamically sets aria-labelledby and aria-describedby based on modal content.
   */
  setAriaAttributes() {
    const content = this.querySelector('[data-modal-content]');
    if (!content) return;

    const heading = content.querySelector('h1, h2, h3, h4, h5, h6');
    const description = content.querySelector('p');

    if (heading) {
      if (!heading.id) heading.id = `${this.id}-title`;
      this.setAttribute('aria-labelledby', heading.id);
    } else {
      this.removeAttribute('aria-labelledby');
    }

    if (description) {
      if (!description.id) description.id = `${this.id}-description`;
      this.setAttribute('aria-describedby', description.id);
    } else {
      this.removeAttribute('aria-describedby');
    }
  }
}

if (!customElements.get('modal-component')) {
  customElements.define('modal-component', Modal);
}


//# sourceURL=webpack://liquid-starter/./src/snippets/modal.js?
;

/***/ }),

/***/ "./src/snippets/review-form.js":
/*!*************************************!*\
  !*** ./src/snippets/review-form.js ***!
  \*************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/**
 * Review Form Component
 * Handles the review submission modal with star rating and form validation
 */

class ReviewFormComponent {
  constructor(element) {
    this.element = element;
    this.formData = {
      productId: '',
      productName: '',
      productHandle: '',
      reviewStarRating: 5,
      reviewAuthorName: '',
      reviewAuthorEmail: '',
      reviewTitle: '',
      reviewBody: '',
    };
    this.captchaCompleted = false;
    this.apiEndpoint = 'https://foray-dashboard-prisma.vercel.app/api/public/createReview';

    this.init();
  }

  init() {
    console.log('ReviewFormComponent initializing...');
    this.bindEvents();

    // Don't setup reCAPTCHA immediately - wait until modal opens
    console.log('ReviewFormComponent initialized');
  }

  bindEvents() {
    // Event delegation for modal interactions
    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('keydown', this.handleKeydown.bind(this));

    // Form submission
    const form = this.element.querySelector('[data-review-form]');
    if (form) {
      form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    // Star rating selection
    const starLabels = this.element.querySelectorAll('[data-star]');
    starLabels.forEach((label) => {
      label.addEventListener('click', this.handleStarClick.bind(this));
    });

    // Form field changes
    const formFields = this.element.querySelectorAll('[data-field]');
    formFields.forEach((field) => {
      field.addEventListener('input', this.handleFieldChange.bind(this));
    });
  }

  handleClick(event) {
    const closeBtn = event.target.closest('[data-close="review-form"]');
    const backdrop = event.target.closest('[data-modal-backdrop]');

    if (closeBtn) {
      this.close();
    }

    if (backdrop && !event.target.closest('[data-modal-content]')) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isActive()) {
      this.close();
    }
  }

  handleStarClick(event) {
    event.preventDefault();

    // Find the label element (which has the data-star attribute)
    const label = event.target.closest('[data-star]');
    if (!label) return;

    const starValue = parseInt(label.getAttribute('data-star'));
    this.setStarRating(starValue);
  }

  handleFieldChange(event) {
    const field = event.target.getAttribute('data-field');
    const value = event.target.value;

    if (field && this.formData.hasOwnProperty(field)) {
      this.formData[field] = value;
    }
  }

  setStarRating(rating) {
    this.formData.reviewStarRating = rating;

    // Update hidden input
    const hiddenInput = this.element.querySelector('[data-star-rating]');
    if (hiddenInput) {
      hiddenInput.value = rating;
    }

    // Update star display - now stars are ordered 1,2,3,4,5 from left to right
    const starLabels = this.element.querySelectorAll('[data-star]');
    const starTotal = this.element.querySelector('.review-form-modal__star-total');

    starLabels.forEach((label) => {
      const starValue = parseInt(label.getAttribute('data-star'));
      // Highlight stars from left to right (1 to rating)
      label.classList.toggle('review-form-modal__radio-star--active', starValue <= rating);
    });

    if (starTotal) {
      starTotal.textContent = `${rating}/5`;
    }
  }

  setupRecaptcha() {
    console.log('Setting up reCAPTCHA...');

    // Load reCAPTCHA script if not already loaded
    if (typeof grecaptcha === 'undefined') {
      console.log('reCAPTCHA not loaded, loading script...');
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onload = () => {
        console.log('reCAPTCHA script loaded');
        // Wait a bit for grecaptcha to be fully initialized
        setTimeout(() => {
          this.renderRecaptcha();
        }, 100);
      };

      script.onerror = () => {
        console.error('Failed to load reCAPTCHA script');
      };
    } else {
      console.log('reCAPTCHA already loaded');
      this.renderRecaptcha();
    }
  }

  renderRecaptcha() {
    console.log('Rendering reCAPTCHA...');
    const container = this.element.querySelector('[data-recaptcha-container]');

    if (!container) {
      console.error('reCAPTCHA container not found');
      return;
    }

    if (typeof grecaptcha === 'undefined') {
      console.error('grecaptcha is undefined');
      return;
    }

    try {
      // Clear any existing reCAPTCHA
      if (container.querySelector('.g-recaptcha')) {
        container.innerHTML = '';
      }

      console.log('Creating reCAPTCHA widget...');
      grecaptcha.render(container, {
        sitekey: '6LfH7CEmAAAAAJKFo5ZX1G7bNpMY0UC6dIcrIFhZ',
        callback: (response) => {
          console.log('reCAPTCHA completed');
          this.captchaCompleted = true;
        },
        'expired-callback': () => {
          console.log('reCAPTCHA expired');
          this.captchaCompleted = false;
        },
        'error-callback': () => {
          console.error('reCAPTCHA error');
          this.captchaCompleted = false;
        },
      });
      console.log('reCAPTCHA widget created successfully');
    } catch (error) {
      console.error('Error rendering reCAPTCHA:', error);
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    // if (!this.captchaCompleted) {
    //   alert('Please complete the captcha');
    //   return;
    // }

    const submitButton = event.target.querySelector('button[type="submit"]');
    const originalText = submitButton.textContent;
    submitButton.textContent = 'Submitting...';
    submitButton.disabled = true;

    try {
      const response = await fetch(this.apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          payload: {
            ...this.formData,
          },
        }),
      });

      const data = await response.json();

      if (response.ok) {
        this.showConfirmation();
        // Delay closing the modal by 5 seconds to allow user to see confirmation
        setTimeout(() => {
          this.close();
        }, 5000);
      } else {
        throw new Error('Failed to submit review');
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      alert('Failed to submit review. Please try again.');
    } finally {
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }
  }

  showConfirmation() {
    const form = this.element.querySelector('[data-review-form]');
    const confirmation = this.element.querySelector('[data-confirmation-container]');
    const formTitle = this.element.querySelector('#review-form-title');

    if (form && confirmation) {
      form.style.display = 'none';
      formTitle.style.display = 'none';
      confirmation.style.display = 'block';
    }
  }

  open(productData = {}) {
    console.log('ReviewFormComponent.open() called with:', productData);

    // Set product data
    this.formData = {
      ...this.formData,
      ...productData,
    };

    console.log('Updated form data:', this.formData);

    // Reset form
    const form = this.element.querySelector('[data-review-form]');
    const confirmation = this.element.querySelector('[data-confirmation-container]');

    if (form) {
      form.reset();
      form.style.display = 'block';
      console.log('Form reset and displayed');
    }

    if (confirmation) {
      confirmation.style.display = 'none';
      console.log('Confirmation hidden');
    }

    // Reset star rating
    this.setStarRating(5);

    // Reset captcha
    this.captchaCompleted = false;

    // Show modal
    this.element.setAttribute('data-active', 'true');
    document.body.setAttribute('data-modal-open', 'true');
    console.log('Modal activated, body scroll prevented');

    // Force a repaint to ensure visibility
    this.element.style.display = 'flex';
    this.element.offsetHeight; // Force reflow
    console.log('Modal display set to flex, forced reflow');

    // Debug modal visibility
    const computedStyle = window.getComputedStyle(this.element);
    console.log('Modal computed styles:', {
      display: computedStyle.display,
      opacity: computedStyle.opacity,
      visibility: computedStyle.visibility,
      zIndex: computedStyle.zIndex,
      position: computedStyle.position,
    });

    // Focus first input
    const firstInput = this.element.querySelector('input:not([type="hidden"])');
    if (firstInput) {
      firstInput.focus();
      console.log('First input focused');
    }

    // Setup reCAPTCHA after modal is visible
    setTimeout(() => {
      // this.setupRecaptcha();
    }, 300);

    console.log('Review form modal opened successfully');
  }

  close() {
    this.element.setAttribute('data-active', 'false');
    document.body.removeAttribute('data-modal-open');
  }

  isActive() {
    return this.element.getAttribute('data-active') === 'true';
  }
}

// Make ReviewFormComponent available globally
window.ReviewFormComponent = ReviewFormComponent;

// Auto-initialize
document.addEventListener('DOMContentLoaded', () => {
  console.log('Initializing review form components...');
  const reviewFormElements = document.querySelectorAll('[data-component="review-form"]');
  console.log('Found review form elements:', reviewFormElements.length);

  reviewFormElements.forEach((element, index) => {
    console.log(`Initializing review form component ${index + 1}...`);
    const component = new ReviewFormComponent(element);
    // Store component instance globally for access from other components
    window.reviewFormComponent = component;
    console.log('Review form component initialized and stored globally');
  });
});


//# sourceURL=webpack://liquid-starter/./src/snippets/review-form.js?
;

/***/ }),

/***/ "./src/snippets/variant-selector.js":
/*!******************************************!*\
  !*** ./src/snippets/variant-selector.js ***!
  \******************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/**
 * Variant Selector Component
 * Handles variant selection, availability updates, and add to cart button state
 *
 * URL Integration:
 * - Updates URL with variant parameter when variants change (e.g., ?variant=123456789)
 * - Initializes from URL parameter on page load
 * - Handles browser back/forward navigation
 * - Maintains URL state without page reloads
 */
class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.variants = [];
    this.currentVariant = null;
    this.previousVariant = null;
    this.productId = this.getAttribute('data-product-id');
    this.optionCount = 0;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.variants = this.getVariants();
    this.optionCount = this.getOptionCount();

    // Check if there's a variant in the URL and select it
    this.initializeFromURL();

    // If no variant from URL, initialize with the correct current variant from DOM
    if (!this.currentVariant) {
      this.currentVariant = this.getInitialVariant();
    }

    this.bindEvents();
    this.updateAllAvailabilityStates();
    this.updateAddToCartButton();
    this.updatePrice();

    // Ensure media galleries are initialized with current variant
    // Use a small delay to ensure all components are loaded
    setTimeout(() => {
      this.updateMediaGalleries();
    }, 100);
  }

  bindEvents() {
    // Use event delegation for all variant option interactions
    this.addEventListener('click', this.handleOptionClick.bind(this));
    this.addEventListener('change', this.handleDropdownChange.bind(this));

    // Listen for browser navigation (back/forward buttons)
    window.addEventListener('popstate', this.handlePopState.bind(this));
  }

  handleOptionClick(event) {
    const trigger = event.target.closest('[data-trigger="variant-option"]');
    if (!trigger) return;

    event.preventDefault();

    const optionIndex = parseInt(trigger.getAttribute('data-option-index'));
    const optionValue = trigger.getAttribute('data-option-value');

    // Don't allow selection of disabled options
    if (trigger.hasAttribute('data-disabled') && trigger.disabled) {
      return;
    }

    this.selectOption(optionIndex, optionValue);
  }

  handleDropdownChange(event) {
    const dropdown = event.target.closest('[data-trigger="variant-dropdown"]');
    if (!dropdown) return;

    const optionIndex = parseInt(dropdown.getAttribute('data-option-index'));
    const optionValue = dropdown.value;
    this.selectOption(optionIndex, optionValue);
  }

  selectOption(optionIndex, optionValue) {
    console.log('🎨 Selecting option:', { optionIndex, optionValue });

    // Store the previous variant before updating
    this.previousVariant = this.currentVariant;

    // Find the new variant based on current selections and the new option
    this.currentVariant = this.findVariantByOptionChange(optionIndex, optionValue);

    console.log('🎨 Found variant:', this.currentVariant);

    // Update the UI to reflect the new variant
    this.updateVariantUI();

    // Update availability states for all options
    this.updateAllAvailabilityStates();

    // Update add to cart button
    this.updateAddToCartButton();

    // Trigger variant change event with option information
    this.triggerVariantChange(this.previousVariant, optionIndex, optionValue);
  }

  /**
   * BULLETPROOF: Find variant by option change
   * This is the single source of truth for variant selection
   */
  findVariantByOptionChange(changedOptionIndex, changedOptionValue) {
    // Get current selections (excluding the option that's being changed)
    const currentSelections = this.getCurrentSelections();

    // Create new selections with the changed option
    const newSelections = [...currentSelections];
    newSelections[changedOptionIndex] = changedOptionValue;

    // Find exact match first. If it's sold out but the value just picked
    // (usually a colour) has stock in another size, move to the closest
    // in-stock variant instead: on Core Skirt, Black / XXS then Navy used to
    // carry XXS over and leave a sold-out size selected.
    const exactMatch = this.findExactVariantMatch(newSelections);
    if (exactMatch && !exactMatch.available) {
      const sharedOptions = (variant) =>
        variant.options.filter((value, index) => value === newSelections[index]).length;
      const inStock = this.variants
        .filter((variant) => variant.available && variant.options[changedOptionIndex] === changedOptionValue)
        .sort((a, b) => sharedOptions(b) - sharedOptions(a));
      if (inStock.length) return inStock[0];
    }
    if (exactMatch) {
      return exactMatch;
    }

    // If no exact match, find the best available variant with the changed option
    return this.findBestAvailableVariant(changedOptionIndex, changedOptionValue);
  }

  /**
   * BULLETPROOF: Find exact variant match for all selections
   */
  findExactVariantMatch(selections) {
    return this.variants.find((variant) => {
      return selections.every((selection, index) => {
        // If we have a selection for this option, it must match
        // If we don't have a selection, any value is acceptable
        if (!selection) return true;

        // Normalize both values for comparison (handle quotes)
        const normalizedSelection = selection
          .replace(/"/g, '"')
          .replace(/"/g, '"')
          .replace(/\\"/g, '"')
          .replace(/\\"/g, '"')
          .replace(/"/g, '')
          .replace(/"/g, '');
        const normalizedVariantOption = variant.options[index]
          .replace(/"/g, '"')
          .replace(/"/g, '"')
          .replace(/\\"/g, '"')
          .replace(/\\"/g, '"')
          .replace(/"/g, '')
          .replace(/"/g, '');

        return normalizedVariantOption === normalizedSelection;
      });
    });
  }

  /**
   * BULLETPROOF: Find best available variant with the specified option
   */
  findBestAvailableVariant(optionIndex, optionValue) {
    // First, try to find an available variant with this option
    const availableVariant = this.variants.find((variant) => {
      return variant.options[optionIndex] === optionValue && variant.available;
    });

    if (availableVariant) {
      return availableVariant;
    }

    // If no available variant, find any variant with this option (even unavailable)
    const anyVariant = this.variants.find((variant) => {
      return variant.options[optionIndex] === optionValue;
    });

    return anyVariant || this.variants[0] || null;
  }

  /**
   * BULLETPROOF: Check if a specific option combination is available
   * This is the single source of truth for availability checking
   */
  isOptionCombinationAvailable(selections) {
    const variant = this.findExactVariantMatch(selections);
    return variant ? variant.available : false;
  }

  /**
   * BULLETPROOF: Update availability states for all options
   * This method handles all availability logic in one place
   * Colors are always clickable for preview, sizes are restricted based on color
   */
  updateAllAvailabilityStates() {
    if (!this.variants || this.variants.length === 0) {
      return;
    }

    // Get all option buttons and dropdowns
    const allOptions = this.querySelectorAll(
      '[data-trigger="variant-option"], [data-trigger="variant-dropdown"]',
    );

    // Group by option index
    const optionsByIndex = {};
    allOptions.forEach((option) => {
      const optionIndex = parseInt(option.getAttribute('data-option-index'));
      if (!optionsByIndex[optionIndex]) {
        optionsByIndex[optionIndex] = [];
      }
      optionsByIndex[optionIndex].push(option);
    });

    // Get current selections
    const currentSelections = this.getCurrentSelections();

    // For each option type, check availability of each value
    Object.keys(optionsByIndex).forEach((optionIndexStr) => {
      const optionIndex = parseInt(optionIndexStr);
      const options = optionsByIndex[optionIndex];

      // Check if this is a color option
      const isColorOption =
        options[0] && options[0].classList.contains('variant-selector__color-option');

      // Check if this is a length option
      const isLengthOption =
        options[0] &&
        options[0].getAttribute('data-option-value') &&
        (options[0].getAttribute('data-option-value').includes('Regular') ||
          options[0].getAttribute('data-option-value').includes('Tall'));

      options.forEach((option) => {
        const optionValue = option.getAttribute('data-option-value') || option.value;

        if (isColorOption) {
          // BULLETPROOF: Colors are always clickable for preview
          // They may be marked as unavailable but still clickable
          this.updateColorOptionAvailability(option, optionValue);
        } else if (isLengthOption) {
          // Length options are always clickable
          this.updateOptionAvailability(option, true);
        } else {
          // For non-color options (like sizes), check if they're available with current color
          const testSelections = [...currentSelections];
          testSelections[optionIndex] = optionValue;
          const isAvailable = this.isOptionCombinationAvailable(testSelections);
          this.updateOptionAvailability(option, isAvailable);
        }
      });
    });
  }

  /**
   * BULLETPROOF: Update color option availability
   * Colors are always clickable but may be marked as unavailable
   */
  updateColorOptionAvailability(option, optionValue) {
    const isButton =
      option.hasAttribute('data-trigger') &&
      option.getAttribute('data-trigger') === 'variant-option';

    if (!isButton) return;

    // Check if this color has any available variants (regardless of current size)
    const hasAnyAvailableVariants = this.variants.some((variant) => {
      const colorIndex = this.findColorOptionIndex();
      return variant.options[colorIndex] === optionValue && variant.available;
    });

    // Colors are always clickable, but may be marked as unavailable
    option.removeAttribute('data-disabled');
    option.disabled = false;

    if (hasAnyAvailableVariants) {
      // Color has some available variants
      option.removeAttribute('data-unavailable');
    } else {
      // Color has no available variants at all
      option.setAttribute('data-unavailable', 'true');
    }
  }

  /**
   * BULLETPROOF: Find the color option index dynamically
   * This handles cases where color might be first, second, or third option
   */
  findColorOptionIndex() {
    // Look for color option in the variant selector DOM
    const colorOptions = this.querySelectorAll('.variant-selector__color-option');
    if (colorOptions.length > 0) {
      const firstColorOption = colorOptions[0];
      const colorIndex = parseInt(firstColorOption.getAttribute('data-option-index'));
      return colorIndex;
    }

    // Fallback: assume first option is color (original behavior)
    return 0;
  }

  /**
   * BULLETPROOF: Update a single option's availability state
   * Consistent handling for all option types
   */
  updateOptionAvailability(option, isAvailable) {
    const isButton =
      option.hasAttribute('data-trigger') &&
      option.getAttribute('data-trigger') === 'variant-option';
    const isDropdown =
      option.hasAttribute('data-trigger') &&
      option.getAttribute('data-trigger') === 'variant-dropdown';

    if (isButton) {
      // For buttons, use data-disabled for consistency
      if (isAvailable) {
        option.removeAttribute('data-disabled');
        option.removeAttribute('data-unavailable');
        option.disabled = false;
      } else {
        option.setAttribute('data-disabled', 'true');
        option.setAttribute('data-unavailable', 'true');
        option.disabled = true;
      }
    } else if (isDropdown) {
      // For dropdown options, use disabled attribute
      if (isAvailable) {
        option.disabled = false;
        option.removeAttribute('data-unavailable');
      } else {
        option.disabled = true;
        option.setAttribute('data-unavailable', 'true');
      }
    }
  }

  getInitialVariant() {
    // Try to find the currently selected variant from the DOM
    const activeButtons = this.querySelectorAll(
      '[data-trigger="variant-option"][data-active="true"]',
    );
    const selectedDropdowns = this.querySelectorAll('[data-trigger="variant-dropdown"]');

    if (activeButtons.length > 0 || selectedDropdowns.length > 0) {
      // Build current selections from DOM
      const currentSelections = [];

      // Get selections from active buttons
      activeButtons.forEach((button) => {
        const optionIndex = parseInt(button.getAttribute('data-option-index'));
        const optionValue = button.getAttribute('data-option-value');
        currentSelections[optionIndex] = optionValue;
      });

      // Get selections from dropdowns
      selectedDropdowns.forEach((dropdown) => {
        const optionIndex = parseInt(dropdown.getAttribute('data-option-index'));
        const optionValue = dropdown.value;
        currentSelections[optionIndex] = optionValue;
      });

      // Find the variant that matches these selections
      const matchingVariant = this.findExactVariantMatch(currentSelections);
      if (matchingVariant) {
        return matchingVariant;
      }
    }

    // Fallback to first available variant, then first variant
    const firstAvailableVariant = this.variants.find((variant) => variant.available);
    if (firstAvailableVariant) {
      return firstAvailableVariant;
    }

    return this.variants[0] || null;
  }

  getVariants() {
    // Get complete variant data from the base64 encoded data attribute
    const variantsDataBase64 = this.getAttribute('data-variants-base64');

    if (variantsDataBase64) {
      try {
        const variantsJson = atob(variantsDataBase64);
        const variants = JSON.parse(variantsJson);

        // Validate variant structure
        if (Array.isArray(variants) && variants.length > 0) {
          return variants;
        }
      } catch (error) {
        console.error('Failed to decode/parse variants data:', error);
      }
    }

    // Fallback: build variants from DOM elements
    return this.buildVariantsFromDOM();
  }

  buildVariantsFromDOM() {
    const variantElements = this.querySelectorAll('[data-variant-id]');
    const variantGroups = new Map();

    variantElements.forEach((element) => {
      const variantId = element.getAttribute('data-variant-id');
      const optionIndex = parseInt(element.getAttribute('data-option-index'));
      const optionValue = element.getAttribute('data-option-value') || element.value;
      const isAvailable = !element.hasAttribute('data-disabled') && !element.disabled;

      if (!variantId || !optionValue) {
        return;
      }

      if (!variantGroups.has(variantId)) {
        variantGroups.set(variantId, {
          id: variantId,
          available: true,
          options: [],
          elements: [],
        });
      }

      const variantGroup = variantGroups.get(variantId);
      variantGroup.options[optionIndex] = optionValue;
      variantGroup.elements.push(element);

      // If any element is disabled/unavailable, mark the variant as unavailable
      if (!isAvailable) {
        variantGroup.available = false;
      }
    });

    // Convert groups to complete variants
    return Array.from(variantGroups.values())
      .filter((variantGroup) => {
        return variantGroup.options.every((option) => option && option.trim() !== '');
      })
      .map((variantGroup) => ({
        id: variantGroup.id,
        available: variantGroup.available,
        options: variantGroup.options,
      }));
  }

  getOptionCount() {
    // Count unique option indices
    const optionIndices = new Set();
    const allOptions = this.querySelectorAll('[data-option-index]');

    allOptions.forEach((option) => {
      const index = parseInt(option.getAttribute('data-option-index'));
      if (!isNaN(index)) {
        optionIndices.add(index);
      }
    });

    return optionIndices.size;
  }

  getCurrentSelections() {
    const selections = [];
    const allButtons = this.querySelectorAll('[data-trigger="variant-option"][data-active="true"]');
    const allDropdowns = this.querySelectorAll('[data-trigger="variant-dropdown"]');

    // Get selections from active buttons
    allButtons.forEach((button) => {
      const optionIndex = parseInt(button.getAttribute('data-option-index'));
      const optionValue = button.getAttribute('data-option-value');
      selections[optionIndex] = optionValue;
    });

    // Get selections from dropdowns
    allDropdowns.forEach((dropdown) => {
      const optionIndex = parseInt(dropdown.getAttribute('data-option-index'));
      const optionValue = dropdown.value;
      selections[optionIndex] = optionValue;
    });

    // Fallback: if no active buttons found, use current variant options
    if (this.currentVariant && selections.length === 0) {
      this.currentVariant.options.forEach((option, index) => {
        selections[index] = option;
      });
    }

    return selections;
  }

  updateCurrentVariant() {
    if (!this.currentVariant) return;

    const currentValueSpans = this.querySelectorAll('.variant-selector__current-value');
    currentValueSpans.forEach((span, index) => {
      if (this.currentVariant.options[index]) {
        span.textContent = this.currentVariant.options[index];
      }
    });
  }

  updateAddToCartButton() {
    // Scoped to this selector's own buy box. The cart drawer's add-on cards
    // render <variant-selector> too, and a document-wide lookup let a size
    // click there re-enable the PDP button with the add-on's variant id.
    const addToCartButton = this.closest('.product-form')?.querySelector(
      '.product-form__add-to-cart button[type="submit"], [data-add-to-cart-button]',
    );
    if (!addToCartButton || !this.currentVariant) return;

    // Update the variant ID on the button
    addToCartButton.setAttribute('data-variant-id', this.currentVariant.id);

    // Update button text and state
    const buttonText = addToCartButton.querySelector('.add-to-cart__text');
    if (buttonText) {
      if (this.currentVariant.available) {
        buttonText.textContent = 'Add to Cart';
        addToCartButton.disabled = false;
      } else {
        buttonText.textContent = 'Sold Out';
        addToCartButton.disabled = true;
      }
    } else {
      // Fallback for buttons without text span
      if (this.currentVariant.available) {
        addToCartButton.textContent = 'Add to Cart';
        addToCartButton.disabled = false;
      } else {
        addToCartButton.textContent = 'Sold Out';
        addToCartButton.disabled = true;
      }
    }

    // Update quantity input ID if it exists
    const quantityInput = addToCartButton
      .closest('[data-add-to-cart]')
      ?.querySelector('[data-quantity-input]');
    if (quantityInput) {
      quantityInput.id = `quantity-${this.currentVariant.id}`;
    }
  }

  triggerVariantChange(previousVariant, changedOptionIndex, changedOptionValue) {
    // Update URL with variant parameter
    this.updateURLWithVariant();

    // Update price display
    this.updatePrice();

    // Ensure media galleries are updated
    this.updateMediaGalleries();

    const event = new CustomEvent('variant:changed', {
      detail: {
        variant: this.currentVariant,
        productId: this.productId,
        previousVariant: previousVariant,
        changedOptionIndex: changedOptionIndex,
        changedOptionValue: changedOptionValue,
      },
      bubbles: true,
    });
    this.dispatchEvent(event);

    // Also dispatch a specific price update event for product cards
    const priceEvent = new CustomEvent('variant:price-changed', {
      detail: {
        variant: this.currentVariant,
        productId: this.productId,
        price: this.currentVariant.price,
        compareAtPrice: this.currentVariant.compare_at_price,
      },
      bubbles: true,
    });
    this.dispatchEvent(priceEvent);
  }

  updatePrice() {
    if (!this.currentVariant) {
      console.log('❌ No current variant for price update');
      return;
    }

    console.log('💰 Updating price for variant:', this.currentVariant);

    // Find price display elements - improved selectors to match both product page and product cards
    // Only the PDP selector owns the page price (see updateAddToCartButton).
    const productPage = this.closest('.single-product-container');
    if (!productPage) {
      console.log('❌ No product page found for price update');
      return;
    }
    const priceElements = productPage.querySelectorAll(
      `[data-product-price="${this.productId}"], .product-price, .product-info__header p, .product-card__price`,
    );

    console.log('💰 Found price elements:', priceElements.length);

    priceElements.forEach((priceElement) => {
      const price = this.currentVariant.price;
      const compareAtPrice = this.currentVariant.compare_at_price;

      console.log('💰 Price data:', { price, compareAtPrice });

      // Format prices
      const formattedPrice = this.formatMoney(price);
      const formattedCompareAtPrice = compareAtPrice ? this.formatMoney(compareAtPrice) : null;

      // Check if this is a sale price
      const isOnSale = compareAtPrice && compareAtPrice > price;

      // Determine CSS classes based on element type
      const isProductCard = priceElement.classList.contains('product-card__price');
      const saleClass = isProductCard ? 'product-card__price--sale' : 'product-price--sale';
      const compareClass = isProductCard
        ? 'product-card__price--compare'
        : 'product-price--compare';
      const regularClass = isProductCard
        ? 'product-card__price--regular'
        : 'product-price--regular';

      if (isOnSale) {
        priceElement.innerHTML = `
          <span class="${saleClass}">${formattedPrice}</span>
          <span class="${compareClass}">${formattedCompareAtPrice}</span>
        `;
      } else {
        priceElement.innerHTML = `<span class="${regularClass}">${formattedPrice}</span>`;
      }
    });
  }

  formatMoney(cents) {
    // Delegates to the single currency-aware formatter defined in
    // layout/theme.liquid. This used to hardcode "$" and USD's two decimals,
    // which mislabelled every non-USD presentment currency.
    return window.Shopify.formatMoney(cents);
  }

  updateMediaGalleries() {
    if (!this.currentVariant) return;

    // Update product gallery
    const productGallery = document.querySelector(
      `product-gallery[data-product-id="${this.productId}"]`,
    );
    if (productGallery && typeof productGallery.handleVariantChange === 'function') {
      productGallery.handleVariantChange(this.currentVariant, this.previousVariant);
    }

    // Update product image slider
    const productImageSlider = document.querySelector(
      `product-image-slider[data-product-id="${this.productId}"]`,
    );
    if (productImageSlider && typeof productImageSlider.handleVariantChange === 'function') {
      productImageSlider.handleVariantChange(this.currentVariant, this.previousVariant);
    }
  }

  updateURLWithVariant() {
    // Only the PDP selector owns ?variant= (see updateAddToCartButton).
    if (!this.currentVariant || !this.closest('.product-form')) return;

    const url = new URL(window.location);
    url.searchParams.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', url.toString());
  }

  initializeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (variantId && this.variants.length > 0) {
      const variantFromURL = this.variants.find((variant) => variant.id.toString() === variantId);

      // Only adopt the URL variant if it can actually be bought. Product cards
      // write ?variant= into their links after a swatch click, and email and
      // feed links carry them too, so this param regularly points at a
      // sold-out size. Selecting it would open the PDP on a disabled Sold Out
      // button. Leaving currentVariant unset lets init() fall through to
      // getInitialVariant(), which reads the server-rendered selection.
      if (variantFromURL && variantFromURL.available) {
        this.currentVariant = variantFromURL;
        this.updateVariantUI();
      }
    }
  }

  updateVariantUI() {
    if (!this.currentVariant) return;

    // Update active button states
    const allButtons = this.querySelectorAll('[data-trigger="variant-option"]');
    allButtons.forEach((button) => {
      const buttonOptionIndex = parseInt(button.getAttribute('data-option-index'));
      const buttonOptionValue = button.getAttribute('data-option-value');

      // Normalize both values for comparison (handle quotes)
      const normalizedButtonValue = buttonOptionValue
        .replace(/"/g, '"')
        .replace(/"/g, '"')
        .replace(/\\"/g, '"')
        .replace(/\\"/g, '"')
        .replace(/"/g, '')
        .replace(/"/g, '');
      const normalizedVariantOption = this.currentVariant.options[buttonOptionIndex]
        .replace(/"/g, '"')
        .replace(/"/g, '"')
        .replace(/\\"/g, '"')
        .replace(/\\"/g, '"')
        .replace(/"/g, '')
        .replace(/"/g, '');

      if (normalizedVariantOption === normalizedButtonValue) {
        button.setAttribute('data-active', 'true');
      } else {
        button.removeAttribute('data-active');
      }
    });

    // Update dropdowns
    const allDropdowns = this.querySelectorAll('[data-trigger="variant-dropdown"]');
    allDropdowns.forEach((dropdown) => {
      const dropdownOptionIndex = parseInt(dropdown.getAttribute('data-option-index'));
      if (this.currentVariant.options[dropdownOptionIndex]) {
        dropdown.value = this.currentVariant.options[dropdownOptionIndex];
      }
    });

    // Update hidden input for form submission
    const hiddenInput = this.querySelector('input[name="id"]');
    if (hiddenInput && this.currentVariant) {
      hiddenInput.value = this.currentVariant.id;
    }

    // Update current value displays
    this.updateCurrentVariant();
  }

  handlePopState() {
    // Re-initialize from URL when browser navigation occurs
    this.initializeFromURL();

    // Update availability states and add to cart button
    this.updateAllAvailabilityStates();
    this.updateAddToCartButton();

    // Update media galleries
    this.updateMediaGalleries();
  }

  /**
   * BULLETPROOF: Refresh the entire variant selector state
   * Useful for debugging and ensuring all components are in sync
   */
  refresh() {
    console.log('🔄 Refreshing variant selector state...');

    // Re-get variants (in case they changed)
    this.variants = this.getVariants();

    // Update all states
    this.updateAllAvailabilityStates();
    this.updateAddToCartButton();
    this.updateMediaGalleries();

    console.log('✅ Variant selector refreshed:', {
      currentVariant: this.currentVariant,
      totalVariants: this.variants.length,
      productId: this.productId,
    });
  }

  disconnectedCallback() {
    // Clean up event listeners
    window.removeEventListener('popstate', this.handlePopState.bind(this));
  }
}

// Register the web component
customElements.define('variant-selector', VariantSelector);


//# sourceURL=webpack://liquid-starter/./src/snippets/variant-selector.js?
;

/***/ }),

/***/ "./src/theme.css":
/*!***********************!*\
  !*** ./src/theme.css ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


//# sourceURL=webpack://liquid-starter/./src/theme.css?
;

/***/ }),

/***/ "./src/theme.js":
/*!**********************!*\
  !*** ./src/theme.js ***!
  \**********************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var what_input__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! what-input */ "./node_modules/.pnpm/what-input@5.2.12/node_modules/what-input/dist/what-input.js");
/* harmony import */ var _snippets_modal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./snippets/modal.js */ "./src/snippets/modal.js");
/* harmony import */ var _snippets_mega_menu_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./snippets/mega-menu.js */ "./src/snippets/mega-menu.js");
/* harmony import */ var _snippets_mobile_menu_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./snippets/mobile-menu.js */ "./src/snippets/mobile-menu.js");
/* harmony import */ var _snippets_variant_selector_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./snippets/variant-selector.js */ "./src/snippets/variant-selector.js");
/* harmony import */ var _snippets_review_form_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./snippets/review-form.js */ "./src/snippets/review-form.js");
/* harmony import */ var _snippets_accordion_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./snippets/accordion.js */ "./src/snippets/accordion.js");
/* harmony import */ var _sections_full_width_slider_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./sections/full-width-slider.js */ "./src/sections/full-width-slider.js");
/* harmony import */ var _sections_product_slider_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./sections/product-slider.js */ "./src/sections/product-slider.js");
/* harmony import */ var _sections_custom_items_slider_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./sections/custom-items-slider.js */ "./src/sections/custom-items-slider.js");
/* harmony import */ var _sections_header_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./sections/header.js */ "./src/sections/header.js");
/* harmony import */ var _sections_text_marquee_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./sections/text-marquee.js */ "./src/sections/text-marquee.js");
/* harmony import */ var _sections_email_cta_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./sections/email-cta.js */ "./src/sections/email-cta.js");
/* harmony import */ var _sections_product_reviews_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./sections/product-reviews.js */ "./src/sections/product-reviews.js");
/* harmony import */ var _sections_product_recommendations_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./sections/product-recommendations.js */ "./src/sections/product-recommendations.js");
/* harmony import */ var _sections_faq_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./sections/faq.js */ "./src/sections/faq.js");
/* harmony import */ var _sections_friends_of_foray_form_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./sections/friends-of-foray-form.js */ "./src/sections/friends-of-foray-form.js");
/* harmony import */ var _sections_sourcing_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./sections/sourcing.js */ "./src/sections/sourcing.js");
/* harmony import */ var _components_product_card_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/product-card.js */ "./src/components/product-card.js");
/* harmony import */ var _components_cart_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/cart.js */ "./src/components/cart.js");
/* harmony import */ var _components_cart_addons_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/cart-addons.js */ "./src/components/cart-addons.js");
/* harmony import */ var _components_infinite_scroll_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/infinite-scroll.js */ "./src/components/infinite-scroll.js");
/* harmony import */ var _components_collection_filter_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/collection-filter.js */ "./src/components/collection-filter.js");
/* harmony import */ var _components_product_gallery_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/product-gallery.js */ "./src/components/product-gallery.js");
/* harmony import */ var _components_product_image_slider_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./components/product-image-slider.js */ "./src/components/product-image-slider.js");
/* harmony import */ var _components_breadcrumbs_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./components/breadcrumbs.js */ "./src/components/breadcrumbs.js");
/* harmony import */ var _components_additional_product_selector_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/additional-product-selector.js */ "./src/components/additional-product-selector.js");
/* harmony import */ var _components_search_results_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/search-results.js */ "./src/components/search-results.js");
/* harmony import */ var _components_instantsearch_integration_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/instantsearch-integration.js */ "./src/components/instantsearch-integration.js");
/* harmony import */ var _components_custom_search_results_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/custom-search-results.js */ "./src/components/custom-search-results.js");


console.log('Theme.js: File loaded successfully');

// Global

// Snippets







// Sections












// Components










// Search Components






// Make components available globally
window.SearchResults = _components_search_results_js__WEBPACK_IMPORTED_MODULE_29__.SearchResults;
window.InstantSearchIntegration = _components_instantsearch_integration_js__WEBPACK_IMPORTED_MODULE_30__.InstantSearchIntegration;
window.CustomSearchResults = _components_custom_search_results_js__WEBPACK_IMPORTED_MODULE_31__["default"];

// The single price formatter now lives in layout/theme.liquid, where it can
// read the active presentment currency and be shared with Liquid snippets.
// Defining it here as well would overwrite that one: this bundle is deferred,
// so it executes after the inline script in <head>.

// Initialize search components
document.addEventListener('DOMContentLoaded', () => {
  console.log('Theme.js: DOMContentLoaded - Initializing search components');
  console.log('Theme.js: InstantSearchIntegration available:', typeof _components_instantsearch_integration_js__WEBPACK_IMPORTED_MODULE_30__.InstantSearchIntegration);

  // Initialize InstantSearch integration in header
  const headerSearchContainer = document.querySelector('[data-search-autocomplete-container]');
  console.log('Theme.js: Header search container found:', headerSearchContainer);
  console.log(
    'Theme.js: All elements with data-search-autocomplete-container:',
    document.querySelectorAll('[data-search-autocomplete-container]'),
  );

  if (headerSearchContainer) {
    console.log('Theme.js: Initializing InstantSearchIntegration');
    try {
      new _components_instantsearch_integration_js__WEBPACK_IMPORTED_MODULE_30__.InstantSearchIntegration(headerSearchContainer, {
        placeholder: 'Search for products, brands, or categories...',
        maxSuggestions: 8,
        showEmptyState: true,
      });
      console.log('Theme.js: InstantSearchIntegration initialized successfully');
    } catch (error) {
      console.error('Theme.js: Error initializing InstantSearchIntegration:', error);
    }
  } else {
    console.warn('Theme.js: No header search container found');
  }

  // Initialize search results on search page (for direct navigation to /search)
  const searchResultsContainer = document.querySelector('[data-search-results]');
  if (searchResultsContainer) {
    new _components_search_results_js__WEBPACK_IMPORTED_MODULE_29__.SearchResults(searchResultsContainer);
  }
});


//# sourceURL=webpack://liquid-starter/./src/theme.js?
;

/***/ }),

/***/ "./src/utils/freeze.js":
/*!*****************************!*\
  !*** ./src/utils/freeze.js ***!
  \*****************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FreezeManager: () => (/* binding */ FreezeManager),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Freeze Utility
 * Manages page freeze state to prevent scrolling
 */

class FreezeManager {
  constructor() {
    this.scrollY = 0;
    this.isFrozen = false;
  }

  /**
   * Freeze the page to prevent scrolling
   */
  freeze() {
    if (this.isFrozen) return;

    this.scrollY = window.scrollY;
    this.isFrozen = true;

    document.documentElement.classList.add('frozen-scroll');
    document.body.classList.add('frozen-scroll');
    document.body.style.top = `-${this.scrollY}px`;
  }

  /**
   * Unfreeze the page and restore scroll position
   */
  unfreeze() {
    if (!this.isFrozen) return;

    this.isFrozen = false;

    document.documentElement.classList.remove('frozen-scroll');
    document.body.classList.remove('frozen-scroll');
    document.body.style.top = '';
    window.scrollTo(0, this.scrollY);
  }

  /**
   * Check if the page is currently frozen
   */
  getFrozenState() {
    return this.isFrozen;
  }

  /**
   * Get the stored scroll position
   */
  getScrollPosition() {
    return this.scrollY;
  }
}

// Create a singleton instance
const freezeManager = new FreezeManager();

// Export the singleton instance
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (freezeManager);

// Also export the class for custom instances



//# sourceURL=webpack://liquid-starter/./src/utils/freeze.js?
;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	__webpack_require__("./src/theme.js");
/******/ 	var __webpack_exports__ = __webpack_require__("./src/theme.css");
/******/ 	
/******/ })()
;